
export const SURGICAL_ASSISTANTS = {
  health_practitioners: {
    title: "ADVANCED ALLIED HEALTH PRACTITIONERS KEY RESPONSIBILITIES",
    image: "/images/providers/surgicalAssistants/team.jpg",
    data: [
      { item: "Greet and prepare the patient in the pre-operative area" },
      { item: "Anticipate and support the needs of the surgical team" },
      { item: "Assist OR staff with patient positioning, prepping, and draping" },
      { item: "Support the surgeon by selecting instruments and equipment" },
      { item: "Maintain a clear surgical field by holding open incisions" },
      { item: "Control bleeding and ensure hemostasis during procedures" },
      { item: "Assist in closing incisions and completing the surgical procedure" },
    ],
    surgeonTxt1: "REMA MALIK, MD",
    surgeonTxt2: "Gulf Coast Vascular - West",
    surgeonTxt3: "12606 West Houston Center Blvd Ste 301 Houston, TX 77082",
    surgeonTxt4: "Specialist in Vascular Surgery and Surgical Critical Care.",
    surgeonTxt5: "(713) 842-9015",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/specialities/cardiothoracic/MD.png",
  },
};

export const SURGICAL_ASSISTANTS1 = {
  health_practitioners: {
    title: "Advanced Allied Healthcare Practitioners",
    image: "/images/providers/surgicalAssistants/team.jpg",
    data: "Edwin is a highly skilled and motivated professional with extensive expertise in robotic-assisted surgery. He greets and prepares patients in the pre-operative area, anticipates and supports the needs of the surgical team, and assists with patient positioning, prepping, and draping. Edwin supports the surgeon by selecting instruments and equipment, maintains a clear surgical field, controls bleeding to ensure hemostasis, and assists in closing incisions and completing surgical procedures. His precision, technical proficiency, and proactive approach make him an invaluable asset to the surgical team.",
    surgeonTxt1: "REMA MALIK, MD",
    surgeonTxt2: "Gulf Coast Vascular - West",
    surgeonTxt3: "12606 West Houston Center Blvd Ste 301 Houston, TX 77082",
    surgeonTxt4: "Specialist in Vascular Surgery and Surgical Critical Care.",
    surgeonTxt5: "(713) 842-9015",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/specialities/cardiothoracic/MD.png",
  },
};
export const SpecialTeam = [

  {
    surgeonTxt1: "Michael T. Wood, MD, FACS",
    surgeonTxt2: "Memorial Hermann Southwest",
    surgeonTxt3: "7600 Beechnut St, Houston, TX 77074",
    surgeonTxt4: "Laparoscopic General Surgery",
    surgeonTxt5: "713-772-1200",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_1.jpg",
    specialtyType: "General Surgery",
    priority: 1,
  },
  {
    surgeonTxt1: "John Abdelsayed, MD",
    surgeonTxt2: "Memorial Hermann Southwest",
    surgeonTxt3: "7600 Beechnut St, Houston, TX 77074",
    surgeonTxt4: "Colon and Rectal Surgery",
    surgeonTxt5: "713-772-1200",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_2.png",
    specialtyType: "General Surgery",
    priority: 2,
  },
  {
    surgeonTxt1: "Charles J. Aramburo, MD, FACS",
    surgeonTxt2: "Memorial Hermann Southwest",
    surgeonTxt3: "7600 Beechnut St, Houston, TX 77074",
    surgeonTxt4: "Advanced Laparoscopic Surgery, Gastrointestinal Surgery, Hernia Surgery",
    surgeonTxt5: "713-772-1200",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_3.png",
    specialtyType: "General Surgery",
  },
  {
    surgeonTxt1: "Bidhan Das, MD, FASCRS",
    surgeonTxt2: "Medical Center – Museum Medical Tower",
    surgeonTxt3: "1213 Hermann Dr, Suite 540, Houston, TX 77004",
    surgeonTxt4: "Colon and Rectal Surgery",
    surgeonTxt5: "713-772-1200",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_4.png",
    specialtyType: "General Surgery",
  },
  {
    surgeonTxt1: "Kelly S. Dempsey, MD, FACS",
    surgeonTxt2: "Methodist Sugar Land",
    surgeonTxt3: "16655 Southwest Fwy, Sugar Land, TX 77479",
    surgeonTxt4: "Breast Disease/Cancer",
    surgeonTxt5: "713-772-1200",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/MDDetails/kelly.png",
    specialtyType: "General Surgery",
  },
  {
    surgeonTxt1: "John D. Fisher, MD, FACS",
    surgeonTxt2: "Memorial Hermann Sugar Land",
    surgeonTxt3: "17500 W Grand Parkway South, Sugar Land, TX 77479",
    surgeonTxt4: "General Surgery and Advanced Laparoscopic Surgery",
    surgeonTxt5: "713-772-1200",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_6.png",
    specialtyType: "General Surgery",
  },
  {
    surgeonTxt1: "Guillermo Ponce de Leon, MD, FACS",
    surgeonTxt2: "Memorial Hermann Southwest",
    surgeonTxt3: "7600 Beechnut St, Houston, TX 77074",
    surgeonTxt4: "General Surgery, Bariatric Surgery",
    surgeonTxt5: "713-772-1200",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_7.png",
    specialtyType: "General Surgery",
  },
  {
    surgeonTxt1: "Robert M. Shirley, MD, FACS",
    surgeonTxt2: "Memorial Hermann Sugar Land",
    surgeonTxt3: "17500 West Grand Parkway South, Sugar Land, TX 77479",
    surgeonTxt4: "General, Laparoscopic, and Robotic Surgeries",
    surgeonTxt5: "713-772-1200",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_8.png",
    specialtyType: "General Surgery",
  },
  {
    surgeonTxt1: "Ronak Patel, DO",
    surgeonTxt2: "HCA Houston Tomball",
    surgeonTxt3: "605 Holderrieth Blvd, Tomball, TX 77375",
    surgeonTxt4: "General Surgery, Bariatric Surgery",
    surgeonTxt5: "(281) 970-8484",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_9.png",
    specialtyType: "General Surgery",
  },
  {
    surgeonTxt1: "Ted Kovacev, MD",
    surgeonTxt2: "Lake Jackson Office",
    surgeonTxt3: "104 Circle Way Street, Lake Jackson, TX 77566",
    surgeonTxt4: "General Surgery, Laparoscopic Surgery, Endoscopy",
    surgeonTxt5: "(979) 721-7007",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_10.png",
    specialtyType: "General Surgery",
  },
  {
    surgeonTxt1: "Eseroghene Otah, MD",
    surgeonTxt2: "Center for General & Laparoscopic Surgery",
    surgeonTxt3: "139 Eldridge Road, Ste E, Sugar Land, TX 77478",
    surgeonTxt4: "Bariatric Surgery, General Surgery, Wound Care",
    surgeonTxt5: "(281) 302-5838",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_11.png",
    specialtyType: "General Surgery",
  },
  {
    surgeonTxt1: "Stephen Chiang, MD",
    surgeonTxt2: "Texas Colon & Rectal Specialists — Houston West",
    surgeonTxt3: "11221 Richmond Ave, Suite 115, Houston, TX 77082",
    surgeonTxt4: "Colon and Rectal Surgery, General Surgery",
    surgeonTxt5: "(832) 220-3016",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_12.png",
    specialtyType: "General Surgery",
  },
  {
    surgeonTxt1: "Alex Tse, MD",
    surgeonTxt2: "Houston Surgical Weight Loss",
    surgeonTxt3: "5220 FM 2920, Suite 120, Spring, TX 77388",
    surgeonTxt4: "General Surgery, Bariatric Surgery, Minimally Invasive Surgery",
    surgeonTxt5: "281-653-6544",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/G-Tse.png",
    specialtyType: "General Surgery",
  },
  {
    surgeonTxt1: "Obonoruma I. Ekhaese, DO",
    surgeonTxt2: "CARE Surgery Clinic, PA",
    surgeonTxt3: "10907 Memorial Hermann Dr #440, Pearland, TX 77584",
    surgeonTxt4: "General Surgery, Bariatric Surgery",
    surgeonTxt5: "832-915-8140",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/G-Ekhaese.jpg",
    specialtyType: "General Surgery",
  },
  {
    surgeonTxt1: "Priya Prakash, MD",
    surgeonTxt2: "Houston Colon - Pearland",
    surgeonTxt3: "10970 Shadow Creek Parkway Ste 250, Pearland, TX 77584",
    surgeonTxt4: "Colon & Rectal Surgery",
    surgeonTxt5: "713-701-5186",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/G-Prakash.jpg",
    specialtyType: "General Surgery",
  },
  {
    surgeonTxt1: "Stevenson C. Tsiao, MD",
    surgeonTxt2: "Texas Laparoscopic Consultants",
    surgeonTxt3: "5115 Fannin Street, Ste 950, Houston, TX 77004",
    surgeonTxt4: "General Surgery, Bariatric Surgery",
    surgeonTxt5: "346-655-5551",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/G-Tsiao.png",
    specialtyType: "General Surgery",
  },
  {
    surgeonTxt1: "Viet Phuong, MD",
    surgeonTxt2: "General & Minimally Invasive Surgery",
    surgeonTxt3: "11609 Spring Cypress Rd Ste C, Tomball, TX 77377",
    surgeonTxt4: "General Surgery, Bariatric Surgery, Minimally Invasive Surgery",
    surgeonTxt5: "281-519-7421",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/G-Phuong.jpg",
    specialtyType: "General Surgery",
  },
  {
    surgeonTxt1: "Malcolm H. Bremer, MD",
    surgeonTxt2: "Memorial Hermann Heart And Vascular Institute Southwest",
    surgeonTxt3: "7737 Southwest Fwy, Houston, TX 77074",
    surgeonTxt4: "Cardiovascular Disease, Thoracic Surgery, General Surgery, Vascular Surgery",
    surgeonTxt5: "(281) 446-6464",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/CT-Bremer silhouette-male_ (1).jpg",
    specialtyType: "Cardio-Thoracic",
  },
  {
    surgeonTxt1: "Steven B. Eisenberg, MD",
    surgeonTxt2: "UT Physicians Cardiothoracic & Vascular Surgery – Texas Medical Center",
    surgeonTxt3: "6400 Fannin St, Ste 2850, Houston, TX 77030",
    surgeonTxt4: "Cardiothoracic and Vascular Surgery, Cardiovascular Surgery, Heart and Vascular Services, Thoracic Surgery, Vascular Surgery",
    surgeonTxt5: "(713) 486-5100",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_14.png",
    specialtyType: "Cardio-Thoracic",
  },
  {
    surgeonTxt1: "Dan Loberman, MD",
    surgeonTxt2: "Houston Heart – Northwest",
    surgeonTxt3: "800 Peakwood Dr, Ste 201, Houston, TX 77090",
    surgeonTxt4: "Cardiac Surgery, Thoracic Surgery",
    surgeonTxt5: "(281) 973-2738",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_15.png",
    specialtyType: "Cardio-Thoracic",
  },
  {
    surgeonTxt1: "Rema Malik, MD",
    surgeonTxt2: "Gulf Coast Vascular – West Houston",
    surgeonTxt3: "12606 West Houston Center Blvd, Suite 301, Houston, TX 77082",
    surgeonTxt4: "Vascular Surgery, Surgical Critical Care, General Surgery",
    surgeonTxt5: "(713) 701-1410",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_13.png",
    specialtyType: "Cardio-Thoracic",
  },
  {
    surgeonTxt1: "Robert L. McKowen, MD",
    surgeonTxt2: "West Houston Cardiovascular Associates",
    surgeonTxt3: "12121 Richmond Ave Ste 328, Houston, TX 77082",
    surgeonTxt4: "Vascular Surgery, Cardiac Surgery, Thoracic Surgery, Cardiovascular Disease",
    surgeonTxt5: "(281) 496-1700",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_16.png",
    specialtyType: "Cardio-Thoracic",
  },
  {
    surgeonTxt1: "Scott E. Olsson, MD",
    surgeonTxt2: "Houston Methodist West Hospital – Cardiovascular Surgery Associates",
    surgeonTxt3: "18400 Katy Fwy, Ste 640, Houston, TX 77094",
    surgeonTxt4: "Cardiac Surgery, Thoracic Surgery, Vascular Surgery, Cardiovascular Surgery",
    surgeonTxt5: "(832) 522-8600",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_17.png",
    specialtyType: "Cardio-Thoracic",
  },
  {
    surgeonTxt1: "Cristian S. Sarateanu, MD",
    surgeonTxt2: "Center for Advanced Cardiology in Greater Heights",
    surgeonTxt3: "Houston, TX",
    surgeonTxt4: "Cardiothoracic Surgery, Cardiovascular Surgery",
    surgeonTxt5: "713-864-2710",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/CT-Sarateanu.jpg",
    specialtyType: "Cardio-Thoracic",
  },
  {
    surgeonTxt1: "Eve Grace Cieutat, MD",
    surgeonTxt2: "Corpus Christi Medical Center Bay Area",
    surgeonTxt3: "Corpus Christi, TX",
    surgeonTxt4: "Thoracic Surgery, Cardiovascular Surgery",
    surgeonTxt5: "361-761-1000",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/CT-Cieutat.jpg",
    specialtyType: "Cardio-Thoracic",
  },
  {
    surgeonTxt1: "Hannan Chaugle, MD",
    surgeonTxt2: "Houston Heart - Clear Lake",
    surgeonTxt3: "Webster, TX",
    surgeonTxt4: "Cardiac Surgery, Thoracic Surgery",
    surgeonTxt5: "281-332-4596",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/CT-Chaugle.jpg",
    specialtyType: "Cardio-Thoracic",
  },
  {
    surgeonTxt1: "Manish K. Patel, MD",
    surgeonTxt2: "Center for Advanced Heart Failure – Texas Medical Center",
    surgeonTxt3: "Houston, TX",
    surgeonTxt4: "Thoracic Surgery, Cardiovascular Surgery, Organ Transplant Surgery",
    surgeonTxt5: "713-704-4300",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/CT-Patel.jpg",
    specialtyType: "Cardio-Thoracic",
  },
  {
    surgeonTxt1: "Mark Mettauer, MD",
    surgeonTxt2: "St. Luke's Health - The Woodlands Hospital",
    surgeonTxt3: "Conroe, TX",
    surgeonTxt4: "Cardiac Surgery, Congenital Cardiac Surgery, General Surgery, Thoracic Surgery",
    surgeonTxt5: "713-798-7717",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/CT-Mettauer.jpg",
    specialtyType: "Cardio-Thoracic",
  },
  {
    surgeonTxt1: "Stephen P. Maniscalco, MD",
    surgeonTxt2: "Elite Heart Surgeons",
    surgeonTxt3: "The Woodlands, TX",
    surgeonTxt4: "Cardiothoracic and Vascular Surgery, Cardiovascular Surgery",
    surgeonTxt5: "713-486-0460",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/CT-Maniscalco.jpg",
    specialtyType: "Cardio-Thoracic",
  },
  {
    surgeonTxt1: "Carlos O. Encarnacion, MD",
    surgeonTxt2: "Houston Heart - Cypress",
    surgeonTxt3: "Cypress, TX",
    surgeonTxt4: "Cardiac Surgery, Thoracic Surgery",
    surgeonTxt5: "832-478-2216",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/CT-Encarnacion.jpg",
    specialtyType: "Cardio-Thoracic",
  },
  {
    surgeonTxt1: "Devinder S. Bhatia, MD",
    surgeonTxt2: "Southeast TX Cardiovascular",
    surgeonTxt3: "Humble, TX",
    surgeonTxt4: "Cardiac Surgery, Congenital Cardiac Surgery, Thoracic Surgery",
    surgeonTxt5: "281-397-7000",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/CT-Bhatia.jpg",
    specialtyType: "Cardio-Thoracic",
  },
  {
    surgeonTxt1: "Eyal E. Porat, MD",
    surgeonTxt2: "Houston Heart - Med Center",
    surgeonTxt3: "Houston, TX",
    surgeonTxt4: "Cardiac Surgery, Thoracic Surgery, Aortic Surgery",
    surgeonTxt5: "713-522-0220",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/CT-Porat.jpg",
    specialtyType: "Cardio-Thoracic",
  },
  {
    surgeonTxt1: "Ibrahim Yazji, MD",
    surgeonTxt2: "Quality Surgical Heart & Vascular",
    surgeonTxt3: "Kingwood, TX",
    surgeonTxt4: "Thoracic Surgery",
    surgeonTxt5: "281-899-0229",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/CT-Yazji.jpg",
    specialtyType: "Cardio-Thoracic",
  },
  {
    surgeonTxt1: "John W. Davis, MD",
    surgeonTxt2: "Davis Vein & Vascular Center",
    surgeonTxt3: "Kingwood, TX",
    surgeonTxt4: "Cardiac Surgery, Vascular Surgery",
    surgeonTxt5: "936-441-1010",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/CT-Davis.png",
    specialtyType: "Cardio-Thoracic",
  },
  {
    surgeonTxt1: "Khaja Moinuddeen, MD",
    surgeonTxt2: "Houston Heart - Southeast",
    surgeonTxt3: "Pasadena, TX",
    surgeonTxt4: "Thoracic Surgery, Vascular Surgery",
    surgeonTxt5: "713-942-2536",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/CT-Moinudeen.jpg",
    specialtyType: "Cardio-Thoracic",
  },
  {
    surgeonTxt1: "Shuab Omer, MD",
    surgeonTxt2: "Houston Heart - Conroe",
    surgeonTxt3: "Conroe, TX",
    surgeonTxt4: "Cardiac Surgery, Thoracic Surgery",
    surgeonTxt5: "936-539-5000",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/CT-Omer.jpg",
    specialtyType: "Cardio-Thoracic",
  },
  {
    surgeonTxt1: "Uttam Tripathy, MD",
    surgeonTxt2: "Uttam Tripathy MD",
    surgeonTxt3: "Sugar Land, TX",
    surgeonTxt4: "Thoracic Surgery, Cardiac Surgery",
    surgeonTxt5: "281-232-1908",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/CT-Tripathy.png",
    specialtyType: "Cardio-Thoracic",
  },
  {
    surgeonTxt1: "Viacheslav Bobovnikov, MD",
    surgeonTxt2: "UT Physicians Cardiothoracic & Vascular Surgery – Texas Medical Center",
    surgeonTxt3: "Houston, TX",
    surgeonTxt4: "Cardiothoracic Surgery",
    surgeonTxt5: "713-486-5100",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/CT-Bobovnikov.webp",
    specialtyType: "Cardio-Thoracic",
  },
  {
    surgeonTxt1: "Ata Ahmad, MD",
    surgeonTxt2: "Cy-Fair Location",
    surgeonTxt3: "11740 FM 1960,  Houston, TX 77065",
    surgeonTxt4: "General Surgery, Bariatric Surgery, Breast Surgery",
    surgeonTxt5: "281-970-8484",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_50.png",
    specialtyType: "Robotic",
  },
  {
    surgeonTxt1: "Abimbola Ayangbesan, MD",
    surgeonTxt2: "Texas Urology Specialists-Houston Willowbrook",
    surgeonTxt3: "13215 Dotson Road, Suite 170B, Houston, TX 77070",
    surgeonTxt4: "Urology",
    surgeonTxt5: "281-351-5174",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_51.png",
    specialtyType: "Robotic",
  },
  {
    surgeonTxt1: "Linh T. Do, MD",
    surgeonTxt2: "Houston Metro Urology",
    surgeonTxt3: "12121 Richmond Ave Ste 100, Houston, TX 77082",
    surgeonTxt4: "Female Pelvic Medicine & Reconstructive Surgery, Obstetrics and Gynecology",
    surgeonTxt5: "281-493-9966",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_52.webp",
    specialtyType: "Robotic",
  },
  {
    surgeonTxt1: "Caroline K. Fiser, MD",
    surgeonTxt2: "Texas Breast Specialists-The Woodlands",
    surgeonTxt3: "9180 Pinecroft, Suite 600, The Woodlands, TX 77380",
    surgeonTxt4: "Breast Surgery, Breast Surgical Oncology, General Surgery",
    surgeonTxt5: "281-296-0365",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_53.jpg",
    specialtyType: "Robotic",
  },
  {
    surgeonTxt1: "Kelly K. Gilmore, MD",
    surgeonTxt2: " Texas Colon & Rectal Specialists–Conroe",
    surgeonTxt3: "500 Medical Center Blvd, Suite 340, Conroe, Texas 77304",
    surgeonTxt4: "Colon and Rectal Surgery, General Surgery",
    surgeonTxt5: "833-437-1707",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_54.png",
    specialtyType: "Robotic",
  },
  {
    surgeonTxt1: "Zishan Hirani, MD, MS, FACOG",
    surgeonTxt2: "Stafford Clinic",
    surgeonTxt3: "11211 Nexus Ave, Stafford, TX 77477",
    surgeonTxt4: "General Obstetrics & Gynecology, Minimally Invasive / Endoscopic Surgery, Urogynecology & Pelvic Reconstructive Surgery",
    surgeonTxt5: "713-442-8000",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_27.png",
    specialtyType: "Robotic",
  },
  {
    surgeonTxt1: "John C. Hardaway, MD, PhD",
    surgeonTxt2: "Texas Oncology Surgical Specialists - Kingwood",
    surgeonTxt3: "18980 W. Memorial Drive, Suite 440, Humble, TX 77338",
    surgeonTxt4: "Hepatobiliary Surgery, Surgical Oncology, General Surgery",
    surgeonTxt5: "832-616-5180",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_56.png",
    specialtyType: "Robotic",
  },
  {
    surgeonTxt1: "Daniel L. Phillips, MD",
    surgeonTxt2: "Memorial Hermann Medical Group Sugar Land Multi-Specialty",
    surgeonTxt3: "17520 West Grand Pkwy South, Suite 350, Sugar Land, TX 77479",
    surgeonTxt4: "Urological Surgery, General Surgery",
    surgeonTxt5: "281-725-5970",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_57.png",
    specialtyType: "Robotic",
  },
  {
    surgeonTxt1: "Kumaran Sathyamoorthy, MD, MPH",
    surgeonTxt2: "North Cypress Urology",
    surgeonTxt3: "10425 Huffmeister Rd Ste 210, Houston, TX 77065",
    surgeonTxt4: "Urology",
    surgeonTxt5: "281-890-0911",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_58.png",
    specialtyType: "Robotic",
  },
  {
    surgeonTxt1: "Penner T. Schraudenbach, MD",
    surgeonTxt2: "Texas Urology Specialists-Houston Willowbrook",
    surgeonTxt3: "13215 Dotson Road, Suite 170B, Houston, TX 77070",
    surgeonTxt4: "Urology",
    surgeonTxt5: "281-351-5174",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_59.png",
    specialtyType: "Robotic",
  },
  {
    surgeonTxt1: "Nicholai Stephens, MD",
    surgeonTxt2: "Surgical Associates of Houston",
    surgeonTxt3: "12121 Richmond Ave, Ste 103, Houston, TX 77082",
    surgeonTxt4: "General Surgery",
    surgeonTxt5: "832-672-6266",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_60.png",
    specialtyType: "Robotic",
  },
  {
    surgeonTxt1: "Karen Tart, MD",
    surgeonTxt2: "Memorial Hermann Medical Group Sugar Land Multi-Specialty",
    surgeonTxt3: "17520 West Grand Pkwy South, Suite 350, Sugar Land, TX 77479",
    surgeonTxt4: "Urological Surgery",
    surgeonTxt5: "281-725-5970",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/R-Tart.jpg",
    specialtyType: "Robotic",
  },
  // new surgeons
  {
    surgeonTxt1: "Alan E. Hananel, MD",
    surgeonTxt2: "Houston Metro Urology- Sugar Land",
    surgeonTxt3: "16605 Southwest Fwy, Ste 250, Sugar Land, TX 77479",
    surgeonTxt4: "Urological Surgery",
    surgeonTxt5: "281-325-1090",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/R-Hanamel.png",
    specialtyType: "Robotic",
  },
  {
    surgeonTxt1: "Antonio N. Villamor III, MD",
    surgeonTxt2: "Texas Colon & Rectal Specialists-Pasadena",
    surgeonTxt3: "4000 Spencer Highway, Suite 200, Pasadena, TX 77504",
    surgeonTxt4: "Colon & Rectal Surgery, Surgical Oncology",
    surgeonTxt5: "832-220-3018",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/R-Villamor.avif",
    specialtyType: "Robotic",
  },
  {
    surgeonTxt1: "Bryan Pham, MD",
    surgeonTxt2: "Crescent Urology Institute",
    surgeonTxt3: "1200 Binz St Ste 690, Houston, TX 77004",
    surgeonTxt4: "Urological Surgery",
    surgeonTxt5: "713-366-7831",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/R-BryanPham.webp",
    specialtyType: "Robotic",
  },
  {
    surgeonTxt1: "Denis K. Hoasjoe, MD",
    surgeonTxt2: "Baytown Clinic",
    surgeonTxt3: "4301 Garth Rd Ste 216, Baytown, TX 77521",
    surgeonTxt4: "Otolaryngology-Head & Neck Surgery, Plastic Surgery",
    surgeonTxt5: "281-422-9167",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/R-Hoasjoe.jpg",
    specialtyType: "Robotic",
  },
  {
    surgeonTxt1: "Dung Q. Pham, MD",
    surgeonTxt2: "Crescent Urology Institute",
    surgeonTxt3: "1200 Binz St Ste 690, Houston, TX 77004",
    surgeonTxt4: "Pediatric Urology, Urological Surgery",
    surgeonTxt5: "713-366-7831",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/R-DungPham.webp",
    specialtyType: "Robotic",
  },
  {
    surgeonTxt1: "Leo Lapuerta, MD",
    surgeonTxt2: "The Plastic Surgery Institute of Southeast Texas",
    surgeonTxt3: "2360 Country Road 94, Ste 104, Pearland, TX 77584",
    surgeonTxt4: "Plastic Surgery, Hand Surgery",
    surgeonTxt5: "713-701-7608",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/R-Lapuerta.webp",
    specialtyType: "Robotic",
  },
  {
    surgeonTxt1: "M. Brian Harkins, MD",
    surgeonTxt2: "Surgical Advanced Specialty Center",
    surgeonTxt3: "455 School Street, Bldg 1, Suite 10, Tomball, TX 77375",
    surgeonTxt4: "General Surgery",
    surgeonTxt5: "281-801-7207",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/R-Harkins.webp",
    specialtyType: "Robotic",
  },
  {
    surgeonTxt1: "Ori Hampel, MD",
    surgeonTxt2: "Adult and Pediatric Urology of Houston- Pasadena Office",
    surgeonTxt3: "3230 Strawberry Rd., Pasadena, TX 77504",
    surgeonTxt4: "Urology",
    surgeonTxt5: "713-477-8600",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/R-Hampel.jpg",
    specialtyType: "Robotic",
  },
  {
    surgeonTxt1: "Robert A. Darling, MD",
    surgeonTxt2: "Darling ENT",
    surgeonTxt3: "1106 S. Friendswood Dr., Ste C, Friendswood, TX 77546",
    surgeonTxt4: "Otolaryngology",
    surgeonTxt5: "281-895-2150",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/R-Darling.jpg",
    specialtyType: "Robotic",
  },
  {
    surgeonTxt1: "Robert C. Dillard, DO",
    surgeonTxt2: "North Texas Surgical Specialists- West Houston",
    surgeonTxt3: "12121 Richmond Ave, Ste 103D, Houston, TX 77082",
    surgeonTxt4: "General Surgery, Bariatric Surgery, Robotic Surgery",
    surgeonTxt5: "281-516-8184",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/R-Dillard.webp",
    specialtyType: "Robotic",
  },
  {
    surgeonTxt1: "Ryan D. Gunter, MD",
    surgeonTxt2: "Houston Colon - Pearland",
    surgeonTxt3: "10970 Shadow Creek Parkway Ste 250, Pearland, TX 77584",
    surgeonTxt4: "Colon and Rectal Surgery",
    surgeonTxt5: "713-790-0600",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/R-Gunter.jpg",
    specialtyType: "Robotic",
  },
  {
    surgeonTxt1: "Seyed S. Pairawan, MD",
    surgeonTxt2: "Gulf Coast Vascular - Pearland",
    surgeonTxt3: "10970 Shadow Creek Pkwy, Suite 370, Pearland, TX 77584",
    surgeonTxt4: "Vascular Surgery",
    surgeonTxt5: "346-207-6820",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/R-Pairawan.jpg",
    specialtyType: "Robotic",
  },
  {
    surgeonTxt1: "Mohammed Tarek Al-Fahl, MD",
    surgeonTxt2: "Texas Orthopedic & Sports Medicine – Tomball",
    surgeonTxt3: "13603 Michel Rd, Tomball, TX 77375",
    surgeonTxt4: "Orthopedic Surgery, Sports Medicine",
    surgeonTxt5: "(281) 351-7261",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_39.png",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Miguel A. Berastain, Jr.",
    surgeonTxt2: "The Orthopaedic Center of Corpus Christi",
    surgeonTxt3: "6118 Parkway Drive, Corpus Christi, TX 78414",
    surgeonTxt4: "General Orthopaedics, Orthopedic Surgery, Sports Medicine",
    surgeonTxt5: "361-883-2000",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_40.png",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Michael L. Blackwell, MD",
    surgeonTxt2: "Center for Orthopaedic and Sports Medicine",
    surgeonTxt3: "425 Holderrieth Boulevard, Suite 208, Tomball, TX 77375",
    surgeonTxt4: "Orthopaedic Surgery, Sports Medicine",
    surgeonTxt5: "281-357-5515",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_41.jpg",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Nikoletta Carayannopoulos, DO",
    surgeonTxt2: "West Houston Orthopedics",
    surgeonTxt3: "12606 West Houston Center Blvd Ste 350, Houston, TX 77082",
    surgeonTxt4: "Orthopaedic Trauma, General Surgical Orthopedics, Sports Medicine",
    surgeonTxt5: "281-496-2482",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_42.png",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "John J. Eager, MD",
    surgeonTxt2: "West Houston Orthopedics",
    surgeonTxt3: "12606 West Houston Center Blvd Ste 350, Houston, TX 77082",
    surgeonTxt4: "Orthopaedic Surgery, Orthopedic Spine Surgery",
    surgeonTxt5: "901-641-3000",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_43.png",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Nicholas Fiore II, MD",
    surgeonTxt2: "Fiore Hand & Wrist",
    surgeonTxt3: "11307 FM 1960 Rd W #250, Houston, TX 77065-4917",
    surgeonTxt4: "Orthopedics, Surgery of the Hand",
    surgeonTxt5: "281-970-8002",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_44.png",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Enrique J. Garcia-Pena, MD",
    surgeonTxt2: "Texas Bone & Joint - North Houston",
    surgeonTxt3: "800 Peakwood Drive 5D, Houston, TX 77090",
    surgeonTxt4: "Orthopaedic Surgery, Sports Medicine",
    surgeonTxt5: "281-895-2065",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_45.png",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Cristin Mathew, DO",
    surgeonTxt2: "All American Orthopedics & Sports Medicine- Clear Lake Main Campus",
    surgeonTxt3: "1045 Gemini Ste 100, Houston, TX 77058",
    surgeonTxt4: "Orthopedic Surgeon, Hip & Knee Orthopedic Specialist",
    surgeonTxt5: "281-335-1111",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_46.png",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Paul F. Merkle, MD",
    surgeonTxt2: "Corpus Christi Medical Center Bay Area",
    surgeonTxt3: "7101 S Padre Island Dr, Corpus Christi, TX 78412",
    surgeonTxt4: "Orthopedic Surgery, Pediatric Orthopedics",
    surgeonTxt5: "361-761-1000",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Orth-Merkle.webp",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Tyler Roberts, MD",
    surgeonTxt2: "Advanced Orthopaedics & Sports Medicine of Houston",
    surgeonTxt3: "10425 Huffmeister Rd Ste 320, Houston, TX 77065",
    surgeonTxt4: "Orthopedic Surgery",
    surgeonTxt5: "281-955-2650",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_47.png",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Matthew D. Weldon, MD",
    surgeonTxt2: "Texas Bone and Joint - Houston",
    surgeonTxt3: "1200 Binz St Ste 580, Houston, TX 770045",
    surgeonTxt4: "Orthopedic Surgery, Sports Medicine, Pediatric Orthopaedic Surgery, Pediatric Sports Medicine",
    surgeonTxt5: "281-836-9020",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_48.png",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Craig A. Winkler, MD",
    surgeonTxt2: "Texas Orthopaedic & Sports Medicine - Tomball",
    surgeonTxt3: "13603 Michel Rd., Houston, TX 77375",
    surgeonTxt4: "Orthopaedic Surgery, Orthopedics and Sports Medicine",
    surgeonTxt5: "281-351-7261",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_49.png",
    specialtyType: "Orthopedic",
  },
  // new surgeons
  {
    surgeonTxt1: "Alexander Nguyen, MD",
    surgeonTxt2: "Texas Orthopaedic & Sports Medicine - Woodlands",
    surgeonTxt3: "9319 Pinecroft Dr., Ste 200, The Woodlands, TX 77380",
    surgeonTxt4: "Orthopedic Surgery, Orthopedics and Sports Medicine",
    surgeonTxt5: "281-351-7261",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Orth-Nguyen.jpg",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Anthony P. Gualtieri, MD",
    surgeonTxt2: "INOV8 Orthopedics",
    surgeonTxt3: "10496 Katy Fwy, Ste 101, Houston, TX 77043",
    surgeonTxt4: "Orthopedic Surgery",
    surgeonTxt5: "346-571-7500",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Orth-Gualtieri.webp",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Barkha Chhabra, MD, MPH",
    surgeonTxt2: "Pediatric Orthopedic Clear Lake",
    surgeonTxt3: "600 North Kobayashi, Suite 208, Webster, TX 77598",
    surgeonTxt4: "Pediatric Orthopaedic Surgery",
    surgeonTxt5: "281-985-9342",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Orth-Chhabra.jpg",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Caleb Jones, MD",
    surgeonTxt2: "All American Orthopedics & Sports Medicine- Clear Lake Main Campus",
    surgeonTxt3: "1045 Gemini Ste 100, Houston, TX 77058",
    surgeonTxt4: "Orthopedic Surgery, Elbow Surgery, Hand Surgery, Shoulder Surgery",
    surgeonTxt5: "281-335-1111",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Orth-Jones.webp",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Connor Armstrong, MD",
    surgeonTxt2: "South Texas Bone & Joint",
    surgeonTxt3: "5917 Crosstown Expressway SH 286, Corpus Christi, TX 78417",
    surgeonTxt4: "Hip & Knee Surgery",
    surgeonTxt5: "361-854-0811",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Orth-Armstrong.webp",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Dhvanil K. Thakor, DPM",
    surgeonTxt2: "Foot & Ankle Doctors PLLC",
    surgeonTxt3: "3129 Kingsley Drive, Ste 640, Pearland, TX 77584",
    surgeonTxt4: "Podiatry, Foot & Ankle Surgery",
    surgeonTxt5: "281-901-1133",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Orth-Thakor.png",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Eugene F. Stautberg III, MD",
    surgeonTxt2: "Southwest Orthopedic Group- Pearland",
    surgeonTxt3: "10970 Shadow Creek Parkway, Suite 130, Pearland, TX 77584",
    surgeonTxt4: "Orthopedic Surgery",
    surgeonTxt5: "281-977-4870",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Orth-Stautberg.jpg",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "James M. Saucedo, MD, MBA",
    surgeonTxt2: "UT Physicians Orthopedics at Memorial Hermann | Rockets Sports Medicine Institute – The Woodlands",
    surgeonTxt3: "9305 Pinecroft Dr, Ste 400, The Woodlands, TX 77380-3482",
    surgeonTxt4: "Orthopaedic Surgery, Hand Surgery",
    surgeonTxt5: "713-486-8800",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Orth-Saucedo.jpg",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Jonathan P. Behrens, MD",
    surgeonTxt2: "Fondren Orthopedic Group",
    surgeonTxt3: "520 Blossom Street, Webster, TX 77598",
    surgeonTxt4: "Orthopaedic Surgery",
    surgeonTxt5: "281-922-9979",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Orth-Behrens.webp",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Kenneth Brooks, MD",
    surgeonTxt2: "CLS Health Orthopedics & Sports Medicine Associates - Clear Lake",
    surgeonTxt3: "905 West Medical Center Blvd, Ste 404, Webster, TX 77598",
    surgeonTxt4: "Orthopedic Sports Medicine, Hip and Knee Orthopedic Surgery",
    surgeonTxt5: "281-985-9342",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Orth-Brooks.webp",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Kenneth L. Caldwell, MD",
    surgeonTxt2: "Multi-Specialty Clinic of HCA Houston Healthcare Southeast",
    surgeonTxt3: "3801 Vista Road, Suite 360, Pasadena, TX 77504",
    surgeonTxt4: "Orthopedic Surgery",
    surgeonTxt5: "713-359-2221",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Orth-Caldwell.jpg",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Kevin A. West, MD",
    surgeonTxt2: "Corpus Christi Medical Center- Bay Area",
    surgeonTxt3: "7101 S Padre Island Dr, Corpus Christi, TX 78412",
    surgeonTxt4: "Orthopedic Surgery, Sports Medicine",
    surgeonTxt5: "361-761-1000",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Orth-West.jpg",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Laura Linscheid, MD",
    surgeonTxt2: "CLS Health Orthopedics & Sports Medicine Associates - Sugar Land",
    surgeonTxt3: "14100 Southwest Freeway, Suite 500, Sugar Land, TX 77478",
    surgeonTxt4: "Orthopaedic Surgery, Orthopedic Sports Medicine",
    surgeonTxt5: "281-985-9342",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Orth-Linscheid.webp",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Matthew Darlow, MD",
    surgeonTxt2: "Orthopedic Specialists of Texas - Webster",
    surgeonTxt3: "450 W Medical Center Blvd # 600B, Webster, TX 77598",
    surgeonTxt4: "Orthopaedic Surgery, Spine Surgeon",
    surgeonTxt5: "281-316-0121",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Orth-Darlow.jpg",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Michael Maier, MD",
    surgeonTxt2: "Baylor College of Medicine Dr. Maier",
    surgeonTxt3: "14090 Southwest Fwy #130, Sugar Land, TX 77478",
    surgeonTxt4: "Orthopedics and Sports Medicine, Orthopedic Surgery, Spine Care",
    surgeonTxt5: "281-491-7111",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Orth-Maier.jpg",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Nileshkumar M. Chaudhari, MD",
    surgeonTxt2: "Houston Hand & Foot Orthopedics- Pearland",
    surgeonTxt3: "9804 Broadway Street, Pearland, TX 77584",
    surgeonTxt4: "Orthopedic Surgery Hand, Upper Extremity and Microvascular Surgery Foot and Ankle Surgery",
    surgeonTxt5: "281-456-4412",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Orth-Chaudhari.jpg",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Rohan Anup Gheewala, MD",
    surgeonTxt2: "Sterling Ridge Orthopaedics & Sports Medicine- Woodforest",
    surgeonTxt3: "750 Fish Creek Thoroughfare, Montgomery, TX 77316",
    surgeonTxt4: "Hip and Knee Reconstructive Surgery, Orthopedic Trauma",
    surgeonTxt5: "936-272-0790",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Orth-Gheewala.jpg",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Taggart Gauvain, MD",
    surgeonTxt2: "Memorial Hermann Sports Park",
    surgeonTxt3: "11049 Memorial Hermann Drive, Suite 200, Pearland, TX 77584",
    surgeonTxt4: "Orthopedic Surgery, Foot and Ankle Surgery",
    surgeonTxt5: "713-486-6000",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Orth-Gauvain.webp",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Victor Van Phan, DO",
    surgeonTxt2: "Premier Orthopaedics",
    surgeonTxt3: "11920 Astoria Blvd, Suite 390, Houston, TX 77089",
    surgeonTxt4: "Orthopedic Surgery",
    surgeonTxt5: "281-922-1800",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Orth-Phan.jpg",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "William J. Jordan, MD",
    surgeonTxt2: "Woodlands Center for Special Surgery",
    surgeonTxt3: "134 Vision Park Blvd, Ste 100, The Woodlands, TX 77384",
    surgeonTxt4: "Orthopedic Surgery, Sports Medicine",
    surgeonTxt5: "936-242-1437",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Orth-Jordan.jpg",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Alejandra Andrade-Gonzalez, MD",
    surgeonTxt2: "Hope Clinic Main",
    surgeonTxt3: "7001 Corporate Dr Ste 120, Houston, TX 77036",
    surgeonTxt4: "Obstetrics and Gynecology",
    surgeonTxt5: "(713) 773-6803",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_26.png",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Zishan Hirani, MD, MS, FACOG",
    surgeonTxt2: "Stafford Clinic",
    surgeonTxt3: "11211 Nexus Ave, Stafford, TX 77477",
    surgeonTxt4: "General Obstetrics & Gynecology, Minimally Invasive Gynecologic Surgery, Urogynecology & Pelvic Reconstructive Surgery",
    surgeonTxt5: "713-442-8000",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_27.png",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Alpa M. Nick, MD, MS",
    surgeonTxt2: "Texas Oncology – Houston Memorial",
    surgeonTxt3: "925 Gessner Rd, Suite 550, Houston, TX 77024",
    surgeonTxt4: "Gynecologic Oncology, General Gynecology",
    surgeonTxt5: "(713) 467-1722",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_28.png",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Therese A. Malcolm, MD",
    surgeonTxt2: "HCA Houston Healthcare Kingwood",
    surgeonTxt3: "22999 Highway 59 N, Kingwood, TX 77339",
    surgeonTxt4: "Obstetrics and Gynecology",
    surgeonTxt5: "(281) 348-8000",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_29.png",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Paola G. Torres Ortiz, MD",
    surgeonTxt2: "Texas Children’s Pavilion for Women",
    surgeonTxt3: "6651 Main Street, Houston, TX 77030",
    surgeonTxt4: "Obstetrics and Gynecology",
    surgeonTxt5: "(832) 826-7500",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_30.png",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Christine M. Lee, MD",
    surgeonTxt2: "Texas Oncology – The Woodlands East",
    surgeonTxt3: "9180 Pinecroft Dr Ste 600, The Woodlands, TX 77380",
    surgeonTxt4: "Oncology, Gynecologic Oncology",
    surgeonTxt5: "(281) 296-0365",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_31.png",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Jennifer L. Brown, MD, MS",
    surgeonTxt2: "Texas Oncology",
    surgeonTxt3: "9180 Pinecroft Dr, Ste 600, Shenandoah, TX 77380",
    surgeonTxt4: "Gynecologic Oncology, Obstetrics & Gynecology",
    surgeonTxt5: "(281) 296-0365",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_32.png",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Ngozi Ibe, MD",
    surgeonTxt2: "Tomball Woman’s Healthcare Center",
    surgeonTxt3: "13426 Medical Complex Dr Ste 200 Tomball, TX 77375",
    surgeonTxt4: "Obstetrics and Gynecology",
    surgeonTxt5: "(281) 255-0000",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_33.png",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Brooke Jemelka Weaver, MD",
    surgeonTxt2: "Caritas Women’s Care – Baylor St. Luke’s Medical Group",
    surgeonTxt3: "1327 Lake Pointe Parkway, Suite 500, Sugar Land, TX 77478",
    surgeonTxt4: "Obstetrics and Gynecology, Women’s Health",
    surgeonTxt5: "(281) 637-9905",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_34.png",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Nina H. Dereska, MD",
    surgeonTxt2: "UT Physicians – Department of Urogynecology",
    surgeonTxt3: "17510 West Grand Parkway South, Suite 500, Sugar Land, TX 77479",
    surgeonTxt4: "Female Pelvic Medicine and Reconstructive Surgery, Urogynecology",
    surgeonTxt5: "(713) 406-1530",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_35.png",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Elvis Torres, DO",
    surgeonTxt2: "Family Futures",
    surgeonTxt3: "12121 Richmond Ave Ste 201 Houston, TX 77082",
    surgeonTxt4: "Obstetrics and Gynecology",
    surgeonTxt5: "(281) 496-2496",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_36.png",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Silvana Pedra Nobre, MD",
    surgeonTxt2: "Texas Oncology–Houston Medical Center Gynecologic Oncology",
    surgeonTxt3: "7500 Fannin St, Suite 100A, Houston, TX 77054",
    surgeonTxt4: "Gynecologic Oncology, Obstetrics & Gynecology",
    surgeonTxt5: "(832) 377-3770",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_37.png",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Dama A. Ziwortin, MD",
    surgeonTxt2: "Genesys Women OB Gyn",
    surgeonTxt3: "12000 Richmond Avenue, Suite 215, Houston, TX, 77082",
    surgeonTxt4: "Obstetrics & Gynecology, Critical Care Medicine",
    surgeonTxt5: "(832) 532-7068",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_38.png",
    specialtyType: "Obs-Gyn",
  },
  //new surgeons
  {
    surgeonTxt1: "Adekorewale A. Odulate-Williams, MD",
    surgeonTxt2: "UT Physicians Urogynecology Center – Greater Heights",
    surgeonTxt3: "1631 North Loop W, Ste 220, Houston, TX 77008",
    surgeonTxt4: "Obstetrics and Gynecology, Female Pelvic Medicine and Reconstructive Surgery",
    surgeonTxt5: "713-486-3050",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Odulate.jpg",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Ameer L. Touadrous, MD",
    surgeonTxt2: "Hope Clinic- Beltway",
    surgeonTxt3: "7001 Corporate Dr., Suite #120, Houston, TX 77036",
    surgeonTxt4: "Obstetrics & Gynecology",
    surgeonTxt5: "713-773-0803",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Touadrous.jpg",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Anne B. Alaniz, DO",
    surgeonTxt2: "Texas Oncology-Houston Willowbrook",
    surgeonTxt3: "13215 Dotson Road, Suite 300, Houston, TX 77070",
    surgeonTxt4: "Gynecologic Oncology, Gynecology",
    surgeonTxt5: "281-894-8822",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Alaniz.avif",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Brandon L. Sass, MD",
    surgeonTxt2: "UT Physicians Urogynecology Center – Sugar Land",
    surgeonTxt3: "17510 W Grand Pkwy S, Ste 500, Sugar Land, TX 77479",
    surgeonTxt4: "Obstetrics And Gynecology, Gynecology, Urogynecology, Pelvic Reconstructive Surgery",
    surgeonTxt5: "713-486-1530",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Sass.webp",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Bryan Behne, MD",
    surgeonTxt2: "Woman's Healthcare Affiliates",
    surgeonTxt3: "9180 Pinecroft Drive, Ste 100, Shenandoah, TX 77380",
    surgeonTxt4: "Obstetrics and Gynecology, Gynecology",
    surgeonTxt5: "281-367-6836",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Behne.jpg",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Chundar Tsai, MD",
    surgeonTxt2: "Southwest Woman Care OB/GYN",
    surgeonTxt3: "7789 Southwest Fwy Ste 400, Houston, TX 77074",
    surgeonTxt4: "Obstetrics and Gynecology",
    surgeonTxt5: "832-649-4273",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Tsai.jpg",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Cynthia E. Larson, DO",
    surgeonTxt2: "HCA Houston Healthcare Clear Lake",
    surgeonTxt3: "500 W Medical Center Blvd, Webster, TX 77598",
    surgeonTxt4: "Obstetrics and Gynecology",
    surgeonTxt5: "281-332-2511",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Larson.jpg",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Ebonee Hayward-Sencherery, DO",
    surgeonTxt2: "Tomball Woman's Healthcare Center",
    surgeonTxt3: "13426 Medical Complex Drive, Suite 200, Tomball, Texas 77375",
    surgeonTxt4: "Obstetrics and Gynecology",
    surgeonTxt5: "281-255-0000",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-HaywardSen.webp",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Emily C. Bullock, MD",
    surgeonTxt2: "Women of the Woodlands Obstetrics and Gynecology",
    surgeonTxt3: "9200 Pinecroft Dr Ste 400, Shenandoah, TX 77380",
    surgeonTxt4: "Obstetrics and Gynecology",
    surgeonTxt5: "281-602-6888",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Bullock.avif",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Heidi A. Lyn, MD",
    surgeonTxt2: "Women's Healthcare Affiliates",
    surgeonTxt3: "9180 Pinecroft, Suite #100 The Woodlands, Texas 77380",
    surgeonTxt4: "Obstetrics And Gynecology, Gynecology",
    surgeonTxt5: "281-367-6836",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Lyn.jpg",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Jacey Beasley, MD",
    surgeonTxt2: "Kelsey-Seybold- Bay Area Clinic",
    surgeonTxt3: "1010 South Ponds Dr, Webster, TX 77598",
    surgeonTxt4: "Obstetrics & Gynecology",
    surgeonTxt5: "713-442-2826",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Beasley.jpg",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Jorge Pablo Orezzoli, MD",
    surgeonTxt2: "Hope Clinic- West",
    surgeonTxt3: "12121 Westheimer Rd., Suite #205, Houston, TX 77077",
    surgeonTxt4: "Obstetrics & Gynecology, Gastroenterology",
    surgeonTxt5: "713-773-0803",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Orezzoli.avif",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "June G. Marshall, MD",
    surgeonTxt2: "Obstetrics and Gynecology Center of Northwest Houston",
    surgeonTxt3: "11307 FM 1960 Rd W, Ste 230, Houston, TX 77065",
    surgeonTxt4: "Obstetrics & Gynecology",
    surgeonTxt5: "713-697-2897",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Marshall.webp",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Kjersti M. Aagaard, MD, PhD",
    surgeonTxt2: "Texas Maternal Fetal Medicine- Conroe",
    surgeonTxt3: "508 Medical Center Blvd, Ste 200, Conroe, TX 77304",
    surgeonTxt4: "Obstetrics and Gynecology",
    surgeonTxt5: "346-416-6678",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Aagaard.jpg",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Mena A. Shaker, MD",
    surgeonTxt2: "Woodlands Medical Aesthetics Institute",
    surgeonTxt3: "17350 St. Lukes Way, Suite 380, The Woodlands, TX 77384",
    surgeonTxt4: "Obstetrics & Gynecology",
    surgeonTxt5: "936-273-1600",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Shaker.jpg",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Merlyn Thomas, MD",
    surgeonTxt2: "Kelsey Seybold- Fort Bend Campus",
    surgeonTxt3: "11555 University Blvd., Sugar Land, TX 77478",
    surgeonTxt4: "Obstetrics & Gynecology",
    surgeonTxt5: "713-442-9100",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Thomas.jpg",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Natasha Abdullah, MD",
    surgeonTxt2: "Kelsey-Seybold- Sienna Clinic",
    surgeonTxt3: "7010 Highway 6, Missouri City, TX 77459",
    surgeonTxt4: "Obstetrics & Gynecology",
    surgeonTxt5: "713-442-6700",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Abdullah.jpg",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Nichole Ogojiaku, MD",
    surgeonTxt2: "Hope Clinic Alief",
    surgeonTxt3: "13930 Bellaire Blvd, Houston, TX 77083",
    surgeonTxt4: "Obstetrics & Gynecology",
    surgeonTxt5: "713-773-0803",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Ogojiaku.avif",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Paola Ortiz Rodriguez, MD",
    surgeonTxt2: "Hope Clinic Alief",
    surgeonTxt3: "13930 Bellaire Blvd, Houston, TX 77083",
    surgeonTxt4: "Obstetrics & Gynecology",
    surgeonTxt5: "713-773-0803",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-OrtizRodriguez.jpg",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Romany T. Gawargious Hana, MD",
    surgeonTxt2: "Hope Clinic Alief",
    surgeonTxt3: "13930 Bellaire Blvd, Houston, TX 77083",
    surgeonTxt4: "Obstetrics & Gynecology",
    surgeonTxt5: "713-773-0803",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-GawaH.jpg",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Samatha K. Kadiyala, MD",
    surgeonTxt2: "Brazosport Women's Health P.A.",
    surgeonTxt3: "208 Oak Drive South, Suite 300, Lake Jackson, TX 77566",
    surgeonTxt4: "Obstetrics & Gynecology, Urogynecology, Reconstructive Pelvic Surgery",
    surgeonTxt5: "979-266-9544",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Kadiyala.webp",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Samuel Fekry, MD",
    surgeonTxt2: "Hope Clinic- Aldine",
    surgeonTxt3: "3000 Aldine Mail Route Rd., Building C, Suite #200 Houston, TX 77039",
    surgeonTxt4: "Obstetrics & Gynecology",
    surgeonTxt5: "713-773-0803",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Fekry.jpg",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Samuel Maxwell Adu-Lartey, DO",
    surgeonTxt2: "Houston Spine Institute",
    surgeonTxt3: "705 South Fry Rd, Suite 215, Katy, TX 77450",
    surgeonTxt4: "Spine Surgery, Orthopedic Surgery",
    surgeonTxt5: "(832) 321-4076",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_18.png",
    specialtyType: "Neuro-Spinal",
  },
  {
    surgeonTxt1: "John B. Berry, MD",
    surgeonTxt2: "Baylor St. Luke’s Medical Center",
    surgeonTxt3: "4635 Southwest Fwy, Houston, TX 77027",
    surgeonTxt4: "Neurological Surgery",
    surgeonTxt5: "(713) 796-2101",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_19.png",
    specialtyType: "Neuro-Spinal",
  },
  {
    surgeonTxt1: "Dani Bidros, MD",
    surgeonTxt2: "West Houston Brain and Spine",
    surgeonTxt3: "2222 Greenhouse Road, Suite 1100A, Houston, TX 77084",
    surgeonTxt4: "Neurological Surgery, Neuroscience Services",
    surgeonTxt5: "(281) 529-6264",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_20.png",
    specialtyType: "Neuro-Spinal",
  },
  {
    surgeonTxt1: "Keith A. Kerr, MD",
    surgeonTxt2: "Mischer Neuroscience Associates – Cypress",
    surgeonTxt3: "27700 Northwest Fwy, Suite 360, Cypress, TX 77433",
    surgeonTxt4: "Neurological Surgery, Spine Surgery, Neuroscience Services",
    surgeonTxt5: "(346) 231-6830",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_21.png",
    specialtyType: "Neuro-Spinal",
  },
  {
    surgeonTxt1: "John P. Masciale, M.D.",
    surgeonTxt2: "South Texas Bone and Joint Main Office",
    surgeonTxt3: "5917 Crosstown Expressway SH 286, Corpus Christi, TX 78417",
    surgeonTxt4: "Adult Reconstructive Spine Surgery",
    surgeonTxt5: "(361) 694-0811",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_22.png",
    specialtyType: "Neuro-Spinal",
  },
  {
    surgeonTxt1: "R. Alexander Mohr, MD",
    surgeonTxt2: "Advanced Orthopaedics & Sports Medicine",
    surgeonTxt3: "10425 Huffmeister Rd Ste 320, Houston, TX 77065",
    surgeonTxt4: "Spine Surgery, Orthopedic Surgery",
    surgeonTxt5: "(281) 955-7577",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_23.png",
    specialtyType: "Neuro-Spinal",
  },
  {
    surgeonTxt1: "Neel T. Patel, MD",
    surgeonTxt2: "Center for Minimally Invasive Neurosurgery",
    surgeonTxt3: "1710 West Loop N Fwy, Kingswood, TX 77339",
    surgeonTxt4: "Neurological Surgery, Neurology",
    surgeonTxt5: "(832) 447-7494",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_24.png",
    specialtyType: "Neuro-Spinal",
  },
  {
    surgeonTxt1: "Allison M. Rathmann, DO",
    surgeonTxt2: "Texas Neurosurgical PLLC",
    surgeonTxt3: "400 W. Medical Center Blvd, Suite 245Webster, TX 77598",
    surgeonTxt4: "Pediatric Neurosurgery, Adult Neurosurgeon",
    surgeonTxt5: "(832) 932-5229",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/md_25.png",
    specialtyType: "Neuro-Spinal",
  },
  // UPDATED profile pics
  {
    surgeonTxt1: "Adam I. Lewis, MD",
    surgeonTxt2: "Center for Minimally Invasive Neurosurgery",
    surgeonTxt3: "7121 S Padre Island Drive, Ste 106, Corpus Christi, TX 78412",
    surgeonTxt4: "Neurological Surgery, Spine Surgery",
    surgeonTxt5: "(361) 561-9560",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/N-Lewis.png",
    specialtyType: "Neuro-Spinal",
  },
  {
    surgeonTxt1: "Davin Cordell, MD",
    surgeonTxt2: "Orthopaedic Center of Corpus Christi",
    surgeonTxt3: "6118 Parkway Drive, Corpus Christi, TX 78414",
    surgeonTxt4: "Orthopaedic Surgery, Orthopedic Spine Surgery",
    surgeonTxt5: "(361) 883-2000",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/N-Cordell.avif",
    specialtyType: "Neuro-Spinal",
  },
  {
    surgeonTxt1: "Anthony Owusu II, MD",
    surgeonTxt2: "Next Generation Orthopedic and Spine Institute",
    surgeonTxt3: "200 Valleywood Dr., Ste 300A, The Woodlands, TX 77380",
    surgeonTxt4: "Orthopedic Surgery, Spine Surgery",
    surgeonTxt5: "(832) 402-1400",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/N-Owusu.jpg",
    specialtyType: "Neuro-Spinal",
  },
  {
    surgeonTxt1: "Michael Leahy, MD",
    surgeonTxt2: "Texas Orthopaedic & Sports Medicine - Tomball",
    surgeonTxt3: "13603 Michel Road, Tomball, TX 77375",
    surgeonTxt4: "Orthopaedic Surgery, Spine Surgeon, Sports Medicine",
    surgeonTxt5: "(281) 351-7261",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/N-Leahy.jpg",
    specialtyType: "Neuro-Spinal",
  },

  // NEW entries
  {
    surgeonTxt1: "Andre M. Samuel, MD",
    surgeonTxt2: "Fondren Orthopedic Group – Clear Lake Office",
    surgeonTxt3: "520 Blossom St., Webster, TX 77598",
    surgeonTxt4: "Orthopedic Surgery, Spine Surgery",
    surgeonTxt5: "(281) 332-9537",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/N-Samuel.jpg",
    specialtyType: "Neuro-Spinal",
  },
  {
    surgeonTxt1: "Bonaventure Ngu, MD",
    surgeonTxt2: "Premier Spine Institute",
    surgeonTxt3: "411 Lantern Bend Dr, Suite 100A, Houston, TX 77090",
    surgeonTxt4: "Orthopedic Surgery, Spine Surgery",
    surgeonTxt5: "(281) 719-9505",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/N-Ngu.jpg",
    specialtyType: "Neuro-Spinal",
  },
  {
    surgeonTxt1: "Mathew T. Alexander, MD",
    surgeonTxt2: "South Texas Brain and Spine Center",
    surgeonTxt3: "1227 3rd St, Corpus Christi, TX 78404",
    surgeonTxt4: "Neurological Surgery, Spine Surgery",
    surgeonTxt5: "(361) 883-4323",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/N-Alexander.png",
    specialtyType: "Neuro-Spinal",
  },

  {
    surgeonTxt1: "Lisa M. Haubert, MD",
    surgeonTxt2: "Memorial Hermann Sugar Land",
    surgeonTxt3: "17510 W Grand Pkwy S, Ste 490, Sugar Land, TX 77479",
    surgeonTxt4: "Colon and Rectal Surgery, General Surgery",
    surgeonTxt5: "713-772-1200",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/G-Haubert.jpg",
    specialtyType: "General Surgery",
  },
  {
    surgeonTxt1: "Zhen Fan, MD",
    surgeonTxt2: "Surgical Associates of Houston",
    surgeonTxt3: "1140 Business Center Drive #403, Houston, TX 77043",
    surgeonTxt4: "General Surgery",
    surgeonTxt5: "713-935-9758",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/G-Fan.avif",
    specialtyType: "General Surgery",
  },
  {
    surgeonTxt1: "Tianming Liu, MD",
    surgeonTxt2: "Houston Colon - Med Center",
    surgeonTxt3: "6560 Fannin Street ,Suite 1404, Houston, TX 77030",
    surgeonTxt4: "General Surgery, Colon and Rectal Surgery",
    surgeonTxt5: "713-790-0600",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/G-Liu.jpg",
    specialtyType: "General Surgery",
  },
  {
    surgeonTxt1: "Caroline Kim, MD",
    surgeonTxt2: "Houston Robotic Hernia Surgery",
    surgeonTxt3: "18400 Katy Freeway, Suite 530, Houston, TX 77094",
    surgeonTxt4: "General Surgery",
    surgeonTxt5: "713-464-2100",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/G-Kim.jpeg",
    specialtyType: "General Surgery",
  },
  {
    surgeonTxt1: "Joshua H. Lee, MD",
    surgeonTxt2: "Advanced Orthopaedics Sports Medicine",
    surgeonTxt3: "601 Rockmead Drive, Suite 100, Kingwood, TX 77339",
    surgeonTxt4: "Orthopedic Surgery, Spine Surgery",
    surgeonTxt5: "281-955-7577",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/N-Lee.jpg",
    specialtyType: "Neuro-Spinal",
  },
  {
    surgeonTxt1: "John M. Borkowski, MD",
    surgeonTxt2: "South Texas Bone and Joint",
    surgeonTxt3: "601 Texan Trail, Suite 300, Corpus Christi, TX 78411",
    surgeonTxt4: "Orthopedic Surgery, Orthopedic Spine Surgery, Minimally Invasive Surgery & Innovative Technology",
    surgeonTxt5: "361-854-0811",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/N-Borkowski.jpg",
    specialtyType: "Neuro-Spinal",
  },
  {
    surgeonTxt1: "Kim-Thu Chu, MD",
    surgeonTxt2: "West Houston OBGYN",
    surgeonTxt3: "12606 West Houston Center Blvd, Ste 302, Houston, TX 77082",
    surgeonTxt4: "Obstetrics and Gynecology",
    surgeonTxt5: "713-230-8677",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Chu.jpg",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Reena A. Tharappel-Jacob, MD",
    surgeonTxt2: "Women's Specialists of Sugar Land",
    surgeonTxt3: "16659 Southwest Freeway, Suite 225, Sugar Land, TX 77479",
    surgeonTxt4: "Obstetrics and Gynecology",
    surgeonTxt5: "713-578-3833",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Tharappel-Jacob.jpg",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "David Brinkman, MD",
    surgeonTxt2: "Caritas Women's Care - OBGYN Services",
    surgeonTxt3: "Baylor St. Luke's Medical Group 1327 Lake Pointe Parkway, Suite 500, Sugar Land, TX 77478",
    surgeonTxt4: "Obstetrics and Gynecology, Gynecology, Women's Health",
    surgeonTxt5: "281-637-9095",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Brinkman.jpg",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Nelson Uzquiano, MD",
    surgeonTxt2: "Brookhollow Obstetrics & Gynecology",
    surgeonTxt3: "10109 Louetta Road, Ste 101, Houston, TX 77070",
    surgeonTxt4: "Obstetrics And Gynecology, Gynecology",
    surgeonTxt5: "713-772-4876",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Uzquiano.jpg",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Barbara J. McLaren, MD",
    surgeonTxt2: "New Beginnings OB/GYN",
    surgeonTxt3: "1570 S Dairy Ashford Rd Ste 108, Houston, TX 77077",
    surgeonTxt4: "Obstetrics And Gynecology",
    surgeonTxt5: "281-214-6894",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-McLaren.jpg",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Miriam E. Busch, MD",
    surgeonTxt2: "Tomball Woman's Healthcare Center",
    surgeonTxt3: "13426 Medical Complex Drive, Suite 200, Tomball, TX 77375",
    surgeonTxt4: "Obstetrics and Gynecology",
    surgeonTxt5: "346-534-6318",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Busch.jpg",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "Jamie G. Hernandez, MD",
    surgeonTxt2: "Caritas Women's Care - OBGYN Services - Baylor St. Luke's Medical Group - Sugar Land, TX",
    surgeonTxt3: "1327 Lake Pointe Parkway, Suite 500, Sugar Land, TX 77478",
    surgeonTxt4: "Obstetrics and Gynecology",
    surgeonTxt5: "281-637-9095",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Hernandez.jpg",
    specialtyType: "Obs-Gyn",
  },
  {
    surgeonTxt1: "James Shaw, MD",
    surgeonTxt2: "Orthopedic Specialists of Texas - Webster",
    surgeonTxt3: "450 Medical Center Blvd ,Suite 600B, Webster, TX 77598",
    surgeonTxt4: "Orthopedic Surgery, Spine Surgery",
    surgeonTxt5: "281-316-0121",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Orth-Shaw.jpg",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Dr. Jeffrey R. Schlimmer, MD",
    surgeonTxt2: "The Orthopaedic Center of Corpus Christi",
    surgeonTxt3: "6118 Parkway Drive, Corpus Christi, TX 78414",
    surgeonTxt4: "Orthopedic Surgery, Sports Medicine",
    surgeonTxt5: "361-883-2000",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Orth-Schlimmer.avif",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Kyle F. Dickson, MD, MBA",
    surgeonTxt2: "Southwest Orthopaedic Group",
    surgeonTxt3: "6560 Fannin, Suite 1016, Houston, Texas 77030",
    surgeonTxt4: "Orthopedic Surgery",
    surgeonTxt5: "713-800-1080",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Orth-Dickson.png",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Marilyn E. Copeland, MD",
    surgeonTxt2: "CLS Health",
    surgeonTxt3: "905 W. Medical Center Blvd Ste. 404, Webster, TX 77598",
    surgeonTxt4: "Orthopedic Surgery, Sports Medicine",
    surgeonTxt5: "281-985-9342",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Orth-Copeland.avif",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Venkata Karthik Jonna, MD",
    surgeonTxt2: "Houston Advanced Orthopedics",
    surgeonTxt3: "600 N Kobayashi Rd., Suite 114, Webster, TX 77598",
    surgeonTxt4: "Orthopedic Surgery, Joint Replacement Surgery, Hip and Knee Orthopedic Surgery",
    surgeonTxt5: "281-985-9342",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Orth-Jonna.webp",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Jesus A. Juarez, MD",
    surgeonTxt2: "CLS Health Orthopedics & Sports Medicine Associates- Clear Lake",
    surgeonTxt3: "905 W. Medical Center Blvd Ste 404, Webster, TX 77598",
    surgeonTxt4: "Orthopedic Surgery",
    surgeonTxt5: "281-985-9342",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Orth-Juarez.jpg",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Robert S. Williams, MD",
    surgeonTxt2: "Coastal Orthopedics",
    surgeonTxt3: "5920 Saratoga Boulevard, Suite 600A, Corpus Christi, TX 78414",
    surgeonTxt4: "Orthopedic Surgery, Sports Medicine, Spine Surgery",
    surgeonTxt5: "361-994-1166",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Orth-Williams.webp",
    specialtyType: "Orthopedic",
  },
  {
    surgeonTxt1: "Rohan Kulangara, MD",
    surgeonTxt2: "Memorial Hermann Katy",
    surgeonTxt3: "23920 Katy Fwy, Ste 410, Katy, TX 77494",
    surgeonTxt4: "General Laparoscopic Procedures, Minimally Invasive and Robotic Surgery",
    surgeonTxt5: "713-772-1200",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/R-Kulangara.jpg",
    specialtyType: "Robotic",
  },
  {
    surgeonTxt1: "Philip A. Matorin, MD",
    surgeonTxt2: "West Houston Office",
    surgeonTxt3: "12121 Richmond Avenue, Suite #104, Houston, Texas 77082",
    surgeonTxt4: "Otolaryngology (ENT), Sleep Medicine",
    surgeonTxt5: "281-920-5558",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/R-Matorin.jpg",
    specialtyType: "Robotic",
  },
  {
    surgeonTxt1: "Limael E. Rodriguez, MD",
    surgeonTxt2: "Texas Vascular and Imaging",
    surgeonTxt3: "2500 Fondren Rd #210, Houston, TX, 77063",
    surgeonTxt4: "Vascular Surgery, General Surgery",
    surgeonTxt5: "713-781-5676",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/R-Rodriguez.jpg",
    specialtyType: "Robotic",
  },
  {
    surgeonTxt1: "Steven D. Maislos, MD",
    surgeonTxt2: "Urology Institute of West Houston",
    surgeonTxt3: "5420 Dashwood Street, Ste 210, Houston, TX 77081",
    surgeonTxt4: "Urology, Surgery",
    surgeonTxt5: "713-771-5300",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/R-Maislos.webp",
    specialtyType: "Robotic",
  },

  {
    surgeonTxt1: "Imran T. Mohiuddin, MD",
    surgeonTxt2: "Texas Advanced Surgery Center",
    surgeonTxt3: "6927 Brisbane Ct. STE 100, Sugar Land, TX 77479",
    surgeonTxt4: "Vascular Surgery",
    surgeonTxt5: "281-397-2967",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/CT-Mohiuddin.jpg",
    specialtyType: "Cardio-Thoracic",
  },
  {
    surgeonTxt1: "Kenneth E. Otah, MD",
    surgeonTxt2: "Total Heart Cardiovascular Consultants",
    surgeonTxt3: "138 Eldridge Road, Ste E, Sugar Land, TX 77478",
    surgeonTxt4: "Cardiovascular Diseases, Cardiology, Heart and Vascular Services",
    surgeonTxt5: "281-302-5838",
    surgeonIcon: "/images/specialities/cardiothoracic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/CT-Otah.webp",
    specialtyType: "Cardio-Thoracic",
  },
  {
    surgeonTxt1: "Paul J. James, MD",
    surgeonTxt2: "Metropolitan Houston Surgery Associates",
    surgeonTxt3: "2101 Crawford St. Ste. 304, Houston, TX 77002",
    surgeonTxt4: "General Surgeon",
    surgeonTxt5: "713-659-1728",
    surgeonIcon: "/images/specialities/general/mdLogo.png",
    surgeonImg: "/images/physianDirectory/G-James.webp",
    specialtyType: "General Surgery",
  },

  {
    surgeonTxt1: "Arturo G. Gonzalez, MD",
    surgeonTxt2: "Minimally Invasive & Robotic Surgery",
    surgeonTxt3: "2222 Greenhouse Road, Suite 2000, Houston, TX 77084",
    surgeonTxt4: "General Surgeon",
    surgeonTxt5: "713-864-5487",
    surgeonIcon: "/images/specialities/general/mdLogo.png",
    surgeonImg: "/images/physianDirectory/G-Gonzalez.png",
    specialtyType: "General Surgery",
  },
  {
    surgeonTxt1: "Mark J. Pidala, MD",
    surgeonTxt2: "UT Physicians Colon & Rectal Clinic – Peakwood",
    surgeonTxt3: "800 Peakwood Dr, Ste 2C, Houston, TX 77090",
    surgeonTxt4: "General Surgeon",
    surgeonTxt5: "713-486-4660",
    surgeonIcon: "/images/specialities/general/mdLogo.png",
    surgeonImg: "/images/physianDirectory/G-Pidala.jpg",
    specialtyType: "General Surgery",
  },
  {
    surgeonTxt1: "Desmond A. Brown, MD, PhD",
    surgeonTxt2: "HCA Houston Brain & Spine- North Cypress",
    surgeonTxt3: "21216 Northwest Freeway, Suite 250, Cypress, TX 77429",
    surgeonTxt4: "Neurosurgical Oncology",
    surgeonTxt5: "346-623-3170",
    surgeonIcon: "/images/specialities/neurosurgery/mdLogo.png",
    surgeonImg: "/images/physianDirectory/N-Brown.jpg",
    specialtyType: "Neuro-Spinal",
  },
  {
    surgeonTxt1: "Yan Michael Li, MD, PhD",
    surgeonTxt2: "Minimally Invasive Brain and Spine Institute",
    surgeonTxt3: "7601 W Sam Houston Pkwy S, Suite 300, Houston, TX 77072",
    surgeonTxt4: "Neurosurgeon",
    surgeonTxt5: "713-396-2969",
    surgeonIcon: "/images/specialities/neurosurgery/mdLogo.png",
    surgeonImg: "/images/physianDirectory/N-YanLi.webp",
    specialtyType: "Neuro-Spinal",
  },
  {
    surgeonTxt1: "Gerilynn Salmeron Vine, MD",
    surgeonTxt2: "UT Physicians Family Medicine Texas Medical Center",
    surgeonTxt3: "6410 Fannin St Ste 170, Houston, TX 77030",
    surgeonTxt4: "Obstetrics & Gynecology Surgeon",
    surgeonTxt5: "713-500-4360",
    surgeonIcon: "/images/specialities/obstetrics_gynecology/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Vine.jpg",
    specialtyType: "Obstetrics",
  },
  {
    surgeonTxt1: "Melinda H. Chai, MD",
    surgeonTxt2: "Kelsey-Seybold- Rosenberg Clinic",
    surgeonTxt3: "3915 Kians Way, Richmond, TX 77469",
    surgeonTxt4: "Obstetrics & Gynecology Surgeon",
    surgeonTxt5: "346-674-1200",
    surgeonIcon: "/images/specialities/obstetrics_gynecology/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Chai.jpg",
    specialtyType: "Obstetrics",
  },
  {
    surgeonTxt1: "Pamela Bremer Plancarte, MD",
    surgeonTxt2: "Hope Clinic- Beltway",
    surgeonTxt3: "7001 Corporate Drive, Ste 120, Houston, TX 77036",
    surgeonTxt4: "Obstetrics & Gynecology Surgeon",
    surgeonTxt5: "713-773-0803",
    surgeonIcon: "/images/specialities/obstetrics_gynecology/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-BremerPlancarte.png",
    specialtyType: "Obstetrics",
  },
  {
    surgeonTxt1: "Lauren Jane Tharp, MD",
    surgeonTxt2: "UT Physicians Womens Center Texas Medical Center",
    surgeonTxt3: "6410 Fannin Street, Ste 250, Houston, TX 77030",
    surgeonTxt4: "Obstetrics & Gynecology Surgeon",
    surgeonTxt5: "832-325-7131",
    surgeonIcon: "/images/specialities/obstetrics_gynecology/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Tharp.jpg",
    specialtyType: "Obstetrics",
  },
  {
    surgeonTxt1: "Nefertiti C. DuPont, MD, MPH",
    surgeonTxt2: "North Houston Gynecologic Oncology Surgeons",
    surgeonTxt3: "128 Vision Park Blvd, Ste 280, Shenandoah, TX 77384",
    surgeonTxt4: "Obstetrics & Gynecology Surgeon",
    surgeonTxt5: "936-207-4287",
    surgeonIcon: "/images/specialities/obstetrics_gynecology/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Dupont.avif",
    specialtyType: "Obstetrics",
  },
  {
    surgeonTxt1: "Daisy A. Ayim, MD",
    surgeonTxt2: "Park West Women's Associates",
    surgeonTxt3: "12606 W Houston Ctr Blvd Ste 120, Houston, TX 77082",
    surgeonTxt4: "Obstetrics & Gynecology Surgeon",
    surgeonTxt5: "713-640-5922",
    surgeonIcon: "/images/specialities/obstetrics_gynecology/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Ayim.jpg",
    specialtyType: "Obstetrics",
  },
  {
    surgeonTxt1: "LaKeisha N. Demerson, MD",
    surgeonTxt2: "Bay Area OB/GYN",
    surgeonTxt3: "17 Professional Park Drive, Webster, TX 77598",
    surgeonTxt4: "Obstetrics & Gynecology Surgeon",
    surgeonTxt5: "281-332-9511",
    surgeonIcon: "/images/specialities/obstetrics_gynecology/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Demerson.webp",
    specialtyType: "Obstetrics",
  },
  {
    surgeonTxt1: "Chinyere Ndidi Ohakweh, MD",
    surgeonTxt2: "Legacy Community Health - Southwest",
    surgeonTxt3: "6441 High Star Drive, Houston, TX 77074",
    surgeonTxt4: "Obstetrics & Gynecology Surgeon",
    surgeonTxt5: "832-828-1005",
    surgeonIcon: "/images/specialities/obstetrics_gynecology/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Ohakweh.webp",
    specialtyType: "Obstetrics",
  },
  {
    surgeonTxt1: "Steven S. Dalati, MD",
    surgeonTxt2: "Women's Healthcare Affiliates",
    surgeonTxt3: "9180 Pinecroft Dr., Ste 100, The Woodlands, TX 77380",
    surgeonTxt4: "Obstetrics & Gynecology Surgeon",
    surgeonTxt5: "281-367-6836",
    surgeonIcon: "/images/specialities/obstetrics_gynecology/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Dalati.jpg",
    specialtyType: "Obstetrics",
  },
  {
    surgeonTxt1: "Rita A. Makhlouf, MD",
    surgeonTxt2: "Pediatrix Neonatology of Houston",
    surgeonTxt3: "12141 Richmond Ave, Houston, TX 77082",
    surgeonTxt4: "Neonatologist",
    surgeonTxt5: "(281) 558-3444",
    surgeonIcon: "/images/specialities/obstetrics_gynecology/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Makhlouf.jpg",
    specialtyType: "Obstetrics",
  },
  {
    surgeonTxt1: "Adanna C. Ukazu, MD",
    surgeonTxt2: "New Dawn Wellness and Medical Center",
    surgeonTxt3: "12000 Richmond Ave Ste 221, Houston, TX 77082",
    surgeonTxt4: "Gynecologist",
    surgeonTxt5: "(281) 809-5467",
    surgeonIcon: "/images/specialities/obstetrics_gynecology/mdLogo.png",
    surgeonImg: "/images/physianDirectory/Ob-Ukazu.jpg",
    specialtyType: "Obstetrics",
  },
  {
    surgeonTxt1: "Akashdeep Singh, DPM",
    surgeonTxt2: "Anchor Bone & Joint- Pearland",
    surgeonTxt3: "11555 Magnolia Pkwy, Ste 140, Pearland, TX 77584",
    surgeonTxt4: "Podiatric Surgeon",
    surgeonTxt5: "281-724-8241",
    surgeonIcon: "/images/specialities/robotic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/R-Singh DPM.jpg",
    specialtyType: "Robotic",
  },
  {
    surgeonTxt1: "Peter P. Hinh, MD",
    surgeonTxt2: "Crescent Urology Institute",
    surgeonTxt3: "1200 Binz Street, Ste 690, Houston, TX 77004",
    surgeonTxt4: "Urologist",
    surgeonTxt5: "713-366-7831",
    surgeonIcon: "/images/specialities/robotic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/R-Hinh.webp",
    specialtyType: "Robotic",
  },
  {
    surgeonTxt1: "Anthony N. Hoang, MD",
    surgeonTxt2: "Houston Metro Urology",
    surgeonTxt3: "16605 Southwest Fwy Ste 250, Sugar Land, TX 77479",
    surgeonTxt4: "Urological Surgery",
    surgeonTxt5: "281-325-1090",
    surgeonIcon: "/images/specialities/robotic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/R-Hoang.webp",
    specialtyType: "Robotic",
  },
  {
    surgeonTxt1: "Richard D. Drake, MD",
    surgeonTxt2: "Comprehensive Medical Specialists of Texas",
    surgeonTxt3: "8845 Six Pines Dr, Ste 100, Shenandoah, TX 77380",
    surgeonTxt4: "Gynecological Oncology",
    surgeonTxt5: "281-203-5115",
    surgeonIcon: "/images/specialities/robotic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/R-Drake.jpg",
    specialtyType: "Robotic",
  },
  {
    surgeonTxt1: "Francisco J. Gelpi-Hammerschmidt, MD",
    surgeonTxt2: "Houston Metro Urology",
    surgeonTxt3: "9230 Katy Freeway, Suite 510, Houston, TX 77055",
    surgeonTxt4: "Urologist",
    surgeonTxt5: "713-634-4441",
    surgeonIcon: "/images/specialities/robotic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/R-Gelpi.webp",
    specialtyType: "Robotic",
  },
  {
    surgeonTxt1: "Christopher K. Livingston, MD",
    surgeonTxt2: "Livingston Plastic Surgery",
    surgeonTxt3: "12121 Richmond Ave, Suite 317, Houston, TX 77082",
    surgeonTxt4: "Plastic Surgeon",
    surgeonTxt5: "(281) 501-1812",
    surgeonIcon: "/images/specialities/robotic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/R-Livingston.jpg",
    specialtyType: "Robotic",
  },
  {
    surgeonTxt1: "Thomas M. Loh, MD",
    surgeonTxt2: "Houston Methodist Cardiovascular Surgery Associates",
    surgeonTxt3: "24518 Northwest Freeway, Ste 525, Cypress, TX 77429",
    surgeonTxt4: "Vascular Surgeon",
    surgeonTxt5: "(832) 533-3790",
    surgeonIcon: "/images/specialities/robotic/mdLogo.png",
    surgeonImg: "/images/physianDirectory/R-Loh.jpg",
    specialtyType: "Robotic",
  }
];
export const physiciansData = [

  {
    provider_General_surgery_detail: {
      //video: "/video/LandingPage/dna.mp4",
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "GENERAL SURGERY",
      mdName: "Michael T. Wood, MD, FACS",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },
    generalSurgeryDetailData: {
      //link: "https://www.youtube.com/watch?v=9XyaJCr8-NA",
      title: "GENERAL SURGEONS DELIVER EXPERT, PATIENT-CENTERED CARE WITH A FOCUS ON SAFETY AND OPTIMAL OUTCOMES.",
      contentTop: "Here in the United States, General Surgeons perform an average of 23 different types of surgeries with the range being from 1 to 73 different operations, so the surgical team must always stay up to date on procedures and knowledge. General surgery often sets the standard of surgical care in the community due to the extensive range of surgeries they must perform. Each day is not like the day before, so the surgical team must always remain sharp throughout the care of each patient during their procedure.",
      slope: true,
      intoImgData: "/images/providers/genralSurgeryFrame.png",
    },
    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_1.jpg",
      title: "GENERAL SURGEON",
      mdcontent:
        "Michael T. Wood, MD, FACS, is a skilled general surgeon at Southwest Surgical Associates. He sees patients from the practice’s office locations in Sugar Land and Houston, Texas.",
      mdname: "MICHAEL T. WOOD, MD, FAC",
    },

    id: "michael-t-wood",
    name: "Michael T. Wood, MD, FACS",
    image: "/images/doctors/michael-wood.jpg",
    phone: "713-772-1200",
    gender: "Male",
    language: "English",
    specialty: "Laparoscopic General Surgery",
    degrees: ["Doctor of Medicine Bachelor of Arts, Biology"],
    clinics: [
      {
        name: "Memorial Hermann Southwest",
        address: "7600 Beechnut St, Houston, TX 77074",
        phone: "(713) 456-5000",
      },
      {
        name: "Methodist Sugar Land",
        address: "16655 Southwest Fwy, Sugar Land, TX 77479",
        phone: "(281) 274-7000",
      },
      {
        name: "Memorial Hermann Sugar Land",
        address: "17500 West Grand Parkway South, Sugar Land, TX 77479",
        phone: "(281) 725-5000",
      },
    ],
    bio_name: "About Dr. Wood",
    bio: `
        Michael T. Wood, MD, FACS, is a skilled general surgeon at Southwest Surgical Associates. He sees patients from the practice’s office
        locations in Sugar Land and Houston, Texas. A native of the Houston area, Dr. Wood attended The Kinkaid School before completing his
        Bachelor of Arts at Rice University. He obtained his Medical Degree at the University of Texas-Houston.
      </br></br>
        Dr. Wood’s interest in business motivated him to return to Rice University for his MBA. His advanced degree made him perfect for the
        role of managing partner of Southwest Surgical Associates, a position he currently holds in addition to continuing with his surgical
        practice. He specializes in minimally invasive laparoscopic general surgery and is committed to providing his patients with the most
        state-of-the-art surgical care.
      </br></br>
        He and his wife Amy, also a physician, have three lovely children. When he’s not in the office, Dr. Wood enjoys traveling and spending
        time with his family.
      `,
    education: ["Bachelor of Arts at Rice University", "Medical Degree at the University of Texas–Houston", "MBA from Rice University"],
    areasOfExpertise: ` <ul>
    <li>Hernia Repair</li>
    <li>Gallbladder Disease</li>
    <li>Appendicitis</li>
    <li>Reflux Surgery</li>
  </ul>
  <ul>
    <li>Breast Disease/Cancer</li>
    <li>Colon Disease/Cancer</li>
    <li>Hemorrhoids</li>
    <li>Skin Lesions/Masses/Cysts</li>
  </ul>`,
    generalSurgeryDetaillinkData: {
      // link: "https://youtu.be/ASiloDyp0s4?si=kTP7SrttHk7NjvKr",
      // link: "https://www.youtube.com/embed/ASiloDyp0s4",
      link: "https://www.youtube.com/embed/FfNfde_u-ko",
      title: "GENERAL SURGERY",
      contentTop: "General surgeons focus on organs within the abdominal cavity, including the stomach and colon. Many surgeons specialize in specific conditions or areas of the body. For example, vascular surgeons treat problems arising in the blood vessels, cardiac surgeons perform open surgeries on the heart, orthopedic surgeons treat the joints and bones, and neurosurgeons treat brain and spinal cord diseases.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      // video: "/video/LandingPage/dna.mp4",
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "GENERAL SURGERY",
      mdName: "John Abdelsayed, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    generalSurgeryDetailData: {
      // link: "https://www.youtube.com/watch?v=9XyaJCr8-NA",
      title: "GENERAL SURGEONS DELIVER EXPERT, PATIENT-CENTERED CARE WITH A FOCUS ON SAFETY AND OPTIMAL OUTCOMES.",
      contentTop: "Here in the United States, General Surgeons perform an average of 23 different types of surgeries with the range being from 1 to 73 different operations, so the surgical team must always stay up to date on procedures and knowledge. General surgery often sets the standard of surgical care in the community due to the extensive range of surgeries they must perform. Each day is not like the day before, so the surgical team must always remain sharp throughout the care of each patient during their procedure.",
      slope: true,
      intoImgData: "/images/providers/genralSurgeryFrame.png",
    },

    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_2.png",
      title: "GENERAL AND COLORECTAL SURGEON",
      mdcontent:
        "John Abdelsayed, MD, is an experienced general and colorectal surgeon at Southwest Surgical Associates. Specializing in robotic surgery and the treatment of cancer and gallbladder disease, he is proud to care for patients in Sugar Land, Texas, and throughout the greater Houston area.",
      mdname: "JOHN ABDELSAYED, MD",
    },

    id: "john-abdelsayed",
    name: "John Abdelsayed, MD",
    image: "/images/doctors/john-abdelsayed.jpg",
    phone: "713-772-1200",
    gender: "Male",
    language: "English, Conversational Arabic",
    specialty: "Colon and Rectal Surgery",

    degrees: ["Doctor of Medicine"],

    clinics: [
      {
        name: "Memorial Hermann Southwest",
        address: "7600 Beechnut St, Houston, TX 77074",
        phone: "(713) 456-5000",
      },
      {
        name: "Methodist Sugar Land",
        address: "16655 Southwest Fwy, Sugar Land, TX 77479",
        phone: "(281) 274-7000",
      },
      {
        name: "Memorial Hermann Sugar Land",
        address: "17500 West Grand Parkway South, Sugar Land, TX 77479",
        phone: "(281) 725-5000",
      },
    ],

    bio_name: "About Dr. Abdelsayed",
    bio: `
        John Abdelsayed, MD, is an experienced general and colorectal surgeon at Southwest Surgical Associates.
        Specializing in robotic surgery and the treatment of cancer and gallbladder disease, he is proud to care for
        patients in Sugar Land, Texas, and throughout the greater Houston area.
      </br></br>
        Dr. Abdelsayed is a true Texas native. He was born and raised in Houston and started his medical education at
        the University of Texas Medical School at Houston. He then went on and completed his General Surgery training
        at the University of Texas Southwestern Medical Center in Dallas. During this time, he was inducted into the
        Alpha Omega Alpha Medical honor society and also selected to receive the Gold Humanism Award, which recognizes physicians who serve as role models, mentors, and leaders in medicine.
        </br></br>
        After his General Surgery training, Dr. Abdelsayed spent a year specializing in colon and rectal surgery at UT
        Southwestern & Presbyterian Hospital in Dallas, Texas. Here he learned the latest techniques in robotic
        surgery, trans-anal cancer resection, and minimally invasive surgery. He is an expert in treating colon and
        rectal cancer, inflammatory bowel disease, and anorectal disorders.
        </br></br>
        Dr. Abdelsayed is described by his colleagues as the doctor they would want to take care of their own family.
        He relocated to Houston to be closer to home. He enjoys spending time with his wife and puppy, watching Houston professional sporting events, and traveling the world when able.`,

    education: ["University of Texas Medical School at Houston", "University of Texas Southwestern Medical Center in Dallas"],

    areasOfExpertise: `<ul>
        <li>General Surgery/Cancer</li>
        <li>Colon & Rectal Surgery</li>
        <li>Gallbladder Disease</li>
        <li>Robotic Surgery</li>
      </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/37187126_xl.jpg",
      // (This page shows a banner section rather than an embedded video; keep copy consistent)
      title: "GENERAL SURGERY",
      contentTop: "General surgeons focus on organs within the abdominal cavity, including the stomach and colon. Many surgeons specialize in specific conditions or areas of the body. For example, vascular surgeons treat problems arising in the blood vessels, cardiac surgeons perform open surgeries on the heart, orthopedic surgeons treat the joints and bones, and neurosurgeons treat brain and spinal cord diseases.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      // video: "/video/LandingPage/dna.mp4",
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "GENERAL SURGERY",
      mdName: "Charles J. Aramburo, MD, FACS",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    generalSurgeryDetailData: {
      title: "GENERAL SURGEONS DELIVER EXPERT, PATIENT-CENTERED CARE WITH A FOCUS ON SAFETY AND OPTIMAL OUTCOMES.",
      contentTop: "Here in the United States, General Surgeons perform an average of 23 different types of surgeries with the range being from 1 to 73 different operations, so the surgical team must always stay up to date on procedures and knowledge. General surgery often sets the standard of surgical care in the community due to the extensive range of surgeries they must perform. Each day is not like the day before, so the surgical team must always remain sharp throughout the care of each patient during their procedure.",
      slope: true,
      intoImgData: "/images/providers/genralSurgeryFrame.png",
    },

    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_3.png",
      title: "GENERAL SURGEON",
      mdcontent:
        "Charles J. Aramburo, MD, FACS, practices general surgery in the Houston and Sugar Land, Texas, offices of Southwest Surgical Associates. He is skilled in the surgical treatment of a wide range of conditions and specializes in advanced laparoscopic surgery, gastrointestinal surgery, and hernia surgery.",
      mdname: "CHARLES J. ARAMBURO, MD, FACS",
    },

    id: "charles-j-aramburo",
    name: "Charles J. Aramburo, MD, FACS",
    image: "/images/doctors/charles-aramburo.jpg",
    phone: "713-772-1200",
    gender: "Male",
    language: "English",
    specialty: "Advanced Laparoscopic Surgery, Gastrointestinal Surgery, Hernia Surgery",

    degrees: ["Doctor of Medicine Degree", "Bachelor of Science Degree, Biology Major/Chemistry Minor"],

    clinics: [
      {
        name: "Memorial Hermann Southwest",
        address: "7600 Beechnut St, Houston, TX 77074",
        phone: "(713) 456-5000",
      },
      {
        name: "Methodist Sugar Land",
        address: "16655 Southwest Fwy, Sugar Land, TX 77479",
        phone: "(281) 274-7000",
      },
      {
        name: "Memorial Hermann Sugar Land",
        address: "17500 West Grand Parkway South, Sugar Land, TX 77479",
        phone: "(281) 725-5000",
      },
    ],

    bio_name: "About Dr. Charles J. Aramburo",
    bio: `
        Charles J. Aramburo, MD, FACS, practices general surgery in the Houston and Sugar Land, Texas, offices of Southwest Surgical Associates.
        He is skilled in the surgical treatment of a wide range of conditions and specializes in advanced laparoscopic surgery, gastrointestinal
        surgery, and hernia surgery.
        </br></br>
        A native of Louisiana, Dr. Aramburo graduated medical school from Meharry Medical College in Tennessee. He completed a residency at the
        University of Texas Medical Branch in Galveston along with an additional fellowship at Baylor College of Medicine, focusing on minimally
        invasive laparoscopic surgery.
        </br></br>
        Dr. Aramburo prides himself on excellence in patient care. He is a Fellow of the American College of Surgeons and board-certified by the
        American Board of Surgery. He also maintains membership with multiple professional organizations, including the Texas Medical Association
        and the Harris County Medical Society.`,

    education: [
      "Meharry Medical College in Tennessee",
      "University of Texas Medical Branch in Galveston",
      "Fellowship at Baylor College of Medicine",
    ],

    areasOfExpertise: `<ul>
        <li>Breast Disease/Cancer</li>
        <li>Appendicitis</li>
        <li>Gallbladder Disease</li>
        <li>Colon Disease/Cancer</li>
        <li>Hemorrhoids</li>
        <li>Hernia Repair</li>
      </ul>
      <ul>
        <li>Reflux Surgery</li>
        <li>Thyroid/Parathyroid Disease/Cancer</li>
        <li>Pancreatic Disease/Cancer</li>
        <li>Skin Lesions/Masses/Cysts</li>
        <li>GI Tract Surgery</li>
        <li>Laparoscopic Surgery</li>
      </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/37187126_xl.jpg",
      title: "GENERAL SURGERY",
      contentTop: "General surgeons focus on organs within the abdominal cavity, including the stomach and colon. Many surgeons specialize in specific conditions or areas of the body. For example, vascular surgeons treat problems arising in the blood vessels, cardiac surgeons perform open surgeries on the heart, orthopedic surgeons treat the joints and bones, and neurosurgeons treat brain and spinal cord diseases.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "GENERAL SURGERY",
      mdName: "Bidhan Das, MD, FASCRS",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    generalSurgeryDetailData: {
      title: "GENERAL SURGEONS DELIVER EXPERT, PATIENT-CENTERED CARE WITH A FOCUS ON SAFETY AND OPTIMAL OUTCOMES.",
      contentTop: "Here in the United States, General Surgeons perform an average of 23 different types of surgeries with the range being from 1 to 73 different operations, so the surgical team must always stay up to date on procedures and knowledge. General surgery often sets the standard of surgical care in the community due to the extensive range of surgeries they must perform. Each day is not like the day before, so the surgical team must always remain sharp throughout the care of each patient during their procedure.",
      slope: true,
      intoImgData: "/images/providers/genralSurgeryFrame.png",
    },

    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_4.png",
      title: "COLORECTAL SURGEON",
      mdcontent:
        "Dr. Bidhan Das is an internationally recognized colorectal surgeon in Houston, Texas, known for his expertise, innovation, and patient-centered approach to care. As a member of Southwest Surgical Associates, Dr. Das combines extensive experience with a commitment to providing the highest standard of treatment for every patient.",
      mdname: "BIDHAN DAS, MD, FASCRS",
    },

    id: "bidhan-das",
    name: "Bidhan Das, MD, FASCRS",
    image: "/images/doctors/bidhan-das.jpg",
    phone: "713-772-1200",
    gender: "Male",
    language: "English",
    specialty: "Colon and Rectal Surgery",

    degrees: ["Bachelors Degree - Rice University, graduating Summa Cum Laude", "Medical Degree - Yale University School of Medicine"],

    clinics: [
      {
        name: "Medical Center – Museum Medical Tower",
        address: "1213 Hermann Dr, Suite 540, Houston, TX 77004",
        phone: "(832) 900-7698",
      },
      {
        name: "Memorial Hermann Southwest",
        address: "7737 Southwest Freeway, Suite 570, Houston, TX 77074",
        phone: "(281) 222-2222",
      },
      {
        name: "Methodist Sugar Land",
        address: "16655 Southwest Fwy, Sugar Land, TX 77479",
        phone: "(281) 704-7000",
      },
      {
        name: "North Houston 1960/45",
        address: "275 Lantern Bend Dr, Suite 200, Houston, TX 77090",
        phone: "(281) 440-0810",
      },
      {
        name: "Gastro Health & Nutrition – Victoria",
        address: "6016 Nursery Dr #201, Victoria, TX 77904",
        phone: "(361) 485-2495",
      },
    ],

    bio_name: "About Dr. Bidhan Das",
    bio: `
        Dr. Das began his distinguished medical journey at the Yale University School of Medicine, where his academic excellence earned him the Howard Hughes Fellowship—a recognition of his potential in advancing medical research. He further honed his surgical skills during his residency at Harvard Medical School under the mentorship of the esteemed Dr. David Rattner. These experiences instilled in Dr. Das a deep respect for both the science and art of surgery, shaping his approach to providing compassionate, evidence-based care.
        </br></br>
      Throughout his career, Dr. Das has been at the forefront of colorectal surgery, pioneering numerous advancements in the field. He was instrumental in introducing enhanced recovery after surgery (ERAS) pathways in Houston, significantly improving patient outcomes and reducing recovery times. His expertise spans a wide range of procedures, including minimally invasive surgery, advanced colonoscopic techniques, screening colonoscopy, and the management of anorectal conditions such as anal fistula and hemorrhoidal disease. Dr. Das’s dedication to excellence ensures that his patients receive comprehensive care tailored to their specific needs.
      </br></br>
      In addition to his clinical practice, Dr. Das has made significant contributions to the medical community. He co-founded the Daniel Lehane Colon and Rectal Cancer Tumor Board at Houston Methodist Hospital with Dr. Alexandria Phan. This multidisciplinary board focuses on providing collaborative, patient-centered care for those with complex colorectal cancers. Dr. Das also established the first Colon and Rectal Surgeon Center of Excellence for InterStim Sacral Neuromodulation, a groundbreaking treatment for fecal incontinence that greatly enhances the quality of life for affected patients.
      </br></br>
      Dr. Das is also recognized for his pioneering work in transgender surgical care. He single-handedly created the Colorectal Surgical arm of the Center for Transgender Medicine, providing specialized, affirming care for transgender patients. His work in this area underscores his commitment to inclusivity and his belief that every patient deserves compassionate, personalized care.
      </br></br>
      Beyond his direct patient care, Dr. Das is an influential voice in colorectal surgery through his role as the host of “GUT CHECK,” a national podcast sponsored by the American Society of Colon and Rectal Surgeons (ASCRS). Through the podcast, he engages with fellow experts to discuss the latest advancements in the field, sharing knowledge that benefits both his peers and his patients.
      </br></br>
      At the core of Dr. Das’s practice is a focus on partnership with his patients. He believes that the best outcomes are achieved when patients are well-informed and actively involved in their care decisions. By listening, educating, and guiding his patients through every step of their treatment, Dr. Das ensures that they receive not only the best medical care but also the support and respect they deserve.
      `,

    education: [
      "Rice University, Houston, Texas",
      "Yale University School of Medicine – Medical Degree",
      "Residency at Harvard Medical School – Boston, MA",
      "Residency at Massachusetts General Hospital",
      "Transplantation Biology Research Center",
      "Howard Hughes Medical Institute Research Fellow",
    ],

    areasOfExpertise: `<ul>
        <li>Colon Disease/Cancer</li>
        <li>Anal Fissures</li>
        <li>Bowel resection</li>
        <li>Colon resection</li>
      </ul>
      <ul>
        <li>Pilonidal Cysts</li>
        <li>Rectal Bleeding</li>
        <li>Hemorrhoids</li>
        <li>Laparoscopic Surgery</li>
      </ul>`,

    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=OUWu1wI8614",
      title: "GENERAL SURGERY",
      contentTop: "General surgeons focus on organs within the abdominal cavity, including the stomach and colon. Many surgeons specialize in specific conditions or areas of the body. For example, vascular surgeons treat problems arising in the blood vessels, cardiac surgeons perform open surgeries on the heart, orthopedic surgeons treat the joints and bones, and neurosurgeons treat brain and spinal cord diseases.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "GENERAL SURGERY",
      mdName: "Kelly S. Dempsey, MD, FACS",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    generalSurgeryDetailData: {
      title: "GENERAL SURGEONS DELIVER EXPERT, PATIENT-CENTERED CARE WITH A FOCUS ON SAFETY AND OPTIMAL OUTCOMES.",
      contentTop: "Here in the United States, General Surgeons perform an average of 23 different types of surgeries with the range being from 1 to 73 different operations, so the surgical team must always stay up to date on procedures and knowledge. General surgery often sets the standard of surgical care in the community due to the extensive range of surgeries they must perform. Each day is not like the day before, so the surgical team must always remain sharp throughout the care of each patient during their procedure.",
      slope: true,
      intoImgData: "/images/providers/genralSurgeryFrame.png",
    },

    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/MDDetails/kelly.png",
      title: "BREAST SURGEON",
      mdcontent:
        "Kelly S. Dempsey, MD, FACS, is a breast cancer surgeon on the team at Southwest Surgical Associates. She is committed to providing superior care to women in Sugar Land, Texas, and throughout the greater Houston area.",
      mdname: "KELLY S. DEMPSEY, MD, FACS",
    },

    id: "kelly-s-dempsey",
    name: "KELLY S. DEMPSEY, MD, FACS",
    image: "/images/doctors/kelly-dempsey.jpg",
    phone: "713-772-1200",
    gender: "Female",
    language: "English",
    specialty: "Breast Disease/Cancer",

    degrees: ["Doctor of Medicine B. S. Chemical Engineering, Cum Laude"],

    clinics: [
      {
        name: "Methodist Sugar Land",
        address: "16655 Southwest Fwy, Sugar Land, TX 77479",
        phone: "(281) 274-7000",
      },
      {
        name: "Memorial Hermann Southwest",
        address: "17500 W Grand Pkwy S, Suite 430, Sugar Land, TX 77479",
        phone: "(281) 725-5000",
      },
    ],

    bio_name: "About Dr. Dempsey",
    bio: `
    Kelly S. Dempsey, MD, FACS, is a breast cancer surgeon on the team at Southwest Surgical Associates. She is committed to providing superior care to women in Sugar Land, Texas, and throughout the greater Houston area. </br></br> Dr. Dempsey is a native of Louisiana and earned her Bachelor of Science degree at Newcomb-Tulane College in New Orleans. She went on to earn her Doctor of Medicine Degree from LSU School of Medicine and completed a residency at the University of Texas at Houston. She also completed a Craniofacial Research Fellowship at the same institution.  </br></br>Dr. Dempsey has dedicated her career to women’s breast health issues and breast surgery. She specializes in minimally invasive biopsy techniques, partial breast irradiation, and breast-conserving therapy when appropriate. Dr. Dempsey is also a specialist in oncoplastic breast surgery, which combines cancer treatment and cosmetic outcomes.    </br></br> She leads a very busy life between caring for her patients and spending time with her family.  </br> </br> Dr. Kelly Dempsey speaks on the local news about male breast cancer. Watch here</br></br>`,

    education: [
      "Bachelor of Science degree at Newcomb-Tulane College in New Orleans",
      "Doctor of Medicine Degree from LSU School of Medicine",
      "Residency at the University of Texas at Houston",
    ],

    areasOfExpertise: `<ul>
        <li>Breast Disease/Cancer</li>
      </ul>`,

    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=MtbGMBMf19s",
      // link: "https://www.click2houston.com/news/local/2022/10/06/breast-cancer-awareness-heres-what-men-should-know/",
      // introImg:'/images/MDDetails/frame10.jpg',
      title: "GENERAL SURGERY",
      contentTop: "General surgeons focus on organs within the abdominal cavity, including the stomach and colon. Many surgeons specialize in specific conditions or areas of the body. For example, vascular surgeons treat problems arising in the blood vessels, cardiac surgeons perform open surgeries on the heart, orthopedic surgeons treat the joints and bones, and neurosurgeons treat brain and spinal cord diseases.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "GENERAL SURGERY",
      mdName: "John D. Fisher, MD, FACS",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    generalSurgeryDetailData: {
      title: "GENERAL SURGEONS DELIVER EXPERT, PATIENT-CENTERED CARE WITH A FOCUS ON SAFETY AND OPTIMAL OUTCOMES.",
      contentTop: "Here in the United States, General Surgeons perform an average of 23 different types of surgeries with the range being from 1 to 73 different operations, so the surgical team must always stay up to date on procedures and knowledge. General surgery often sets the standard of surgical care in the community due to the extensive range of surgeries they must perform. Each day is not like the day before, so the surgical team must always remain sharp throughout the care of each patient during their procedure.",
      slope: true,
      intoImgData: "/images/providers/genralSurgeryFrame.png",
    },

    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_6.png",
      title: "GENERAL SURGEON",
      mdcontent:
        "Dr. John D. Fisher, MD, FACS, practices general surgery in the Houston and Sugar Land, Texas, offices of Southwest Surgical Associates. He is one of the founding partners of the practice. Dr. Fisher has been practicing in the region as a general surgeon for over 15 years.",
      mdname: "JOHN D. FISHER, MD, FACS",
    },

    id: "john-d-fisher",
    name: "JOHN D. FISHER, MD, FACS",
    image: "/images/doctors/john-fisher.jpg",
    phone: "713-772-1200",
    gender: "Male",
    language: "English, Spanish",
    specialty: "General Surgery and Advanced Laparoscopic Surgery",

    degrees: ["Doctor of Medicine", "Bachelor of Science in Chemical Engineering, Cum Laude"],

    clinics: [
      {
        name: "Memorial Hermann Sugar Land",
        address: "17500 W Grand Parkway South, Sugar Land, TX 77479",
        phone: "(281) 725-5000",
      },
      {
        name: "Methodist Sugar Land",
        address: "16655 Southwest Fwy, Sugar Land, TX 77479",
        phone: "(281) 274-7000",
      },
      {
        name: "Memorial Hermann Southwest",
        address: "7600 Beechnut St, Houston, TX 77074",
        phone: "(713) 456-5000",
      },
    ],

    bio_name: "About Dr. Fisher",
    bio: `Dr. John D. Fisher, MD, FACS, practices general surgery in the Houston and Sugar Land, Texas, offices of Southwest Surgical Associates. <br /><br />He is one of the founding partners of the practice. Dr. Fisher has been practicing in the region as a general surgeon for over 15 years. <br /><br />
    He specializes in general surgery and performs advanced laparoscopic procedures to reduce pain and recovery time. He is highly skilled in the areas of breast disease and cancer, appendicitis, gallbladder disease, colon disease and cancer, hemorrhoids, hernia repair, thyroid and parathyroid disease and cancer, skin lesions, masses, and cysts.<br /><br />
    A native of Houston, Dr. Fisher completed a residency at the Baylor College of Medicine (BCM) in Houston. He achieved a Doctor of Medicine at the University of Texas Medical School at Houston (UT Health) after completing his Bachelor of Science in Chemical Engineering and graduating Cum Laude from Tulane University, New Orleans, Louisiana.<br /><br />
    Dr. Fisher enjoys teaching and mentoring others in the field. He serves as a Clinical Instructor at the Department of Surgery.<br /><br />
    He is a fellow at the American College of Surgeons (ACS) and a member of the American Society of General Surgeons (ASGS), American Society of Abdominal Surgeons (ASAS), Texas Medical Association (TMA), Houston Surgical Society, and SAGES- Society of American Gastrointestinal and Endoscopic Surgeons.<br /><br />
    When not fulfilling a lifelong goal of caring for patients, Dr. Fisher enjoys art and traveling.`,

    education: [
      "Bachelor of Science in Chemical Engineering, Cum Laude from Tulane University, New Orleans, Louisiana",
      "Doctor of Medicine at the University of Texas Medical School at Houston (UT Health)",
      "Completed residency at the Baylor College of Medicine (BCM) in Houston",
    ],

    areasOfExpertise: `<ul>
        <li>Breast Disease/Cancer</li>
        <li>Appendicitis</li>
        <li>Gallbladder Disease</li>
        <li>Colon Disease/Cancer</li>
      </ul>
      <ul>
        <li>Hemorrhoids</li>
        <li>Hernia Repair</li>
        <li>Thyroid/Parathyroid Disease/Cancer</li>
        <li>Skin Lesions/Masses/Cysts</li>
      </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/37187126_xl.jpg",
      title: "GENERAL SURGERY",
      contentTop: "General surgeons focus on organs within the abdominal cavity, including the stomach and colon. Many surgeons specialize in specific conditions or areas of the body. For example, vascular surgeons treat problems arising in the blood vessels, cardiac surgeons perform open surgeries on the heart, orthopedic surgeons treat the joints and bones, and neurosurgeons treat brain and spinal cord diseases.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "GENERAL SURGERY",
      mdName: "Guillermo Ponce de Leon, MD, FACS",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    generalSurgeryDetailData: {
      title: "GENERAL SURGEONS DELIVER EXPERT, PATIENT-CENTERED CARE WITH A FOCUS ON SAFETY AND OPTIMAL OUTCOMES.",
      contentTop: "Here in the United States, General Surgeons perform an average of 23 different types of surgeries with the range being from 1 to 73 different operations, so the surgical team must always stay up to date on procedures and knowledge. General surgery often sets the standard of surgical care in the community due to the extensive range of surgeries they must perform. Each day is not like the day before, so the surgical team must always remain sharp throughout the care of each patient during their procedure.",
      slope: true,
      intoImgData: "/images/providers/genralSurgeryFrame.png",
    },

    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_7.png",
      title: "GENERAL AND BARIATRIC SURGEON",
      mdcontent:
        "Guillermo Ponce de Leon, MD, FACS, is a skilled general and bariatric surgeon at Southwest Surgical Associates. He is proud to serve patients in Sugar Land, Texas, and throughout the greater Houston area.",
      mdname: "GUILLERMO PONCE DE LEON, MD, FACS",
    },

    id: "guillermo-ponce-de-leon",
    name: "GUILLERMO PONCE DE LEON, MD, FACS",
    image: "/images/doctors/guillermo-ponce-de-leon.jpg",
    phone: "713-772-1200",
    gender: "Male",
    language: "English, Spanish",
    specialty: "General Surgery, Bariatric Surgery",

    degrees: ["Doctor of Medicine Bachelor of Science, Biochemistry"],

    clinics: [
      {
        name: "Memorial Hermann Southwest",
        address: "7600 Beechnut St, Houston, TX 77074",
        phone: "(713) 456-5000",
      },
      {
        name: "Methodist Sugar Land",
        address: "16655 Southwest Fwy, Sugar Land, TX 77479",
        phone: "(281) 274-7000",
      },
      {
        name: "Memorial Hermann Sugar Land",
        address: "17500 West Grand Parkway South, Sugar Land, TX 77479",
        phone: "(281) 725-5000",
      },
    ],

    bio_name: "About Dr. Ponce de Leon",
    bio: `Guillermo Ponce de Leon, MD, FACS, is a skilled general and bariatric surgeon at Southwest Surgical Associates. He is proud to serve patients in Sugar Land, Texas, and throughout the greater Houston area.</br></br>
    Dr. Ponce de Leon, a native of Cuba, earned his Bachelor of Biochemistry at Houston Baptist University in Texas. He then moved on to medical school at the University of Texas at Houston, completing a transitional internship and earning his doctorate in medicine. For his residency, Dr. Ponce de Leon moved to Dallas, Texas, where he completed his general surgery training at Baylor University Medical Center. </br></br>
    Dr. Ponce de Leon is a pioneer in advanced laparoscopic general surgery, recently performing the first, single-incision adrenalectomy in Texas. He specializes in bariatric surgery, including lap band. Recently certified to perform a new robotic surgery called the da Vinci® procedure, Dr. Ponce de Leon continues to stay on the cutting-edge of medical advancements. Being a constant learner helps Dr. Ponce de Leon achieve his goal of providing the best possible care to each of his patients. </br></br>
    Dr. Ponce de Leon is a fluent Spanish speaker and stays active in the Hispanic community. In his spare time, he enjoys fishing and spending time with his family.`,

    education: [
      "Bachelor of Biochemistry at Houston Baptist University in Texas",
      "Medical School at the University of Texas at Houston",
      "General Surgery Residency training at Baylor University Medical Center",
    ],

    areasOfExpertise: `<ul>
        <li>Appendicitis</li>
        <li>Gallbladder Disease</li>
        <li>Hernia Repair</li>
        <li>Weight Loss Surgery</li>
        <li>Colon Disease/Cancer</li>
        <li>Hemorrhoids</li>
        <li>Breast Disease/Cancer</li>
      </ul>
      <ul>
        <li>Reflux Surgery</li>
        <li>Thyroid/Parathyroid Disease/Cancer</li>
        <li>Pancreatic Disease/Cancer</li>
        <li>Skin Lesions/Masses/Cysts</li>
        <li>Laparoscopic Surgery</li>
        <li>Robotic Surgery</li>
        <li>Spinal exposure for anterior lumbar interbody fusion (ALIF)</li>
      </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/37187126_xl.jpg",
      title: "GENERAL SURGERY",
      contentTop: "General surgeons focus on organs within the abdominal cavity, including the stomach and colon. Many surgeons specialize in specific conditions or areas of the body. For example, vascular surgeons treat problems arising in the blood vessels, cardiac surgeons perform open surgeries on the heart, orthopedic surgeons treat the joints and bones, and neurosurgeons treat brain and spinal cord diseases.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "GENERAL SURGERY",
      mdName: "Robert M. Shirley, MD, FACS",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    generalSurgeryDetailData: {
      title: "GENERAL SURGEONS DELIVER EXPERT, PATIENT-CENTERED CARE WITH A FOCUS ON SAFETY AND OPTIMAL OUTCOMES.",
      contentTop: "Here in the United States, General Surgeons perform an average of 23 different types of surgeries with the range being from 1 to 73 different operations, so the surgical team must always stay up to date on procedures and knowledge. General surgery often sets the standard of surgical care in the community due to the extensive range of surgeries they must perform. Each day is not like the day before, so the surgical team must always remain sharp throughout the care of each patient during their procedure.",
      slope: true,
      intoImgData: "/images/providers/genralSurgeryFrame.png",
    },

    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_8.png",
      title: "GENERAL SURGEON",
      mdcontent:
        "Robert M. Shirley, MD, FACS, is a native of Oklahoma. He works as a general surgeon for Southwest Surgical Associates, serving patients in Sugar Land, Texas, and throughout the greater Houston area.",
      mdname: "ROBERT M. SHIRLEY, MD, FACS",
    },

    id: "robert-m-shirley",
    name: "ROBERT M. SHIRLEY, MD, FACS",
    image: "/images/doctors/robert-shirley.jpg",
    phone: "713-772-1200",
    gender: "Male",
    language: "English, Spanish",
    specialty: "General, Laparoscopic, and Robotic Surgeries",

    degrees: ["Doctor of Medicine", "Bachelor of Science, Biochemistry"],

    clinics: [
      {
        name: "Memorial Hermann Sugar Land",
        address: "17500 West Grand Parkway South, Sugar Land, TX 77479",
        phone: "(281) 725-5000",
      },
      {
        name: "Methodist Sugar Land",
        address: "16655 Southwest Fwy, Sugar Land, TX 77479",
        phone: "(281) 274-7000",
      },
    ],

    bio_name: "About Dr. Shirley",
    bio: `Robert M. Shirley, MD, FACS, is a native of Oklahoma. He works as a general surgeon for Southwest Surgical Associates, serving patients in Sugar Land, Texas, and throughout the greater Houston area. </br></br>
    Dr. Shirley attended medical school at Texas Tech University in Lubbock, Texas, and completed his general surgery residency at the University of Kentucky in Louisville. </br></br>
    He and his wife, Heather, moved to the East Texas area, where he enjoyed a successful surgical practice for nine years. They then relocated to the coast to be closer to family and were drawn to the Sugar Land/Richmond/Rosenberg area because of the community’s friendliness and the vast array of amenities that the region has to offer.</br></br>
    Dr. Shirley wanted to be a surgeon from an early age and considers improving his patients’ health and increasing their longevity his lifelong calling. He specializes in board-based general, laparoscopic, and robotic surgeries. Dr. Shirley is also board-certified by the American College of Surgeons. </br></br>
    When away from the hospital, Dr. Shirley enjoys saltwater fishing, golfing, biking, kayaking, and most of all, coaching and playing sports with his son, Daniel. He also participates in medical missions and has had the opportunity to volunteer his services over the years in several villages in Ecuador and Malawi, Africa.`,

    education: ["Medical School at Texas Tech University in Lubbock, Texas", "General Surgery Residency at the University of Kentucky in Louisville"],

    areasOfExpertise: `<ul>
        <li>Breast Disease/Cancer</li>
        <li>Appendicitis</li>
        <li>Gallbladder Disease</li>
        <li>Colon Disease/Cancer</li>
        <li>Hemorrhoids</li>
        <li>Hernia Repair</li>
      </ul>
      <ul>
        <li>Reflux Surgery</li>
        <li>Thyroid/Parathyroid Disease/Cancer</li>
        <li>Skin Lesions/Masses/Cysts</li>
        <li>GI Tract Surgery</li>
        <li>Laparoscopic Surgery</li>
      </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/37187126_xl.jpg",
      title: "GENERAL SURGERY",
      contentTop: "General surgeons focus on organs within the abdominal cavity, including the stomach and colon. Many surgeons specialize in specific conditions or areas of the body. For example, vascular surgeons treat problems arising in the blood vessels, cardiac surgeons perform open surgeries on the heart, orthopedic surgeons treat the joints and bones, and neurosurgeons treat brain and spinal cord diseases.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "GENERAL SURGERY",
      mdName: "Ronak Patel, DO",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    generalSurgeryDetailData: {
      title: "GENERAL SURGEONS DELIVER EXPERT, PATIENT-CENTERED CARE WITH A FOCUS ON SAFETY AND OPTIMAL OUTCOMES.",
      contentTop: "Here in the United States, General Surgeons perform an average of 23 different types of surgeries with the range being from 1 to 73 different operations, so the surgical team must always stay up to date on procedures and knowledge. General surgery often sets the standard of surgical care in the community due to the extensive range of surgeries they must perform. Each day is not like the day before, so the surgical team must always remain sharp throughout the care of each patient during their procedure.",
      slope: true,
      intoImgData: "/images/providers/genralSurgeryFrame.png",
    },

    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_9.png",
      title: "GENERAL SURGEON",
      mdcontent:
        "Dr. Ronak J. Patel is a general surgeon in Houston, Texas, and is affiliated with multiple hospitals in the area. He received his medical degree from TCU and UNTHSC School of Medicine and has been in practice between 11–20 years. Dr. Patel has expertise in treating colonoscopy, colon removal, upper GI endoscopy, among other conditions.",
      mdname: "RONAK PATEL, DO",
    },

    id: "ronak-patel",
    name: "RONAK PATEL, DO",
    image: "/images/doctors/ronak-patel.jpg",
    phone: "(281) 970-8484",
    gender: "Male",
    language: "English, Spanish, Hindi, Gujarati",
    specialty: "General Surgery, Bariatric Surgery",

    degrees: ["Graduate degree with honors", "Bachelor’s degree in Biology and Economics"],

    clinics: [
      {
        name: "HCA Houston Tomball",
        address: "605 Holderrieth Blvd, Tomball, TX 77375",
        phone: "(281) 290-7500",
      },
      {
        name: "North Cypress Medical Center",
        address: "21214 Northwest Fwy, Cypress, TX 77429",
        phone: "(832) 912-3500",
      },
      {
        name: "Memorial Hermann Cypress Hospital",
        address: "27800 Northwest Fwy, Cypress, TX 77433",
        phone: "(346) 231-2000",
      },
      {
        name: "Memorial Hermann The Woodlands Hospital",
        address: "9250 Pinecroft Dr, The Woodlands, TX 77380",
        phone: "(713) 897-2300",
      },
    ],

    bio_name: "About Dr. Patel",
    bio: `
        Ronak Patel, DO, is a native Texan. He attended the University of Texas at Austin, graduating with a
        Bachelor’s degree in Biology and Economics. He went on to attend Texas College of Osteopathic
        Medicine in Fort Worth, Texas, where he graduated with honors, was in the top 5% of his class, and
        obtained the President’s Scholar award, given to students who maintained Dean’s List throughout
        every semester of college.
      </br></br>
        Dr. Patel completed his surgical training at the University of Texas Health Science Center at Houston
        Medical School in the US, with physicians such as Dr. James “Red” Duke and Dr. John B. Holcomb. He
        then went on to the University of South Florida for fellowship in Advanced Laparoscopy and Bariatric Surgery.
        Training was extensive in laparoscopic foregut surgery including (but not limited to) Nissen fundoplication,
        distal pancreatectomy, splenectomy, bowel resection, colon surgery, and bariatric surgery with an emphasis
        on revisional surgeries. He has also completed DaVinci Robotic Surgical training.</br></br>He is a member of the American Society for Metabolic and Bariatric Surgery (ASMBS). He has presented
        posters at the annual Obesity Week in the past. Dr. Patel has a strong interest in Bariatric Surgery and the
        maintenance of weight loss after. He teaches weight sensitivity courses for medical professionals at the hospital
        where he works as he knows the difficulty of weight loss, the importance of it, and the difficulty when expressing
        the need for help by a patient.
      </br></br>`,

    education: ["University of North Texas Health Science Center – Fort Worth, TX", "University of South Florida College of Medicine – Tampa, FL"],

    areasOfExpertise: `<ul>
        <li>Acid Reflux/GERD</li>
        <li>Anal/Rectal/Colon</li>
        <li>Breast Cancer</li>
        <li>Breast Surgery</li>
        <li>Colon Cancer</li>
      </ul>
      <ul>
        <li>GI Disease</li>
        <li>Laparoscopic Appendectomy</li>
        <li>Laparoscopic Cancer Surgery</li>
        <li>Laparoscopic Cholecystectomy</li>
        <li>Laparoscopic Colon Resection</li>
      </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/37187126_xl.jpg",
      title: "GENERAL SURGERY",
      contentTop: "General surgeons focus on organs within the abdominal cavity, including the stomach and colon. Many surgeons specialize in specific conditions or areas of the body. For example, vascular surgeons treat problems arising in the blood vessels, cardiac surgeons perform open surgeries on the heart, orthopedic surgeons treat the joints and bones, and neurosurgeons treat brain and spinal cord diseases.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "GENERAL SURGERY",
      mdName: "Ted Kovacev, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    generalSurgeryDetailData: {
      title: "GENERAL SURGEONS DELIVER EXPERT, PATIENT-CENTERED CARE WITH A FOCUS ON SAFETY AND OPTIMAL OUTCOMES.",
      contentTop: "Here in the United States, General Surgeons perform an average of 23 different types of surgeries with the range being from 1 to 73 different operations, so the surgical team must always stay up to date on procedures and knowledge. General surgery often sets the standard of surgical care in the community due to the extensive range of surgeries they must perform. Each day is not like the day before, so the surgical team must always remain sharp throughout the care of each patient during their procedure.",
      slope: true,
      intoImgData: "/images/providers/genralSurgeryFrame.png",
    },

    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_10.png",
      title: "GENERAL SURGERY",
      mdcontent:
        "Dr. Kovacev is a general surgeon in Lake Jackson, Texas, and is affiliated with multiple hospitals in the area. He received his medical degree from St. George’s University School of Medicine and has been in practice for more than 20 years. He has expertise in treating colonoscopy, colon removal, upper GI endoscopy, among other conditions.",
      mdname: "TED KOVACEV, MD",
    },

    id: "ted-kovacev",
    name: "TED KOVACEV, MD",
    image: "/images/doctors/ted-kovacev.jpg",
    phone: "(979) 721-7007",
    gender: "Male",
    language: "English, Spanish",
    specialty: "General Surgery, Laparoscopic Surgery, Endoscopy",

    degrees: ["Medical Degree from St. George’s University School of Medicine", "Grenada Bachelor’s Degree in Biology"],

    clinics: [
      {
        name: "Lake Jackson Office",
        address: "104 Circle Way Street, Lake Jackson, TX 77566",
        phone: "(979) 721-7007",
      },
      {
        name: "St. Luke’s Health – Brazosport Hospital",
        address: "100 Medical Drive, Lake Jackson, TX 77566",
        phone: "(979) 297-4411",
      },
    ],

    bio_name: "About Dr. Ted Kovacev",
    bio: `
        Dr. Kovacev is a general surgeon in Lake Jackson, Texas and is affiliated with multiple hospitals in the area.
        He received his medical degree from St. George’s University School of Medicine and has been in practice for
        more than 20 years. He has expertise in treating colonoscopy, colon removal, upper GI endoscopy, among other
        conditions.`,

    education: [
      "The Methodist Hospital Residency Hospital, 2010",
      "St. George’s University School of Medicine – Medical School, 2005",
      "University of Texas at Arlington – Undergraduate School, 1999",
    ],

    areasOfExpertise: `<ul>
        <li>Abdominal hernia repair surgery</li>
        <li>Colon removal</li>
        <li>Groin hernia surgery</li>
      </ul>
      <ul>
        <li>Upper GI endoscopy</li>
        <li>Hemorrhoids</li>
        <li>Gallbladder removal</li>
      </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/37187126_xl.jpg",
      title: "GENERAL SURGERY",
      contentTop: "General surgeons focus on organs within the abdominal cavity, including the stomach and colon. Many surgeons specialize in specific conditions or areas of the body. For example, vascular surgeons treat problems arising in the blood vessels, cardiac surgeons perform open surgeries on the heart, orthopedic surgeons treat the joints and bones, and neurosurgeons treat brain and spinal cord diseases.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "GENERAL SURGERY",
      mdName: "Eseroghene Otah, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    generalSurgeryDetailData: {
      title: "GENERAL SURGEONS DELIVER EXPERT, PATIENT-CENTERED CARE WITH A FOCUS ON SAFETY AND OPTIMAL OUTCOMES.",
      contentTop: "Here in the United States, General Surgeons perform an average of 23 different types of surgeries with the range being from 1 to 73 different operations, so the surgical team must always stay up to date on procedures and knowledge. General surgery often sets the standard of surgical care in the community due to the extensive range of surgeries they must perform. Each day is not like the day before, so the surgical team must always remain sharp throughout the care of each patient during their procedure.",
      slope: true,
      intoImgData: "/images/providers/genralSurgeryFrame.png",
    },

    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_11.png",
      title: "GENERAL SURGERY",
      mdcontent:
        "Dr. Ese Otah is a board-certified general surgeon with advanced training in minimally invasive, bariatric, and robotic surgery. She has been serving and empowering patients through expert care for over 14 years in the Houston area.",
      mdname: "ESEROGHENE OTAH, MD",
    },

    id: "eseroghene-otah",
    name: "ESEROGHENE OTAH, MD",
    image: "/images/doctors/eseroghene-otah.jpg",
    phone: "(281) 302-5838",
    gender: "Female",
    language: "English, Spanish",
    specialty: "Bariatric Surgery, General Surgery, Wound Care",

    degrees: ["Medical Degree at the SUNY Health Science Center of Brooklyn"],

    clinics: [
      {
        name: "Center for General & Laparoscopic Surgery",
        address: "139 Eldridge Road, Ste E, Sugar Land, TX 77478",
        phone: "(281) 302-5838",
      },
    ],

    bio_name: "About Dr. Eseroghene Otah",
    bio: `
    Dr. Ese Otah is a native New Yorker who spent her early years being raised in San Antonio, Texas. She has been in practice for over 10 years. She graduated from college with honors and earned her Medical Degree at the SUNY Health Science Center of Brooklyn (Downstate Medical Center). She completed her General Surgery Residency at New York Medical College and affiliated hospitals. After residency she trained in advanced laparoscopic and bariatric surgery at The University of Texas Health Science Center and Methodist Medical Center in Houston.`,

    education: [
      "New York Medical College | Internship 2002",
      "New York Medical College | Residency 2002",
      "State University of New York – Health Science Center – Brooklyn | Graduate Degree",
      "University of Texas Health Science Center | Fellowship 2004",
    ],

    areasOfExpertise: `<ul>
        <li>Gallstones</li>
        <li>Hernias</li>
        <li>Hemorrhoid Repair</li>
        <li>Skin Lesions</li>
      </ul>
      <ul>
        <li>Acid Reflux</li>
        <li>Appendix</li>
        <li>Colon and Small Intestine Disease</li>
      </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/37187126_xl.jpg",
      title: "GENERAL SURGERY",
      contentTop: "General surgeons focus on organs within the abdominal cavity, including the stomach and colon. Many surgeons specialize in specific conditions or areas of the body. For example, vascular surgeons treat problems arising in the blood vessels, cardiac surgeons perform open surgeries on the heart, orthopedic surgeons treat the joints and bones, and neurosurgeons treat brain and spinal cord diseases.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "GENERAL SURGERY",
      mdName: "Stephen Chiang, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    generalSurgeryDetailData: {
      title: "GENERAL SURGEONS DELIVER EXPERT, PATIENT-CENTERED CARE WITH A FOCUS ON SAFETY AND OPTIMAL OUTCOMES.",
      contentTop: "Here in the United States, General Surgeons perform an average of 23 different types of surgeries with the range being from 1 to 73 different operations, so the surgical team must always stay up to date on procedures and knowledge. General surgery often sets the standard of surgical care in the community due to the extensive range of surgeries they must perform. Each day is not like the day before, so the surgical team must always remain sharp throughout the care of each patient during their procedure.",
      slope: true,
      intoImgData: "/images/providers/genralSurgeryFrame.png",
    },

    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_12.png",
      title: "GENERAL SURGERY",
      mdcontent:
        "Stephen Chiang, MD, is a colon and rectal surgeon in Houston, Texas. He received his medical degree from the University of Texas Southwestern Medical School. He has been in practice between 11–20 years and works at Texas Colon & Rectal Specialists in Pearland, TX.",
      mdname: "STEPHEN CHIANG, MD",
    },

    id: "stephen-chiang",
    name: "Stephen Chiang, MD",
    image: "/images/doctors/stephen-chiang.jpg",
    phone: "(832) 220-3016",
    gender: "Male",
    language: "English, Mandarin",
    specialty: "Colon and Rectal Surgery, General Surgery",

    degrees: ["Master of Science in Biomedical Engineering", "Medical Doctorate"],

    clinics: [
      {
        name: "Texas Colon & Rectal Specialists — Houston West",
        address: "11221 Richmond Ave, Suite 115, Houston, TX 77082",
        phone: "832-220-3016",
      },
      {
        name: "Texas Colon & Rectal Specialists — Pearland",
        address: "10970 Shadow Creek Parkway, Suite 270, Pearland, TX 77584",
        phone: "832-220-3018",
      },
    ],

    bio_name: "About Dr. Stephen Chiang",
    bio: `Dr. Chiang is board certified in Colon & Rectal Surgery and graduated from The University of Texas Southwestern Medical Center. Dr. Chiang completed a residency at State University of New York at Buffalo. At present, Dr. Chiang has received an average rating of 5.0 from patients and has been reviewed 5 times. Dr. Chiang is affiliated with HCA Houston Healthcare West. Dr. Chiang practices at Texas Colon & Rectal Specialists - Pearland in Pearland,`,

    education: [
      "Fellowship in Colon and Rectal Surgery – The University of Texas Health Science Center at Houston, Houston, TX",
      "Residency in General Surgery – State University of New York at Buffalo, Buffalo, NY",
      "Medical Doctorate – The University of Texas Southwestern Medical Center, Dallas, TX",
      "Master of Science in Biomedical Engineering – University at Buffalo, Buffalo, NY",
    ],

    areasOfExpertise: `<ul>
        <li>Anal Cancer</li>
        <li>Anal Fissures</li>
        <li>Anal Fistula</li>
        <li>Anorectal Disease (Anal Warts, HPV, Levator Ani</li>
        <li>Syndrome, Lichen Sclerosis, Skin Tags)</li>
        <li>Colon and Rectal Cancer</li>
      </ul>
      <ul>
        <li>Colon Polyps</li>
        <li>Colonic Dysmotility and Inertia</li>
        <li>Colon: Strictures</li>
        <li>Constipation</li>
        <li>Crohn’s Disease</li>
      </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/37187126_xl.jpg",
      title: "GENERAL SURGERY",
      contentTop: "General surgeons focus on organs within the abdominal cavity, including the stomach and colon. Many surgeons specialize in specific conditions or areas of the body. For example, vascular surgeons treat problems arising in the blood vessels, cardiac surgeons perform open surgeries on the heart, orthopedic surgeons treat the joints and bones, and neurosurgeons treat brain and spinal cord diseases.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "GENERAL SURGERY",
      mdName: "Alex Tse, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    generalSurgeryDetailData: {
      title: "GENERAL SURGEONS DELIVER EXPERT, PATIENT-CENTERED CARE WITH A FOCUS ON SAFETY AND OPTIMAL OUTCOMES.",
      contentTop: "Here in the United States, General Surgeons perform an average of 23 different types of surgeries with the range being from 1 to 73 different operations, so the surgical team must always stay up to date on procedures and knowledge. General surgery often sets the standard of surgical care in the community due to the extensive range of surgeries they must perform. Each day is not like the day before, so the surgical team must always remain sharp throughout the care of each patient during their procedure.",
      slope: true,
      intoImgData: "/images/providers/genralSurgeryFrame.png",
    },

    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/G-Tse.png",
      title: "GENERAL SURGEON",
      mdcontent:
        "Dr. Alex Tse, MD is a board-certified general and bariatric surgeon with a passion for helping patients achieve lasting health through surgical excellence, education, and compassionate care. With extensive experience in advanced laparoscopic and robotic techniques, he specializes in minimally invasive procedures that promote faster recovery, reduced pain, and better outcomes.",
      mdname: "ALEX TSE, MD",
    },

    id: "alex-tse-md",
    name: "Alex Tse, MD",
    image: "/images/physianDirectory/md_1.jpg",
    phone: "281-653-6544",
    gender: "Male",
    language: "English",
    specialty: "General Surgery, Bariatric Surgery, Minimally Invasive Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Houston Surgical Weight Loss",
        address: "5220 FM 2920, Suite 120, Spring, TX 77388",
        phone: "(281) 653-6544",
      },
    ],

    bio_name: "About Dr. Alex Tse",
    bio: `Dr. Tse, MD is a board-certified general and bariatric surgeon with a passion for helping patients achieve lasting health through surgical excellence, education, and compassionate care. With extensive experience in advanced laparoscopic and robotic techniques, he specializes in minimally invasive procedures that promote faster recovery, reduced pain, and better outcomes.</br></br>
His clinical focus includes Bariatric surgery (gastric bypass, sleeve gastrectomy, duodenal switch), General surgery (hernia repair, gallbladder, anti-reflux procedures, colon surgery and more), Advanced minimally invasive and robotic-assisted techniques.</br></br>
Beyond the operating room, Dr. Tse is dedicated to guiding patients through their entire surgical journey—from preoperative education and optimization to long-term postoperative care. He believes in treating the whole person, not just the condition, and works to ensure every patient receives personalized, evidence-based care.</br></br>
He is a member of American College of Surgeons and American Society for Metabolic and Bariatric Surgery.`,

    education: [
      "Medical Degree from McGovern Medical School at UTHealth",
      "BS, (Biochemistry) Magna Cum Laude from The University of Texas at Austin",
      "Residency (Surgery) at Icahn School of Medicine at Mount Sinai/South Nassau",
      "Internship (Surgery) at University of Texas Health Science Center at Houston",
      "Fellowship (Minimally Invasive Surgery) at University of Texas Health Science Center at Houston",
      "UTHealth Fellowship Consortium with BMI of Texas Minimally Invasive Surgery",
    ],

    areasOfExpertise: `<ul>
      <li>Abdominal Wall Reconstruction</li>
      <li>Appendectomy</li>
      <li>Bariatrics</li>
      <li>Colon Surgery</li>
      <li>Duodenal Switch</li>
      <li>Gallbladder Surgery</li>
    </ul>
    <ul>
      <li>Gastric Bypass Surgery</li>
      <li>Hernia Repair</li>
      <li>Lap-Band Surgery</li>
      <li>Minimally Invasive Surgery</li>
      <li>Sleeve Gastrectomy</li>
      <li>Small Bowel Resection</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/providers/genralSurgeryFrame.png",
      title: "GENERAL SURGERY",
      contentTop: "General surgeons focus on organs within the abdominal cavity, including the stomach and colon. Many surgeons specialize in specific conditions or areas of the body. For example, vascular surgeons treat problems arising in the blood vessels, cardiac surgeons perform open surgeries on the heart, orthopedic surgeons treat the joints and bones, and neurosurgeons treat brain and spinal cord diseases.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "GENERAL SURGERY",
      mdName: "Obonoruma I. Ekhaese, DO",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    generalSurgeryDetailData: {
      title: "GENERAL SURGEONS DELIVER EXPERT, PATIENT-CENTERED CARE WITH A FOCUS ON SAFETY AND OPTIMAL OUTCOMES.",
      contentTop: "Here in the United States, General Surgeons perform an average of 23 different types of surgeries with the range being from 1 to 73 different operations, so the surgical team must always stay up to date on procedures and knowledge. General surgery often sets the standard of surgical care in the community due to the extensive range of surgeries they must perform. Each day is not like the day before, so the surgical team must always remain sharp throughout the care of each patient during their procedure.",
      slope: true,
      intoImgData: "/images/providers/genralSurgeryFrame.png",
    },

    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/G-Ekhaese.jpg",
      title: "GENERAL SURGEON",
      mdcontent:
        "Obonoruma (Obos) Ekhaese, MD is a general surgeon in Pearland, Texas. He received his medical degree from College of Osteopathic Medicine of the Pacific and has been in practice for more than 20 years. He believes in helping patients achieve their health and weight loss goals through procedures such as gastric sleeve, gastric bypass, and gastric balloon.",
      mdname: "OBONORUMA I. EKHAESE, DO",
    },

    id: "obonoruma-ekhaese-do",
    name: "Obonoruma I. Ekhaese, DO",
    image: "/images/physianDirectory/md_2.png",
    phone: "832-915-8140",
    gender: "Male",
    language: "English",
    specialty: "General Surgery, Bariatric Surgery",

    degrees: ["Doctor of Osteopathy"],

    clinics: [
      {
        name: "CARE Surgery Clinic, PA",
        address: "3351 Plainview Ste A-7, Pasadena, TX 77504",
        phone: "(832) 915-8140",
      },
      {
        name: "CARE Surgery Clinic, PA",
        address: "12835 Gulf Freeway, Houston, TX 77034",
        phone: "(832) 915-8140",
      },
      {
        name: "CARE Surgery Clinic, PA",
        address: "10907 Memorial Hermann Dr #440, Pearland, TX 77584",
        phone: "(832) 915-8140",
      },
    ],

    bio_name: "About Dr. Obonoruma I. Ekhaese",
    bio: `Born and raised in Nigeria, Dr. Ekhaese moved to Houston when he was 17 years old, attended San Jacinto College South Campus for two years and ultimately graduated from the University of Houston before heading out west to study medicine.</br></br>
In 2000, Dr. Ekhaese graduated with his medical degree from the Western University of Health Sciences in Pomona, California. After completing a year-long internship in Illinois at Franciscan St. James Health Olympia Fields, he trained as a resident with Michigan State University (MSU) College of Osteopathic Medicine at the Pontiac Osteopathic Hospital. Next, Dr. Ekhaese cared for patients in a private practice setting in Central Illinois before moving back to Texas and completing a minimally invasive surgery fellowship with McGovern Medical School at UTHealth at Houston Northwest Medical Center in 2009.</br></br>
Board certified by the American Osteopathic Board of Surgery (AOBS) in general surgery, Dr. Ekhaese specializes in bariatric surgery, endoscopic surgery, hernia surgery, reflux surgery and robotic surgery. He is a fellow of the American College of Surgeons (ACS).</br></br>
Dr. Ekhaese is an assistant professor in the Department of General Surgery and Division of Minimally Invasive Surgery at McGovern Medical School. He co-authored the Bariatric Surgery chapter in Yamada's Textbook of Gastroenterology, 6th edition. He has volunteered at hospitals in Haiti, Honduras, Kenya and Nigeria.`,

    education: [
      "Medical Degree from Western University of Health Sciences College Osteopathic Medicine",
      "Residency (Surgery) at Pontiac Osteopathic Hospital",
      "Fellowship (Advanced GI Minimally Invasive Surgery) at University of Texas Health Science Center-Houston",
    ],

    areasOfExpertise: `<ul>
      <li>Appendectomy</li>
      <li>Bowel Obstructions</li>
      <li>Duodenal Switch</li>
      <li>Excision of Masses and Lesions</li>
      <li>Gallbladder Removal Surgery</li>
    </ul>
    <ul>
      <li>Gastric Bypass</li>
      <li>Gastric Sleeve</li>
      <li>Hernia Repairs</li>
      <li>Perforated Ulcers</li>
      <li>Testosterone Replacement Therapy</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=erihYpTuaBk",
      title: "GENERAL SURGERY",
      contentTop: "General surgeons focus on organs within the abdominal cavity, including the stomach and colon. Many surgeons specialize in specific conditions or areas of the body. For example, vascular surgeons treat problems arising in the blood vessels, cardiac surgeons perform open surgeries on the heart, orthopedic surgeons treat the joints and bones, and neurosurgeons treat brain and spinal cord diseases.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "GENERAL SURGERY",
      mdName: "Priya Prakash, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    generalSurgeryDetailData: {
      title: "GENERAL SURGEONS DELIVER EXPERT, PATIENT-CENTERED CARE WITH A FOCUS ON SAFETY AND OPTIMAL OUTCOMES.",
      contentTop: "Here in the United States, General Surgeons perform an average of 23 different types of surgeries with the range being from 1 to 73 different operations, so the surgical team must always stay up to date on procedures and knowledge. General surgery often sets the standard of surgical care in the community due to the extensive range of surgeries they must perform. Each day is not like the day before, so the surgical team must always remain sharp throughout the care of each patient during their procedure.",
      slope: true,
      intoImgData: "/images/providers/genralSurgeryFrame.png",
    },

    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/G-Prakash.jpg",
      title: "GENERAL SURGEON",
      mdcontent:
        "Dr. Priya Prakash, MD is a general surgeon in Houston, Texas. She has expertise in treating colonoscopy, among other conditions.",
      mdname: "PRIYA PRAKASH, MD",
    },

    id: "priya-prakash-md",
    name: "Priya Prakash, MD",
    image: "/images/physianDirectory/md_3.png",
    phone: "713-701-5186",
    gender: "Female",
    language: "English",
    specialty: "Colon & Rectal Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Houston Colon - Pearland",
        address: "10970 Shadow Creek Parkway Ste 250, Pearland, TX 77584",
        phone: "(713) 790-0600",
      },
      {
        name: "Houston Colon - Woman's Campus",
        address: "7900 Fannin Street, Ste 3700, Houston, TX 77054",
        phone: "(713) 790-0600",
      },
      {
        name: "Houston Colon- Katy",
        address: "21814 Katy Fwy, Suite 200, Katy, TX 77449",
        phone: "(713) 790-0600",
      },
    ],

    bio_name: "About Dr. Priya Prakash",
    bio: `Dr. Prakash is board certified in General Surgery. She received her medical degree from St. George's University School of Medicine and has been in practice between 6-10 years. She completed a residency at HCA Healthcare Kansas City/Menorah Medical Center. Dr. Prakash is affiliated with HCA Healthcare facilities and practices at Houston Colon- Pearland.`,

    education: [
      "Medical Degree from St. George's University School of Medicine",
      "BA, Plan II Honors at The University of Texas at Austin",
      "Fellowship (Minimally Invasive Surgery) at University of Texas Health Science Center at Houston",
      "Residency (Surgery) at HCA Healthcare Kansas City/Menorah Medical Center",
    ],

    areasOfExpertise: `<ul>
      <li>Acute Bowel Infarction</li>
      <li>Abdominoplasty</li>
      <li>Appendicitis</li>
      <li>Bladder Stimulator Implant</li>
      <li>Colectomy</li>
      <li>Constipation Management</li>
    </ul>
    <ul>
      <li>Duodenal Polypectomy</li>
      <li>Inguinal Hernia</li>
      <li>Laparoscopic Appendectomy</li>
      <li>Laparoscopic Inguinal Hernia Repair</li>
      <li>Open Appendectomy</li>
      <li>Physical Therapy and Rehabilitation</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/providers/genralSurgeryFrame.png",
      title: "GENERAL SURGERY",
      contentTop: "General surgeons focus on organs within the abdominal cavity, including the stomach and colon. Many surgeons specialize in specific conditions or areas of the body. For example, vascular surgeons treat problems arising in the blood vessels, cardiac surgeons perform open surgeries on the heart, orthopedic surgeons treat the joints and bones, and neurosurgeons treat brain and spinal cord diseases.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "GENERAL SURGERY",
      mdName: "Stevenson C. Tsiao, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    generalSurgeryDetailData: {
      title: "GENERAL SURGEONS DELIVER EXPERT, PATIENT-CENTERED CARE WITH A FOCUS ON SAFETY AND OPTIMAL OUTCOMES.",
      contentTop: "Here in the United States, General Surgeons perform an average of 23 different types of surgeries with the range being from 1 to 73 different operations, so the surgical team must always stay up to date on procedures and knowledge. General surgery often sets the standard of surgical care in the community due to the extensive range of surgeries they must perform. Each day is not like the day before, so the surgical team must always remain sharp throughout the care of each patient during their procedure.",
      slope: true,
      intoImgData: "/images/providers/genralSurgeryFrame.png",
    },

    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/G-Tsiao.png",
      title: "GENERAL SURGEON",
      mdcontent:
        "Stevenson Tsiao, MD is a Board-Certified surgeon well-trained in performing a range of bariatric procedures, including Roux-en-Y gastric bypass, sleeve gastrectomy, and revisional bariatric surgery as well as foregut, general surgery, and trauma procedures.",
      mdname: "STEVENSON C. TSIAO, MD",
    },

    id: "stevenson-tsiao-md",
    name: "Stevenson C. Tsiao, MD",
    image: "/images/physianDirectory/md_4.png",
    phone: "346-655-5551",
    gender: "Male",
    language: "English",
    specialty: "General Surgery, Bariatric Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Texas Laparoscopic Consultants",
        address: "5115 Fannin Street, Ste 950, Houston, TX 77004",
        phone: "(346) 655-5551",
      },
    ],

    bio_name: "About Dr. Stevenson C. Tsiao",
    bio: `Dr. Tsiao received his undergraduate degree in Information Management Systems with a minor in Biology from the University of Texas at Austin. He went on to complete a masters of science degree in Medical Sciences at University of North Texas Health Science Center before earning his doctorate of medicine degree at Texas Tech University. He completed a residency at Riverside University Health System in Southern California, followed by a fellowship in Minimally Invasive and Bariatric Surgery at Houston Methodist Hospital.</br></br>
Dr. Tsiao has authored a number of articles in peer-reviewed journals and has also made multiple presentations to his peers and colleagues at scientific and medical conferences and symposia.</br></br>
Dr. Tsiao believes in thoroughly educating patients about their conditions and treatment options so that they can make confident, informed decisions about their care. For him, the most rewarding part of his role as a bariatric surgeon is helping his patients achieve their goals and watching them live healthier, happier lives.`,

    education: [
      "Medical Degree from Texas Tech University",
      "Masters of Science (Medical Science) from University of North Texas Health Science Center",
      "Undergraduate Degree from University of Texas, Austin",
      "Residency at Riverside University Health System, Southern California",
      "Fellowship (Minimally Invasive and Bariatric Surgery) at Houston Methodist Hospital",
    ],

    areasOfExpertise: `<ul>
      <li>Acid Reflux and GERD Treatment</li>
      <li>Duodenal Switch</li>
      <li>Gastric Bypass</li>
      <li>Gastric Sleeve</li>
      <li>Laparoscopic Colon Surgery</li>
    </ul>
    <ul>
      <li>Laparoscopic Fundoplication</li>
      <li>Laparoscopic Gallbladder Surgery</li>
      <li>Laparoscopic Hernia Surgery</li>
      <li>Laparoscopic Surgery of the Spleen, Adrenal Gland, Pancreas, and Kidney</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/providers/genralSurgeryFrame.png",
      title: "GENERAL SURGERY",
      contentTop: "General surgeons focus on organs within the abdominal cavity, including the stomach and colon. Many surgeons specialize in specific conditions or areas of the body. For example, vascular surgeons treat problems arising in the blood vessels, cardiac surgeons perform open surgeries on the heart, orthopedic surgeons treat the joints and bones, and neurosurgeons treat brain and spinal cord diseases.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "GENERAL SURGERY",
      mdName: "Viet Phuong, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    generalSurgeryDetailData: {
      title: "GENERAL SURGEONS DELIVER EXPERT, PATIENT-CENTERED CARE WITH A FOCUS ON SAFETY AND OPTIMAL OUTCOMES.",
      contentTop: "Here in the United States, General Surgeons perform an average of 23 different types of surgeries with the range being from 1 to 73 different operations, so the surgical team must always stay up to date on procedures and knowledge. General surgery often sets the standard of surgical care in the community due to the extensive range of surgeries they must perform. Each day is not like the day before, so the surgical team must always remain sharp throughout the care of each patient during their procedure.",
      slope: true,
      intoImgData: "/images/providers/genralSurgeryFrame.png",
    },

    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/G-Phuong.jpg",
      title: "GENERAL SURGEON",
      mdcontent:
        "Viet Phuong, MD is a general surgeon in Tomball, TX. He has worked on more claims relating to Intestinal Obstruction, Appendicitis and Cholecystitis and Gallstones than other providers in the area. With over a decade of medical experience, his mission is to provide state-of-the-art surgical care to individuals living in and around Harris County and throughout the Greater Houston area.",
      mdname: "VIET PHUONG, MD",
    },

    id: "viet-phuong-md",
    name: "Viet Phuong, MD",
    image: "/images/physianDirectory/md_5.png",
    phone: "281-519-7421",
    gender: "Male",
    language: "English",
    specialty: "General Surgery, Bariatric Surgery, Minimally Invasive Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "General & Minimally Invasive Surgery",
        address: "11609 Spring Cypress Rd Ste C, Tomball, TX 77377",
        phone: "(281) 519-7421",
      },
      {
        name: "General & Minimally Invasive Surgery",
        address: "10425 Huffmeister Rd, Ste 200, Houston, TX, 77065",
        phone: "(281) 519-7421",
      },
    ],

    bio_name: "About Dr. Viet Phuong",
    bio: `Dr. Phuong is a board-certified surgeon who practices general and bariatric surgery at General & Minimally Invasive Surgery in Tomball, Texas. He graduated from the University of Texas Southwestern Medical School in 2008. He then went on to complete his residency at the Cleveland Clinic Foundation and is fellowship-trained in bariatric/minimally invasive surgery. He has been in practice since 2014 and currently practices with Northwest Surgical Associates and is affiliated with HCA Houston Healthcare Tomball. He accepts multiple insurance plans.</br></br>
In his spare time, Dr. Phuong enjoys playing golf, traveling with his family, and motorsports racing.`,

    education: [
      "Medical Degree from University of Texas Southwestern Medical School",
      "Residency (Surgery) at Cleveland Clinic Foundation",
      "Fellowship (Bariatric/ Minimally Invasive Surgery) at Atrium Health Carolinas Medical Center",
    ],

    areasOfExpertise: `<ul>
      <li>Bariatric Surgery</li>
      <li>Colon Resections</li>
      <li>Cyst Excisions</li>
      <li>Gallbladder Surgery</li>
      <li>Hemorrhoidectomy</li>
    </ul>
    <ul>
      <li>Hernia Repairs</li>
      <li>Laparoscopic Surgery</li>
      <li>Lysis of Adhesions</li>
      <li>Thyroidectomy</li>
      <li>Weight Loss Procedures</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/providers/genralSurgeryFrame.png",
      title: "GENERAL SURGERY",
      contentTop: "General surgeons focus on organs within the abdominal cavity, including the stomach and colon. Many surgeons specialize in specific conditions or areas of the body. For example, vascular surgeons treat problems arising in the blood vessels, cardiac surgeons perform open surgeries on the heart, orthopedic surgeons treat the joints and bones, and neurosurgeons treat brain and spinal cord diseases.",
      slope: true,
    },
  },

  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "GENERAL SURGERY",
      mdName: "Lisa M. Haubert, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    generalSurgeryDetailData: {
      title: "GENERAL SURGERY",
      contentTop: "General surgeons focus on organs within the abdominal cavity, including the stomach and colon. Many surgeons specialize in specific conditions or areas of the body. For example, vascular surgeons treat problems arising in the blood vessels, cardiac surgeons perform open surgeries on the heart, orthopedic surgeons treat the joints and bones, and neurosurgeons treat brain and spinal cord diseases.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },
    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/G-Haubert.jpg",
      title: "COLONRECTAL SURGEON",
      mdcontent: "Board certified in both general surgery and colorectal surgery, Dr. Lisa Haubert has practiced in Houston since 2014.     She treats any colorectal co...",
      mdname: "LISA M. HAUBERT, MD"
    },
    id: "lisa-m-haubert-md",
    name: "Lisa M. Haubert, MD",
    image: "/images/doctors/lisa-m-haubert-md.jpg",
    phone: "713-772-1200",
    gender: "Female",
    language: "English",
    specialty: "Colon and Rectal Surgery, General Surgery",
    degrees: ["Doctor of Medicine"],
    clinics: [{
        name: "Memorial Hermann Sugar Land",
        address: "17510 W Grand Pkwy S, Ste 490, Sugar Land, TX 77479",
        phone: "(713) 772-1200"
      }, {
        name: "Memorial Hermann Southwest",
        address: "7777 Southwest Fwy, Ste 810, Houston, TX 77074",
        phone: "(713) 772-1200"
      }, {
        name: "Houston Methodist Sugar Land",
        address: "16655 Southwest Fwy Sugar Land, TX 77479",
        phone: "(281) 274-7000"
      }],
    bio_name: "About Dr. Lisa M. Haubert",
    bio: `Dr. Lisa Haubert obtained her medical degree from The Ohio State University College of Medicine and completed her General Surgery residency at The Ohio State University Medical Center. During residency, Dr. Haubert also received a Master of Science degree in Anatomy from The Ohio State University and performed research in surgical education. Her research was used to develop a novel medical student curriculum with greater involvement of surgeons in student education and experience. She then completed a fellowship in Colon and Rectal Surgery at the esteemed Cleveland Clinic Florida.     Dr. Haubert’s clinical interests include advanced minimally invasive colon and rectal surgery, as well as common anorectal conditions including fistulas, fissures, and hemorrhoids. Dr. Haubert treats pelvic floor disorders in both men and women including constipation and fecal incontinence. She also performs colonoscopies and is actively involved in the American Society of Colon and Rectal Surgeons.    Being a female physician in a male-dominated specialty sets Dr. Haubert’s practice apart. Her patients appreciate that she takes time to listen, explain everything and answer questions thoroughly. They describe her as skilled, caring, kind and respectful. They value her realistic approach to treatment.    A resident of Sugar Land, Dr. Haubert is married and enjoys spending her free time traveling and spending time with her dogs.`,
    education: ["Medical Degree from Ohio State University College of Medicine & Public Health", "Residency (General Surgery) at Ohio State University", "Fellowship (Colorectal Surgery) at Cleveland Clinic Florida"],
    areasOfExpertise: `<ul>
<li>Bowel Surgery</li>
<li>Cancer Surgery</li>
<li>Colonoscopy</li>
<li>Crohn's Disease and Diverticular Disease</li>
<li>Hemmorrhoids</li>
</ul>
<ul>
<li>Laparoscopic Surgery</li>
<li>Pelvic Floor Disorders</li>
<li>Pilonidal Cysts</li>
<li>Rectal Bleeding</li>
<li>Ulcerative Colitis</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      link: "https://vimeo.com/531492063?autoplay=1&muted=1&stream_id=Y2xpcHN8NDQ0MDEzMjB8aWQ6ZGVzY3xbXQ%3D%3D",
      title: "GENERAL SURGERY",
      contentTop: "General surgeons focus on organs within the abdominal cavity, including the stomach and colon. Many surgeons specialize in specific conditions or areas of the body. For example, vascular surgeons treat problems arising in the blood vessels, cardiac surgeons perform open surgeries on the heart, orthopedic surgeons treat the joints and bones, and neurosurgeons treat brain and spinal cord diseases.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "GENERAL SURGERY",
      mdName: "Zhen Fan, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    generalSurgeryDetailData: {
      title: "GENERAL SURGERY",
      contentTop: "General surgeons focus on organs within the abdominal cavity, including the stomach and colon. Many surgeons specialize in specific conditions or areas of the body. For example, vascular surgeons treat problems arising in the blood vessels, cardiac surgeons perform open surgeries on the heart, orthopedic surgeons treat the joints and bones, and neurosurgeons treat brain and spinal cord diseases.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },
    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/G-Fan.avif",
      title: "GENERAL SURGEON",
      mdcontent: "Zhen Fan, MD, is board certified in general surgery. He has over 14 years of experience performing a wide range of surgical procedures.   He is passio...",
      mdname: "ZHEN FAN, MD"
    },
    id: "zhen-fan-md",
    name: "Zhen Fan, MD",
    image: "/images/doctors/zhen-fan-md.jpg",
    phone: "713-935-9758",
    gender: "Male",
    language: "English, Chinese",
    specialty: "General Surgery",
    degrees: ["Medical Degree"],
    clinics: [{
        name: "Surgical Associates of Houston",
        address: "1140 Business Center Drive #403, Houston, TX 77043",
        phone: "(713) 935-9758"
      }, {
        name: "Surgical Associates of Houston",
        address: "9440 Bellaire Blvd. Suite 205, Houston, TX 77036",
        phone: ""
      }],
    bio_name: "About Dr. Zhen Fan",
    bio: `Dr.Fan earned his medical degree at the University of Cincinnati College of Medicine in Ohio and completed his surgical residency at the Good Samaritan Hospital, also in Cincinnati. He then completed his laparoscopic colorectal fellowship at Case Western Reserve University in Cleveland, Ohio.    Board certified in surgery, Dr. Fan specializes in minimally invasive procedures including laparoscopic hernia repair, biliary surgery and colon resection. His interests also include endocrine surgery.    Fluent in Chinese, Dr. Fan listens closely to each patient to understand their needs. He offers minimally invasive techniques which can reduce trauma to the body, allowing patients to return to normal activities sooner after surgery.    Dr. Fan and his wife have a boy and a girl. In his spare time he, enjoys going to the movies and spending time with his family.`,
    education: ["Medical Degree from University of Cincinnati College of Medicine", "Residency (General and Vascular Surgery) at Good Samaritan Hospital of Cincinnati", "Fellowship (Minimally Invasive Colorectal Surgery) at Case Medical Center"],
    areasOfExpertise: `<ul>
<li>Ablations</li>
<li>Appendectomy</li>
<li>Cholecystectomy</li>
<li>Colon And Rectal Diseases</li>
<li>Colon Resection</li>
</ul>
<ul>
<li>Gallbladder Removal</li>
<li>Gastrectomy</li>
<li>Hemorrhoidectomy</li>
<li>Inguinal & Ventral Hernias</li>
<li>Robotic Surgery</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/37187126_xl.jpg",
      title: "GENERAL SURGERY",
      contentTop: "General surgeons focus on organs within the abdominal cavity, including the stomach and colon. Many surgeons specialize in specific conditions or areas of the body. For example, vascular surgeons treat problems arising in the blood vessels, cardiac surgeons perform open surgeries on the heart, orthopedic surgeons treat the joints and bones, and neurosurgeons treat brain and spinal cord diseases.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "GENERAL SURGERY",
      mdName: "Tianming Liu, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    generalSurgeryDetailData: {
      title: "GENERAL SURGERY",
      contentTop: "General surgeons focus on organs within the abdominal cavity, including the stomach and colon. Many surgeons specialize in specific conditions or areas of the body. For example, vascular surgeons treat problems arising in the blood vessels, cardiac surgeons perform open surgeries on the heart, orthopedic surgeons treat the joints and bones, and neurosurgeons treat brain and spinal cord diseases.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },
    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/G-Liu.jpg",
      title: "COLONRECTAL SURGEON",
      mdcontent: "Tianming Liu, MD is a Colorectal Surgery Specialist with Houston Colon in Houston, TX.  He's been in practice between 13+ years and has expertise in c...",
      mdname: "TIANMING LIU, MD"
    },
    id: "tianming-liu-md",
    name: "Tianming Liu, MD",
    image: "/images/doctors/tianming-liu-md.jpg",
    phone: "713-790-0600",
    gender: "Male",
    language: "English",
    specialty: "General Surgery, Colon and Rectal Surgery",
    degrees: ["Medical Degree"],
    clinics: [{
        name: "Houston Colon - Med Center",
        address: "6560 Fannin Street ,Suite 1404, Houston, TX 77030",
        phone: "(713) 790-0600"
      }, {
        name: "Houston Colon - Sugarland",
        address: "16902 Southwest Fwy, Ste 100, Sugarland, TX 77479",
        phone: ""
      }, {
        name: "Houston Colon - Katy",
        address: "21814 Katy Fwy, Suite 200, Katy, TX 77449",
        phone: ""
      }],
    bio_name: "About Dr. Tianming Liu",
    bio: `Dr. Liu earned his Bachelor of Science degree from Tulane University and obtained a dual medical degree and masters of public health degree (MD/MPH) from Tulane University School of Medicine and Tulane's School of Public Health and Tropical Medicine. After completing his General Surgery residency at New York-Presbyterian Brooklyn Methodist Hospital, Dr. Liu pursued specialization and completed a fellowship in Colon and Rectal Surgery at the University of Texas Health Science Center At Houston McGovern Medical School.    He is a member of American Board of Colon and Rectal Surgery and American Board Of Surgery.    Dr. Liu is a strong believer in patient centered care and includes them as an important part of the treatment team. Outside of medicine, he enjoys cycling, running and hiking.`,
    education: ["Medical Degree from Tulane University Medical School", "MPH Degree (Epidemiology) from Tulane School of Public Health and Tropical Medicine", "Residency (General Surgery) at NewYork-Presbyterian Hospital", "Fellowship (Colon and Rectal Surgery) at The University of Texas Health Science Center at Houston"],
    areasOfExpertise: `<ul>
<li>Anorectal Fistula</li>
<li>Colectomy</li>
<li>Gallstones</li>
<li>Hemorrhoids</li>
<li>Intestinal Diverticulitis</li>
</ul>
<ul>
<li>Intestinal Obstruction</li>
<li>Laparoscopic Excision of Ovary</li>
<li>Pelvic Abscess</li>
<li>Rectal Cancer</li>
<li>Ulcerative Colitis</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/37187126_xl.jpg",
      title: "GENERAL SURGERY",
      contentTop: "General surgeons focus on organs within the abdominal cavity, including the stomach and colon. Many surgeons specialize in specific conditions or areas of the body. For example, vascular surgeons treat problems arising in the blood vessels, cardiac surgeons perform open surgeries on the heart, orthopedic surgeons treat the joints and bones, and neurosurgeons treat brain and spinal cord diseases.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "GENERAL SURGERY",
      mdName: "Caroline Kim, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    generalSurgeryDetailData: {
      title: "GENERAL SURGERY",
      contentTop: "General surgeons focus on organs within the abdominal cavity, including the stomach and colon. Many surgeons specialize in specific conditions or areas of the body. For example, vascular surgeons treat problems arising in the blood vessels, cardiac surgeons perform open surgeries on the heart, orthopedic surgeons treat the joints and bones, and neurosurgeons treat brain and spinal cord diseases.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },
    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/G-Kim.jpeg",
      title: "GENERAL SURGEON",
      mdcontent: "Caroline Kim, MD is a general surgeon in Houston, TX and has over 20 years of experience in the medical field.",
      mdname: "CAROLINE KIM, MD"
    },
    id: "caroline-kim-md",
    name: "Caroline Kim, MD",
    image: "/images/doctors/caroline-kim-md.jpg",
    phone: "713-464-2100",
    gender: "Female",
    language: "English",
    specialty: "General Surgery",
    degrees: ["Medical Degree"],
    clinics: [{
        name: "Houston Robotic Hernia Surgery",
        address: "18400 Katy Freeway, Suite 530, Houston, TX 77094",
        phone: "(713) 932-1001"
      }],
    bio_name: "About Dr. Caroline Kim",
    bio: `Dr. Kim completed her undergraduate studies at Harvard University in Cambridge, MA on a ROTC scholarship. She served in the U.S. Army as an active duty officer in the Medical Service Corps in Korea and Germany before attending medical school at Vanderbilt University in Nashville, TN. She did her general surgery residency through Vanderbilt University Medical Center and the Banner University Health System in Phoenix AZ.    She also completed a Burn Surgery Fellowship at Vanderbilt University Medical Center. She is board certified in General Surgery through the American College of Surgeons.`,
    education: ["Medical Degree from Vanderbilt University School of Medicine", "Undergraduate Degree from Harvard University", "Residency (General Surgery) at Vanderbilt University", "Residency (General Surgery) at Phoenix Integrated Surgical Residency", "Fellowship (Burn Surgery) at Vanderbilt University - Nashville"],
    areasOfExpertise: `<ul>
<li>Appendectomy</li>
<li>Cholecystitis</li>
<li>Colon Removal</li>
<li>Gallstones</li>
<li>Gastrointestinal Obstruction</li>
</ul>
<ul>
<li>Inguinal Hernia</li>
<li>Laparoscopic Inguinal Hernia Repair</li>
<li>Lipomas</li>
<li>Umbilical Hernia</li>
<li>Ventral Hernia</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/37187126_xl.jpg",
      title: "GENERAL SURGERY",
      contentTop: "General surgeons focus on organs within the abdominal cavity, including the stomach and colon. Many surgeons specialize in specific conditions or areas of the body. For example, vascular surgeons treat problems arising in the blood vessels, cardiac surgeons perform open surgeries on the heart, orthopedic surgeons treat the joints and bones, and neurosurgeons treat brain and spinal cord diseases.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "GENERAL SURGERY",
      mdName: "Paul J. James, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },
    generalSurgeryDetailData: {
      title: "GENERAL SURGEONS DELIVER EXPERT, PATIENT-CENTERED CARE WITH A FOCUS ON SAFETY AND OPTIMAL OUTCOMES.",
      contentTop: "Here in the United States, General Surgeons perform an average of 23 different types of surgeries with the range being from 1 to 73 different operations, so the surgical team must always stay up to date on procedures and knowledge. General surgery often sets the standard of surgical care in the community due to the extensive range of surgeries they must perform. Each day is not like the day before, so the surgical team must always remain sharp throughout the care of each patient during their procedure.",
      slope: true,
      intoImgData: "/images/providers/genralSurgeryFrame.png",
    },
    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/G-James.webp",
      title: "GENERAL SURGEON",
      mdcontent: "Paul J. James is a board certified general surgeon in Houston, Texas and has been in practice for more than 20 years. Dr. James is one of a few surgeons in the Houston area trained in robotic assisted surgery.",
      mdname: "PAUL J. JAMES, MD",
    },
        generalSurgeryDetaillinkData: {
      link: "",
      introImg: "/images/MDDetails/37187126_xl.jpg",
      title: "GENERAL SURGERY",
      contentTop: "General surgeons focus on organs within the abdominal cavity, including the stomach and colon. Many surgeons specialize in specific conditions or areas of the body. For example, vascular surgeons treat problems arising in the blood vessels, cardiac surgeons perform open surgeries on the heart, orthopedic surgeons treat the joints and bones, and neurosurgeons treat brain and spinal cord diseases.",
      slope: true
    },
    id: "paul-j-james",
    name: "Paul J. James, MD",
    image: "/images/physianDirectory/G-James.webp",
    phone: "713-659-1728",
    gender: "Male",
    language: "English, Spanish, Tigrinya",
    specialty: "General Surgery",
    degrees: ["Medical Degree"],
    clinics: [
      {
        name: "Metropolitan Houston Surgery Associates",
        address: "2101 Crawford St. Ste. 304, Houston, TX 77002",
        phone: "(713) 659-1728",
        fax: ""
      }
    ],
    aboutBio: "Dr. James received his undergraduate degree from Texas Southern University, and later attended Meharry Medical College of Medicine in Nashville, Tennessee where he received his Doctorate of Medicine. He then completed his General Surgery Residency at St. Joseph Hospital in Houston, Texas. Dr. Paul J. James is a Fellow of the American College of Surgeons. He is also a member of numerous professional organizations such as American Medical Association, Texas Medical Foundation, and Houston Medical Forum. Dr. Paul J. James has received various awards and honors including graduating Cum Laude from Texas Southern University, where from 1977-1980 he achieved the Dean's List. He also went on to be recognized in the Who's Who in American Colleges and Universities, received the Senior Medical Class Outstanding Leadership Award, General Surgery Resident of the Year, and General Surgery Residency Faculty of the Year just to name a few. Recently, he was honored to be recognized as one of Houston's Top Doctors by H Texas Magazine and Americas Top Surgeons by Consumers' Research Council of America.",
    education: [
      "Medical Degree from Meharry Medical College School of Medicine",
      "Undergraduate Degree from Texas Southern University",
      "Residency (Surgery) at UT Health Science Center at Houston"
    ],
    expertise: [
      "Abdominal Hernia Repair",
      "Appendectomy",
      "Colon Removal",
      "Gallstones/ Gallbladder Removal",
      "Gastric Surgery",
      "Necrosis/ Wound Debridement",
      "Peptic Ulcer",
      "Splenectomy & Splenorrhaphy",
      "Thyroid and Parathyroid Surgery",
      "Ulcers"
    ]
  },

  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "GENERAL SURGERY",
      mdName: "Arturo G. Gonzalez, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },
    generalSurgeryDetailData: {
      title: "GENERAL SURGEONS DELIVER EXPERT, PATIENT-CENTERED CARE WITH A FOCUS ON SAFETY AND OPTIMAL OUTCOMES.",
      contentTop: "Here in the United States, General Surgeons perform an average of 23 different types of surgeries with the range being from 1 to 73 different operations, so the surgical team must always stay up to date on procedures and knowledge. General surgery often sets the standard of surgical care in the community due to the extensive range of surgeries they must perform. Each day is not like the day before, so the surgical team must always remain sharp throughout the care of each patient during their procedure.",
      slope: true,
      intoImgData: "/images/providers/genralSurgeryFrame.png",
    },
    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/G-Gonzalez.png",
      title: "GENERAL SURGEON",
      mdcontent: `Arturo G. Gonzalez is a general surgeon in Houston, Texas and is affiliated with multiple hospitals in the area. He is a board-certified general surgeon offering a range of general surgery procedures and techniques. He has been in practice for more than 20 years and provides quality surgical service for gravely ill or injured patients and is able to respond quickly due to knowledge of various surgical procedures. He has expertise in treating mastectomy, colonoscopy, upper gi endoscopy, among other conditions.`,
      mdname: "ARTURO G. GONZALEZ, MD",
    },
        generalSurgeryDetaillinkData: {
      link: "",
      introImg: "/images/MDDetails/37187126_xl.jpg",
      title: "GENERAL SURGERY",
      contentTop: "General surgeons focus on organs within the abdominal cavity, including the stomach and colon. Many surgeons specialize in specific conditions or areas of the body. For example, vascular surgeons treat problems arising in the blood vessels, cardiac surgeons perform open surgeries on the heart, orthopedic surgeons treat the joints and bones, and neurosurgeons treat brain and spinal cord diseases.",
      slope: true
    },
    id: "arturo-g-gonzalez-md",
    name: "Arturo G. Gonzalez, MD",
    image: "/images/physianDirectory/G-Gonzalez.png",
    phone: "713-864-5487",
    gender: "Male",
    language: "English, Spanish",
    specialty: "General Surgery, GastroIntestinal Surgery",
    degrees: ["Medical Degree"],
    clinics: [
      {
            "name": "Minimally Invasive & Robotic Surgery",
            "address": "2222 Greenhouse Road, Suite 2000, Houston, TX 77084",
            "phone": "(713) 864-5487"
      }
],
    aboutBio: `Dr. Gonzalez is a general surgeon with 32 years of experience providing comprehensive surgical care to patients. He specialize in surgery, bringing more than three decades of expertise to complex medical procedures and patient care. Dr. Gonzalez completed medical school from Universidad Autonoma De Guadalajara Facultad De Medicina and went on to complete residency training of General Surgery at Houston Methodist Hospital. He specializes in minimally invasive procedures, including robotic-assisted surgery, laparoscopic surgery and colonoscopy, for both benign and malignant diseases. He multilingual capabilities enable him to communicate effectively with patients from diverse backgrounds. He is a member of American College of Surgeons.`,
    education: [
      "Medical Degree from Autonomous University of Guadalajara Mexico",
      "Residency (General Surgery) at Houston Methodist Hospital"
],
    expertise: [
      "Appendectomy",
      "Cholecystectomy (gallbladder removal)",
      "Cyst removal",
      "Diverticulitis Treatment",
      "Gastrointestinal surgery",
      "Hernia Repair",
      "Mastectomy and breast biopsy",
      "Reflux Surgery",
      "Splenectomy",
      "Thyroid/parathyroid surgery"
]
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "GENERAL SURGERY",
      mdName: "Mark J. Pidala, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },
    generalSurgeryDetailData: {
      title: "GENERAL SURGEONS DELIVER EXPERT, PATIENT-CENTERED CARE WITH A FOCUS ON SAFETY AND OPTIMAL OUTCOMES.",
      contentTop: "Here in the United States, General Surgeons perform an average of 23 different types of surgeries with the range being from 1 to 73 different operations, so the surgical team must always stay up to date on procedures and knowledge. General surgery often sets the standard of surgical care in the community due to the extensive range of surgeries they must perform. Each day is not like the day before, so the surgical team must always remain sharp throughout the care of each patient during their procedure.",
      slope: true,
      intoImgData: "/images/providers/genralSurgeryFrame.png",
    },
    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/G-Pidala.jpg",
      title: "GENERAL SURGEON",
      mdcontent: `Mark J. Pidala, MD is board certified in both general surgery and colon and rectal surgery. He has been in practice since 1990. Dr. Pidala performs all surgeries on the colon, rectum and anus, as well as routine and advanced colonoscopies. With over 35 years of experience in the medical field, his patients say they feel confident they are receiving the best care and soundest advice. They describe him as a very knowledgeable, extremely caring surgeon who communicates honestly with them.`,
      mdname: "MARK J. PIDALA, MD",
    },
        generalSurgeryDetaillinkData: {
      link: "",
      introImg: "/images/MDDetails/37187126_xl.jpg",
      title: "GENERAL SURGERY",
      contentTop: "General surgeons focus on organs within the abdominal cavity, including the stomach and colon. Many surgeons specialize in specific conditions or areas of the body. For example, vascular surgeons treat problems arising in the blood vessels, cardiac surgeons perform open surgeries on the heart, orthopedic surgeons treat the joints and bones, and neurosurgeons treat brain and spinal cord diseases.",
      slope: true
    },
    id: "mark-j-pidala-md",
    name: "Mark J. Pidala, MD",
    image: "/images/physianDirectory/G-Pidala.jpg",
    phone: "713-486-4660",
    gender: "Male",
    language: "English, Spanish",
    specialty: "Colorectal Surgery, General Surgery",
    degrees: ["Medical Degree"],
    clinics: [
      {
            "name": "UT Physicians Colon & Rectal Clinic \u2013 Peakwood",
            "address": "800 Peakwood Dr, Ste 2C, Houston, TX 77090",
            "phone": "(713) 486-4650"
      },
      {
            "name": "UT Physicians Colon & Rectal Clinic \u2013 The Woodlands",
            "address": "9200 Pinecroft Dr, Ste 320, Shenandoah, TX 77380",
            "phone": "(713) 486-4660"
      }
],
    aboutBio: `Dr. Pidala has extensive experience in both laparoscopic and robotic colon and rectal procedures. He performs all surgeries on the colon, rectum, and anus, as well as routine and advanced colonoscopies. Pidala moved here in 1998 and was one of the first colon and rectal surgeons in Houston to perform minimally invasive laparoscopic colon resections. Pidala is an assistant professor of surgery at McGovern Medical School at UTHealth Houston. He plays an active role in the education of the residents enrolled in the colon and rectal surgery program at the medical school. Pidala received his medical degree from the University of Cincinnati College of Medicine and completed his residency in general surgery at Summa Health System Akron City Hospital. He then completed fellowship training in colon and rectal surgery at the University of Medicine and Dentistry of New Jersey/Robert Wood Johnson Medical School in New Brunswick. He has published numerous peer-reviewed articles and book chapters. Outside of work, Pidala enjoys spending quality time with his wife and three children, traveling, and exercising.`,
    education: [
      "Medical School at University of Cincinnati College of Medicine",
      "Residency, Summa Health System Akron City Hospital",
      "Fellowship at University of Medicine and Dentistry of New Jersey"
],
    expertise: [
      "Anorectal Abscess",
      "Anal and Rectal Cancer",
      "Colon Cancer",
      "Constipation",
      "Crohns Disease",
      "Flexible Sigmoidoscopy",
      "Hemorrhoids",
      "Incontinence",
      "Proctosigmoidoscopy",
      "Warts"
]
  }
];

export const physicianObsGynData = [
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Alejandra Andrade-Gonzalez, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
  
    cardioThoracicDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/G-Kim.jpeg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent:
        "Dr. Alejandra Andrade-Gonzalez, MD is an Obstetrician Gynecologist based in Houston, TX and has over 21 years of experience.",
      mdname: "ALEJANDRA ANDRADE-GONZALEZ, MD"
    },
  
    generalSurgeryDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women’s care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
  
    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/G-Kim.jpeg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent:
        "Dr. Alejandra Andrade-Gonzalez, MD is an Obstetrician Gynecologist based in Houston, TX and has over 21 years of experience.",
      mdname: "ALEJANDRA ANDRADE-GONZALEZ, MD"
    },
  
    id: "alejandra-andrade-gonzalez-md",
    name: "Alejandra Andrade-Gonzalez, MD",
    image: "/images/doctors/alejandra-andrade-gonzalez.jpg",
    phone: "(713) 773-6803",
    gender: "Female",
    language: "English, Spanish",
  
    specialty: "Obstetrics and Gynecology",
  
    degrees: [
      "Medical Degree – University of Iowa Carver College of Medicine"
    ],
  
    clinics: [
      {
        name: "Hope Clinic Main",
        address: "7001 Corporate Dr Ste 120, Houston, TX 77036"
      },
      {
        name: "Hope Clinic – West",
        address: "12121 Westheimer Rd Ste 205, Houston, TX 77077"
      }
    ],
  
    bio_name: "About Dr. Alejandra Andrade-Gonzalez",
    bio: `
    Dr. Andrade-Gonzalez graduated from medical school in Honduras and completed her first OBGYN residency in Guatemala. Dr. Andrade-Gonzalez graduated from University of Iowa Carver College of Medicine in 2013. Dr. Andrade-Gonzalez completed a residency at Yale University. She then completed her second residency in Obstetrics and Gynecology at UT Houston McGovern Medical School. </br>After deciding to pursue a career as an OBGYN in the United States she has dedicated her career to providing quality health care, with a focus on women in vulnerable populations.
    `,
  
    education: [
      "Medical Education – University of Iowa Carver College of Medicine",
      "Residency – Yale University",
      "Fellowship – Brown University Alpert Medical School"
    ],
  
    areasOfExpertise: `
      <ul>
        <li>Vaginal Cysts</li>
        <li>Vaginal Dryness</li>
        <li>Excessive Vaginal Bleeding</li>
        <li>Hormone Replacement Therapy (HRT)</li>
      </ul>
      <ul>
        <li>Intrauterine Device (IUD) Insertion</li>
        <li>C-Section</li>
        <li>Vaginal Delivery and VBAC</li>
        <li>Coagulation Defects in Pregnancy and Postpartum</li>
      </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Zishan Hirani, MD, MS, FACOG",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
  
    cardioThoracicDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent:
        "Zishan Hirani, MD, MS, FACOG, received his medical degree from the University of Texas Southwestern Medical School in 2015. He went on to complete his Obstetrics and Gynecology residency at the University of Texas Rio Grande Valley at Doctors Hospital at Renaissance in 2019.",
      mdname: "ZISHAN HIRANI, MD, MS, FACOG"
    },
  
    id: "zishan-hirani-md",
    name: "Zishan Hirani, MD, MS, FACOG",
    image: "/images/doctors/zishan-hirani.jpg",
    phone: "713-442-8000",
    gender: "Male",
    language: "English, Hindi",
  
    specialty:
      "General Obstetrics & Gynecology, Minimally Invasive Gynecologic Surgery, Urogynecology & Pelvic Reconstructive Surgery",
  
    degrees: [
      "Medical Degree – University of Texas Southwestern Medical School"
    ],
  
    clinics: [
      {
        name: "Stafford Clinic",
        address: "11211 Nexus Ave, Stafford, TX 77477"
      }
    ],
  
    bio_name: "About Dr. Zishan Hirani",
    bio: `
    Dr. Hirani treats women from adolescence and beyond for common gynecological conditions and issues, including annual well-woman exams, irregular menstrual cycles, premenstrual syndrome (PMS), vaginitis, other vaginal or pelvic pain or infections, and more. In addition, he provides obstetric care for all stages of pregnancy, including childbirth and post-partum care, as well as family planning. His clinical interests include minimally invasive gynecological surgery, urinary incontinence, pelvic organ prolapse surgery, and high-risk
    obstetrics.</br></br>Z. Hirani, L. Padilla-Williams, R. Prieto-Harris, C. Ballesteros (2017). Oral Presentation: A Multidisciplinary Collaboration to Decrease the Primary Cesarean Section Rate at a New Academic Medical Center. 1st Place Abstract, SASGOG: 2017 ACOG Annual Clinical and Scientific Meeting, Annual Meeting, 05/07/2017.</br></br>L. Padilla-Williams, R. Prieto-Harris, Z. Hirani, C. Ballesteros (2017). Oral Presentation: Engaging Residents in Quality Improvement: a Multidisciplinary Collaboration to Decrease the Primary Cesarean Section Rate at a New Academic Medical Center. Group 3, Regency O. Oral Abstract, CREOG and APGO Annual Meeting, 03/09/2017.
    `,
  
    education: [
      "University of Texas Southwestern Medical School – 2015",
      "University of Texas Rio Grande Valley at Doctors Hospital at Renaissance – Residency, 2019",
      "American Board of Obstetrics and Gynecology – OBGYN"
    ],
  
    areasOfExpertise: `
      <ul>
        <li>Weight Loss Surgeries</li>
        <li>Colon Surgery</li>
        <li>Hernia Surgery</li>
        <li>Gallbladder Surgery</li>
        <li>GERD/Reflux Surgery</li>
      </ul>
      <ul>
        <li>Lumpectomy</li>
        <li>Mastectomy</li>
      </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=6lDyanlgzWw",
      title: "Obstetrics & Gynecology Surgery",
      contentTop:
        "Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training while staying current on the latest advances in women’s care and state-of-the-art surgical procedures.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Alpa M. Nick, MD, MS",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
  
    cardioThoracicDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women’s care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent:
        "Dr. Alpa M. Nick is a Gynecologist Oncologist in Houston, TX. She received her medical degree from LSU School of Medicine in Shreveport and has been in practice for more than 20 years. Dr. Alpa M. Nick has expertise in treating hysterectomy, among other feminine pelvic conditions",
      mdname: "ALPA M. NICK, MD, MS"
    },
  
    id: "alpa-m-nick-md",
    name: "Alpa M. Nick, MD, MS",
    image: "/images/doctors/alpa-m-nick.jpg",
    phone: "(713) 467-1722",
    gender: "Female",
    language: "English",
  
    specialty:
      "Gynecologic Oncology, General Gynecology",
  
    degrees: [
      "Medical Doctorate – Louisiana State University School of Medicine",
      "Master of Science in Cancer Biology;",
      "The University of Texas MD Anderson Cancer Center"
    ],
  
    clinics: [
      {
        name: "Texas Oncology – Houston Memorial",
        address: "925 Gessner Rd, Suite 550, Houston, TX 77024",
        phone: "(713) 467-1722"
      },
      {
        name: "Texas Oncology – Katy",
        address: "1331 West Grand Pkwy. North, Suite 340 Katy, TX 77493",
        phone: "(281) 392-2757"
      }
    ],
  
    bio_name: "About Dr. Alpa M. Nick",
    bio: `
    Dr. Nick graduated from Louisiana State University and is completed a residency at Vanderbilt University Medical Center.</br>Dr. Nick offers highly specialized care in uterine, ovarian and other gynecologic cancers, laparoscopic and robotic surgery, lymphatic mapping, novel chemotherapy treatment options, clinical research trials, management of patients with high risk genetics for gynecologic disease, and surgical management of complex gynecologic disorders.
    `,
  
    education: [
      "Medical Doctorate – Louisiana State University School of Medicine",
      "Residency in Obstetrics and Gynecology – Vanderbilt University Medical Center",
      "Fellowship in Gynecologic Oncology – The University of Texas MD Anderson Cancer Center",
      "Master of Science in Cancer Biology – The University of Texas MD Anderson Cancer Center"
    ],
  
    areasOfExpertise: `
      <ul>
        <li>Uterine (Endometrial) Cancer</li>
        <li>Ovarian Cancer</li>
        <li>Fallopian Tube Cancer</li>
        <li>Peritoneal Cancer</li>
        <li>Cervical Cancer</li>
      </ul>
      <ul>
        <li>Vaginal Cancer</li>
        <li>Vulvar Cancer</li>
        <li>Gynecologic Sarcomas</li>
        <li>Gestational Trophoblastic Disease</li>
        <li>Pre-Invasive Diseases of the Genital Tract</li>
      </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Therese A. Malcolm, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
  
    cardioThoracicDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women’s care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent:
        "Dr. Therese A Malcolm, MD is a Gynecologist/Obstetrician and primarily located in Kingwood, Texas.  Dr. Malcolm has an experience of 30+ years in this fields of expertise, including Birth Control, C-section, and standard Child Birth.",
      mdname: "THERESE A. MALCOLM, MD"
    },
  
    id: "therese-a-malcolm-md",
    name: "Therese A. Malcolm, MD",
    image: "/images/doctors/therese-a-malcolm.jpg",
    phone: "(281) 348-8000",
    gender: "Female",
    language: "English",
  
    specialty: "Obstetrics and Gynecology",
  
    degrees: [
      "Medical Degree – Albert Einstein College of Medicine"
    ],
  
    clinics: [
      {
        name: "HCA Houston Healthcare Kingwood",
        address: "22999 Highway 59 N, Kingwood, TX 77339"
      },
      {
        name: "Woman’s Hospital of Texas",
        address: "7600 Fannin St, Houston, TX 77054"
      }
    ],
  
    bio_name: "About Dr. Therese A. Malcolm",
    bio: `
    Dr. Malcolm completed Medical School from Albert Einstein College of Medicine in 1992. She specializes in women's health, particularly the female reproductive system, pregnancy and childbirth. As an obstetrician-gynecologist, she can treat a number of health issues related to the vagina, uterus, ovaries, fallopian tubes and breasts. Dr Malcolm can also treat women during pregnancy, labor, childbirth and the postpartum period. In this specialty, doctors focus on reproductive care from puberty through adulthood.
    `,
  
    education: [
      "Medical Degree – Albert Einstein College of Medicine",
      "Residency – Mount Sinai Saint Luke’s Roosevelt Hospital"
    ],
  
    areasOfExpertise: `
      <ul>
        <li>Abdominal Pain in Pregnancy</li>
        <li>High-Risk Pregnancy</li>
        <li>Salpingitis</li>
        <li>Endometriosis</li>
        <li>Chronic Pelvic Pain</li>
      </ul>
      <ul>
        <li>Preeclampsia</li>
        <li>Prelabor Rupture of Membranes</li>
        <li>Pudendal Neuralgia</li>
        <li>Round Ligament Pain</li>
        <li>Coagulation Defects in Pregnancy and Postpartum</li>
      </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Paola G. Torres Ortiz, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
  
    cardioThoracicDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women’s care and state-of-the-art surgical procedures.",
      slope: true,
       intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent:
        "Dr. Paola Torres-Ortiz, MD completed her residency in Obstetrics and Gynecology at Michigan State University/Spectrum Health in Grand Rapids, Michigan.  She offers comprehensive obstetrics and gynecology care that follows evidence-based medicine for women during all phases of their life. Her clinical interests include managing high-risk pregnancies, chronic pelvic pain, and minimally invasive surgery, including robotic surgery.",
      mdname: "PAOLA G. TORRES ORTIZ, MD"
    },
  
    id: "paola-g-torres-ortiz-md",
    name: "Paola G. Torres Ortiz, MD",
    image: "/images/doctors/paola-g-torres-ortiz.jpg",
    phone: "(832) 826-7500",
    gender: "Female",
    language: "English, Spanish",
  
    specialty: "Obstetrics and Gynecology",
  
    degrees: [
      "Medical Degree – Universidad de Los Andes"
    ],
  
    clinics: [
      {
        name: "Texas Children’s Pavilion for Women",
        address: "6651 Main Street, Houston, TX 77030"
      }
    ],
  
    bio_name: "About Dr. Paola G. Torres Ortiz",
    bio: `
    Dr. Torres Ortiz, who was born and raised in Venezuela, is driven by her passion for women's health and providing quality care.  Her clinical interests encompass a wide spectrum, from pregnancy and well-woman care to minimally invasive gynecologic surgery and the management of benign gynecologic conditions.</br>In her practice, Dr. Torres Ortiz aims to provide personalized treatment options designed to meet the unique needs of each patient. She prioritizes patient-centered care and strives to build strong, collaborative relationships with her patients. By fostering open communication and mutual trust, she empowers her patients to actively participate in their health care decisions, ensuring they feel heard and valued throughout their journey to wellness. 
    `,
  
    education: [
      "Medical Degree – Universidad de Los Andes",
      "Residency; Michigan State University"
    ],
  
    areasOfExpertise: `
      <ul>
        <li>Birth Control / Contraception</li>
        <li>Cervical Cancer</li>
        <li>Ectopic / Tubal Pregnancy</li>
        <li>Endometriosis</li>
        <li>Hormone Replacement Therapy (HRT)</li>
      </ul>
      <ul>
        <li>Hysterectomy</li>
        <li>Intrauterine Device (IUD) Insertion / Removal</li>
        <li>IVF / Reproductive Endocrinology</li>
        <li>Myomectomy</li>
        <li>Ovarian Cystectomy</li>
      </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Christine M. Lee, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
  
    cardioThoracicDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women’s care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent:
        "Dr. Christine M. Lee, MD is a gynecologic oncologist in Shenandoah, TX with over 20 years of experience. She specializes in the surgical and medical treatment of gynecologic cancers.",
      mdname: "CHRISTINE M. LEE, MD"
    },
  
    id: "christine-m-lee-md",
    name: "Christine M. Lee, MD",
    image: "/images/doctors/christine-m-lee.jpg",
    phone: "(281) 296-0365",
    gender: "Female",
    language: "English, Spanish",
  
    specialty: "Oncology, Gynecologic Oncology",
  
    degrees: [
      "Medical Degree – Wayne State University School of Medicine"
    ],
  
    clinics: [
      {
        name: "Texas Oncology – The Woodlands East",
        address: "9180 Pinecroft Dr Ste 600, The Woodlands, TX 77380"
      },
      {
        name: "Texas Oncology – Beaumont MaC Center",
        address: "690 N 14th St FL 3, Beaumont, TX 77702"
      }
    ],
  
    bio_name: "About Dr. Christine M. Lee",
    bio: `
    A graduate of Wayne State University School of Medicine in Detroit, Mich., Dr. Lee completed her residency in obstetrics and gynecology at The University of Texas Medical Branch in Galveston.</br>Dr. Lee completed a fellowship in gynecologic oncology at The University of Texas MD Anderson Cancer Center in Houston. While at MD Anderson, she received a master's degree in cancer biology from McGovern Medical School at UTHealth. Dr. Lee is double board certified in obstetrics and gynecology as well as gynecologic oncology.</br>Possessing a particular interest in ovarian cancer at the molecular level, Dr. Lee was awarded an educational grant to investigate ovarian cancer and targeted gene therapy. She also has access to gynecologic oncology clinical trials for patients with recurrent/progressive cancers. She provides many highly specialized cancer treatments, including tumor debulking surgeries for ovarian cancer and complex ovarian cancer chemotherapy regimens.</br>In addition to patient care and research activities, Dr. Lee has contributed numerous articles and abstracts that have been published in peer-reviewed journals with emphasis on endometrial and ovarian cancers. She is a member of numerous medical societies, including the Society of Gynecologic Oncology, American Society of Clinical Oncology and American College of Obstetrics and Gynecology.
    `,
  
    education: [
      "BA Degree in Biology – Wellesley College",
      "Medical Degree – Wayne State University School of Medicine",
      "MS Degree in Cancer Biology – University of Texas Graduate School of Biomedical Sciences",
      "Residency – University of Texas Medical Branch",
      "Fellowship – University of Texas MD Anderson Cancer Center"
    ],
  
    areasOfExpertise: `
      <ul>
        <li>Robotic Laparoscopic Hysterectomy</li>
        <li>Robotic Lymphadenectomy</li>
        <li>Radical Vulvectomy</li>
        <li>Sentinel Lymph Node (SLN) Mapping</li>
      </ul>
      <ul>
        <li>Gestational Trophoblastic Disease</li>
        <li>Gynecologic Sarcomas</li>
        <li>Tumor Debulking for Gynecologic Malignancies</li>
        <li>Complex Benign Gynecological Conditions</li>
      </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      link: "https://embed-ssl.wistia.com/deliveries/8d06a4b6338b956c50dae603c05320872204e0a1/file.mp4",
      // introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Jennifer L. Brown, MD, MS",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
  
    cardioThoracicDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women’s care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/MDDetails/22086509_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent:
        "Dr. Jennifer L. Brown, MD, MS is a Gynecologic Oncologist and Obstetrician Gynecologist in Webster, TX with over 16 years of experience.",
      mdname: "JENNIFER L. BROWN, MD, MS"
    },
  
    id: "jennifer-l-brown-md-ms",
    name: "Jennifer L. Brown, MD, MS",
    image: "/images/doctors/jennifer-l-brown.jpg",
    phone: "(281) 296-0365",
    gender: "Female",
    language: "English",
  
    specialty: "Gynecologic Oncology, Obstetrics & Gynecology",
  
    degrees: [
      "Medical Doctorate – University of Alabama at Birmingham",
     // "Master of Science in Clinical Research – Drexel University"
    ],
  
    clinics: [
      {
        name: "Texas Oncology",
        address: "9180 Pinecroft Dr, Ste 600, Shenandoah, TX 77380"
      },
      {
        name: "Texas Oncology – Kingwood",
        address: "18980 W. Memorial Drive, Suite 440 Kingwood, TX 77338"
      },
      {
        name: "Texas Oncology – Beaumont",
        address: "3010 Harrison Ave.Beaumont, TX 77702"
      }
    ],
  
    bio_name: "About Dr. Jennifer L. Brown",
    bio: `
    Dr. Brown is a gynecology oncologist, that sees patients at Texas Oncology- Kingwood.</br>She attended a gynecologic oncology lecture during medical school and was inspired by the speaker’s passion about the specialty. During her earlier years, she gained an understanding and appreciation for the continuity of care throughout a patient’s cancer journey.  She fell in love with gynecologic oncologic surgery, as well as the high level of care and patient involvement. All these factors played into her decision to pursue this specialty as a career.
    `,
  
    education: [
      "Fellowship in Gynecologic Oncology – Temple University",
      "Fellowship in Minimally Invasive Advanced Pelvic Surgery – Fox Chase Cancer Center",
      "Residency in Obstetrics and Gynecology – University of Alabama at Birmingham Hospital",
      "Medical Doctorate – University of Alabama at Birmingham",
      "Master of Science in Clinical Research – Drexel University"
    ],
  
    areasOfExpertise: `
      <ul>
        <li>Uterine Ovarian Cancer</li>
        <li>Cervical Cancer</li>
        <li>Complex Benign Gynecological Conditions</li>
      </ul>
      <ul>
        <li>Gestational Trophoblastic Disease</li>
        <li>Gynecological Sarcoma</li>
        <li>Robotic Laparoscopic Pelvic SLN</li>
      </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Ngozi Ibe, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
  
    cardioThoracicDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women’s care and state-of-the-art surgical procedures.",
      slope: true,
     intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent:
        "Dr. Ngozi Ibe, MD is an Obstetrician Gynecologist in Tomball, TX with over 15 years of experience in the medical field.",
      mdname: "NGOZI IBE, MD"
    },
  
    id: "ngozi-ibe-md",
    name: "Ngozi Ibe, MD",
    image: "/images/doctors/ngozi-ibe.jpg",
    phone: "(281) 255-0000",
    gender: "Female",
    language: "English",
  
    specialty: "Obstetrics and Gynecology",
  
    degrees: [
      "Medical Degree – Jacobs School of Medicine and Biomedical Sciences, University at Buffalo"
    ],
  
    clinics: [
      {
        name: "Tomball Woman’s Healthcare Center",
        address: "13426 Medical Complex Dr Ste 200 Tomball, TX 77375"
      }
    ],
  
    bio_name: "About Dr. Ngozi Ibe",
    bio: `
    Dr. Ibe is board-certified by the American Board of Obstetrics and Gynecology and provides comprehensive care for women of all ages and brings with her a diverse range of experience including management of high-risk pregnancies. Dr. Ibe earned her medical degree from the State University of New York at Buffalo and completed residency in Obstetrics and Gynecology at The Ohio State University Medical Center in Columbus. Patients of Dr. Ibe receive the time and attention they deserve at each visit as she considers it a privilege to get to know them in order to provide high quality, individualized care that fits their needs. Dedicated to improving population health, Dr. Ibe has served the communities in which she has practiced by conducting education seminars at local colleges and churches, where she covered topics relating to women’s health issues.
    `,
  
    education: [
      "Undergraduate Degree – University at Buffalo",
      "Medical Degree – University at Buffalo",
      "Internship – Ohio State University Wexner Medical Center",
      "Residency – Ohio State University Wexner Medical Center"
    ],
  
    areasOfExpertise: `
      <ul>
        <li>Hysterectomy</li>
        <li>IUD Implantation / Removal</li>
        <li>Benign Ovarian Cyst</li>
        <li>C-Section</li>
        <li>Cervical Cancer</li>
      </ul>
      <ul>
        <li>Menopausal Disorders</li>
        <li>Menstrual Disorders</li>
        <li>Oophorectomy</li>
        <li>Ovarian Cancer</li>
        <li>Pelvic Exams and Pap Smear</li>
      </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Brooke Jemelka Weaver, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
  
    cardioThoracicDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women’s care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_34.png",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent:
        "Dr. Brooke Jemelka Weaver earned her medical degree from Texas A&M Health Science Center and completed her residency training in Obstetrics and Gynecology at Mercy Hospital in St. Louis, MO.",
      mdname: "BROOKE JEMELKA WEAVER, MD"
    },
  
    id: "brooke-jemelka-weaver-md",
    name: "Brooke Jemelka Weaver, MD",
    image: "/images/doctors/brooke-jemelka-weaver.jpg",
    phone: "(281) 637-9905",
    gender: "Female",
    language: "English",
  
    specialty: "Obstetrics and Gynecology, Women’s Health",
  
    degrees: [
      "Medical Degree – Texas A&M College of Medicine"
    ],
  
    clinics: [
      {
        name: "Caritas Women’s Care – Baylor St. Luke’s Medical Group",
        address: "1327 Lake Pointe Parkway, Suite 500, Sugar Land, TX 77478"
      }
    ],
  
    bio_name: "About Dr. Brooke Jemelka Weaver",
    bio: `
    Dr. Jemelka Weaver is an OBGYN in Sugar Land, Texas. She earned a medical degree from Texas A&M Health Science Center and completed residency training in OB/GYN care at Mercy Hospital in St. Louis, MO. She is a member of the American Academy of FertilityCare Professionals, American Association of Gynecologic Laparoscopists, International Institute of Restorative Reproductive Medicine, American Congress of Obstetrics & Gynecology, Catholic Medical Association, and is a Fellow of The American Congress of Obstetricians and Gynecologists (FACOG).</br>Dedicated to providing holistic, comprehensive, and restorative services for women from adolescence through menopause, Dr. Jemelka Weaver is a member of Baylor St. Luke's Medical Group Caritas Women's Care in Sugar Land. As one of only a handful of fellowship-trained NaProTECHNOLOGY surgeons in the United States, Dr. Jemelka uses this technology to address and treat a full range of gynecologic health concerns.</br>She is a member of the American Academy of Fertility Care Professionals, American Association of Gynecologic Laparoscopists, International Institute of Restorative Reproductive Medicine, American Congress of Obstetrics & Gynecology, and the Catholic Medical Association.
    `,
  
    education: [
      "Medical Degree – Texas A&M College of Medicine",
      "Medical School – University of North Texas Health Science Center at Fort Worth",
      "Residency – Mercy Hospital, St. Louis"
    ],
  
    areasOfExpertise: `
      <ul>
        <li>Hysterosalpingo Sonography</li>
        <li>Amenorrhea</li>
        <li>Coagulation Defects in Pregnancy & Postpartum</li>
        <li>C-Section</li>
        <li>Vaginal Delivery & VBAC</li>
      </ul>
      <ul>
        <li>Polycystic Ovarian Syndrome</li>
        <li>Menstrual Disorders</li>
        <li>Pregestational Diabetes Mellitus</li>
        <li>Preeclampsia</li>
        <li>Excessive Menstrual Bleeding</li>
      </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=rNoPs9Zmx-0",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Nina H. Dereska, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
  
    cardioThoracicDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women’s care and state-of-the-art surgical procedures.",
      slope: true,
     intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_35.png",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent:
        "Dr. Nina H. Dereska, MD is a fellowship-trained and board-certified specialist in Female Pelvic Medicine and Reconstructive Surgery and Obstetrics and Gynecology.",
      mdname: "NINA H. DERESKA, MD"
    },
  
    id: "nina-h-dereska-md",
    name: "Nina H. Dereska, MD",
    image: "/images/doctors/nina-h-dereska.jpg",
    phone: "(713) 406-1530",
    gender: "Female",
    language: "English",
  
    specialty:
      "Female Pelvic Medicine and Reconstructive Surgery, Urogynecology",
  
    degrees: [
      "Medical Degree – University of Florida College of Medicine"
    ],
  
    clinics: [
      {
        name: "UT Physicians – Department of Urogynecology",
        address:
          "17510 West Grand Parkway South, Suite 500, Sugar Land, TX 77479"
      }
    ],
  
    bio_name: "About Dr. Nina H. Dereska",
    bio: `
    Dr. Dereska earned her medical degree from the University of Florida College of Medicine in Gainesville, and completed her residency at Medical College of Georgia in Augusta. This was followed by her fellowship in female pelvic medicine and reconstructive surgery at Mayo Hospital and Clinic in Scottsdale, Arizona. She has expertise in urology and gynecology to provide women with comprehensive care for conditions such as prolapse, incontinence, pelvic pain, and other pelvic floor disorders. Her years of experience and advanced training helps restore a woman’s active lifestyle. She thoroughly reviews with each patient treatment options that include medical and surgical management of pelvic floor dysfunction. </br>Dr. Dereska often utilizes medical robotics for surgical cases to help minimize pain, hospital stay, blood loss, and scarring. Her goal is to get patients back to their normal daily activities.</br>In addition to providing compassionate patient care, Dereska is an assistant professor in the Department of Obstetrics, Gynecology and Reproductive Sciences at McGovern Medical School at UTHealth Houston.
    `,
  
    education: [
      "Medical School – University of Florida College of Medicine",
      "Residency – Medical College of Georgia",
      "Fellowship – Female Pelvic Medicine and Reconstructive Surgery, Mayo Hospital and Clinic, Scottsdale"
    ],
  
    areasOfExpertise: `
      <ul>
        <li>Bladder Emptying Challenges</li>
        <li>Female Sexual Dysfunction</li>
        <li>Loss of Bladder Control</li>
        <li>Painful Bladder Issues</li>
      </ul>
      <ul>
        <li>Urinary Tract Infections</li>
        <li>Vaginal Prolapse Surgery</li>
        <li>Colporrhaphy with Robotic Assist</li>
        <li>Atrophic Vaginitis</li>
      </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Elvis Torres, DO",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
  
    cardioThoracicDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women’s care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_36.png",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent:
        "Dr. Elvis Torres, DO is an obstetrician-gynecologist in Houston, Texas and is affiliated with multiple facilities in the area. He received his medical degree from Nova Southeastern University - College of Osteopathic Medicine and has been in practice for more than 30 years.",
      mdname: "ELVIS TORRES, DO"
    },
  
    id: "elvis-torres-do",
    name: "Elvis Torres, DO",
    image: "/images/doctors/elvis-torres.jpg",
    phone: "(281) 496-2496",
    gender: "Male",
    language: "English, Spanish",
  
    specialty: "Obstetrics and Gynecology",
  
    degrees: [
      "Medical Doctorate – Nova Southeastern University – The Health Sciences"
    ],
  
    clinics: [
      {
        name: "Family Futures",
        address: "12121 Richmond Ave Ste 201 Houston, TX 77082"
      }
    ],
  
    bio_name: "About Dr. Elvis Torres",
    bio: `
    Dr. Torres graduated from Nova Southeastern University -The Health Sciences in 1991. Dr. Torres completed a residency at University of South Alabama. </br>Dr. Torres is affiliated with HCA Houston Healthcare West and practices at Family Futures in Houston, TX. He frequently treats conditions like Maternal Anemia and Coagulation Defects in Pregnancy and Postpartum along with other conditions at varying frequencies.
    `,
  
    education: [
      "Medical Degree – Nova Southeastern University – The Health Sciences",
      "Residency – University of South Alabama",
      "Internship – Universal Medical Center"
    ],
  
    areasOfExpertise: `
      <ul>
        <li>Maternal Anemia</li>
        <li>Coagulation Defects in Pregnancy and Postpartum</li>
        <li>C-Section</li>
        <li>Vaginal Delivery and VBAC</li>
        <li>Tubal Ligation</li>
      </ul>
      <ul>
        <li>Mastodynia</li>
        <li>Pregestational Diabetes Mellitus</li>
        <li>Birth Control</li>
        <li>Intrauterine Device (IUD) Placement</li>
        <li>Chronic Pelvic Pain</li>
      </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Silvana Pedra Nobre, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
  
    cardioThoracicDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women’s care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_37.png",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent:
        "Dr. Silvana Pedra-Nobre, MD is a Gynecologic Oncologist and an Obstetrics and Gynecologist in Houston, Texas. Her top areas of expertise are Endometrial Cancer, Vaginal Cancer, Ovarian Cancer, Cervical Cancer, and Hysterectomy.",
      mdname: "SILVANA PEDRA NOBRE, MD"
    },
  
    id: "silvana-pedra-nobre-md",
    name: "Silvana Pedra Nobre, MD",
    image: "/images/doctors/silvana-pedra-nobre.jpg",
    phone: "(832) 377-3770",
    gender: "Female",
    language: "English, Spanish, Portuguese",
  
    specialty: "Gynecologic Oncology, Obstetrics & Gynecology",
  
    degrees: [
      "Medical Doctorate – Ponce Health Sciences University"
    ],
  
    clinics: [
      {
        name: "Texas Oncology–Houston Medical Center Gynecologic Oncology",
        address: "7500 Fannin St, Suite 100A, Houston, TX 77054",
        phone: "(832) 377-3770"
      },
      {
        name: "Texas Oncology–Houston Willowbrook",
        address: "13215 Dotson Road, Suite 300</br>Houston, TX 77070",
        phone: "(281) 894-8823"
      }
    ],
  
    bio_name: "About Dr. Silvana Pedra Nobre",
    bio: `
    Dr. Pedra Nobre, MD is a board-certified Gynecological Oncologist. She received her medical doctorate from Ponce Health Sciences University School of Medicine and completed a residency at Medstar Washington Hospital Center.  Dr. Pedra Nobre is affiliated with The Woman's Hospital of Texas and she practices at Texas Oncology - Houston Medical Center Gynecologic Oncology in Houston, TX.
    `,
  
    education: [
      "Medical Doctorate – Ponce Health Sciences University",
      "Master of Science in Clinical Epidemiology and Health Services Research – Cornell University",
      "Fellowship in Gynecologic Oncology – University of Iowa Hospitals & Clinics",
      "Residency in Obstetrics and Gynecology – MedStar Washington Hospital Center"
    ],
  
    areasOfExpertise: `
      <ul>
        <li>Chronic Pelvic Pain</li>
        <li>C-Section</li>
        <li>Ectopic Pregnancy</li>
        <li>Endometriosis</li>
        <li>Gestational Diabetes</li>
      </ul>
      <ul>
        <li>Intrauterine Growth Restriction</li>
        <li>Menopausal and Postmenopausal Disorders</li>
        <li>Ovarian Cysts</li>
        <li>Preeclampsia</li>
        <li>Hysterectomy</li>
      </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Dama A. Ziwortin, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
  
    cardioThoracicDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women’s care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_38.png",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent:
        "Dr. Dama A. Ziworitin, MD is an obstetrician-gynecologist in Houston, Texas. He received his medical degree from University of Port Harcourt College of Health Services and has been in practice for more than 20 years.",
      mdname: "DAMA A. ZIWORTIN, MD"
    },
  
    id: "dama-a-ziwortin-md",
    name: "Dama A. Ziwortin, MD",
    image: "/images/doctors/dama-a-ziwortin.jpg",
    phone: "(832) 532-7068",
    gender: "Male",
    language: "English, Spanish, French",
  
    specialty: "Obstetrics & Gynecology, Critical Care Medicine",
  
    degrees: [
      "Medical Degree – University of Port Harcourt College of Health Services",
      "MBBS – University of Port Harcourt College of Health Services"
    ],
  
    clinics: [
      {
        name: "Genesys Women OB Gyn",
        address: "12000 Richmond Avenue, Suite 215, Houston, TX, 77082"
      },
      {
        name: "HCA Houston Healthcare West",
        address: "12141 Richmond Ave., Houston, TX 77082"
      }
    ],
  
    bio_name: "About Dr. Dama A. Ziwortin",
    bio: `
    Dr. Ziworitin is a board-certified OB/GYN with extensive training in women’s health and advanced pelvic surgery. He earned his MBBS and MD from the University of Port Harcourt in 1996, followed by an internship at Braithwaite Memorial Hospital. From 2004 to 2007, he pursued further specialized training in obstetrics and gynecology, including a fellowship in Advanced Pelvic Surgery at Southeastern Gynecologic and Oncology, LLC. Dr. Ziworitin is known for his deep compassion, clinical expertise, and dedication to providing comprehensive, personalized care to women at all stages of life. He is committed to ensuring each patient feels heard, supported, and empowered in their healthcare journey.
    `,
  
    education: [
      "Fellowship, Advance Pelvic Surgery; Southeastern Gynecologic and Oncology, LLC",
      "Residency – Brookdale Hospital Medical Center",
      "Fellowship – Advanced Pelvic Surgery, Southeastern Gynecologic Oncology, LLC",
      "Internship – Braithwaite Memorial Hospital"
    ],
  
    areasOfExpertise: `
      <ul>
        <li>Hysterosalpingography</li>
        <li>Uterine Fibroid Procedures</li>
        <li>Vaginal Delivery and VBAC</li>
        <li>C-Section</li>
        <li>Maternal Anemia</li>
      </ul>
      <ul>
        <li>Coagulation Defects in Pregnancy and Postpartum</li>
        <li>Chronic Pelvic Pain</li>
        <li>Preterm Labor</li>
        <li>Preeclampsia</li>
        <li>Vaginal & Vulvar Cancer</li>
      </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true
    }
  },
  //new surgeons
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Adekorewale A. Odulate-Williams, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    cardioThoracicDetailData: {
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg",
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Odulate.jpg",
      title: "UROGYNECOLOGIST",
      mdcontent:
        "Adekorewale Odulate-Williams, MD is an obstetrician-gynecologist in Houston, Texas. He has been in practice between 6-10 years. His top areas of expertise are Stress Urinary Incontinence, Urinary Incontinence, and Uterine Prolapse.",
      mdname: "ADEKOREWALE A. ODULATE-WILLIAMS, MD",
    },

    id: "adekorewale-odulate-williams-md",
    name: "Adekorewale A. Odulate-Williams, MD",
    image: "/images/physianDirectory/md_26.png",
    phone: "713-486-3050",
    gender: "Male",
    language: "English",
    specialty: "Obstetrics and Gynecology, Female Pelvic Medicine and Reconstructive Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "UT Physicians Urogynecology Center – Greater Heights",
        address: "1631 North Loop W, Ste 220, Houston, TX 77008",
        phone: "(713) 486-3050",
      },
      {
        name: "UT Physicians Urogynecology Center – Katy",
        address: "23920 Katy Fwy, Ste 305, Katy, TX 77494",
        phone: "(713) 486-3050",
      },
      {
        name: "UT Physicians Urogynecology Center – Sugar Land",
        address: "17510 W Grand Pkwy S, Ste 500, Sugar Land, TX 77479",
        phone: "(713) 486-1530",
      },
    ],

    bio_name: "About Dr. Adekorewale A. Odulate-Williams",
    bio: `Dr. Odulate-Williams received his medical degree from SUNY Upstate Medical University and did his post graduate trainings at UTHealth Houston and USC's Keck School of Medicine.</br></br>
Dr. Odulate-Williams is an Assistant Professor of UTHealth's McGovern Medical School's Department of Obstetrics, Gynecology, and Reproductive Sciences. His clinical research consists of co-authoring 2 peer reviewed articles. He won 2nd place at Texas Association of Obstetricians and Gynecologists (TAOG) Resident Day for his research on route of colpoplexy post hysterectomy and surgical outcomes.`,

    education: [
      "Medical Degree from SUNY Upstate Medical University",
      "Bachelor of Science (Biological Sciences) from Tufts University",
      "Residency (Obstetrics and Gynecology) at The University of Texas Health Science Center at Houston",
      "Fellowship (Urogynecology & Reconstructive Surgery) at University of Southern California Medical Center",
    ],

    areasOfExpertise: `<ul>
      <li>Female Pelvic Medicine</li>
      <li>Fistulas</li>
      <li>Minimally Invasive Surgery/Robotic Surgery</li>
      <li>Pelvic Organ Prolapse</li>
      <li>Preeclampsia</li>
    </ul>
    <ul>
      <li>Reconstructive Surgery</li>
      <li>Reproductive and Pelvic Health Issues</li>
      <li>Urethral Diverticulum</li>
      <li>Urinary Incontinence</li>
      <li>Urinary Tract Infections (UTI)</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Ameer L. Touadrous, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    cardioThoracicDetailData: {
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg",
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Touadrous.jpg",
      title: "OBSTETRICIAN-GYNECOLOGIST",
      mdcontent:
        "Ameer L. Touadrous, MD is a board certified obstetrician-gynecologist in Houston, Texas. He received his medical degree from Cairo University School of Medicine and has been in practice for more than 20 years.",
      mdname: "AMEER L. TOUADROUS, MD",
    },

    id: "ameer-touadrous-md",
    name: "Ameer L. Touadrous, MD",
    image: "/images/physianDirectory/md_27.png",
    phone: "713-773-0803",
    gender: "Male",
    language: "English, Spanish, Arabic",
    specialty: "Obstetrics & Gynecology",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Hope Clinic- Beltway",
        address: "7001 Corporate Dr., Suite #120, Houston, TX 77036",
        phone: "(713) 773-0803",
      },
    ],

    bio_name: "About Dr. Ameer L. Touadrous",
    bio: `Dr. Touadrous lived in Cairo, Egypt until the age of 28, when he moved to Brooklyn, NY. He attended Cairo University for medical school and completed his residency at the Brooklyn Hospital Center.</br></br>
Dr. Touadrous became an OB/GYN because of the combination of clinical and surgical care. Dr. Touadrous performs Obstetrical care as well as Gynecologic surgeries. There is a real need for doctors and surgeons who specialize in caring for women, and he is both proud and humbled to be able to help.</br></br>
Dr. Touadrous, his wife and two kids love being here in Houston, Texas. His philosophy: "I believe in doing the ordinary things extraordinarily well."`,

    education: [
      "Medical Degree from Kasr El Aini Faculty of Medical, Cairo University",
      "Residency (Obstetrics and Gynecology) at Brooklyn Hospital Center",
    ],

    areasOfExpertise: `<ul>
      <li>Birth Control</li>
      <li>C-Section</li>
      <li>Chronic Pelvic Pain</li>
      <li>Excessive Menstrual Bleeding</li>
      <li>High Risk Pregnancy</li>
    </ul>
    <ul>
      <li>Hypertension</li>
      <li>Hysterosalpingo Sonography</li>
      <li>Maternal Anemia</li>
      <li>Vaginal Delivery</li>
      <li>Vaginal Prolapse Surgery</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Anne B. Alaniz, DO",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    cardioThoracicDetailData: {
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg",
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Alaniz.avif",
      title: "GYNECOLOGICAL ONCOLOGIST",
      mdcontent:
        "Anne B. Alaniz, DO, is board certified in gynecologic oncology, obstetrics, and gynecology and has over 20+ years of experience in the medical field. She has expertise in treating gynecologic conditions, uterine cancers, and hysterectomy, among other conditions.",
      mdname: "ANNE B. ALANIZ, DO",
    },

    id: "anne-alaniz-do",
    name: "Anne B. Alaniz, DO",
    image: "/images/physianDirectory/md_28.png",
    phone: "281-894-8822",
    gender: "Female",
    language: "English, Nyanja",
    specialty: "Gynecologic Oncology, Gynecology",

    degrees: ["Doctor of Osteopathy"],

    clinics: [
      {
        name: "Texas Oncology-Houston Willowbrook",
        address: "13215 Dotson Road, Suite 300, Houston, TX 77070",
        phone: "(281) 894-8822",
      },
      {
        name: "Texas Oncology-The Woodlands",
        address: "9180 Pinecroft, Suite 600, The Woodlands, TX 77380",
        phone: "(281) 296-0365",
      },
    ],

    bio_name: "About Dr. Anne B. Alaniz",
    bio: `Dr. Alaniz obtained her undergraduate degree from Dallas Baptist University in Dallas, Texas. She attended medical school at University of North Texas Health Science Center in Fort Worth, Texas. She completed a one-year rotational internship at Plaza Medical Center in Fort Worth, Texas. After that, she completed 4 years of Obstetrics and Gynecology residency at University of Missouri in Kansas City. She then pursued a fellowship in gynecologic oncology at York Hospital in York Pennsylvania prior to joining Houston Methodist Hospital as a gynecologic oncologist.</br></br>
She opened her practice soon after finishing her fellowship and has become one of the busiest Gynecologic Oncologists in the area. Her expertise is in surgical management and chemotherapy for women with gynecological cancers including ovarian, primary peritoneal, fallopian tube, uterine, cervix, vaginal and vulvar cancer. She has clinical expertise in minimally invasive surgery including robotic surgery and laparoscopy. She also has special interest in genetics of cancer, and clinical trials to continue to improve the prevention, diagnosis, and treatment of gynecological cancers.</br></br>
Dr Alaniz is the Co-Founder of Pothawira (Safe Haven) Christian Mission Organization in her home village around Salima, Malawi. Dr. Alaniz also serves as an Assistant Professor at Weill Cornell College of Medicine and Texas A&M University of College of Medicine.`,

    education: [
      "Doctor of Osteopathic Medicine, The University of North Texas Health Science Center at Fort Worth",
      "Residency (Obstetrics and Gynecology) at University of Missouri-Kansas City",
      "Fellowship (Gynecologic Oncology) at WellSpan York Hospital",
    ],

    areasOfExpertise: `<ul>
      <li>Cervical Cancer</li>
      <li>Endometrial Cancer</li>
      <li>Gynecologic Oncology Clinical Trials</li>
      <li>Hysterectomy</li>
      <li>Ovarian Cancer</li>
    </ul>
    <ul>
      <li>Pelvic Adhesive Disease</li>
      <li>Precancerous gynecologic diseases</li>
      <li>Robotic surgery and laparoscopic surgery</li>
      <li>Uterine Cancer</li>
      <li>Vaginal Cancer</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=3tVAFD13SL0",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Brandon L. Sass, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    cardioThoracicDetailData: {
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg",
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Sass.webp",
      title: "UROGYNECOLOGIST",
      mdcontent:
        "Brandon L. Sass, MD is a fellowship-trained specialist in Female Pelvic Medicine and Reconstructive Surgery, with a dedicated focus on urogynecology for adult and senior patients. Known for his personalized, patient-centered approach, Dr. Sass ensures that every individual feels heard, supported, and cared for.",
      mdname: "BRANDON L. SASS, MD",
    },

    id: "brandon-sass-md",
    name: "Brandon L. Sass, MD",
    image: "/images/physianDirectory/md_29.png",
    phone: "713-486-1530",
    gender: "Male",
    language: "English",
    specialty: "Obstetrics And Gynecology, Gynecology, Urogynecology, Pelvic Reconstructive Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "UT Physicians Urogynecology Center – Sugar Land",
        address: "17510 W Grand Pkwy S, Ste 500, Sugar Land, TX 77479",
        phone: "(713) 486-1530",
      },
    ],

    bio_name: "About Dr. Brandon L. Sass",
    bio: `Dr. Sass earned his medical degree at McGovern Medical School at The University of Texas Health Science Center at Houston (UTHealth), where he also completed his internship and residency in obstetrics and gynecology. He did fellowship training in female pelvic medicine and reconstructive surgery at the Women's Pelvic Restorative Center in Houston and Indiana University School of Medicine in Indianapolis.</br></br>
Dr. Sass has been in practice since 2013. His primary clinical interests are in female pelvic medicine and reconstructive surgery, including pelvic organ prolapse, urinary incontinence and pelvic floor dysfunction. He treats patients of all ages. Dr. Sass also serves as an assistant professor in the Department of Obstetrics, Gynecology, and Reproductive Sciences at McGovern Medical School.</br></br>
His practice centers on caring, appropriate and timely treatment and he provides his patients with a place where people really listen to them.</br></br>
A resident of Southside Place, Dr. Sass's leisure-time interests are literature, film, family, friends and travel.`,

    education: [
      "Medical Degree from The University of Texas Health Science Center at Houston",
      "Undergraduate Degree (Biology) at The University of Texas at Austin",
      "Residency (Obstetrics and Gynecology) from The University of Texas Health Science Center at Houston",
      "Fellowship (Female Pelvic Medicine and Reconstructive Surgery) at Women's Pelvic Restorative Center- UTHealth Houston",
      "Fellowship (Female Pelvic Medicine and Reconstructive Surgery) at Indiana University School of Medicine",
    ],

    areasOfExpertise: `<ul>
      <li>Bladder Disease</li>
      <li>Fistula Repair</li>
      <li>Hysterectomy</li>
      <li>Menopause</li>
      <li>Painful Bladder Syndrome</li>
    </ul>
    <ul>
      <li>Pelvic Floor Disorders</li>
      <li>Pelvic Organ Prolapse</li>
      <li>Stress Urinary Incontinence</li>
      <li>Urge Urinary Incontinence</li>
      <li>Vaginal Prolapse Repair</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Bryan Behne, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    cardioThoracicDetailData: {
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg",
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Behne.jpg",
      title: "OBSTETRICIAN GYNECOLOGIST",
      mdcontent:
        "Bryan Behne, MD specializes in obstetrics and gynecology, providing comprehensive women's healthcare services. With 25 years of experience, he focuses on supporting women through all stages of their reproductive health journey, from routine gynecologic care to pregnancy and delivery.",
      mdname: "BRYAN BEHNE, MD",
    },

    id: "bryan-behne-md",
    name: "Bryan Behne, MD",
    image: "/images/physianDirectory/md_30.png",
    phone: "281-367-6836",
    gender: "Male",
    language: "English, Spanish",
    specialty: "Obstetrics and Gynecology, Gynecology",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Woman's Healthcare Affiliates",
        address: "9180 Pinecroft Drive, Ste 100, Shenandoah, TX 77380",
        phone: "(281) 367-6836",
      },
      {
        name: "Memorial Hermann Surgery Center The Woodlands",
        address: "9200 Pinecroft Drive, Ste 200, Shenandoah, TX 77380",
        phone: "(281) 297-9500",
      },
    ],

    bio_name: "About Dr. Bryan Behne",
    bio: `Dr. Behne, originally from Murfreesboro, Tennessee, brings a unique background to the field of obstetrics and gynecology. Before pursuing medicine, Dr. Behne earned his degree in Electrical Engineering from the University of Tennessee, Knoxville, graduating with honors in 1992. He then spent five years working for Texas Instruments, where he contributed to advanced radar-seeking missile systems and communication technology. In 1996, he pivoted to a career in medicine, earning his medical degree from the University of Texas Health Science Center in San Antonio in 2001, and completing his residency in 2005.</br></br>
Since joining Women's Healthcare Affiliates that same year, Dr. Behne has provided top-tier care in obstetrics and gynecology. He is Board Certified by the American Board of Obstetrics and Gynecology, a Fellow of the American Congress of Obstetricians and Gynecologists, and an active member of the Texas Medical Association.</br></br>
Dr. Behne's clinical focus includes minimally invasive surgery, gynecological urology, pelvic floor reconstruction, and treating pelvic organ prolapse. He is also highly skilled in high-risk obstetrics, with a special interest in genetics and prenatal diagnosis.`,

    education: [
      "Medical Degree from University of Texas at San Antonio, Joe R & Teresa Lozano Long School of Medicine",
      "Residency (Obstetrics & Gynecology- Womens Health) at University of Texas Health Science Center",
      "Internship at University of Texas Health Center",
    ],

    areasOfExpertise: `<ul>
      <li>Birth Control</li>
      <li>C-Section</li>
      <li>Endometriosis</li>
      <li>Excessive Menstrual Bleeding</li>
      <li>Fallopian Tube Disorders</li>
      <li>Gynecological Urology</li>
      <li>Hysterectomy</li>
    </ul>
    <ul>
      <li>Minimally Invasive Surgery</li>
      <li>Pelvic Floor Reconstruction</li>
      <li>Pelvic Organ Prolapse</li>
      <li>Salpingectomy/ Oophorectomy</li>
      <li>Urinary Tract Infection (UTI)</li>
      <li>Vaginal Delivery and VBAC</li>
      <li>Vaginal Prolapse</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Chundar Tsai, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    cardioThoracicDetailData: {
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg",
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Tsai.jpg",
      title: "OBSTETRICIAN GYNECOLOGIST",
      mdcontent:
        "Chundar Tsai, MD is a board-certified obstetrician and gynecologist with 31 years of experience providing comprehensive women's healthcare. He specializes in obstetrics and gynecology, caring for women throughout all stages of life from routine wellness visits to pregnancy and delivery.",
      mdname: "CHUNDAR TSAI, MD",
    },

    id: "chundar-tsai-md",
    name: "Chundar Tsai, MD",
    image: "/images/physianDirectory/md_31.png",
    phone: "832-649-4273",
    gender: "Male",
    language: "Chinese (Mandarin), English",
    specialty: "Obstetrics and Gynecology",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Southwest Woman Care OB/GYN",
        address: "7789 Southwest Fwy Ste 400, Houston, TX 77074",
        phone: "(832) 649-4273",
      },
      {
        name: "Houston Plaza OBGYN",
        address: "1801 Binz St, Suite 500, Houston, TX 77004",
        phone: "(713) 522-3333",
      },
      {
        name: "Woman's Health Group",
        address: "7580 Fannin Street, Suite 208, Houston, TX 77054",
        phone: "(713) 791-9708",
      },
    ],

    bio_name: "About Dr. Chundar Tsai",
    bio: `Dr. Tsai came to Houston for his graduate education. After receiving his PhD. degree at University of Houston, he worked for a brief period in the industry. He changed his career when he discovered it is more rewarding in helping patients. He received his M.D. degree from Indiana University School of Medicine in Indianapolis. He received his residency training at University of Texas Medical Branch at Galveston. Since finishing his training, he has been practicing at the Texas Medical Center for the past 23 years.</br></br>
Dr. Tsai has received several honors, including the CMS Meaningful Use Stage 1 Certification and recognition as a Most Compassionate Doctor. He is also a Fellow of the American Congress of Obstetricians and Gynecologists (FACOG).</br></br>
Dr. Tsai believes in good patient education, teamwork among patient, family members and the physician. Dr. Tsai always keeps patient's interest as the highest priority. His approach is well appreciated by his patients and reflected in the results.</br></br>
Dr. Tsai lives in Houston with his wife. He enjoys traveling, table tennis, action movies, and jogging.`,

    education: [
      "Medical Degree from Indiana University School of Medicine",
      "Residency (Obstetrics and Gynecology) at University of Texas Medical Branch- Galveston",
    ],

    areasOfExpertise: `<ul>
      <li>Birth Control</li>
      <li>C-Section</li>
      <li>Cervical Cancer</li>
      <li>Gestational Diabetes</li>
      <li>High Risk Pregnancy</li>
    </ul>
    <ul>
      <li>Hysterosalpingo Sonography</li>
      <li>Infertility Evaluation</li>
      <li>Mastodynia</li>
      <li>Maternal Anemia</li>
      <li>Polycystic Ovarian Syndrome</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Cynthia E. Larson, DO",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    cardioThoracicDetailData: {
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg",
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Larson.jpg",
      title: "OBSTETRICIAN",
      mdcontent:
        "Cynthia Larson, DO is an obstetrician gynecologist in Webster, TX and has over 20 years of experience in the medical field. She graduated from University North Texas Health Science Center College of Osteopathic Medicine in 2002. Passionate about women's care and long term relationships with patients.",
      mdname: "CYNTHIA E. LARSON, DO",
    },

    id: "cynthia-larson-do",
    name: "Cynthia E. Larson, DO",
    image: "/images/physianDirectory/md_32.png",
    phone: "281-332-2511",
    gender: "Female",
    language: "English, Spanish",
    specialty: "Obstetrics and Gynecology",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "HCA Houston Healthcare West",
        address: "12141 Richmond Ave, Houston, TX 77082",
        phone: "(281) 558-3444",
      },
      {
        name: "HCA Houston Healthcare Clear Lake",
        address: "500 W Medical Center Blvd, Webster, TX 77598",
        phone: "(281) 332-2511",
      },
    ],

    bio_name: "About Dr. Cynthia E. Larson",
    bio: `Dr. Larson is a Gynecologist/Obstetrician with an experience of 21 years in this field. She completed medical school from Texas A&M University / Main Campus in 1998, Residency from Tulane in 2008 and Medical School from University North Texas Health Science Center College Of Osteopathic Medicine in 2002.</br></br>
Some of the services provided by the doctor are Menopausal and Postmenopausal Disorders, Herpes Simplex Screening, Gynecologic Cancer Screening, First Trimester Screening and Menstrual Disorders etc.`,

    education: [
      "Medical School from University North Texas Health Science Center College Of Osteopathic Medicine",
      "Residency at Tulane Hospital",
      "Internship at Good Samaritan Hospital",
    ],

    areasOfExpertise: `<ul>
      <li>C-Section</li>
      <li>Coagulation Defects in Pregnancy</li>
      <li>Fetal Enterovirus Syndrome</li>
      <li>Hysterosalpingo Oophorectomy</li>
      <li>Maternal Anemia</li>
    </ul>
    <ul>
      <li>Pelvic Neuralgia</li>
      <li>Preeclampsia</li>
      <li>Vaginal Bleeding in Pregnancy</li>
      <li>Vaginal Cysts</li>
      <li>Vaginal Dryness</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Ebonee Hayward-Sencherery, DO",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    cardioThoracicDetailData: {
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg",
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-HaywardSen.webp",
      title: "OBSTETRICIAN GYNECOLOGIST",
      mdcontent:
        "Ebonee Hayward-Sencherey, DO is an obstetrician-gynecologist with Tomball Women's Healthcare Center Doctors in Houston, TX. She specializes in general obstetrics and gynecology, with a focus on women's reproductive health, pregnancy care, childbirth, and postpartum support, and benign gynecological surgery.",
      mdname: "EBONEE HAYWARD-SENCHERERY, DO",
    },

    id: "ebonee-hayward-sencherery-do",
    name: "Ebonee Hayward-Sencherery, DO",
    image: "/images/physianDirectory/md_33.png",
    phone: "281-255-0000",
    gender: "Female",
    language: "English",
    specialty: "Obstetrics and Gynecology",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Tomball Woman's Healthcare Center",
        address: "13426 Medical Complex Drive, Suite 200, Tomball, Texas 77375",
        phone: "(281) 255-0000",
      },
      {
        name: "Tomball Woman's Healthcare Center - Michel Road",
        address: "13635 Michel Road, Tomball, TX 77375",
        phone: "(281) 516-9441",
      },
    ],

    bio_name: "About Dr. Ebonee Hayward-Sencherery",
    bio: `A native of Houston, Texas, Dr. Hayward-Sencherey earned her Bachelor of Science degree from Prairie View A&M University and Doctor of Osteopathic Medicine degree from Ohio University Heritage College of Osteopathic Medicine in Athens. She completed her residency in Obstetrics and Gynecology at Oklahoma State University Center for Health Sciences.</br></br>
Dr. Hayward-Sencherey models her practice from the belief that all patients deserve an advocate. She uses the principals of Christ to ensure all patients feel heard, respected, understood and has the knowledge to make informed decisions.</br></br>
Dr. Hayward-Sencherey is dedicated to empowering women and serving diverse communities. As a recent residency graduate, she continues to advance her expertise in OB/GYN, with a passion for mentorship and advocacy in healthcare equity.</br></br>
In her leisure time, she enjoys traveling with her husband and listening to music.`,

    education: [
      "Medical Degree from Ohio University Heritage College of Osteopathic Medicine",
      "Residency (Obstetrics and Gynecology) at Oklahoma State University Center for Health Sciences",
    ],

    areasOfExpertise: `<ul>
      <li>Amniocentesis</li>
      <li>Benign Ovarian Cyst</li>
      <li>Birth Control Management</li>
      <li>C-section</li>
      <li>Cervical Cancer</li>
      <li>Endometriosis</li>
      <li>Hormone Replacement Therapy</li>
      <li>Hysterectomy</li>
      <li>IUD Implantation/Removal</li>
      <li>Menopausal Disorders</li>
      <li>Menstrual & Other Female Reproductive System Disorders</li>
    </ul>
    <ul>
      <li>Osteoporosis</li>
      <li>Pap Smear</li>
      <li>Pelvic Exam</li>
      <li>Postpartum Care</li>
      <li>Prenatal Care</li>
      <li>Prolapse Of Female Genital Organs</li>
      <li>Sexually Transmitted Diseases</li>
      <li>Urinary Incontinence</li>
      <li>Uterine Cancer</li>
      <li>Uterine Fibroid Procedures</li>
      <li>Vaginal Deliveries</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Emily C. Bullock, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    cardioThoracicDetailData: {
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg",
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Bullock.avif",
      title: "OBSTETRICIAN GYNECOLOGIST",
      mdcontent:
        "Emily C. Bullock, MD is an obstetrician-gynecologist in the Woodlands area of Texas. She received her medical degree from Texas Tech University Health Sciences Center at Lubbock and has been in practice for more than 20 years.",
      mdname: "EMILY C. BULLOCK, MD",
    },

    id: "emily-bullock-md",
    name: "Emily C. Bullock, MD",
    image: "/images/physianDirectory/md_34.png",
    phone: "281-602-6888",
    gender: "Female",
    language: "English",
    specialty: "Obstetrics and Gynecology",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Women of the Woodlands Obstetrics and Gynecology",
        address: "9200 Pinecroft Dr Ste 400, Shenandoah, TX 77380",
        phone: "(281) 602-6888",
      },
      {
        name: "Memorial Hermann The Woodlands Hospitals",
        address: "9250 Pinecroft Drive, Shenandoah, TX 77380",
        phone: "(713) 897-2300",
      },
    ],

    bio_name: "About Dr. Emily C. Bullock",
    bio: `Dr. Bullock is a board certified obstetrician/gynecologist. She was in private practice with her father and mentor Gerald Bullock, MD, JD in Conroe and The Woodlands for the past 9 years. She attended TCU and finished Cum Laude with a B.S. in Biology. She then attended medical school at Texas Tech University School of Medicine. Dr. Bullock completed her residency in OB/GYN at Baylor University Medical Center in Dallas.</br></br>
She brings over 20 years of experience working with women of all ages in her specialty. She currently serves as an OB/Gyn hospitalist at Houston Methodist Sugarland and Memorial Hermann The Woodlands. She has found personally and through years of caring for her patients that women need a place to go where they can relax, feel like family and be pampered.`,

    education: [
      "Medical Degree from Texas Tech University- Lubbock",
      "B.S. (Biology) Cum Laude from Texas Christian University",
      "Residency (Obstetrics and Gynecology) at Baylor University Medical Center",
    ],

    areasOfExpertise: `<ul>
      <li>Abdominal Disorders</li>
      <li>Birth Control</li>
      <li>C-Sections</li>
      <li>Fallopian Tube Disorders</li>
      <li>High Risk Pregnancy</li>
      <li>Hysterectomy</li>
    </ul>
    <ul>
      <li>Miscarriages</li>
      <li>Ovarian Cysts</li>
      <li>Salpingo Oopherectomy</li>
      <li>Sexually Transmitted Diseases (STDs)</li>
      <li>Uterine Cancer</li>
      <li>Vaginal Delivery and VBAC</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Heidi A. Lyn, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    cardioThoracicDetailData: {
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg",
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Lyn.jpg",
      title: "OBSTETRICIAN AND GYNECOLOGIST",
      mdcontent:
        "Heidi A. Lyn, MD is an obstetrician-gynecologist in Shenandoah, Texas. She received her medical degree from Baylor College of Medicine and has been in practice for more than 20 years.",
      mdname: "HEIDI A. LYN, MD",
    },

    id: "heidi-lyn-md",
    name: "Heidi A. Lyn, MD",
    image: "/images/physianDirectory/md_35.png",
    phone: "281-367-6836",
    gender: "Female",
    language: "English, Spanish",
    specialty: "Obstetrics And Gynecology, Gynecology",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Women's Healthcare Affiliates",
        address: "9180 Pinecroft, Suite #100 The Woodlands, Texas 77380",
        phone: "(281) 367-6836",
      },
    ],

    bio_name: "About Dr. Heidi A. Lyn",
    bio: `Dr. Lyn grew up in Potomac, Maryland, and began her career in healthcare after graduating cum laude from Duke University with a Bachelor of Science in Nursing. As a proud member of the Sigma Theta Tau National Nursing Honor Society, she practiced pediatric nursing for six years and earned her Certification in Emergency Nursing.</br></br>
Driven by her passion for medicine, she earned her MD from Baylor College of Medicine in Houston, Texas, in 1994, and completed her OB/GYN residency at The University of Texas Health Sciences Center at San Antonio in 1998. Dr. Lyn has a wealth of experience in both private practice and academic medicine. She is board-certified by the American Board of Obstetrics and Gynecology and is a Fellow of the American Congress of Obstetrics and Gynecology.</br></br>
After five years in private practice in Phoenix, Arizona, she pursued a career in academic medicine, holding faculty positions at Tulane University Medical School and Texas Tech University Health Sciences Center in El Paso. During her tenure, she served as President of the Faculty Senate and Clerkship Director for OB/GYN.</br></br>
Dr. Lyn is committed to delivering personalized care. She has an interest in low and high risk pregnancies, adolescent gynecology, and menopause. She is trained in the use of the da Vinci robot for gynecologic surgeries.</br></br>
Dr. Lyn and her husband, Kevin Stern, moved to the Woodlands in 2020. Together they have five adult children, and are grandparents. A former triathlete, Dr. Lyn enjoys distance running, golf and scuba diving.`,

    education: [
      "Medical Degree from Baylor College of Medicine",
      "Bachelor of Science (Nursing) from Duke University",
      "Residency (OB/GYN) at The University of Texas Health Sciences Center at San Antonio",
    ],

    areasOfExpertise: `<ul>
      <li>Birth Control</li>
      <li>C-Section</li>
      <li>Hysterosalpingo Sonography</li>
      <li>Infertility</li>
      <li>Menopausal Disorders</li>
    </ul>
    <ul>
      <li>Menstrual Pain</li>
      <li>Pelvic Exam</li>
      <li>Oophorectomy</li>
      <li>Vaginitis or Vaginosis</li>
      <li>Yeast Infections</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=JndKBRdoWSY",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Jacey Beasley, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    cardioThoracicDetailData: {
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg",
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Beasley.jpg",
      title: "OBSTETRICIAN GYNECOLOGIST",
      mdcontent:
        "Jacey Beasley, MD, is an OBGYN physician from League City, Texas. Passionate about women's health, Dr. Beasley provides care for a broad range of OBGYN needs, including pregnancy, contraception, menstrual problems, menopause, and pelvic pain.",
      mdname: "JACEY BEASLEY, MD",
    },

    id: "jacey-beasley-md",
    name: "Jacey Beasley, MD",
    image: "/images/physianDirectory/md_36.png",
    phone: "713-442-2826",
    gender: "Female",
    language: "English",
    specialty: "Obstetrics & Gynecology",

    degrees: ["Doctor of Medicine"],

    clinics: [
      {
        name: "Kelsey-Seybold- Bay Area Clinic",
        address: "1010 South Ponds Dr, Webster, TX 77598",
        phone: "(713) 442-4300",
      },
      {
        name: "Kelsey-Seybold- Pasadena Clinic",
        address: "5001 East Sam Houston Pkwy South, Pasadena, TX 77505",
        phone: "(713) 442-7100",
      },
    ],

    bio_name: "About Dr. Jacey Beasley",
    bio: `Dr. Beasley and her team provide a comprehensive range of women's healthcare services in a warm, welcoming environment. With a strong reputation for clinical excellence and an unwavering commitment to patient-centered care, Dr. Beasley has become a trusted healthcare partner for women throughout the greater Houston area.</br></br>
At the heart of Dr. Beasley's approach is a genuine passion for helping women of all ages achieve optimal health and wellness. Whether a patient is seeking routine gynecological care, family planning guidance, or specialized treatment for a complex condition, one can expect to receive the personalized attention and empathetic support she deserves.</br></br>
For expectant mothers, Dr. Beasley offers comprehensive prenatal care, from the initial confirmation of pregnancy through the delivery of your bundle of joy. Patients consistently praise her personable bedside manner. Beyond pregnancy, the practice also provides a wide array of family planning services, including contraceptive counseling, IUD insertions, and nexplanon implants. For women navigating the challenges of menopause, Dr. Beasley and her staff offer comprehensive care, including hormone therapy, management of menopausal symptoms, and screening for related health conditions.`,

    education: [
      "Medical Degree from University of Texas Medical Branch, Galveston",
      "Bachelor of Science (Molecular Biology) from University of Texas at Dallas",
      "Residency (Obstetrics and Gynecology) at University of Texas Medical Branch, Galveston",
    ],

    areasOfExpertise: `<ul>
      <li>Abdominal Surgeries</li>
      <li>Obstetrics</li>
      <li>Post-Partum</li>
      <li>Pre-Eclampsia</li>
      <li>Pregnancy Complications</li>
    </ul>
    <ul>
      <li>Pregnancy Wellness Education</li>
      <li>Premenstrual Dysphoric Disorder (PMDD/PMS)</li>
      <li>Prenatal Care</li>
      <li>Preterm Labor</li>
      <li>Sexually Transmitted Disease (STD)</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=0sTjrrQQ3d0",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Jorge Pablo Orezzoli, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    cardioThoracicDetailData: {
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg",
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Orezzoli.avif",
      title: "OBSTETRICIAN-GYNECOLOGIST",
      mdcontent:
        "Jorge P. Orezzoli, MD is an obstetrician-gynecologist in Houston, Texas. He received his medical degree from University of Buenos Aires and has been in practice for more than 20 years.",
      mdname: "JORGE PABLO OREZZOLI, MD",
    },

    id: "jorge-orezzoli-md",
    name: "Jorge Pablo Orezzoli, MD",
    image: "/images/physianDirectory/md_37.png",
    phone: "713-773-0803",
    gender: "Male",
    language: "English, Spanish",
    specialty: "Obstetrics & Gynecology, Gastroenterology",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Hope Clinic- West",
        address: "12121 Westheimer Rd., Suite #205, Houston, TX 77077",
        phone: "(713) 773-0803",
      },
    ],

    bio_name: "About Dr. Jorge Pablo Orezzoli",
    bio: `Dr. Orezzoli was born and raised in Argentina, where he completed his education and full training as an obstetrician and gynecologist.</br></br>
About 10 years ago he emigrated to the United States where he successfully completed two years of clinical research in women's cancers at one of Harvard's teaching hospitals, graduating in 2012 from Brown University with a full license to practice as an Obstetrician and Gynecologist in the USA. Since then, he has developed a career centered in populations at risk and minorities in low resource areas, delivering high quality and compassionate care.`,

    education: [
      "Medical Degree from Faculty of Medical Sciences, University of Buenos Aires",
      "Residency (Obstetrics and Gynecology) at Women and Infants Hospital of Rhode Island/Brown University",
    ],

    areasOfExpertise: `<ul>
      <li>C-Section</li>
      <li>Coagulation Defects in Pregnancy</li>
      <li>Encounters for Normal Pregnancy</li>
      <li>Gestational Diabetes</li>
      <li>High Risk Pregnancy</li>
    </ul>
    <ul>
      <li>Hysterosalpingo Sonography</li>
      <li>Maternal Anemia</li>
      <li>Preeclampsia</li>
      <li>Uterine Fibroids</li>
      <li>Vaginal Delivery</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "June G. Marshall, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    cardioThoracicDetailData: {
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg",
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Marshall.webp",
      title: "OBSTETRICIAN-GYNECOLOGIST",
      mdcontent:
        "June G. Marshall, MD is an Obstetrician-Gynecologist primarily located in Houston, Texas. She graduated from medical school at NYU Grossman School of Medicine and has 46 years of medical experience.",
      mdname: "JUNE G. MARSHALL, MD",
    },

    id: "june-marshall-md",
    name: "June G. Marshall, MD",
    image: "/images/physianDirectory/md_38.png",
    phone: "713-697-2897",
    gender: "Female",
    language: "English, Spanish",
    specialty: "Obstetrics & Gynecology",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Obstetrics and Gynecology Center of Northwest Houston",
        address: "11307 FM 1960 Rd W, Ste 230, Houston, TX, 77065",
        phone: "(910) 676-2509",
      },
    ],

    bio_name: "About Dr. June G. Marshall",
    bio: `Dr. Marshall is an obstetrician-gynecologist in Houston, Texas. She received her medical degree from New York University Grossman School of Medicine and has been in practice for more than 20 years.</br></br>
Dr. Marshall is dedicated to providing comprehensive healthcare services to women throughout the Houston area. Fully certified as an obstetrician and gynecologist, Dr. Marshall enjoys interacting with women of all ages, and she is known for her caring, compassionate bedside manner. Dr. Marshall understands the excitement and worry that many women feel while expecting a child, and puts her professional knowledge to use to ease the worries of mothers-to-be. Dr. Marshall is also committed to staying current on new developments and innovations in the field of women's health.`,

    education: [
      "Medical Degree from New York University Grossman School of Medicine",
      "Residency (Obstetrics and Gynecology) at Brookdale University Hospital and Medical Center",
    ],

    areasOfExpertise: `<ul>
      <li>C-Section</li>
      <li>Cervical Dysplasia</li>
      <li>Child Birth</li>
      <li>Contraceptions</li>
      <li>Infertility</li>
    </ul>
    <ul>
      <li>Menopause</li>
      <li>Menstrual Pain</li>
      <li>Pap Smear</li>
      <li>Pelvic Exam</li>
      <li>Women's Health</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Kjersti M. Aagaard, MD, PhD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    cardioThoracicDetailData: {
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg",
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Aagaard.jpg",
      title: "MATERNAL AND FETAL MEDICINE SPECIALIST",
      mdcontent:
        "Kjersti Aagaard, MD is an obstetrician-gynecologist in Houston, Texas and is caring for patients at HCA Houston Tomball, Conroe, Northwest or The Woman's Hospital of Texas hospitals. She received her medical degree from University of Minnesota Medical School and has been in practice for more than 20 years.",
      mdname: "KJERSTI M. AAGAARD, MD, PHD",
    },

    id: "kjersti-aagaard-md",
    name: "Kjersti M. Aagaard, MD, PhD",
    image: "/images/physianDirectory/md_39.png",
    phone: "346-416-6678",
    gender: "Female",
    language: "English",
    specialty: "Obstetrics and Gynecology",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Texas Maternal Fetal Medicine- Conroe",
        address: "508 Medical Center Blvd, Ste 200, Conroe, TX 77304",
        phone: "(346) 416-6678",
      },
      {
        name: "Texas Maternal Fetal Medicine- Tomball",
        address: "13426 Medical Complex Dr, Ste 200, Tomball, TX 77375",
        phone: "(346) 416-6678",
      },
    ],

    bio_name: "About Dr. Kjersti M. Aagaard",
    bio: `Dr. Aagaard, MD, Ph.D. serves as the Medical Director of HCA Healthcare Gulf Coast Division, and the lead clinician at Texas Maternal Fetal Medicine. She is leading the HCA perinatal research at a national level with the HCA Women's Research Advisory Board and HCA Healthcare Research Institute. She continues her research and mentorship roles through her ongoing academic appointments with Boston Children's Hospital at Harvard Medical School and the Oregon National Primate Research Center.</br></br>
Prior to joining HCA Houston Healthcare, Dr. Aagaard served as the Henry & Emma Meyer Endowed Chair and Professor in Obstetrics & Gynecology and Vice Chair of Research at Baylor College of Medicine and Texas Children's Hospital, where she practiced Maternal Fetal Medicine for two decades.</br></br>
Dr. Aagaard earned her Bachelor of Science degree from Mills College, her Ph.D. in Immunology from Mayo Graduate School of Medicine and her M.D. from the University of Minnesota, where she also completed her residency in Obstetrics & Gynecology. Dr. Aagaard completed her fellowship in maternal-fetal medicine at the University of Utah, where she concomitantly earned a Masters in Clinical Investigation.</br></br>
Dr. Aagaard is a renowned clinician, specializing in preterm birth and congenital anomalies, and pregnancies complicated by diabetes, hypertension and infectious diseases. She has been elected to Texas SuperDoctors every year for over a decade.`,

    education: [
      "Medical Degree from University of Minnesota Medical School",
      "PhD (Immunology) from Mayo Graduate School of Medicine",
      "Undergraduate Degree from Mills College",
      "Residency (Obstetrics and Gynecology) at University of Minnesota",
      "Fellowship (Neonatal-Perinatal Medicine) University of Utah Health",
    ],

    areasOfExpertise: `<ul>
      <li>Abnormal Vaginal Bleeding</li>
      <li>Amniocentesis</li>
      <li>Breast Disorders</li>
      <li>Complicated Pregnancy or Childbirth</li>
      <li>Herpes Genitalis</li>
      <li>Hypertension (HTN)</li>
    </ul>
    <ul>
      <li>Microbiome Research</li>
      <li>Neonatology</li>
      <li>Obstetric Care</li>
      <li>Pregnancy-Induced Hypertension</li>
      <li>Uncomplicated or Low Risk Pregnancy and Delivery</li>
      <li>Venous Embolism and Thrombosis</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=CU2uU1ed-JM",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Mena A. Shaker, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    cardioThoracicDetailData: {
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg",
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Shaker.jpg",
      title: "OBSTETRICIAN-GYNECOLOGIST",
      mdcontent:
        "Mena A. Shaker, MD is a board certified OBGYN with 15 years of clinical experience in Obstetrics, Gynecology, Surgical Gynecology, and OB/GYN Critical Care Hospitalist Medicine.",
      mdname: "MENA A. SHAKER, MD",
    },

    id: "mena-shaker-md",
    name: "Mena A. Shaker, MD",
    image: "/images/physianDirectory/md_40.png",
    phone: "936-273-1600",
    gender: "Male",
    language: "English",
    specialty: "Obstetrics & Gynecology",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Woodlands Medical Aesthetics Institute",
        address: "17350 St. Lukes Way, Suite 380, The Woodlands, TX 77384",
        phone: "(936) 273-1600",
      },
      {
        name: "Woodlands Medical Aesthetics Institute",
        address: "18001 Highway 105 W., Suite 208, Montgomery, TX 77356",
        phone: "(936) 385-0160",
      },
    ],

    bio_name: "About Dr. Mena A. Shaker",
    bio: `Dr. Shaker has a passion for women's health and strives to deliver the highest level of care to his patients. He enjoys all aspects of obstetrics and gynecology ranging from women's annual exam, infertility evaluation, abnormal uterine bleeding, different routes of hysterectomies, and hormone replacement therapy. Minimally invasive Robotic gynecologic surgery is a special interest of his, which enables patients to promptly recover and achieve a higher quality of life.</br></br>
Dr. Shaker received his undergraduate degree in Bachelor of Science Biology and Chemistry majors at University of Alabama with Summa Cum Laude. He then completed his medical school at the Virginia Tech College of Medicine and finished residency as Chief Resident at University of Tennessee College of Medicine. He then served in the United States Navy as an active duty Medical Officer Lieutenant Commander OBGYN and has then joined us in Houston, TX after the completion of his service where he serves the Woodlands community at Houston Methodist.</br></br>
Dr. Shaker is board certified in Obstetrics and Gynecology and is VNOTES and DaVinci Robotically trained and performs Minimally Invasive Gynecology Surgery.</br></br>
Dr. Shaker enjoys spending time with his wife and two boys. He likes to travel and play tennis and soccer.`,

    education: [
      "Medical Degree at the Virginia Tech College of Medicine",
      "Bachelor of Science (Biology and Chemistry) with Summa Cum Laude at University of Alabama",
      "Residency (Obstetrics and Gynecology) at University of Tennessee College of Medicine",
    ],

    areasOfExpertise: `<ul>
      <li>Anterior Repair</li>
      <li>Cervical Cancer</li>
      <li>Endometrial Ablation</li>
      <li>Genital Herpes</li>
      <li>Hysterectomy</li>
      <li>Laparoscopic Tubal Ligation</li>
    </ul>
    <ul>
      <li>Myomectomy</li>
      <li>Oophorectomy</li>
      <li>Ovarian Cyst(s)</li>
      <li>Pelvic Organ Prolapse</li>
      <li>Uterine Fibroids</li>
      <li>Vulvovaginitis</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Merlyn Thomas, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    cardioThoracicDetailData: {
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg",
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Thomas.jpg",
      title: "OBSTETRICIAN-GYNECOLOGIST",
      mdcontent:
        "Merlyn Thomas, MD, is a compassionate obstetrician and gynecologist dedicated to providing comprehensive care to women throughout all stages of life in Sugar Land, TX.",
      mdname: "MERLYN THOMAS, MD",
    },

    id: "merlyn-thomas-md",
    name: "Merlyn Thomas, MD",
    image: "/images/physianDirectory/md_41.png",
    phone: "713-442-9100",
    gender: "Female",
    language: "English, Malayalam, Spanish",
    specialty: "Obstetrics & Gynecology",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Kelsey Seybold- Fort Bend Campus",
        address: "11555 University Blvd., Sugar Land, TX 77478",
        phone: "(713) 442-9100",
      },
      {
        name: "Kelsey Seybold- Sienna Clinic",
        address: "7010 Highway 6, Missouri City, TX 77459",
        phone: "(713) 442-6700",
      },
    ],

    bio_name: "About Dr. Merlyn Thomas",
    bio: `Dr. Thomas earned her Bachelor of Science in biomedical sciences at Texas A&M University in College Station in 2012. She earned her Doctor of Medicine in 2016 at Paul L. Foster School of Medicine, Texas Tech University Health Sciences Center in El Paso. She completed her Obstetrics and Gynecology residency at The University of Texas Health Science Center at Houston in 2020, where she served as administrative chief resident in her final year.</br></br>
With expertise in obstetrics, gynecology, and reproductive health, Dr. Thomas offers personalized treatment plans and support to address a wide range of women's health concerns. She provides a range of services, including prenatal care, childbirth support, gynecological screenings, and family planning services. Through her holistic approach and comprehensive care, she helps women achieve and maintain optimal health and well-being.</br></br>
Dr. Thomas enjoys reading science fiction novels, spending time with family and friends, watching documentaries, and trying new restaurants and new foods.`,

    education: [
      "Medical Degree from Paul L. Foster School of Medicine, Texas Tech University Health Sciences Center",
      "Bachelor of Science (Biomedical Sciences) from Texas A&M University",
      "Residency (Obstetrics and Gynecology) at The University of Texas Health Science Center- Houston",
    ],

    areasOfExpertise: `<ul>
      <li>C-Section</li>
      <li>Child Birth</li>
      <li>Endometriosis</li>
      <li>HPV/ HIV</li>
      <li>Infertility</li>
    </ul>
    <ul>
      <li>Menopause</li>
      <li>Preeclampsia</li>
      <li>Pre-natal Care</li>
      <li>Uterine Fibroids</li>
      <li>Vaginal Cysts</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=sVlblwFyR8I",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Natasha Abdullah, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    cardioThoracicDetailData: {
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg",
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Abdullah.jpg",
      title: "OBSTETRICIAN GYNECOLOGIST",
      mdcontent:
        "Natasha Abdullah, MD is an obstetrician-gynecologist in Missouri City, Texas. She received her medical degree from Texas AM Health Science Center College of Medicine and has been in practice between 6-10 years.",
      mdname: "NATASHA ABDULLAH, MD",
    },

    id: "natasha-abdullah-md",
    name: "Natasha Abdullah, MD",
    image: "/images/physianDirectory/md_42.png",
    phone: "713-442-6700",
    gender: "Female",
    language: "English, Hindi, Urdu",
    specialty: "Obstetrics & Gynecology",

    degrees: ["Doctor of Medicine"],

    clinics: [
      {
        name: "Kelsey-Seybold- Sienna Clinic",
        address: "7010 Highway 6, Missouri City, TX 77459",
        phone: "(713) 442-6700",
      },
      {
        name: "Kelsey-Seybold- Fort Bend Campus",
        address: "11555 University Blvd, Sugar Land, TX 77478",
        phone: "(713) 442-9100",
      },
    ],

    bio_name: "About Dr. Natasha Abdullah",
    bio: `Dr. Abdullah, MD, attended Texas A&M University College of Medicine, earning her medical degree in 2020. She went on to Jefferson Einstein Philadelphia Hospital to complete her OB/GYN residency in 2024. Dr. Abdullah joined Kelsey-Seybold's OB/GYN department in November 2024.</br></br>
Dr. Abdullah was initially drawn to the OB/GYN specialty because it involves educating and empowering patients on topics that can impact multiple stages of life and facilitates long-term relationships. As a general OB/GYN, she provides the full scope of care related to reproductive health and pregnancy, whether for menstrual disorders, hormonal conditions, infections, screening for gynecological cancers, sexual dysfunction, pelvic pain, prenatal care, or postpartum care and more.</br></br>
Dr. Abdullah is especially interested in preventive medicine, family planning, pregnancy management, and gynecological surgery, including minimally invasive and Da Vinci robotic procedures. Her favorite part of practicing medicine is having the opportunity to build meaningful connections with patients while guiding them through some of the most important stages of their lives.`,

    education: [
      "Medical Degree from Texas A&M University College of Medicine",
      "Residency (Obstetrics and Gynecology) Jefferson Einstein Philadelphia Hospital",
    ],

    areasOfExpertise: `<ul>
      <li>Annual Gynecological Exams</li>
      <li>Birth Control</li>
      <li>Cervical Polyp</li>
      <li>Endometriosis</li>
      <li>Osteoporosis Evaluation</li>
    </ul>
    <ul>
      <li>Salpingo-Oophoritis</li>
      <li>Sexual Dysfunction</li>
      <li>Sexually Transmitted Infection (STI)</li>
      <li>Urinary Tract Infection (UTI)</li>
      <li>Vaginal Discharge/ Infection</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=n78AjUllHno",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Nichole Ogojiaku, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    cardioThoracicDetailData: {
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg",
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Ogojiaku.avif",
      title: "OBSTETRICIAN-GYNECOLOGIST",
      mdcontent:
        "Nichole Ogojiaku, MD is a Gynecologist/Obstetrician in the Houston area and has an experience of 10 years in this field. Patients frequently visit Dr. Ogojiaku for C-sections, miscarriages, gestational diabetes, coagulation defects in pregnancy and postpartum.",
      mdname: "NICHOLE OGOJIAKU, MD",
    },

    id: "nichole-ogojiaku-md",
    name: "Nichole Ogojiaku, MD",
    image: "/images/physianDirectory/md_43.png",
    phone: "713-773-0803",
    gender: "Female",
    language: "English",
    specialty: "Obstetrics & Gynecology",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Hope Clinic Alief",
        address: "13930 Bellaire Blvd, Houston, TX 77083",
        phone: "(713) 773-0803",
      },
      {
        name: "HCA Houston Healthcare West",
        address: "12121 Westheimer Rd Ste 205, Houston, TX 77077",
        phone: "(713) 773-0803",
      },
    ],

    bio_name: "About Dr. Nichole Ogojiaku",
    bio: `Dr. Ogojiaku received her medical degree at Geisinger School of Medicine and completed her training at the University of Texas Health Science Center at Houston. She started practicing at HOPE clinic in 2023 and focuses on general obstetrics, office gynecology, and robotic surgery.`,

    education: [
      "Medical Degree from Commonwealth Medical College",
      "Residency (Obstetrics & Gynecology) at University of Texas Health Science Center at Houston",
    ],

    areasOfExpertise: `<ul>
      <li>Amenorrhea</li>
      <li>Cervical Dysplasia</li>
      <li>Endometriosis Treatment</li>
      <li>Gestational Diabetes</li>
      <li>Infertility</li>
    </ul>
    <ul>
      <li>Intrauterine Device Insertion</li>
      <li>Laparoscopic Hysterectomy</li>
      <li>Preeclampsia</li>
      <li>Uterine Fibroids</li>
      <li>Vaginal Bleeding</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Paola Ortiz Rodriguez, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    cardioThoracicDetailData: {
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg",
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-OrtizRodriguez.jpg",
      title: "OBSTETRICIAN-GYNECOLOGIST",
      mdcontent:
        "Paola Ortiz-Rodriguez, MD is an obstetrician-gynecologist in Houston, Texas. She received her medical degree from Ponce Health Sciences University and has been in practice between 6-10 years.",
      mdname: "PAOLA ORTIZ RODRIGUEZ, MD",
    },

    id: "paola-ortiz-rodriguez-md",
    name: "Paola Ortiz Rodriguez, MD",
    image: "/images/physianDirectory/md_44.png",
    phone: "713-773-0803",
    gender: "Female",
    language: "English, Spanish",
    specialty: "Obstetrics & Gynecology",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Hope Clinic Alief",
        address: "13930 Bellaire Blvd, Houston, TX 77083",
        phone: "(713) 773-0803",
      },
      {
        name: "Hope Clinic- West",
        address: "12121 Westheimer Rd Ste 205, Houston, TX 77077",
        phone: "(713) 773-0803",
      },
    ],

    bio_name: "About Dr. Paola Ortiz Rodriguez",
    bio: `Dr. Ortiz Rodriguez was born and raised in Puerto Rico, where she graduated from medical school with clinical honors in 2019. She then moved to Houston, Texas to continue her medical training in Obstetrics and Gynecology.</br></br>
In 2023, she completed residency at the University of Texas Health Science Center in Houston. She is fluent in both Spanish and English. In her free time, she enjoys reading, traveling and spending time with her family. Dr. Ortiz strives to deliver the highest quality of medical care and build meaningful relationships with her patients.`,

    education: [
      "Medical Degree from Ponce Health Sciences University",
      "Bachelor of Science (Biology) from University of Puerto Rico",
      "Residency (Obstetrics & Gynecology) at HCA Houston Healthcare/University of Houston-West",
      "Residency (Obstetrics & Gynecology) at the University of Texas Health Science Center",
    ],

    areasOfExpertise: `<ul>
      <li>Chronic Pelvic Pain</li>
      <li>High-Risk Pregnancy</li>
      <li>Hysterosalpingo Sonography</li>
      <li>Obstetric Ultrasound</li>
      <li>Pelvic Pain</li>
    </ul>
    <ul>
      <li>Preeclampsia</li>
      <li>Rectovaginal Injury</li>
      <li>Vaginal Bleeding after First Trimester</li>
      <li>Vaginal and Vulvar Cancer</li>
      <li>Vaginal Discharge</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Romany T. Gawargious Hana, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    cardioThoracicDetailData: {
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg",
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-GawaH.jpg",
      title: "OBSTETRICIAN-GYNECOLOGIST",
      mdcontent:
        "Romany T. Gawargious Hana, MD is an obstetrician-gynecologist in Houston, Texas. He received his medical degree from Ain Shams University Faculty of Medicine and has been in practice for more than 30 years.",
      mdname: "ROMANY T. GAWARGIOUS HANA, MD",
    },

    id: "romany-gawargious-hana-md",
    name: "Romany T. Gawargious Hana, MD",
    image: "/images/physianDirectory/md_45.png",
    phone: "713-773-0803",
    gender: "Male",
    language: "Arabic, English",
    specialty: "Obstetrics & Gynecology",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Hope Clinic Alief",
        address: "13930 Bellaire Blvd, Houston, TX 77083",
        phone: "(713) 773-0803",
      },
      {
        name: "Hope Clinic - Beltway Community Health Center",
        address: "7001 Corporate Dr Ste 120, Houston, TX 77036",
        phone: "(713) 773-0803",
      },
      {
        name: "Hope Clinic Aldine",
        address: "3000 Aldine Mail Route Rd., Bldg C Ste 200, Houston, TX 77039",
        phone: "(713) 773-0803",
      },
    ],

    bio_name: "About Dr. Romany T. Gawargious Hana",
    bio: `Dr. Gawargious Hana is a board certified OB/GYN and fellow of the American College of OB/GYN (ACOG) with a special area of interest in infertility. He completed his residency at the Montefiore Medical Center in New York and worked as an Assistant Professor of OB/GYN at the Albert Einstein College of Medicine before joining HOPE Clinic.</br></br>
Dr. Gawargious is happily married and has 3 children.`,

    education: [
      "Medical Degree from Ain Shams University Faculty of Medicine",
      "Residency (Obstetrics and Gynecology) at Montefiore Medical Center in New York",
    ],

    areasOfExpertise: `<ul>
      <li>C-Sections</li>
      <li>Genital Herpes</li>
      <li>Gestational Diabetes</li>
      <li>High Risk Pregnancy</li>
      <li>Hysterectomy</li>
    </ul>
    <ul>
      <li>Menstrual Disorders</li>
      <li>Miscarriages</li>
      <li>Pregestational Diabetes Mellitus</li>
      <li>STDs / HIV</li>
      <li>Uterine Fibroids</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Samatha K. Kadiyala, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    cardioThoracicDetailData: {
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg",
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Kadiyala.webp",
      title: "UROGYNECOLOGIST",
      mdcontent:
        "Samatha Kadiyala, MD is a board-certified Urogynecologist and Pelvic Reconstructive Surgeon. Although the practice was built with a focus on urogynecology, she has taken care of all minimally invasive gynecological surgical needs in the community.",
      mdname: "SAMATHA K. KADIYALA, MD, FACOG, FPMRS",
    },

    id: "samatha-kadiyala-md",
    name: "Samatha K. Kadiyala, MD",
    image: "/images/physianDirectory/md_46.png",
    phone: "979-266-9544",
    gender: "Female",
    language: "English, Hindi, Telugu",
    specialty: "Obstetrics & Gynecology, Urogynecology, Reconstructive Pelvic Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Brazosport Women's Health P.A.",
        address: "208 Oak Drive South, Suite 300, Lake Jackson, TX 77566",
        phone: "(979) 266-9544",
      },
    ],

    bio_name: "About Dr. Samatha K. Kadiyala",
    bio: `Dr. Kadiyala, MD is an obstetrician gynecologist in Lake Jackson, TX and has over 20 years of experience in the medical field. She graduated from Siddhartha Medical College-University of Health Sciences. She offers her patients non-surgical and surgical options including minimally invasive laparoscopic and vaginal techniques for gynecologic and pelvic reconstructive surgery for treatment of incontinence and prolapse.</br></br>
Dr. Kadiyala founded Brazosport Women's Health in 2010 in Lake Jackson with a vision to provide access to a trusted expert locally without the need to travel great distances to receive state-of-the-art, discreet women's healthcare. She created BWH to be a place where women can be seen by experts and feel safe, comfortable, and heard.</br></br>
Dr. Kadiyala lives in Lake Jackson with her husband and daughter. She seeks work-life balance in spending time doing what she enjoys most including hiking, playing tennis, and studying Indian and Middle Eastern History and Culture.</br></br>
Dr. Kadiyala has traveled to Mexico, India, and Kenya for mission work and is passionate about promoting women's healthcare through the education of local health professionals.`,

    education: [
      "Medical Degree from Siddhartha Medical College, in Vijayawada, India",
      "Residency (General Surgery) at University of Connecticut",
      "Residency (Obstetrics and Gynecology) through Saint Francis Hospital- UConn",
      "Fellowship (Minimally Invasive Gynecologic Surgery) at St. Elizabeth Hospital",
    ],

    areasOfExpertise: `<ul>
      <li>Acute Urinary Tract Infection</li>
      <li>Bladder Dysfunction</li>
      <li>Endometritis</li>
      <li>Hysterectomy</li>
      <li>Menopause Symptoms</li>
    </ul>
    <ul>
      <li>Pelvic Organ Prolapse</li>
      <li>Surgical Repair of Vaginal Prolapse</li>
      <li>Urinary Incontinence</li>
      <li>Vaginal Infection</li>
      <li>Vulvovaginitis</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Samuel Fekry, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    cardioThoracicDetailData: {
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg",
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Fekry.jpg",
      title: "OBSTETRICIAN-GYNECOLOGIST",
      mdcontent:
        "Samuel Fekry, MD is an obstetrician gynecologist in Houston, TX and has over 20 years of experience in the medical field.",
      mdname: "SAMUEL FEKRY, MD",
    },

    id: "samuel-fekry-md",
    name: "Samuel Fekry, MD",
    image: "/images/physianDirectory/md_47.png",
    phone: "713-773-0803",
    gender: "Male",
    language: "English, Arabic",
    specialty: "Obstetrics & Gynecology",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Hope Clinic- Aldine",
        address: "3000 Aldine Mail Route Rd., Building C, Suite #200 Houston, TX 77039",
        phone: "(713) 773-0803",
      },
      {
        name: "Hope Clinic- West",
        address: "12121 Westheimer Rd., Suite #205, Houston, TX 77077",
        phone: "(713) 773-0803",
      },
    ],

    bio_name: "About Dr. Samuel Fekry",
    bio: `Dr. Fekry is a Board Certified Obstetrician-Gynecologist and obtained his medical degree from Assiut University. He completed his medical residency at the Brooklyn Hospital Center, a community hospital that is affiliated with Cornell University, where he had the opportunity to care for patients with many different Gynecologic pathologies and high-risk pregnancy.</br></br>
Dr. Fekry delivers complete healthcare for the reproductive system in women across two areas of medicine: obstetrics and gynecology. He has many clinical areas of interest including adolescent gynecology, menopausal management, Overactive Bladder, Pelvic Organ Prolapse, Pelvic Pain, Recurrent UTIs, and Urinary Frequency.`,

    education: [
      "Medical Degree from Assiut University Faculty of Medicine",
      "Residency (Obstetrics and Gynecology) at The Brooklyn Hospital Center",
    ],

    areasOfExpertise: `<ul>
      <li>Birth Control / Contraception</li>
      <li>Cervical Dysplasia</li>
      <li>Endometriosis</li>
      <li>Fibroids</li>
      <li>Hormone Replacement Therapy</li>
    </ul>
    <ul>
      <li>Hysterectomy</li>
      <li>Ovarian Cystectomy</li>
      <li>Pelvic Organ Prolapse</li>
      <li>STD / HPV</li>
      <li>Well Women's Annual Exam</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop: "OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true,
    },
},
  

  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY",
      mdName: "Kim-Thu Chu, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title: "OBSTETRICS & GYNECOLOGY",
      contentTop: "Obstetricians and gynecologists specialize in women's reproductive health, pregnancy, childbirth, and disorders of the female reproductive system. They provide comprehensive care from routine wellness visits to complex surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Chu.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGEON",
      mdcontent: "Kim-Thu Chu, MD is an board-certified obstetrician gynecologist in Houston, TX and has over 32 years of experience in the medical field.     She focus...",
      mdname: "KIM-THU CHU, MD"
    },
    id: "kim-thu-chu-md",
    name: "Kim-Thu Chu, MD",
    image: "/images/doctors/kim-thu-chu-md.jpg",
    phone: "713-230-8677",
    gender: "Female",
    language: "English, Vietnamese",
    specialty: "Obstetrics and Gynecology",
    degrees: ["Doctor of Medicine"],
    clinics: [{
        name: "West Houston OBGYN",
        address: "12606 West Houston Center Blvd, Ste 302, Houston, TX 77082",
        phone: "(713) 230-8677"
      }, {
        name: "HCA Houston Healthcare West",
        address: "12141 Richmond Ave, Houston, TX 77082",
        phone: "(281) 558-3444"
      }],
    bio_name: "About Dr. Kim-Thu Chu",
    bio: `Dr. Chu received her undergraduate from Duke University and her medical training from the University of Miami- School Of Medicine. She completed her residency training at the University of Texas Medical Branch, Galveston, and in Obstetrics and Gynecology at Michigan State University/Sparrow Family Medicine Residency in Lansing, Michigan.     Dr. Chu is an Obstetrician and Gynecologist in West Houston. She is also a member of the American Medical Association, the American College of Obstetrics and Gynecology, the Harris County Medical Society, and the Vietnamese Medical Association.     Dr. Chu is a gynecologist who is devoted to ensuring the longevity of her patients health and developing long-lasting relationships with them. When she is not working, Dr. Chu likes to spend time with her husband and three children. She also enjoys traveling, ballroom dancing, biking, and snow skiing.`,
    education: ["Medical Degree from University of Miami, Miller School of Medicine", "Undergraduate Degree from Duke University", "Residency at University of Texas Medical Branch", "Residency (Obstetrics & Gynecology) at Michigan State University"],
    areasOfExpertise: `<ul>
<li>C-Sections</li>
<li>Excessive Menstrual Bleeding</li>
<li>Genital Herpes</li>
<li>Intrauterine Device Placement</li>
<li>Menstrual Disorders</li>
</ul>
<ul>
<li>Ovarian Cysts</li>
<li>PAP Smears</li>
<li>Uterine Fibroids</li>
<li>Uterine Cancer</li>
<li>Vaginal Delivery and VBAC</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY",
      contentTop: "Obstetricians and gynecologists specialize in women's reproductive health, pregnancy, childbirth, and disorders of the female reproductive system. They provide comprehensive care from routine wellness visits to complex surgical procedures.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY",
      mdName: "Reena A. Tharappel-Jacob, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title: "OBSTETRICS & GYNECOLOGY",
      contentTop: "Obstetricians and gynecologists specialize in women's reproductive health, pregnancy, childbirth, and disorders of the female reproductive system. They provide comprehensive care from routine wellness visits to complex surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Tharappel-Jacob.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGEON",
      mdcontent: "Reena A. Tharappel-Jacob, MD is a board-certified obstetrician and gynecologist with 25 years of experience providing comprehensive women's health car...",
      mdname: "REENA A. THARAPPEL-JACOB, MD"
    },
    id: "reena-a-tharappel-jacob-md",
    name: "Reena A. Tharappel-Jacob, MD",
    image: "/images/doctors/reena-a-tharappel-jacob-md.jpg",
    phone: "713-578-3833",
    gender: "Female",
    language: "English",
    specialty: "Obstetrics and Gynecology",
    degrees: ["Doctor of Medicine"],
    clinics: [{
        name: "Women's Specialists of Sugar Land",
        address: "16659 Southwest Freeway, Suite 225, Sugar Land, TX 77479",
        phone: "(713) 578-3833"
      }],
    bio_name: "About Dr. Reena A. Tharappel-Jacob",
    bio: `Dr. Jacob received a B.S. in Biology/Psychology at the University of Houston. Prior to receiving her medical degree from Ross University School of Medicine, she participated in medical research, which was eventually published. She completed her OB/GYN residency at Texas Tech University Health Science Center – El Paso. Dr. Jacob also received an award for excellence in laparoscopic surgery and best teaching resident award.    Dr. Tharappel-Jacob believes that open communication between physician and patient is essential to a long and mutually beneficial relationship. Focused, in-depth discussions enable a patient to make informed decisions impacting her health and wellness. Dr. Jacob’s goal is to facilitate this communication process and to provide the quality care her patients deserve.`,
    education: ["Medical Degree from Ross University School of Medicine", "Residency (Obstetrics and Gynecology) at Texas Tech University HSC El Paso"],
    areasOfExpertise: `<ul>
<li>Ablation Procedures</li>
<li>Adolescent Health</li>
<li>Amenorrhea</li>
<li>Cervical Dysplasia</li>
<li>Dysfunctional Uterine Bleeding</li>
<li>Endometriosis</li>
</ul>
<ul>
<li>Galactorrhea</li>
<li>Gynecologic Surgery</li>
<li>Gynecological Procedures</li>
<li>Ovarian Cysts</li>
<li>Urinary Tract Infection (UTI)</li>
<li>Vaginal Infection</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY",
      contentTop: "Obstetricians and gynecologists specialize in women's reproductive health, pregnancy, childbirth, and disorders of the female reproductive system. They provide comprehensive care from routine wellness visits to complex surgical procedures.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY",
      mdName: "David Brinkman, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title: "OBSTETRICS & GYNECOLOGY",
      contentTop: "Obstetricians and gynecologists specialize in women's reproductive health, pregnancy, childbirth, and disorders of the female reproductive system. They provide comprehensive care from routine wellness visits to complex surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Brinkman.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGEON",
      mdcontent: "David Gerard Brinkman, MD, is a respected physician specializing in Obstetrics and Gynecology, dedicated to providing exceptional care to patients in ...",
      mdname: "DAVID BRINKMAN, MD"
    },
    id: "david-brinkman-md",
    name: "David Brinkman, MD",
    image: "/images/doctors/david-brinkman-md.jpg",
    phone: "281-637-9095",
    gender: "Male",
    language: "English",
    specialty: "Obstetrics and Gynecology, Gynecology, Women's Health",
    degrees: ["Doctor of Medicine"],
    clinics: [{
        name: "Caritas Women's Care - OBGYN Services",
        address: "Baylor St. Luke's Medical Group 1327 Lake Pointe Parkway, Suite 500, Sugar Land, TX 77478",
        phone: "(281) 637-9095"
      }],
    bio_name: "About Dr. David Brinkman",
    bio: `Dr. Brinkman is a native Texan and attended Texas A&M University for his undergraduate degree and received his medical degree from Texas Tech University Health Science Center in Lubbock. Dr. Brinkman completed his residency in Oklahoma City at the University of Oklahoma Health Science Center and fellowship in Medical and Surgical NaPro Technology at the St. Paul VI Institute in Omaha.     Dr. Brinkman prioritizes listening to his patients and ensuring they have a voice in the decision making process for treatment. He believes it is a privilege to provide a lifetime of care to his patients.     Outside of the clinic, Dr. Brinkman enjoys Texas A&M Football, the Astros, Buc-ee’s and spending time with his family.`,
    education: ["Medical Degree from Texas Tech University Health Sciences Center", "Residency (Obstetrics and Gynecology) at SSM Health St Anthony Hospital", "Residency (Obstetrics and Gynecology) at University of Oklahoma Health Sciences Center"],
    areasOfExpertise: `<ul>
<li>Cesarean Section</li>
<li>Endometriosis</li>
<li>Hysterectomy</li>
<li>Hysterosalpingo Sonography</li>
<li>Ovarian Cysts</li>
</ul>
<ul>
<li>Polycystic Ovarian Disease</li>
<li>Perimenopause & Postmenopausal Symptoms</li>
<li>Premenstrual Syndrome</li>
<li>Recurrent miscarriage</li>
<li>Vaginal Birth</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/embed/PURlcfiYwcY",
      title: "OBSTETRICS & GYNECOLOGY",
      contentTop: "Obstetricians and gynecologists specialize in women's reproductive health, pregnancy, childbirth, and disorders of the female reproductive system. They provide comprehensive care from routine wellness visits to complex surgical procedures.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY",
      mdName: "Nelson Uzquiano, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title: "OBSTETRICS & GYNECOLOGY",
      contentTop: "Obstetricians and gynecologists specialize in women's reproductive health, pregnancy, childbirth, and disorders of the female reproductive system. They provide comprehensive care from routine wellness visits to complex surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Uzquiano.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGEON",
      mdcontent: "Nelson Uzquiano, MD is an obstetrician gynecologist in Houston, TX and has over 50 years of experience in the medical field.",
      mdname: "NELSON UZQUIANO, MD"
    },
    id: "nelson-uzquiano-md",
    name: "Nelson Uzquiano, MD",
    image: "/images/doctors/nelson-uzquiano-md.jpg",
    phone: "713-772-4876",
    gender: "Male",
    language: "English, Spanish",
    specialty: "Obstetrics And Gynecology, Gynecology",
    degrees: ["Doctor of Medicine"],
    clinics: [{
        name: "Brookhollow Obstetrics & Gynecology",
        address: "10109 Louetta Road, Ste 101, Houston, TX 77070",
        phone: "(832) 230-1803"
      }, {
        name: "Memorial Hermann Southwest Hospital",
        address: "7737 Southwest Fwy, Ste 870 · Houston, TX 77074",
        phone: "(713) 772-4876"
      }],
    bio_name: "About Dr. Nelson Uzquiano",
    bio: `Dr. Uzquiano is a board-certified obstetrician-gynecologist with 52 years of experience providing comprehensive women's healthcare. He specializes in obstetrics and gynecology, caring for women throughout all stages of life from routine wellness visits to pregnancy and childbirth. His extensive experience allows him to provide expert care for a wide range of women's health needs with the skill that comes from decades of dedicated practice.    Dr. Uzquiano completed his medical education at Universidad Mayor De San Andres Facultad De Medicina and went on to complete his residency training at Texas Tech University Health Sciences Center. He practices at Memorial Hermann Greater Heights Hospital in Houston, Texas, and maintains hospital affiliations with Memorial Hermann Southwest Hospital. Dr. Uzquiano is fluent in both Spanish and English, enabling him to communicate effectively with patients from diverse backgrounds and provide culturally sensitive care to the Houston community.`,
    education: ["Medical Degree from Universidad Boliviana Mayor de San Andres Faculty of Medicine", "Residency (Family Medicine) at Texas Tech University Health Science Center at Lubbock", "Residency (Obstetrics and Gynecology) at Texas Tech University HSC El Paso"],
    areasOfExpertise: `<ul>
<li>Coagulation Defects in Pregnancy</li>
<li>Colporrhaphy</li>
<li>High Risk Pregnancy</li>
</ul>
<ul>
<li>Hysterosalpingo Sonography</li>
<li>Maternal Anemia</li>
<li>Vaginal Delivery and VBAC</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY",
      contentTop: "Obstetricians and gynecologists specialize in women's reproductive health, pregnancy, childbirth, and disorders of the female reproductive system. They provide comprehensive care from routine wellness visits to complex surgical procedures.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY",
      mdName: "Barbara J. McLaren, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title: "OBSTETRICS & GYNECOLOGY",
      contentTop: "Obstetricians and gynecologists specialize in women's reproductive health, pregnancy, childbirth, and disorders of the female reproductive system. They provide comprehensive care from routine wellness visits to complex surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-McLaren.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGEON",
      mdcontent: "Barbara McLaren, MD, FACOG, is a board-certified OB/GYN with extensive experience in women's health and wellness. Through her work at , Dr. McLaren is...",
      mdname: "BARBARA J. MCLAREN, MD"
    },
    id: "barbara-j-mclaren-md",
    name: "Barbara J. McLaren, MD",
    image: "/images/doctors/barbara-j-mclaren-md.jpg",
    phone: "281-214-6894",
    gender: "Female",
    language: "English, French, Haitian, Haitian Creole, and Spanish",
    specialty: "Obstetrics And Gynecology",
    degrees: ["Doctor of Medicine"],
    clinics: [{
        name: "New Beginnings OB/GYN",
        address: "1570 S Dairy Ashford Rd Ste 108, Houston, TX 77077",
        phone: "(281) 214-6894"
      }],
    bio_name: "About Dr. Barbara J. McLaren",
    bio: `Dr. McLaren spends considerable time and effort remaining abreast of advancements in medical technology. She is dedicated to bringing the very best diagnostic and treatment platforms to the practice.    Technology is important, but nothing can replace the interpersonal connections between patient and provider. That's why Dr. McLaren takes the time to truly get to know the women in her care. Visits are never rushed, and there's no pressure to choose any treatment option before all of the details are fully understood.    For women in Houston, Texas, who are searching for unparalleled women's health care, taking the time to sit down with Barbara McLaren, MD, FACOG, to learn more about how her approach to women's health and wellness is a great choice.`,
    education: ["Medical Degree from Albany Medical College", "Residency (Obstetrics and Gynecology) at Howard University"],
    areasOfExpertise: `<ul>
<li>C-Section</li>
<li>Coagulation Defects in Pregnancy and Postpartum</li>
<li>Hysterosalpingo Sonography</li>
<li>Maternal Anemia</li>
<li>Menstrual Disorders</li>
</ul>
<ul>
<li>Obstetric Ultrasound</li>
<li>Sexually Transmitted Infections (STIs)</li>
<li>Uterine Fibroids</li>
<li>Vaginal Infections</li>
<li>Vulvitis</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY",
      contentTop: "Obstetricians and gynecologists specialize in women's reproductive health, pregnancy, childbirth, and disorders of the female reproductive system. They provide comprehensive care from routine wellness visits to complex surgical procedures.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY",
      mdName: "Miriam E. Busch, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title: "OBSTETRICS & GYNECOLOGY",
      contentTop: "Obstetricians and gynecologists specialize in women's reproductive health, pregnancy, childbirth, and disorders of the female reproductive system. They provide comprehensive care from routine wellness visits to complex surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Busch.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGEON",
      mdcontent: "Miriam Busch, MD is an Obstetrician-Gynecologist (OB-GYN) with Tomball Woman's Healthcare Center in Tomball, Texas.    She has over 10 years of experi...",
      mdname: "MIRIAM E. BUSCH, MD"
    },
    id: "miriam-e-busch-md",
    name: "Miriam E. Busch, MD",
    image: "/images/doctors/miriam-e-busch-md.jpg",
    phone: "346-534-6318",
    gender: "Female",
    language: "English",
    specialty: "Obstetrics and Gynecology",
    degrees: ["Medical Doctorate"],
    clinics: [{
        name: "Tomball Woman's Healthcare Center",
        address: "13426 Medical Complex Drive, Suite 200, Tomball, TX 77375",
        phone: "(346) 534-6318"
      }],
    bio_name: "About Dr. Miriam E. Busch",
    bio: `Dr. Busch earned her medical doctorate from University of Texas Southwestern Medical Center (UTSW), in Dallas. Following medical school, she completed the OB-GYN residency program at Louisiana State University School of Medicine in Baton Rouge, where she served as chief resident. Dr. Busch also holds a bachelor of arts in biochemistry, graduating summa cum laude from Lamar University in Beaumont, Texas.    Dr. Busch is board-certified by the American Board of Obstetrics and Gynecology (ABOG). In addition, she is certified in minimally invasive gynecologic surgical techniques, including minimally invasive robotic surgical system. Dr. Busch has presented research on conditions that include endometriosis, myxedema, and postmenopausal issues. She is an active member of the American Congress of Obstetrics and Gynecology (ACOG).    Dr. Busch decided to pursue a career in women’s healthcare after spending 6 weeks in Pakistan during college, working with women affected by a recent earthquake. She has a reputation for carefully listening to her patients, ensuring that they understand their condition and treatment options, and establishing a care plan together. When not seeing patients, Dr. Busch enjoys spending time with her husband and three children, being outdoors, listening to music, and pursuing religious studies.`,
    education: ["Medical Degree from University of Texas Southwestern Medical Center", "Bachelor of Arts (biochemistry) Summa Cum Laude from Lamar University", "Residency (OB-GYN) at Louisiana State University School of Medicine"],
    areasOfExpertise: `<ul>
<li>C-Section</li>
<li>Cervical Cancer</li>
<li>Endometriosis</li>
<li>Hormone Replacement Therapy</li>
<li>Hysterectomy</li>
<li>Menstrual & Menopausal Disorders</li>
</ul>
<ul>
<li>Myomectomy</li>
<li>Ovarian Cancer</li>
<li>Salpingectomy</li>
<li>Uterine Fibroid Treatment</li>
<li>Vaginal Delivery</li>
<li>Women's Reproductive Health Procedures</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY",
      contentTop: "Obstetricians and gynecologists specialize in women's reproductive health, pregnancy, childbirth, and disorders of the female reproductive system. They provide comprehensive care from routine wellness visits to complex surgical procedures.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY",
      mdName: "Jamie G. Hernandez, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title: "OBSTETRICS & GYNECOLOGY",
      contentTop: "Obstetricians and gynecologists specialize in women's reproductive health, pregnancy, childbirth, and disorders of the female reproductive system. They provide comprehensive care from routine wellness visits to complex surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Hernandez.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGEON",
      mdcontent: "Dr. Jamie G. Hernandez, is a board-certified OB-GYN in Sugar Land, Texas.    With a focus on patient-centered care, Dr. Hernandez is known for her ext...",
      mdname: "JAMIE G. HERNANDEZ, MD"
    },
    id: "jamie-g-hernandez-md",
    name: "Jamie G. Hernandez, MD",
    image: "/images/doctors/jamie-g-hernandez-md.jpg",
    phone: "281-637-9095",
    gender: "Female",
    language: "English",
    specialty: "Obstetrics and Gynecology",
    degrees: ["Medical Degree"],
    clinics: [{
        name: "Caritas Women's Care - OBGYN Services - Baylor St. Luke's Medical Group - Sugar Land, TX",
        address: "1327 Lake Pointe Parkway, Suite 500, Sugar Land, TX 77478",
        phone: "(281) 637-9095"
      }],
    bio_name: "About Dr. Jamie G. Hernandez",
    bio: `Dr. Hernandez, a Louisiana native, earned her medical degree from The University of Texas at Houston and completed her residency at the University of Illinois/OSF St. Francis Medical Center in Peoria, IL. At Pope Paul VI Institute and Creighton University, Dr. Hernandez completed a medical and surgical NaProTECHNOLOGY fellowship. Dr. Hernandez is a member of the American Academy of FertilityCare Professionals, American Association of Gynecologic Laparoscopists, the American Congress of Obstetrics & Gynecology, American Academy of Pro-Life Obstetricians and Gynecologists, Catholic Medical Association, and a Fellow of The American Congress of Obstetricians and Gynecologists (FACOG).     Dedicated to providing holistic, comprehensive, and restorative services for women from adolescence through menopause, Dr. Hernandez is a member of Baylor St. Luke's Medical Group Caritas Women's Care in Sugar Land. As one of only a handful of fellowship-trained NaProTECHNOLOGY surgeons in the United States, Dr. Hernandez uses this technology to address and treat a full range of gynecologic health concerns.`,
    education: ["Medical Degree from McGovern Medical School, University of Texas Health Science Center", "Residency (Obstetrics and Gynecology) at University of Illinois/ OSF St. Francis Medical Center", "Fellowship at Pope Paul VI Institute and Creighton University"],
    areasOfExpertise: `<ul>
<li>C-Section</li>
<li>Chronic Pelvic Pain</li>
<li>Excessive Menstrual Bleeding</li>
<li>High Risk Pregnancy</li>
<li>Hysterosalpingo Sonography</li>
</ul>
<ul>
<li>Ovarian Cysts</li>
<li>Preeclampsia</li>
<li>Uterine Cancer</li>
<li>Uterine Fibroids</li>
<li>Vaginal Delivery and VBAC</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/embed/y-GjYO2J3qI",
      title: "OBSTETRICS & GYNECOLOGY",
      contentTop: "Obstetricians and gynecologists specialize in women's reproductive health, pregnancy, childbirth, and disorders of the female reproductive system. They provide comprehensive care from routine wellness visits to complex surgical procedures.",
      slope: true
    }
  },

  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Gerilynn Salmeron Vine, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Vine.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent: `Gerilynn Vine, MD is a board-certified obstetrician gynecologist in Houston, TX and has over 15 years of experience in the medical field. She specializes in obstetrics and gynecology, providing comprehensive women's healthcare services. She focuses on both reproductive health and pregnancy care, helping women through various stages of their lives from routine gynecological care to prenatal and delivery services.`,
      mdname: "GERILYNN SALMERON VINE, MD"
    },
    generalSurgeryDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women’s care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Vine.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent: `Gerilynn Vine, MD is a board-certified obstetrician gynecologist in Houston, TX and has over 15 years of experience in the medical field. She specializes in obstetrics and gynecology, providing comprehensive women's healthcare services. She focuses on both reproductive health and pregnancy care, helping women through various stages of their lives from routine gynecological care to prenatal and delivery services.`,
      mdname: "GERILYNN SALMERON VINE, MD"
    },
    id: "gerilynn-salmeron-vine-md",
    name: "Gerilynn Salmeron Vine, MD",
    image: "/images/physianDirectory/Ob-Vine.jpg",
    phone: "713-500-4360",
    gender: "Female",
    language: "English",
    specialty: "Obstetrics and Gynecology",
    degrees: ["Medical Degree"],
    clinics: [
      {
            "name": "UT Physicians Family Medicine Texas Medical Center",
            "address": "6410 Fannin St Ste 170, Houston, TX 77030",
            "phone": "(713) 500-4360"
      },
      {
            "name": "Memorial Hermann Medical Group- West University",
            "address": "3525 W. Holcombe Blvd, Houston, TX 77025",
            "phone": "(713) 814-2800"
      }
],
    bio_name: "About Dr. Gerilynn Salmeron Vine",
    bio: `Board certified in obstetrics and gynecology, Dr. Vine cares for women from adolescence and beyond. Dr. Vine focuses on helping patients navigate the complexities of pregnancy and women's health conditions. She works extensively with patients experiencing depression during pregnancy, helping them manage mental health challenges while ensuring safe maternal and fetal outcomes. Dr. Vine also provides specialized care for patients with preeclampsia, a serious pregnancy complication that can affect both mother and baby, and supports women dealing with vaginal bleeding after the first trimester, which often causes significant anxiety and requires careful monitoring. Her practice encompasses comprehensive care for various pregnancy-related complications, including placental abruption and perineal tears that occur during delivery. She also helps patients manage abnormal uterine bleeding and provides treatment for vulvar and vaginal conditions that can impact quality of life and intimate relationships. Dr. Vine addresses chronic pelvic pain conditions, including pudendal neuralgia, helping women find relief from persistent discomfort that can interfere with daily activities. Dr. Vine uses cesarean sections when necessary to ensure safe delivery for both mother and baby, particularly in high-risk situations. Her approach combines careful monitoring with timely intervention to optimize outcomes for her patients and their families.`,
    education: [
      "Medical Degree from McGovern Medical School at UTHealth",
      "Bachelors Degree (Psychology) from University of Texas at Austin",
      "Residency (Obstetrics and Gynecology) at Houston Methodist \u2013 TMC Department of Obstetrics and Gynecology"
],
    areasOfExpertise: `<ul>
  <li>Abnormal Uterine Bleeding</li>
  <li>Irregular Menstrual Cycles</li>
  <li>Noncancerous Ovarian Growths</li>
  <li>Ovarian Cysts</li>
  <li>Pelvic Pain</li>
  <li>Preeclampsia</li>
  <li>Premenstrual Syndrome (PMS)</li>
  <li>Pudendal Neuralgia</li>
  <li>Vaginal and Vulvar Cancer</li>
  <li>Vaginal Infections</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      link: "",
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Melinda H. Chai, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Chai.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent: `Melinda Chai, MD is an obstetrician-gynecologist in Sugar Land, Texas. She provides comprehensive care for women's health needs, including routine gynecological exams, pregnancy care, and childbirth support. Dr. Chai also offers primary care services for patients and families of all ages, focusing on preventive health and managing ongoing medical conditions. Her broad training across multiple medical specialties allows her to provide coordinated care that addresses both women's health concerns and general medical needs.`,
      mdname: "MELINDA H. CHAI, MD"
    },
    generalSurgeryDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women’s care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Chai.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent: `Melinda Chai, MD is an obstetrician-gynecologist in Sugar Land, Texas. She provides comprehensive care for women's health needs, including routine gynecological exams, pregnancy care, and childbirth support. Dr. Chai also offers primary care services for patients and families of all ages, focusing on preventive health and managing ongoing medical conditions. Her broad training across multiple medical specialties allows her to provide coordinated care that addresses both women's health concerns and general medical needs.`,
      mdname: "MELINDA H. CHAI, MD"
    },
    id: "melinda-h-chai-md",
    name: "Melinda H. Chai, MD",
    image: "/images/physianDirectory/Ob-Chai.jpg",
    phone: "346-674-1200",
    gender: "Female",
    language: "English",
    specialty: "Obstetrics and Gynecology",
    degrees: ["Medical Degree"],
    clinics: [
      {
            "name": "Kelsey-Seybold- Rosenberg Clinic",
            "address": "3915 Kians Way, Richmond, TX 77469",
            "phone": "(346) 674-1200"
      },
      {
            "name": "Kelsey-Seybold- Aliana Clinic",
            "address": "11225 W Grand Pkwy S, Richmond, TX 77407",
            "phone": "(346) 674-1700"
      }
],
    bio_name: "About Dr. Melinda H. Chai",
    bio: `Dr. Chai attended the University of Queensland Ochsner Medical School in Brisbane, Australia, obtaining her medical degree in 2019. She relocated to Texas, completing her OB/GYN residency at McGovern Medical School at the University of Texas Health Science Center at Houston (UTHealth) in Houston in 2024. Dr. Chai joined Kelsey-Seybold in September 2024. Having grown up in southeast Asia where healthcare was a rare commodity, Dr. Chai wanted to become a physician to provide care to those who need it. As an OB/GYN, she strives to provide comprehensive care and education for women at all life stages, from puberty to pregnancy and menopause. In addition to providing well woman care, Dr. Chai works with patients on health concerns such as abnormal uterine bleeding, endometriosis, sexually transmitted infections, hormonal therapy, and menopause symptoms. Her clinical interests include minimally invasive gynecology, high-risk and low-risk obstetrical care, and family planning. Dr. Chai's favorite part of practicing medicine is being a part of her patients' lives for both the difficult and exciting times in their lives.`,
    education: [
      "Medical Degree from University of Queensland Ochsner Medical School",
      "Residency (OB/GYN) at McGovern Medical School at the UTHealth"
],
    areasOfExpertise: `<ul>
  <li>Annual Pap Smear/GYN Exam</li>
  <li>Bacterial Vaginosis</li>
  <li>Cervical Dysplasia</li>
  <li>Cervical Intraepithelial Neoplasia (CIN)</li>
  <li>Cervical/ Uterine Polyp</li>
  <li>Chlamydia</li>
  <li>Endometriosis</li>
  <li>Pelvic Floor Disorders</li>
  <li>Salpingo-Oophoritis</li>
  <li>Uterine Abnormality</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=DDqixl7JP68",
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Pamela Bremer Plancarte, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-BremerPlancarte.png",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent: `Pamela Bremer Plancarte, MD is an obstetrician-gynecologist in Houston, Texas and has been in practice for more than 20 years. Her expertise includes helping women manage complex gynecological health concerns with personalized care approaches.`,
      mdname: "PAMELA BREMER PLANCARTE, MD"
    },
    generalSurgeryDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women’s care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-BremerPlancarte.png",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent: `Pamela Bremer Plancarte, MD is an obstetrician-gynecologist in Houston, Texas and has been in practice for more than 20 years. Her expertise includes helping women manage complex gynecological health concerns with personalized care approaches.`,
      mdname: "PAMELA BREMER PLANCARTE, MD"
    },
    id: "pamela-bremer-plancarte-md",
    name: "Pamela Bremer Plancarte, MD",
    image: "/images/physianDirectory/Ob-BremerPlancarte.png",
    phone: "713-773-0803",
    gender: "Female",
    language: "English",
    specialty: "Obstetrics and Gynecology",
    degrees: ["Medical Degree"],
    clinics: [
      {
            "name": "Hope Clinic- Beltway",
            "address": "7001 Corporate Drive, Ste 120, Houston, TX 77036",
            "phone": "(713) 773-0803"
      },
      {
            "name": "Hope Clinic- Alief",
            "address": "13930 Bellaire Blvd, Houston, TX 77083",
            "phone": "(713) 773-0803"
      }
],
    bio_name: "About Dr. Pamela Bremer Plancarte",
    bio: `Dr. Bremer Plancarte is a medical doctor specializing in Obstetrics & Gynecology with 21 years of experience caring for women throughout their reproductive health journey. She provides comprehensive care for pregnancy, childbirth, and women's health needs, helping patients through every stage of life from routine gynecological care to prenatal and delivery services. Dr. Bremer Plancarte completed her medical education at Universidad De Monterrey Facultad De Medicina. She practices at various locations in Houston, Texas making her expertise accessible to patients in all communities. Her extensive experience allows her to provide compassionate, skilled care for the full spectrum of women's health concerns.`,
    education: [
      "Medical Degree from Universidad de Monterrey",
      "Residency (Obstetrics and Gynecology) at University of Texas Health Science Center at Houston"
],
    areasOfExpertise: `<ul>
  <li>Abnormal Vaginal Bleeding</li>
  <li>C-section Births</li>
  <li>Cervical Cancer</li>
  <li>Contraception Management</li>
  <li>Gynecological Concerns</li>
  <li>Menopausal Disorder</li>
  <li>Menstrual Disorders</li>
  <li>Ovarian Disorders</li>
  <li>Urinary Problems</li>
  <li>Vaginal Disease</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      link: "",
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Lauren Jane Tharp, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Tharp.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent: `Lauren J. Tharp, MD is an obstetrician-gynecologist in Houston, Texas and has over 10 years of experience in the medical field. She focuses on helping patients navigate the complexities of high-risk pregnancies, working extensively with women experiencing conditions that require specialized maternal care. She regularly supports patients dealing with preeclampsia, a serious condition that can affect both mother and baby, as well as prelabor rupture of membranes, which can lead to complications if not carefully managed. Her practice also encompasses patients experiencing Braxton Hicks contractions, gestational diabetes, and various forms of abdominal pain during pregnancy, conditions that can cause significant concern and discomfort for expectant mothers. Her approach to care includes comprehensive monitoring through nonstress tests and fetal ultrasounds to ensure both maternal and fetal wellbeing throughout pregnancy. Dr. Tharp uses these diagnostic tools to track fetal development and identify any potential complications early, allowing for timely interventions when necessary. She also assists patients through both vaginal deliveries and cesarean sections when surgical intervention becomes the safest option for delivery. Her comprehensive approach helps ensure the healthiest possible outcomes for both mothers and their babies.`,
      mdname: "LAUREN JANE THARP, MD"
    },
    generalSurgeryDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women’s care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Tharp.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent: `Lauren J. Tharp, MD is an obstetrician-gynecologist in Houston, Texas and has over 10 years of experience in the medical field. She focuses on helping patients navigate the complexities of high-risk pregnancies, working extensively with women experiencing conditions that require specialized maternal care. She regularly supports patients dealing with preeclampsia, a serious condition that can affect both mother and baby, as well as prelabor rupture of membranes, which can lead to complications if not carefully managed. Her practice also encompasses patients experiencing Braxton Hicks contractions, gestational diabetes, and various forms of abdominal pain during pregnancy, conditions that can cause significant concern and discomfort for expectant mothers. Her approach to care includes comprehensive monitoring through nonstress tests and fetal ultrasounds to ensure both maternal and fetal wellbeing throughout pregnancy. Dr. Tharp uses these diagnostic tools to track fetal development and identify any potential complications early, allowing for timely interventions when necessary. She also assists patients through both vaginal deliveries and cesarean sections when surgical intervention becomes the safest option for delivery. Her comprehensive approach helps ensure the healthiest possible outcomes for both mothers and their babies.`,
      mdname: "LAUREN JANE THARP, MD"
    },
    id: "lauren-jane-tharp-md",
    name: "Lauren Jane Tharp, MD",
    image: "/images/physianDirectory/Ob-Tharp.jpg",
    phone: "832-325-7131",
    gender: "Female",
    language: "English",
    specialty: "Obstetrics and Gynecology",
    degrees: ["Medical Degree"],
    clinics: [
      {
            "name": "UT Physicians Womens Center Texas Medical Center",
            "address": "6410 Fannin Street, Ste 250, Houston, TX 77030",
            "phone": "(832) 325-7131"
      },
      {
            "name": "Memorial Hermann Memorial City Medical Center",
            "address": "929 Gessner Road, Houston, TX 77024",
            "phone": "(713) 242-3000"
      },
      {
            "name": "HCA Houston Healthcare West",
            "address": "12141 Richmond Ave., Houston, TX 77082",
            "phone": "(281) 558-3444"
      }
],
    bio_name: "About Dr. Lauren Jane Tharp",
    bio: `Dr. Tharp is an obstetrician and gynecologist with 14 years of experience caring for women throughout their reproductive lives. She specializes in comprehensive women's health, providing care for pregnancy, childbirth, and gynecological conditions. Dr. Tharp focuses on delivering personalized medical care that addresses each patient's unique needs across all stages of womanhood. Dr. Tharp completed her medical degree at Mercer University School of Medicine and her residency training at LBJ General Hospital. She practices at multiple locations throughout Houston, Texas. Her multilingual abilities allow her to communicate effectively with diverse patient populations. This language capability helps ensure clear communication and culturally sensitive care for women from various backgrounds in the Houston community.`,
    education: [
      "Medical Degree from Mercer University School Of Medicine",
      "Residency at LBJ General Hospital"
],
    areasOfExpertise: `<ul>
  <li>Abdominal Pain</li>
  <li>Arrhythmias</li>
  <li>Braxton Hicks Contractions</li>
  <li>Depression During Pregnancy</li>
  <li>Eclampsia</li>
  <li>Gestational Diabetes</li>
  <li>High-Risk Pregnancy</li>
  <li>Placental Abruption</li>
  <li>Prelabor Rupture of Membranes</li>
  <li>Vaginal Bleeding during Pregnancy</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      link: "",
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Nefertiti C. DuPont, MD, MPH",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Dupont.avif",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent: `Nefertiti duPont, MD is a board-certified gynecologic oncologist. Her goal is to help women reclaim their lives through gynecologic cancer prevention, education, and treatment.`,
      mdname: "NEFERTITI C. DUPONT, MD, MPH"
    },
    generalSurgeryDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women’s care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Dupont.avif",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent: `Nefertiti duPont, MD is a board-certified gynecologic oncologist. Her goal is to help women reclaim their lives through gynecologic cancer prevention, education, and treatment.`,
      mdname: "NEFERTITI C. DUPONT, MD, MPH"
    },
    id: "nefertiti-c-dupont-md-mph",
    name: "Nefertiti C. DuPont, MD, MPH",
    image: "/images/physianDirectory/Ob-Dupont.avif",
    phone: "936-207-4287",
    gender: "Female",
    language: "English",
    specialty: "Gynecologic Oncology, Obstetrics and Gynecology",
    degrees: ["Medical Degree"],
    clinics: [
      {
            "name": "North Houston Gynecologic Oncology Surgeons",
            "address": "128 Vision Park Blvd, Ste 280, Shenandoah, TX 77384",
            "phone": "(936) 207-4287"
      }
],
    bio_name: "About Dr. Nefertiti C. DuPont",
    bio: `Dr. DuPont is a distinguished board-certified gynecologic oncologist, recognized for her expertise in the diagnosis, treatment, and management of gynecologic malignancies and precancerous conditions. She is board certified by the American Board of Obstetrics and Gynecology and is a respected figure in her field. In 1999, Dr. duPont earned her medical degree from Texas A&M Health Science Center College of Medicine. In addition to being recognized for her involvement in clinical research, Dr. duPont has authored and co-authored several journal articles. She has served on the Gynecologic Oncology Group's cervix and vulvar committee, the National Comprehensive Cancer Network's cervical and uterine cancer panel, and the American Society of Clinical Oncology's Health Care Disparities committee. Dr. duPont has expertise in the treatment of patients with genetic cancer syndromes such as BRCA 1 & 2 gene mutations, Lynch syndrome, and Cowden syndrome. Her interests include robotic surgery, health care policy, and health care disparities. Currently, Dr. duPont practices at North Houston Gynecologic Oncology Surgeons, PLLC in The Woodlands, Texas and she is the creator of the Reclaim Your Life Podcast on YouTube. She is an active member of several professional organizations, Texas Medical Association, and the Society of Gynecologic Oncology. Outside of her professional life, Dr. duPont is passionate about track and field. She is a former sprinter and triple jumper, and she holds a Level 1 certification as a track and field coach through the USA Track and Field Association. Dr. duPont's multifaceted career and contributions to both medicine and sports highlight her exceptional commitment to improving lives through her professional and personal endeavors.`,
    education: [
      "Medical Degree from Texas A&M University System Health Science Center College of Medicine",
      "Undergraduate Degree (Chemistry) from the University of Virginia",
      "Master's in Public Health Degree from the University of North Carolina",
      "Residency (Obstetrics & Gynecology) at University of Oklahoma",
      "Fellowship (Gynecologic Oncology) at University of California- Irvine"
],
    areasOfExpertise: `<ul>
  <li>Abnormal Pap Smear</li>
  <li>BRCA Genetic Testing</li>
  <li>Colposcopy</li>
  <li>Fallopian Tube Cancer</li>
  <li>Hysterectomy</li>
  <li>Menopause</li>
  <li>Ovarian Cancer</li>
  <li>Salingectomy</li>
  <li>Salpingo Oopherectomy</li>
  <li>Vaginal Dysplasia</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      link: "https://youtu.be/NCShFZ2UK4E?si=88q0_Vx8MxJF0HMl",
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Daisy A. Ayim, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Ayim.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent: `Daisy Ayim, MD is a triple board-certified physician with specialized training in cosmetic surgery, obstetrics, and gynecology. This unique background allows her to offer a full spectrum of women's health, aesthetic treatments, and cosmetic gynecology in Houston. She offers routine and advanced gynecology services personalized to patient's unique needs. With a focus on preventive care, diagnostics, and treatment—including surgical and non-surgical options. Patients say she offers expert, compassionate care to keep them healthy and informed.`,
      mdname: "DAISY A. AYIM, MD"
    },
    generalSurgeryDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women’s care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Ayim.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent: `Daisy Ayim, MD is a triple board-certified physician with specialized training in cosmetic surgery, obstetrics, and gynecology. This unique background allows her to offer a full spectrum of women's health, aesthetic treatments, and cosmetic gynecology in Houston. She offers routine and advanced gynecology services personalized to patient's unique needs. With a focus on preventive care, diagnostics, and treatment—including surgical and non-surgical options. Patients say she offers expert, compassionate care to keep them healthy and informed.`,
      mdname: "DAISY A. AYIM, MD"
    },
    id: "daisy-a-ayim-md",
    name: "Daisy A. Ayim, MD",
    image: "/images/physianDirectory/Ob-Ayim.jpg",
    phone: "713-640-5922",
    gender: "Female",
    language: "English, French",
    specialty: "Obstetrics and Gynecology, Cosmetic Surgery",
    degrees: ["Medical Degree"],
    clinics: [
      {
            "name": "Park West Women's Associates",
            "address": "12606 W Houston Ctr Blvd Ste 120, Houston, TX 77082",
            "phone": "(713) 6460-5922"
      }
],
    bio_name: "About Dr. Daisy A. Ayim",
    bio: `Dr. Ayim is a Board Certified Obstetrician and Gynecologist by the American Board of Obstetrics and Gynecology, as well as, Fellow of American College of Obstetrics and Gynecology(FACOG). She attended Louisiana State University for undergraduate, where she was accepted into medical school as a junior student. However, she chose to defer entrance due to her love for Tigerland. Geaux Tigers! She received her Bachelor's degree in Biochemistry with minor in Zoology in 1998. She matriculated from LSU and attended The University of Texas Medical Branch, where she obtained her Doctor of Medicine degree in 2002. Dr. Ayim completed a year of General Surgery internship at The Methodist Hospital in Houston. She was intrigued by women's health and boldly changed her course to attend the prestigious Howard University Hospital in Washington D.C., where she completed four years of training in Obstetrics and Gynecology. She was appointed as Administrative Chief Resident in her final year of residency. She also received several awards during her residency training such as Wyeth Grant Recipient for 19th Annual Resident Reporter Program by the American Society for Reproductive Medicine and National Institute of Health/NMA Fellows in Academic Careers Grant Recipient. Upon graduation, she was appointed as faculty to the renowned Johns Hopkins Hospital Department of Obstetrics and Gynecology. Dr. Ayim relocated to Houston to pursue her dream of private practice focusing on her philosophy of knowing all her patients and their families. Therefore, starting her solo private practice in 2009 has been a fulfilling journey. She understands the modern day woman and her multi-dimensional responsibilities. As a working mom, she knows patients' wants and takes her time to care for them with current medical knowledge and sound surgical skills.`,
    education: [
      "Medical Degree from University of Texas Medical Branch - Galveston",
      "Residency (Obstetrics and Gynecology) at Howard University Hospital",
      "Internship (General Surgery) at Methodist Hospital"
],
    areasOfExpertise: `<ul>
  <li>Annual Well-Woman Exams</li>
  <li>Abnormal Uterine/Vaginal Bleeding</li>
  <li>Endometriosis</li>
  <li>Hysterectomy</li>
  <li>Menopause</li>
  <li>PAP Smears</li>
  <li>Pelvic Pain</li>
  <li>Polycystic Ovarian Syndrome</li>
  <li>Sexual Dysfunction</li>
  <li>Uterine Fibroids</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      link: "https://youtu.be/_0bVHoVdOI0?si=PAE5Vg4k6ACnLB0B",
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "LaKeisha N. Demerson, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Demerson.webp",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent: `LaKeisha Nicole Demerson, MD is a board-certified obstetrician and gynecologist with 17 years of experience providing comprehensive women's healthcare. She specializes in both obstetrics and gynecology, caring for women through all stages of life from routine preventive care to pregnancy and childbirth. Dr. Demerson's extensive experience allows her to provide personalized, compassionate care tailored to each patient's unique needs. She practices at multiple locations throughout Webster, Texas, and maintains hospital affiliations with The Heart And Vascular Hospital. Fluent in both English and Spanish, she is able to communicate effectively with a diverse patient population, ensuring all women receive clear, understandable care in their preferred language.`,
      mdname: "LAKEISHA N. DEMERSON, MD"
    },
    generalSurgeryDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women’s care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Demerson.webp",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent: `LaKeisha Nicole Demerson, MD is a board-certified obstetrician and gynecologist with 17 years of experience providing comprehensive women's healthcare. She specializes in both obstetrics and gynecology, caring for women through all stages of life from routine preventive care to pregnancy and childbirth. Dr. Demerson's extensive experience allows her to provide personalized, compassionate care tailored to each patient's unique needs. She practices at multiple locations throughout Webster, Texas, and maintains hospital affiliations with The Heart And Vascular Hospital. Fluent in both English and Spanish, she is able to communicate effectively with a diverse patient population, ensuring all women receive clear, understandable care in their preferred language.`,
      mdname: "LAKEISHA N. DEMERSON, MD"
    },
    id: "lakeisha-n-demerson-md",
    name: "LaKeisha N. Demerson, MD",
    image: "/images/physianDirectory/Ob-Demerson.webp",
    phone: "281-332-9511",
    gender: "Female",
    language: "English, Spanish",
    specialty: "Obstetrics and Gynecology",
    degrees: ["Medical Degree"],
    clinics: [
      {
            "name": "Bay Area OB/GYN",
            "address": "17 Professional Park Drive, Webster, TX 77598",
            "phone": "(281) 332-9511"
      },
      {
            "name": "UTMB Health Clear Lake Campus Hospital",
            "address": "200 Blossom Street, Webster, TX 77598",
            "phone": "(832) 632-6500"
      }
],
    bio_name: "About Dr. LaKeisha N. Demerson",
    bio: `Dr. Demerson received her undergraduate degree from Spelman College and her medical degree from the University of Texas Southwestern Medical School in Dallas. She completed her residency in Obstetrics and Gynecology at UT Southwestern Medical Center and Parkland Hospital. She focuses on helping patients navigate the complex challenges of high-risk pregnancies and maternal health concerns. She works extensively with women experiencing depression during pregnancy, preeclampsia, and high-risk pregnancy complications that require specialized monitoring and care. Her practice also addresses challenging conditions like placental abruption and vaginal bleeding after the first trimester, situations that can cause significant anxiety for expectant mothers and require immediate, expert intervention. Dr. Demerson's comprehensive approach extends beyond pregnancy complications to include broader women's health issues such as abnormal uterine bleeding, uterine fibroids, and endometriosis—conditions that can significantly impact a woman's quality of life and reproductive health. She helps patients manage gestational diabetes and pregnancy-related anemia, ensuring both maternal and fetal well-being throughout the pregnancy journey. Her expertise also encompasses routine yet critical aspects of women's health, including addressing abnormal Pap tests, managing sexually transmitted infections, and supporting women through various gynecological concerns. Her clinical work includes performing fetal ultrasounds to monitor baby development and assess pregnancy progression, providing expectant mothers with valuable insights into their pregnancy health.`,
    education: [
      "Medical Degree from University of Texas Southwestern Medical Center",
      "Residency (Obstetrics and Gynecology) at Parkland Memorial Hospital",
      "Residency at UT Southwestern Medical Center"
],
    areasOfExpertise: `<ul>
  <li>Annual Womens Exam</li>
  <li>Birth Control</li>
  <li>C-Section</li>
  <li>Cervical Polyp</li>
  <li>Dysmenorrhea</li>
  <li>Ectopic/Tubal Pregnancy</li>
  <li>Endometriosis</li>
  <li>Fibroids</li>
  <li>Gynecologic Biopsy</li>
  <li>Ovarian Cysts</li>
  <li>Pregnancy</li>
  <li>Uterine/Vaginal Prolapse</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      link: "",
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Chinyere Ndidi Ohakweh, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Ohakweh.webp",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent: `Chinyere N. Ohakweh, MD is an obstetrician-gynecologist in the Greater Houston area and has over 10 years of experience in the medical field. She is dedicated to delivering high-quality, compassionate care to Houston and nearby communities.`,
      mdname: "CHINYERE NDIDI OHAKWEH, MD"
    },
    generalSurgeryDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women’s care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Ohakweh.webp",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent: `Chinyere N. Ohakweh, MD is an obstetrician-gynecologist in the Greater Houston area and has over 10 years of experience in the medical field. She is dedicated to delivering high-quality, compassionate care to Houston and nearby communities.`,
      mdname: "CHINYERE NDIDI OHAKWEH, MD"
    },
    id: "chinyere-ndidi-ohakweh-md",
    name: "Chinyere Ndidi Ohakweh, MD",
    image: "/images/physianDirectory/Ob-Ohakweh.webp",
    phone: "832-828-1005",
    gender: "Female",
    language: "English",
    specialty: "Obstetrics and Gynecology, Gynecology",
    degrees: ["Medical Degree"],
    clinics: [
      {
            "name": "Legacy Community Health - Southwest",
            "address": "6441 High Star Drive, Houston, TX 77074",
            "phone": "(832) 548-5300"
      },
      {
            "name": "Baylor College of Medicine - OBGYN",
            "address": "9700 Bissonnet, Ste 1000W, Houston, TX 77036",
            "phone": "(832) 828-1005"
      },
      {
            "name": "MyCHN at Westwood",
            "address": "9700 Bissonnet Street, Houston, TX 77036",
            "phone": "(281) 824-1480"
      }
],
    bio_name: "About Dr. Chinyere Ndidi Ohakweh",
    bio: `Dr. Ohakweh, MD, is a respected physician specializing in Obstetrics and Gynecology, dedicated to providing exceptional care to patients in Houston. She earned their medical degree from Howard University College of Medicine, building a strong foundation in comprehensive reproductive and maternal health services. With her extensive medical training and compassionate approach, Dr. Ohakweh offers personalized healthcare solutions tailored to each patient's unique needs. Her commitment to patient well-being extends beyond traditional medical practice, as she prioritizes building trusting relationships and fostering open communication. Patients can expect comprehensive and supportive care from Dr. Ohakweh, who is deeply invested in staying abreast of the latest advancements in the field. Dr. Ohakweh welcomes individuals of all ages and backgrounds to her practice, where they can receive the highest standard of medical attention in a warm and welcoming environment.`,
    education: [
      "Medical Degree from Howard University School of Medicine",
      "Residency (Obstetrics and Gynecology) at University of Texas Health Science Center at Houston"
],
    areasOfExpertise: `<ul>
  <li>C-Section</li>
  <li>Coagulation Defects in Pregnancy and Postpartum</li>
  <li>Hysterectomy</li>
  <li>Maternal Anemia</li>
  <li>Menopause</li>
  <li>Obesity Complicating Childbirth</li>
  <li>Oophorectomy</li>
  <li>Ovarian Cancer Screening</li>
  <li>Tubal Ligation</li>
  <li>Vaginal Prolapse Surgery</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      link: "",
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Steven S. Dalati, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Dalati.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent: `Steven Dalati, MD is an obstetrician gynecologist in Shenandoah, TX and has over 15 years of experience in the medical field. He specializes in comprehensive obstetric and gynecologic care, supporting women through pregnancy, childbirth, and all stages of reproductive health. His extensive experience allows him to provide both routine preventive care and specialized treatment for complex women's health conditions. Dr. Dalati speaks multiple languages enabling him to communicate effectively with diverse patient populations and provide culturally sensitive care to women from various backgrounds.`,
      mdname: "STEVEN S. DALATI, MD"
    },
    generalSurgeryDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women’s care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Dalati.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent: `Steven Dalati, MD is an obstetrician gynecologist in Shenandoah, TX and has over 15 years of experience in the medical field. He specializes in comprehensive obstetric and gynecologic care, supporting women through pregnancy, childbirth, and all stages of reproductive health. His extensive experience allows him to provide both routine preventive care and specialized treatment for complex women's health conditions. Dr. Dalati speaks multiple languages enabling him to communicate effectively with diverse patient populations and provide culturally sensitive care to women from various backgrounds.`,
      mdname: "STEVEN S. DALATI, MD"
    },
    id: "steven-s-dalati-md",
    name: "Steven S. Dalati, MD",
    image: "/images/physianDirectory/Ob-Dalati.jpg",
    phone: "281-367-6836",
    gender: "Male",
    language: "English, Spanish, Italian, Russian, Tagalog",
    specialty: "Obstetrics and Gynecology, Gynecology",
    degrees: ["Medical Degree"],
    clinics: [
      {
            "name": "Women's Healthcare Affiliates",
            "address": "9180 Pinecroft Dr., Ste 100, The Woodlands, TX 77380",
            "phone": "(281) 367-6836"
      }
],
    bio_name: "About Dr. Steven S. Dalati",
    bio: `Dr. Dalati brings over 16 years of medical experience to the team. Born and raised in Mobile, Alabama, the middle child of Lebanese immigrants, Dr. Dalati earned his bachelor's degree in biology from Spring Hill College in 2004. He graduated from the University of South Alabama College of Medicine, followed by postgraduate training in Obstetrics and Gynecology at the University of Florida – Jacksonville. Board Certified by the American Board of Obstetrics and Gynecology and a Fellow of the American College of Obstetricians and Gynecologists, Dr. Dalati has been recognized for his excellence in education and clinical practice. He received the Society of Teaching Scholars Outstanding Resident Teacher Award and the University of Florida Excellence in Student Education Award during his residency. In 2014, he was honored with the prestigious ACOG/CREOG National Faculty Award for his contributions to medical education. Dr. Dalati practiced at Olive View-UCLA Medical Center as a faculty member at the David Geffen School of Medicine at UCLA. He is also a co-editor of Ob/Gyn Secrets, 4th Edition, a widely regarded resource in the field. Now practicing full-scope obstetrics and gynecology in The Woodlands, Texas, Dr. Dalati has a special focus on high-risk obstetrics and minimally invasive surgeries. In his free time, Dr. Dalati enjoys spending time with his two sons, Lucian and Dorian.`,
    education: [
      "Medical Degree from University of South Alabama Medical Center",
      "Residency (Obstetrics and Gynecology) at University of Florida College of Medicine Jacksonville"
],
    areasOfExpertise: `<ul>
  <li>High Risk Pregnancy</li>
  <li>Hysterosalpingo Sonography</li>
  <li>Laparoscopic Oophorectomy</li>
  <li>Loop Electrosurgical Excision Procedures</li>
  <li>Myomectomy</li>
  <li>Pelvic Prolapse</li>
  <li>Perimenopause</li>
  <li>Salpingectomy</li>
  <li>Surgical Abortion</li>
  <li>Vaginal Cysts</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      link: "",
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Rita A. Makhlouf, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Makhlouf.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent: `Rita A. Makhlouf is a neonatal-perinatal pediatrician in Houston, Texas and has over 35 years of experience in the medical field. She is affiliated with multiple major hospitals in the area. She received her medical degree from American University of Beirut Faculty of Medicine.`,
      mdname: "RITA A. MAKHLOUF, MD"
    },
    generalSurgeryDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women’s care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Makhlouf.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent: `Rita A. Makhlouf is a neonatal-perinatal pediatrician in Houston, Texas and has over 35 years of experience in the medical field. She is affiliated with multiple major hospitals in the area. She received her medical degree from American University of Beirut Faculty of Medicine.`,
      mdname: "RITA A. MAKHLOUF, MD"
    },
    id: "rita-a-makhlouf-md",
    name: "Rita A. Makhlouf, MD",
    image: "/images/physianDirectory/Ob-Makhlouf.jpg",
    phone: "(281) 558-3444",
    gender: "Female",
    language: "English, Spanish",
    specialty: "Neonatal-Perinatal Medicine, Pediatrics, Obstetrics & Gynecology",
    degrees: ["Doctor of Medicine"],
    clinics: [
      {
            "name": "Pediatrix Neonatology of Houston",
            "address": "12141 Richmond Ave, Houston, TX 77082",
            "phone": ""
      },
      {
            "name": "Pediatrix Neonatology of Houston",
            "address": "17500 W Grand Pkwy S, Sugar Land, TX 77479",
            "phone": ""
      }
],
    bio_name: "About Dr. Rita A. Makhlouf",
    bio: `A graduate of the American University of Beirut Faculty of Medicine, Dr. Makhlouf specializes in Pediatrics, Neonatology and Obstetrics & Gynecology. She is affiliated with multiple hospitals in the Houston, TX area, including HCA Houston Healthcare West and Houston Methodist Sugar Land Hospital. A fellow of the American Academy of Pediatrics, she dedicates her life in treating and providing comprehensive medical care for premature babies, newborns, and infants. She specializes in premature babies and newborns with high-risk or complex health conditions. She particularly provides attention to babies born with severe illnesses, injuries, or birth disorders. Dr. Makhlouf has published multiple peer-reviewed medical articles from The Journal of Pediatrics.`,
    education: [
      "Medical Degree, American University of Beirut Faculty of Medicine",
      "Residency (Pediatrics) at University of North Carolina Hospitals",
      "Internship (Pediatrics) at Moses Cone Memorial Hospital",
      "Fellowship (Neonatal-Perinatal Medicine) at University of North Carolina at Chapel Hill School of Medicine"
],
    areasOfExpertise: `<ul>
  <li>Birth Defects</li>
  <li>Birth Injuries</li>
  <li>Bradycardia</li>
  <li>C-Section</li>
  <li>Congenital Disorders</li>
  <li>Heart Valve Disease</li>
  <li>High-Risk Pregnancy</li>
  <li>Infections</li>
  <li>Premature Birth</li>
  <li>Respiratory Issues</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      link: "",
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdName: "Adanna C. Ukazu, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women's care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Ukazu.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent: `Adanna C. Ukazu, MD is an obstetrician-gynecologist in Houston, TX and has been in practice over 16 years. She received her medical degree from Albert Einstein College of Medicine of Yeshiva University. Dr. Ukazu's dedication to continuous learning and patient advocacy reflects her commitment to enhancing lives, earning her a well-deserved reputation as a leader in her field.`,
      mdname: "ADANNA C. UKAZU, MD"
    },
    generalSurgeryDetailData: {
      title:"OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"Obstetrician-gynecologists (OB/GYN) are physicians who possess special knowledge, skills and professional  capability in the medical and surgical care of the female reproductive system and associated disorders. In the United States, physicians must meet state licensure requirements after an extensive education and special training all while staying current on the latest advances in women’s care and state-of-the-art surgical procedures.",
      slope: true,
      intoImgData: "/images/providers/21213855_obgyn.jpg"
    },
    generalSurgeryDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Ob-Ukazu.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      mdcontent: `Adanna C. Ukazu, MD is an obstetrician-gynecologist in Houston, TX and has been in practice over 16 years. She received her medical degree from Albert Einstein College of Medicine of Yeshiva University. Dr. Ukazu's dedication to continuous learning and patient advocacy reflects her commitment to enhancing lives, earning her a well-deserved reputation as a leader in her field.`,
      mdname: "ADANNA C. UKAZU, MD"
    },
    id: "adanna-c-ukazu-md",
    name: "Adanna C. Ukazu, MD",
    image: "/images/physianDirectory/Ob-Ukazu.jpg",
    phone: "(281) 809-5467",
    gender: "Female",
    language: "English",
    specialty: "Obstetrics & Gynecology, General Gynecology, Addiction Medicine Specialist",
    degrees: ["Doctor of Medicine"],
    clinics: [
      {
            "name": "New Dawn Wellness and Medical Center",
            "address": "12000 Richmond Ave Ste 221, Houston, TX 77082",
            "phone": "(281) 809-5467"
      }
],
    bio_name: "About Dr. Adanna C. Ukazu",
    bio: `Dr. Ukazu began her academic journey at Lehman College in the Bronx, NY, graduating with distinction. She then attended the esteemed Albert Einstein College of Medicine, where she cultivated a strong passion for women's health. Dr. Ukazu completed her residency in Obstetrics and Gynecology at Long Island Jewish Medical Center, where she gained invaluable experience managing complex cases and championing patient advocacy. Driven by a vision for holistic care, she pursued a fellowship in Addiction Medicine at Rutgers University in Newark, NJ, honing her expertise in treating substance use disorders and co-occurring mental health conditions. Dr. Ukazu has co-authored several publications, including studies on myocardial infarction and cervical biopsies, which have been cited multiple times in the literature. She has also been involved in a clinical trial studying the Rx Al-Sense Liner for amniotic fluid leakage screening. Dr. Ukazu is the founder and CEO of New Dawn Medical Center in the Westchase area of Houston, Texas. As a compassionate physician and dedicated mother, her career is marked by academic excellence and a steadfast commitment to patient care. Outside of her medical career, Dr. Ukazu finds joy in gardening and traveling—activities that bring her both relaxation and inspiration.`,
    education: [
      "Doctorate of Medicine from Albert Einstein College of Medicine of Yeshiva University",
      "Bachelor's Degree from City University of New York, Lehman College",
      "Residency (Obstetrics and Gynecology) at Long Island Jewish Medical Center",
      "Fellowship (Addiction Medicine) at Rutgers, The State University of New Jersey"
],
    areasOfExpertise: `<ul>
  <li>Abdominal Pain</li>
  <li>Braxton Hicks Contractions</li>
  <li>C-Sections</li>
  <li>Chronic Pelvic Pain</li>
  <li>Ectopic Pregnancy</li>
  <li>Elevated Blood Pressure</li>
  <li>Genitourinary Tract Infections in Pregnancy</li>
  <li>High Blood Pressure</li>
  <li>High-Risk Pregnancy</li>
  <li>Preeclampsia</li>
  <li>Prudendal Neuralgia</li>
  <li>Round Ligament Pain</li>
  <li>Tubal Pregnancy</li>
  <li>Vulvar Pain</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      link: "",
      introImg: "/images/MDDetails/17788596_xxl.jpg",
      title: "OBSTETRICS & GYNECOLOGY SURGERY",
      contentTop:"OB/GYN Surgeons provides comprehensive medical and surgical care for women's reproductive health, managing pregnancy, childbirth (including C-sections), diagnosing and treating reproductive system disorders (fibroids, cysts), performing preventive screenings (Pap smears, oncology), and offering family planning, often working in hospitals and clinics with irregular hours, requiring critical thinking, precision, and strong communication for a wide range of patient needs across all life stages.",
      slope: true
    }
  }
];

export const physicianNeuroData =[
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "NEURO-SPINAL SURGERY",
      mdName: "Samuel Maxwell Adu-Lartey, DO",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
  
    cardioThoracicDetailData: {
      title:"NEURO-SPINAL SURGERY",
      contentTop:"Neurospinal surgery is the surgical specialization that treats diseases and disorders of the brain and spinal cord. Back pain can sometimes produce neurological symptoms and highly trained surgeons assist in alleviating that pain via surgery. These procedures could range from minimally invasive using robotic tools and small incisions to open spine surgery. In the U.S., Neurospinal surgeons go through many years of education and extensive training to learn how to safely and accurately perform these special techniques.",
      slope: true,
      intoImgData: "/images/providers/67129589_neuro.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_18.png",
      title: "NEURO-SPINAL SURGERY",
      mdcontent:
        "Dr. Samuel Adu-Lartey, DO is an orthopedic spine surgeon in Katy, TX and has over 19 years of experience in the medical field. He graduated from Oklahoma State University Center for Health Sciences College of Osteopathic Medicine.",
      mdname: "SAMUEL MAXWELL ADU-LARTEY, DO"
    },
  
    id: "samuel-maxwell-adu-lartey-do",
    name: "Samuel Maxwell Adu-Lartey, DO",
    image: "/images/doctors/samuel-maxwell-adu-lartey.jpg",
    phone: "(832) 321-4076",
    gender: "Male",
    language: "English, Spanish",
  
    specialty: "Spine Surgery, Orthopedic Surgery",
  
    degrees: [
      "Medical Degree – Oklahoma State University College of Osteopathic Medicine"
    ],
  
    clinics: [
      {
        name: "Houston Spine Institute",
        address: "705 South Fry Rd, Suite 215, Katy, TX 77450"
      }
    ],
  
    bio_name: "About Dr. Samuel Maxwell Adu-Lartey",
    bio: `
    Dr. Adu-Lartey grew up in Ghana as well as Oklahoma City, Oklahoma. Dr. Adu-Lartey obtained his medical degree from Oklahoma State University College of Osteopathic Medicine. While in medical school, Dr. Adu-Lartey was involved in extensive geriatric research at the prestigious Johns Hopkins University where he was awarded a National Medical Fellow in Academic Medicine award.  Dr. Adu-Lartey utilizes non-surgical and surgical techniques in treating conditions of the spine.</br></br>He is trained in the preservation, investigation and restoration of the form and function of the extremities, spine and associated structures by medical, surgical and physical means including the patients with musculoskeletal problems which include congenital deformities, trauma, infections, tumors, metabolic disturbances of the musculoskeletal system, deformities, injuries and degenerative diseases of the spine, hands, feet, knee, hip, shoulder and elbow in children and adults. Patients with primary and secondary muscular problems and the effects of central or peripheral nervous system lesions of the musculoskeletal system are also concerned.
    `,
  
    education: [
      "Medical School – Oklahoma State University College of Osteopathic Medicine",
      "Internship – Pinnacle Health Hospital",
      "Residency – Pinnacle Health Hospital",
      "Fellowship – Florida Orthopedic Institute"
    ],
  
    areasOfExpertise: `
      <ul>
        <li>Back & Neck Pain</li>
        <li>Carpal Tunnel Syndrome</li>
        <li>Cervical Disc Disease</li>
        <li>Foot & Ankle</li>
        <li>Fractures</li>
      </ul>
      <ul>
        <li>General Orthopedic</li>
        <li>Neck Surgery</li>
        <li>Neck/Low Back Pain</li>
        <li>Spine Fixation</li>
        <li>Spine Fusion</li>
      </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/shutterstock_1804240711.jpg",
      title: "NEURO-SPINAL SURGERY",
      contentTop:"Neurosurgeons are physicians who specializes in the diagnosis and surgical treatment of disorders of the central and peripheral nervous system including congenital anomalies, trauma, tumors, vascular disorders, infections of the brain or spine, stroke, or degenerative diseases of the spine. The education and training to become a neurosurgeon is rigorous and extensive. They use minimally invasive surgery to treat brain, nervous system and spinal nerve disorders.",
      slope: true
    }
  },  
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "NEURO-SPINAL SURGERY",
      mdName: "John B. Berry, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
  
    cardioThoracicDetailData: {
      title:"NEURO-SPINAL SURGERY",
      contentTop:"Neurospinal surgery is the surgical specialization that treats diseases and disorders of the brain and spinal cord. Back pain can sometimes produce neurological symptoms and highly trained surgeons assist in alleviating that pain via surgery. These procedures could range from minimally invasive using robotic tools and small incisions to open spine surgery. In the U.S., Neurospinal surgeons go through many years of education and extensive training to learn how to safely and accurately perform these special techniques.",
      slope: true,
     intoImgData: "/images/providers/67129589_neuro.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_19.png",
      title: "NEURO-SPINAL SURGERY",
      mdcontent:
        "Dr. John B. Berry, MD is a neurosurgeon in Houston, TX and has over 55 years of experience in the medical field. His top areas of expertise are Seizures, Hydrocephalus, Cervical Myelopathy, and Thrombophlebitis.",
      mdname: "JOHN B. BERRY, MD"
    },
  
    id: "john-b-berry-md",
    name: "John B. Berry, MD",
    image: "/images/doctors/john-b-berry.jpg",
    phone: "(713) 796-2101",
    gender: "Male",
    language: "English, Spanish",
  
    specialty: "Neurological Surgery",
  
    degrees: [
      "Medical Degree – Baylor College of Medicine",
      "B.A. – University of Oklahoma"
    ],
  
    clinics: [
      {
        name: "Baylor St. Luke’s Medical Center",
        address: "4635 Southwest Fwy, Houston, TX 77027",
        //phone: "(713) 796-2101"
      }
    ],
  
    bio_name: "About Dr. John B. Berry",
    bio: `
    Dr. Berry received his B.A. from the University of Oklahoma in Norman and graduated from the Baylor College of Medicine. His internship was completed at the Mount Sinai Hospital in New York City, New York and his neurological surgery residency was completed with Baylor Affiliated Hospitals as well as at University Hospital in London, Ontario, Canada. Dr. Berry also completed a neurological surgery fellowship at University Hospital in London, Ontario, Canada. He is certified by the American Neurological Surgical Board and is licensed to practice in the states of Texas, Tennessee and Georgia. Dr. Berry is an assistant clinical professor of neurosurgery at the Baylor College of Medicine and has served as assistant professor at the University of Texas Medical School. </br></br>Dr. Berry's current hospital appointments include Memorial Hermann Hospital, Saint Luke's Episcopal Hospital, Methodist Hospital, Memorial Hermann Southeast, Memorial Hermann Southwest, AMI " Twelve Oaks Hospital, Bayshore Medical Center, and AMI-Park Plaza Hospital. He served as Chief of Neurosurgery at Saint Joseph Hospital from December 1994 to December 1999 and Memorial Hermann Southwest Hospital from January 1999 to December 2004. Dr. Berry is a member of the Texas Medical Association, the Harris County Medical Society, the Texas Neurosurgical Association, the Houston Neurological Society, the American College of Surgeons, the American Association of Neurological Surgeons, the Congress of Neurosurgery, the American Medical Association, the Tennessee Medical Association, the Hamilton County Medical Society, the AED Honorary Premedical Society and the Osler Society.
    `,
  
    education: [
      "Fellowship – University Hospital, Western Ontario",
      "Residency – Baylor College of Medicine",
      "Internship – Icahn School of Medicine at Mount Sinai",
      "Medical School – Baylor College of Medicine",
      "Undergraduate Degree – University of Oklahoma"
    ],
  
    areasOfExpertise: `
      <ul>
        <li>Back Pain</li>
        <li>Degenerative Disc Disease</li>
        <li>Flank Pain</li>
        <li>Joint Pain</li>
      </ul>
      <ul>
        <li>Knee Arthritis</li>
        <li>Lumbar Herniated Disc</li>
        <li>Shoulder Pain</li>
        <li>Limping</li>
      </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/shutterstock_1804240711.jpg",
      title: "NEURO-SPINAL SURGERY",
      contentTop:"Neurosurgeons are physicians who specializes in the diagnosis and surgical treatment of disorders of the central and peripheral nervous system including congenital anomalies, trauma, tumors, vascular disorders, infections of the brain or spine, stroke, or degenerative diseases of the spine. The education and training to become a neurosurgeon is rigorous and extensive. They use minimally invasive surgery to treat brain, nervous system and spinal nerve disorders.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "NEURO-SPINAL SURGERY",
      mdName: "Dani Bidros, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
  
    cardioThoracicDetailData: {
      title:"NEURO-SPINAL SURGERY",
      contentTop:"Neurospinal surgery is the surgical specialization that treats diseases and disorders of the brain and spinal cord. Back pain can sometimes produce neurological symptoms and highly trained surgeons assist in alleviating that pain via surgery. These procedures could range from minimally invasive using robotic tools and small incisions to open spine surgery. In the U.S., Neurospinal surgeons go through many years of education and extensive training to learn how to safely and accurately perform these special techniques.",
      slope: true,
     intoImgData: "/images/providers/67129589_neuro.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_20.png",
      title: "NEURO-SPINAL SURGERY",
      mdcontent:
        "Dani Bidros, MD, FACS, FAANS, is a board-certified neurosurgeon specializing in brain and spine surgery. His expertise includes minimally invasive brain and spine surgery, complex spine reconstruction, pituitary surgery, brain tumor surgery, and stereotactic brain radiosurgery in Houston, Memorial City, Katy and surrounding areas.",
      mdname: "DANI BIDROS, MD"
    },
  
    id: "dani-bidros-md",
    name: "Dani Bidros, MD",
    image: "/images/doctors/dani-bidros.jpg",
    phone: "(281) 529-6264",
    gender: "Male",
    language: "English, Arabic",
  
    specialty: "Neurological Surgery, Neuroscience Services",
  
    degrees: [
      "Medical Degree – Louisiana State University School of Medicine"
    ],
  
    clinics: [
      {
        name: "West Houston Brain and Spine",
        address: "2222 Greenhouse Road, Suite 1100A, Houston, TX 77084"
      },
      {
        name: "Minimally Pain & Orthopedics – Stafford",
        address: "11925 Southwest Fwy Suite 1-C, Stafford, TX 77477"
      }
    ],
  
    bio_name: "About Dr. Dani Bidros",
    bio: `
     Dr. Bidros grew up and attended school in Lafayette, Louisiana. After obtaining top honors at the University of Louisiana at Lafayette, he began medical school at the Louisiana State University School of Medicine in New Orleans. Early in medical school, he became intrigued by neuroscience and began his pursuit of becoming a neurosurgeon. He completed his intern year in General Surgery residency at Charity Hospital in New Orleans which provided him with the knowledge and skills to treat critically ill patients. After completing the internship, he began his neurological surgery training at Louisiana State University in New Orleans, rotating at both Charity Hospital and at the Ochsner Clinic Foundation. He was trained by the esteemed Neurosurgery and Harvey Cushing Medal recipient Dr. David Kline. His training in his home state was cut short however by Hurricane Katrina. During the storm, Dr. Bidros spent six days at Charity Hospital caring for patients and helping in the relief efforts.</br>He resumed and completed his neurosurgical training at the Cleveland Clinic Foundation, training under the top professors in the field of Neurosurgery. He completed a combined Orthopedic and Neurosurgical Surgery Spine Fellowship at the Cleveland Clinic under the guidance of Dr. Ed Benzel, Dr. Iain Kalfas, and Dr. Richard Schlenk. During the one-year fellowship, he gained experience in the latest techniques of complex spine deformity and spine oncology.Additional training in pituitary surgery was completed under Dr. Robert Weil, and stereotactic brain and spine radiosurgery was completed under Dr. Lilyana Angelov. Stereotactic spine radiosurgery, a revolutionary treatment modality, has changed the way we approach and treat the metastatic disease of the spine. During his residency, he received special training in Gamma Knife Radiosurgery.</br>After mastering his Neurosurgical skills for two years in Princeton, New Jersey, he and his family decided to relocate back to Louisiana. For four years, Dr. Bidros practiced neurosurgery and provided excellent and compassionate care to the people in the community</br>Dr. Bidros has conducted clinical research and published several articles and book chapters in the neurosurgical literature. He has presented at several neurological society meetings. Dr. Bidros’ clinical interests include the complex spine, cranial and spinal oncology.
    `,
  
    education: [
      "Medical School – Louisiana State University School of Medicine",
      "Internship – General Surgery, Louisiana State University School of Medicine",
      "Residency – Neurosurgery, Louisiana State University School of Medicine",
      "Neurosurgery – Cleveland Clinic Foundation",
      "Fellowship – Brain Tumor, Cleveland Clinic Foundation",
      "Fellowship – Spine Surgery, Cleveland Clinic Foundation",
      "Fellowship – Cranial/Spine Radiosurgery, Cleveland Clinic Foundation"
    ],
  
    areasOfExpertise: `
      <ul>
        <li>Brain Tumors</li>
        <li>Craniopharyngioma</li>
        <li>Pituitary Tumors</li>
        <li>Hemifacial Spasm</li>
        <li>Trigeminal Neuralgia</li>
      </ul>
      <ul>
        <li>Arteriovenous Malformation (AVM)</li>
        <li>Cerebral Aneurysms</li>
        <li>Carpal Tunnel Syndrome</li>
        <li>Cervical & Lumbar Herniated Disc</li>
        <li>Spinal Stenosis</li>
      </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/shutterstock_1804240711.jpg",
      title: "NEURO-SPINAL SURGERY",
      contentTop:"Neurosurgeons are physicians who specializes in the diagnosis and surgical treatment of disorders of the central and peripheral nervous system including congenital anomalies, trauma, tumors, vascular disorders, infections of the brain or spine, stroke, or degenerative diseases of the spine. The education and training to become a neurosurgeon is rigorous and extensive. They use minimally invasive surgery to treat brain, nervous system and spinal nerve disorders.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "NEURO-SPINAL SURGERY",
      mdName: "Keith A. Kerr, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
  
    cardioThoracicDetailData: {
      title:"NEURO-SPINAL SURGERY",
      contentTop:"Neurospinal surgery is the surgical specialization that treats diseases and disorders of the brain and spinal cord. Back pain can sometimes produce neurological symptoms and highly trained surgeons assist in alleviating that pain via surgery. These procedures could range from minimally invasive using robotic tools and small incisions to open spine surgery. In the U.S., Neurospinal surgeons go through many years of education and extensive training to learn how to safely and accurately perform these special techniques.",
      slope: true,
     intoImgData: "/images/providers/67129589_neuro.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_21.png",
      title: "NEURO-SPINAL SURGERY",
      mdcontent:
        "Keith A. Kerr, MD, is a neurosurgeon in Cypress, Texas. He received his medical degree from McGovern Medical School at UTHealth and has been in practice between 11–20 years. Dr. Kerr has expertise in treating spinal fusion, spinal stenosis and spondylosis, among other conditions.",
      mdname: "KEITH A. KERR, MD"
    },
  
    id: "keith-a-kerr-md",
    name: "Keith A. Kerr, MD",
    image: "/images/doctors/keith-a-kerr.jpg",
    phone: "(346) 231-6830",
    gender: "Male",
    language: "English",
  
    specialty:
      "Neurological Surgery, Spine Surgery, Neuroscience Services",
  
    degrees: [
      "Medical Degree – University of Texas Health Science Center at Houston"
    ],
  
    clinics: [
      {
        name: "Mischer Neuroscience Associates – Cypress",
        address: "27700 Northwest Fwy, Suite 360, Cypress, TX 77433"
      },
      {
        name: "HCA Houston Brain & Spine – North Cypress",
        address: "21212 Northwest Fwy, Suite 450A, Cypress, TX 77429"
      }
    ],
  
    bio_name: "About Dr. Keith A. Kerr",
    bio: `
    Dr. Kerr\, who grew up in Spring, earned his undergraduate degree in biology at The University of Texas at Austin and his medical degree at McGovern Medical School at UTHealth Houston. He completed his residency in neurosurgery at UTHealth Houston/Memorial Hermann -Texas Medical Center, where he was selected as most valuable resident.</br>In practice since 2013, Dr. Kerr is board certified in neurological surgery and sees patients of all ages. Dr. Kerr’s training encompasses all aspects of neurosurgical care, including disorders of the brain and spine. Among the conditions he treats are brain trauma, brain tumors, cavernous malformations, Chiari malformations, concussion, cysts of the brain, hydrocephalus, seizures, trigeminal neuralgia, cervical degenerative disease, cervical disc disease, cervical spine trauma, cervical stenosis, lumbar spondylolisthesis, lumbar stenosis, spine tumors, thoracic disc disease, lumbar disc disease and thoracolumbar spine trauma.</br>Drawn to a medical career by his desire to support people during their most trying times, Dr. Kerr strives to treat his patients like members of his own family. Patients especially appreciate his thorough examinations, his ability to answer questions and give clear instructions, the amount of time he spends with them, his positive attitude and that he involves them in decision-making.</br>During his training, Dr. Kerr was elected to the Phi Beta Kappa and Alpha Omega Alpha honor societies. He has presented at professional conferences and authored numerous journal articles and book chapters on topics related to neurological surgery.</br>Dr. Kerr is married to a pediatrician and the father of two sons. His household also includes a Chesapeake Bay Retriever. When he isn’t spending time with them, he is probably playing golf or duck hunting.
    `,
    education: [
      "Medical Education – University of Texas Health Science Center at Houston (McGovern Medical School)",
      "Residency – Neurosurgery, Louisiana State University School of Medicine",
      "Neurosurgery – Cleveland Clinic Foundation",
      "Fellowship – Brain Tumor, Cleveland Clinic Foundation",
      "Fellowship – Spine Surgery, Cleveland Clinic Foundation",
      "Fellowship – Cranial/Spine Radiosurgery, Cleveland Clinic Foundation"
    ],
  
    areasOfExpertise: `
      <ul>
        <li>Spinal Cord Injury</li>
        <li>Neck Pain and Spine Problems</li>
        <li>Spinal Stenosis</li>
        <li>Spinal Fusion</li>
        <li>Craniotomy</li>
      </ul>
      <ul>
        <li>Radiculopathy</li>
        <li>Myelopathy</li>
        <li>Nerve Root Injury and Plexus Disorders</li>
        <li>Intervertebral Disc Disease</li>
        <li>Herniated Disc</li>
      </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      // link: "https://embed-ssl.wistia.com/deliveries/8d06a4b6338b956c50dae603c05320872204e0a1/file.mp4",
      link: "https://embed-cloudfront.wistia.com/deliveries/89406c832bf58da11592a469977221e568992763.m3u8",
      // introImg: "/images/MDDetails/shutterstock_1804240711.jpg",
      title: "NEURO-SPINAL SURGERY",
      contentTop:"Neurosurgeons are physicians who specializes in the diagnosis and surgical treatment of disorders of the central and peripheral nervous system including congenital anomalies, trauma, tumors, vascular disorders, infections of the brain or spine, stroke, or degenerative diseases of the spine. The education and training to become a neurosurgeon is rigorous and extensive. They use minimally invasive surgery to treat brain, nervous system and spinal nerve disorders.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "NEURO-SPINAL SURGERY",
      mdName: "John P. Masciale, M.D.",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
  
    cardioThoracicDetailData: {
      title:"NEURO-SPINAL SURGERY",
      contentTop:"Neurospinal surgery is the surgical specialization that treats diseases and disorders of the brain and spinal cord. Back pain can sometimes produce neurological symptoms and highly trained surgeons assist in alleviating that pain via surgery. These procedures could range from minimally invasive using robotic tools and small incisions to open spine surgery. In the U.S., Neurospinal surgeons go through many years of education and extensive training to learn how to safely and accurately perform these special techniques.",
      slope: true,
     intoImgData: "/images/providers/67129589_neuro.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_22.png",
      title: "NEURO-SPINAL SURGERY",
      mdcontent:
        "John P. Masciale, M.D. is an orthopedic spine surgeon in Corpus Christi, Texas. He received his medical degree from the State University of New York Downstate Medical Center College of Medicine and has been in practice for more than 20 years. Dr. Masciale has expertise in treating spinal fusion, spinal stenosis and spondylosis, among other conditions.",
      mdname: "JOHN P. MASCIALE, M.D."
    },
  
    id: "john-p-masciale-md",
    name: "John P. Masciale, M.D.",
    image: "/images/doctors/john-p-masciale.jpg",
    phone: "(361) 694-0811",
    gender: "Male",
    language: "English, Spanish",
  
    specialty: "Adult Reconstructive Spine Surgery",
  
    degrees: [
      "Medical Degree – State University of New York Downstate Medical Center, Brooklyn"
    ],
  
    clinics: [
      {
        name: "South Texas Bone and Joint Main Office",
        address: "5917 Crosstown Expressway SH 286, Corpus Christi, TX 78417"
      }
    ],
  
    bio_name: "About Dr. John P. Masciale",
    bio: `
    Dr. Masciale is a board-certified orthopaedic surgeon with a subspecialty focused in adult spinal surgery. He is a graduate of Cornell University and received his Doctor of Medicine degree from the State University of New York Downstate Medical Center in 1985.</br>​After completing his orthopaedic residency of Downstate Dr. Masciale completed a fellowship in spinal surgery at the Alamo Bone and Joint Clinic in San Antonio, Texas from 1990-1991.</br>​His philosophy involves a thorough clinical evaluation and non-operative treatment for back and neck pain management and other spinal disorders whenever possible.</br>In cases where non-operative treatment is not effective, Dr. Masciale’s years of experience and dedication to the art and science of spinal surgery have resulted in successful operative treatment of spine conditions such as sciatica, spinal stenosis, herniated discs, and degenerative disc disease in patients throughout South Texas.</br>Dr. Masciale is committed to mastering the latest advancements in minimally invasive spine surgery. This includes proficiency in state-of-the-art techniques for spinal decompressions and cervical and lumbar spine fusions. By prioritizing patient satisfaction and outcomes, Dr. Masciale strives to provide the best possible care for his patients.</br>He has been in practice with South Texas Bone & Joint since 1991 and is the longest practicing spinal surgeon in the city.
    `,
  
    education: [
      "BA Degree – Cornell University",
      "Family Medicine Residency – Universidad Autonoma de Guadalajara, Mexico",
      "Medical Degree – State University of New York Downstate Medical Center",
      "General Surgery Internship – State University of New York Downstate Kings County Hospital",
      "Orthopedic Residency – State University of New York Downstate Kings County Hospital",
      "Fellowship in Spine Surgery – Alamo Bone and Joint Clinic, San Antonio, TX"
    ],
  
    areasOfExpertise: `
      <ul>
        <li>Severe Lumbar Sprains/Strains</li>
        <li>Degenerative Disc Disease</li>
        <li>Herniated Lumbar Discs</li>
        <li>Spondylolisthesis</li>
        <li>Osteoporosis</li>
      </ul>
      <ul>
        <li>Compression/Flexion Fractures</li>
        <li>Spinal Stenosis</li>
        <li>Joint Arthropathy</li>
        <li>Thoracic Spine Disorders</li>
        <li>Scoliosis</li>
      </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/shutterstock_1804240711.jpg",
      title: "NEURO-SPINAL SURGERY",
      contentTop:"Neurosurgeons are physicians who specializes in the diagnosis and surgical treatment of disorders of the central and peripheral nervous system including congenital anomalies, trauma, tumors, vascular disorders, infections of the brain or spine, stroke, or degenerative diseases of the spine. The education and training to become a neurosurgeon is rigorous and extensive. They use minimally invasive surgery to treat brain, nervous system and spinal nerve disorders.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "NEURO-SPINAL SURGERY",
      mdName: "R. Alexander Mohr, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
  
    cardioThoracicDetailData: {
      title:"NEURO-SPINAL SURGERY",
      contentTop:"Neurospinal surgery is the surgical specialization that treats diseases and disorders of the brain and spinal cord. Back pain can sometimes produce neurological symptoms and highly trained surgeons assist in alleviating that pain via surgery. These procedures could range from minimally invasive using robotic tools and small incisions to open spine surgery. In the U.S., Neurospinal surgeons go through many years of education and extensive training to learn how to safely and accurately perform these special techniques.",
      slope: true,
      intoImgData: "/images/providers/67129589_neuro.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_23.png",
      title: "NEURO-SPINAL SURGERY",
      mdcontent:
        "R. Alexander Mohr, MD is a fellowship-trained, board-certified orthopedic spine surgeon. His specialty is operative treatment of spinal disorders including disc degeneration, spinal trauma, sports-related spine injuries, scoliosis, and minimally invasive spinal surgery.",
      mdname: "R. ALEXANDER MOHR, MD"
    },
  
    id: "r-alexander-mohr-md",
    name: "R. Alexander Mohr, MD",
    image: "/images/doctors/r-alexander-mohr.jpg",
    phone: "(281) 955-7577",
    gender: "Male",
    language: "English",
  
    specialty: "Spine Surgery, Orthopedic Surgery",
  
    degrees: [
      "Medical Degree – University of Utah School of Medicine"
    ],
  
    clinics: [
      {
        name: "Advanced Orthopaedics & Sports Medicine",
        address: "10425 Huffmeister Rd Ste 320, Houston, TX 77065"
      },
      {
        name: "Advanced Orthopaedics & Sports Medicine",
        address: "21212 NW Fwy Ste 605, Cypress, TX 77429"
      },
      {
        name: "Advanced Orthopaedics & Sports Medicine",
        address: "22485 Tomball Pkwy Ste 2100, Houston, TX 77070"
      }
    ],
  
    bio_name: "About Dr. R. Alexander Mohr",
    bio: `
    Dr Mohr completed the prestigious University of Wisconsin spine fellowship under the direction of Dr. Thomas Zdeblick. He served three and a half years as the Director of the Division of Orthopedic Spine Surgery at the University of Connecticut and the Assistant Director of the New England Musculoskeletal Institute’s Comprehensive Spine Center.</br>He played Left Tackle at Utah State University where he graduated with honors (summa cum laude) and finished his senior year with Utah State winning the Las Vegas Bowl 2. He then completed medical school with honors at the University of Utah School of Medicine. He finished his five-year Orthopedic residency at the University of Utah where he was earned research awards and was elected Administrative Chief Resident. He was invited to an Orthopedic spine fellowship at the prestigious University of Wisconsin spine fellowship under the direction of Thomas Zdeblick, M.D., Clifford Tribus, M.D., Paul Anderson, M.D.</br>Dr. Mohr is trained in surgical and nonsurgical management of most spinal pathology. He instructs other physicians: orthopedic and neurosurgical residents, fellows and attendings in complex spinal procedures, minimally invasive techniques and construct planning.</br>He is a devoted sports enthusiast who enjoys working with athletes to return them to sport after sports related spinal injuries. He specializes in Football injuries both in diagnosis and prevention.</br>Dr. Mohr is a fellowship trained Board Certified Orthopedic Surgeon. He is a member of the North American Spine Society and the Lumbar Spine Research Society. He is also a board-certified member of the American Academy of Orthopedic Surgeons. He welcomes new patients at both our NCMC and Lakewood offices.
    `,
  
    education: [
      "Undergraduate Degree – Utah State University",
      "Medical School – University of Utah School of Medicine",
      "Internship – University of Utah Hospitals & Clinics",
      "Residency – University of Utah Hospitals & Clinics",
      "Fellowship – University of Wisconsin Spine Fellowship"
    ],
  
    areasOfExpertise: `
      <ul>
        <li>Minimally Invasive Posterior Cervical Instrumentation and Fusion</li>
        <li>Cervical Laminoplasty</li>
        <li>Minimally Invasive Spinal Decompression</li>
        <li>Instrumentation and Fusion</li>
      </ul>
      <ul>
        <li>Microdiscectomy</li>
        <li>Cervical and Lumbar Disc Replacement</li>
        <li>Motion Preservation Surgery</li>
        <li>Revision Surgery</li>
      </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=SuIzJqM6tZQ",
      title: "NEURO-SPINAL SURGERY",
      contentTop:"Neurosurgeons are physicians who specializes in the diagnosis and surgical treatment of disorders of the central and peripheral nervous system including congenital anomalies, trauma, tumors, vascular disorders, infections of the brain or spine, stroke, or degenerative diseases of the spine. The education and training to become a neurosurgeon is rigorous and extensive. They use minimally invasive surgery to treat brain, nervous system and spinal nerve disorders.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "NEURO-SPINAL SURGERY",
      mdName: "Neel T. Patel, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
  
    cardioThoracicDetailData: {
      title:"NEURO-SPINAL SURGERY",
      contentTop:"Neurospinal surgery is the surgical specialization that treats diseases and disorders of the brain and spinal cord. Back pain can sometimes produce neurological symptoms and highly trained surgeons assist in alleviating that pain via surgery. These procedures could range from minimally invasive using robotic tools and small incisions to open spine surgery. In the U.S., Neurospinal surgeons go through many years of education and extensive training to learn how to safely and accurately perform these special techniques.",
      slope: true,
     intoImgData: "/images/providers/67129589_neuro.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_24.png",
      title: "NEURO-SPINAL SURGERY",
      mdcontent:
        "Dr. Neel T. Patel is a neurosurgeon diagnosing and surgically treating disorders of the central and peripheral nervous systems, including the brain, spinal cord, spinal column, and peripheral nerves throughout the body. Dr. Patel’s particular area of focus is wide of spine and peripheral nerve issues utilizing the most advanced procedures and technologies.",
      mdname: "NEEL T. PATEL, MD"
    },
  
    id: "neel-t-patel-md",
    name: "Neel T. Patel, MD",
    image: "/images/doctors/neel-t-patel.jpg",
    phone: "(832) 447-7494",
    gender: "Male",
    language: "English, Spanish",
  
    specialty: "Neurological Surgery, Neurology",
  
    degrees: [
      "Medical Degree – Pennsylvania State University College of Medicine"
    ],
  
    clinics: [
      {
        name: "Center for Minimally Invasive Neurosurgery",
        address: "1710 West Loop N Fwy, Kingswood, TX 77339"
      },
      {
        name: "Center for Minimally Invasive Neurosurgery",
        address: "2121 Williams Trace Blvd, Sugar Land, TX 77478"
      },
      {
        name: "DHR Health Neuroscience Institute – Neurosurgery",
        address: "5513 Doctors Dr, Edinburg, TX 78539"
      }
    ],
  
    bio_name: "About Dr. Neel T. Patel",
    bio: `
    Dr. Patel received his Bachelor’s degree graduating with honors from Rutgers University in New Jersey in 2013. He then attended medical school at Penn State University’s Milton S. Hershey College of Medicine in Pennsylvania, graduating in 2017. Dr. Patel completed his residency training in Neurological Surgery at Penn State Hershey Medical Center and pursued additional training in peripheral nerve studies. He recently finished an enfolded fellowship in complex and minimally invasive spine surgery at the Swedish Neuroscience Institute in Seattle, Washington. Post fellowship he went to Australian Institute of Musculoskeletal Research in Sydney, Australia to learn endoscopic spine surgery.</br>Dr. Patel is a fellowship-trained neurosurgeon specializing in complex spine surgery, motion-preserving techniques, and minimally invasive approaches. Dr. Patel combines cutting-edge technology with compassionate care to deliver personalized treatment for patients with spinal disorders, trauma, and tumors.  </br>After completing his neurosurgical residency at Penn State and advanced spine fellowship at Swedish Neuroscience Institute in Seattle, he pursued global training in endoscopic spine surgery across Australia and Taiwan. </br>Dr. Patel is a member of many medical associations including the American Association of Neurological Surgeons, American Medical Association, and Congress of Neurological Surgeons. He has authored several publications and has presented extensively in his field. He is also actively involved in research, innovation, and education—frequently lecturing on novel surgical techniques and serving on editorial boards of major neurosurgical journals. Dr. Patel is passionate about improving surgical outcomes, expanding access to advanced care, and shaping the future of medical technology.
    `,
  
    education: [
      "Residency – Neurological Surgery, Penn State Milton S. Hershey Medical Center",
      "Medical Degree – Pennsylvania State University College of Medicine"
    ],
  
    areasOfExpertise: `
      <ul>
        <li>Cerebrovascular Disease</li>
        <li>Stroke</li>
        <li>Traumatic Brain Injury</li>
        <li>Carotid Artery Stent Placement</li>
        <li>Neck Pain</li>
      </ul>
      <ul>
        <li>Sciatica</li>
        <li>Back Pain</li>
        <li>Brain Tumors</li>
        <li>Spinal Stenosis</li>
        <li>Aneurysms</li>
      </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/shutterstock_1804240711.jpg",
      title: "NEURO-SPINAL SURGERY",
      contentTop:"Neurosurgeons are physicians who specializes in the diagnosis and surgical treatment of disorders of the central and peripheral nervous system including congenital anomalies, trauma, tumors, vascular disorders, infections of the brain or spine, stroke, or degenerative diseases of the spine. The education and training to become a neurosurgeon is rigorous and extensive. They use minimally invasive surgery to treat brain, nervous system and spinal nerve disorders.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "NEURO-SPINAL SURGERY",
      mdName: "Allison M. Rathmann, DO",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
  
    cardioThoracicDetailData: {
      title:"NEURO-SPINAL SURGERY",
      contentTop:"Neurospinal surgery is the surgical specialization that treats diseases and disorders of the brain and spinal cord. Back pain can sometimes produce neurological symptoms and highly trained surgeons assist in alleviating that pain via surgery. These procedures could range from minimally invasive using robotic tools and small incisions to open spine surgery. In the U.S., Neurospinal surgeons go through many years of education and extensive training to learn how to safely and accurately perform these special techniques.",
      slope: true,
     intoImgData: "/images/providers/67129589_neuro.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_25.png",
      title: "NEURO-SPINAL SURGERY",
      mdcontent:
        "Allison Rathmann, DO is a highly experienced and qualified neurosurgeon who practices in Webster, Texas. She graduated from New York College of Osteopathic Medicine and completed her residency training at St. Barnabas Medical Center in Livingston, NJ. She also completed a fellowship in pediatric neurosurgery at the Cleveland Clinic Foundation. Dr. Rathmann has published several papers and presented at various conferences on topics related to pediatric neurosurgery. She is passionate about providing compassionate and personalized care to her patients and their families.",
      mdname: "ALLISON M. RATHMANN, DO"
    },
  
    id: "allison-m-rathmann-do",
    name: "Allison M. Rathmann, DO",
    image: "/images/doctors/allison-m-rathmann.jpg",
    phone: "(832) 932-5229",
    gender: "Female",
    language: "English",
  
    specialty: "Pediatric Neurosurgery, Adult Neurosurgeon",
  
    degrees: [
      "Doctor of Osteopathy – New York College of Osteopathic Medicine"
    ],
  
    clinics: [
      {
        name: "Texas Neurosurgical PLLC",
        address: "400 W. Medical Center Blvd, Suite 245Webster, TX 77598"
      },
      {
        name: "UTMB Health Neurosurgery Spine Care – Clear Lake Campus",
        address: "250 Blossom Street, 2nd Floor, Suite 270Webster, TX 77598"
      }
    ],
  
    bio_name: "About Dr. Allison M. Rathmann",
    bio: `
    Allison Rathmann was born in North Tonawanda, NY and was raised in Ashland, KY. She completed her undergraduate studies at the University of Kentucky with a Bachelors of Science in Biology. She then relocated to Long Island, NY and attended medical school at New York College of Osteopathic Medicine, earning her DO. She also completed a mini fellowship in Endoscopy at Cornell University in NYC, and a Pediatric Fellowship at Cleveland Clinic in Ohio. She spent the first 8 years after training working in northern New Jersey in a very busy practice, taking care of both pediatric and adult patients. She made her way to Texas in 2021, and opened her own practice, Texas Neurosurgicare. She recently joined UTMB as clinical assistant professor in the Neurosurgery department.</br>Dr Rathmann specializes in pediatric neurosurgical problems but also takes care of adult neurosurgical patients. This includes such disorders as craniosynostosis, hydrocephalus, brain tumors, spinal dysraphism, and trauma. She looks forward to bringing her knowledge and expertise in pediatrics to the UTMB community.</br>She is a member of the AOA, ACOS, a fellow of the CNS, the pediatric section of the AANS, and the TANS Amongst others. She maintains a medical license in Texas, NJ, and Florida.
    `,
  
    education: [
      "Doctor of Osteopathy – New York College of Osteopathic Medicine",
      "Bachelor of Science in Biology – University of Kentucky",
      "Pre-Med focus - Transylvania University",
      "Intern – St. Barnabas Medical Center",
      "Neurosurgery Residency – St. Barnabas Medical Center",
      "Fellowship – Pediatric Neurosurgery, Cleveland Clinic Foundation"
    ],
  
    areasOfExpertise: `
      <ul>
        <li>Anterior Cervical Discectomy & Fusion</li>
        <li>Posterior Lumbar Fusion</li>
        <li>Microdiscectomy</li>
        <li>Tethered Cord Release</li>
        <li>Myelomeningocele Repair (Post Natal)</li>
      </ul>
      <ul>
        <li>Spinal Tumor Resection</li>
        <li>Trauma Craniotomy for Bleed or Fracture</li>
        <li>Brain Tumor Resection</li>
        <li>Shunt Replacement</li>
        <li>Ommaya Reservoir for Neonates</li>
      </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=1QeiysG9waM",
      title: "NEURO-SPINAL SURGERY",
      contentTop:"Neurosurgeons are physicians who specializes in the diagnosis and surgical treatment of disorders of the central and peripheral nervous system including congenital anomalies, trauma, tumors, vascular disorders, infections of the brain or spine, stroke, or degenerative diseases of the spine. The education and training to become a neurosurgeon is rigorous and extensive. They use minimally invasive surgery to treat brain, nervous system and spinal nerve disorders.",
      slope: true
    }
  },
    {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "NEURO-SPINAL SURGERY",
      mdName: "Adam I. Lewis, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },

    cardioThoracicDetailData: {
      title: "NEURO-SPINAL SURGERY",
      contentTop: "Neurospinal surgery is the surgical specialization that treats diseases and disorders of the brain and spinal cord. Back pain can sometimes produce neurological symptoms and highly trained surgeons assist in alleviating that pain via surgery. These procedures could range from minimally invasive using robotic tools and small incisions to open spine surgery. In the U.S., Neurospinal surgeons go through many years of education and extensive training to learn how to safely and accurately perform these special techniques.",
      slope: true,
      intoImgData: "/images/providers/67129589_neuro.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/N-Lewis.png",
      title: "NEUROSURGEON",
      mdcontent:
        "Adam I. Lewis, MD practices neurological surgery at South Texas Brain and Spine Center in Corpus Christi, Texas. As a board certified neurological surgeon, Dr. Lewis performs surgery on disorders of the brain, spine and peripheral nerves.",
      mdname: "ADAM I. LEWIS, MD"
    },

    id: "adam-i-lewis-md",
    name: "Adam I. Lewis, MD",
    image: "/images/providers/67129589_neuro.jpg",
    phone: "361-883-4323",
    gender: "Male",
    language: "English, French",
    specialty: "Neurological Surgery, Spine Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Center for Minimally Invasive Neurosurgery",
        address: "7121 S Padre Island Drive, Ste 106, Corpus Christi, TX 78412",
        phone: "(361) 561-9560"
      }
    ],

    bio_name: "About Dr. Adam I. Lewis",
    bio: `Dr. Lewis is a prominent neurosurgeon at South Texas Brain and Spine Center in Corpus Christi, Texas.</br></br>
Before embarking on his professional journey, he graduated from Harvard University with a BA in Biology. Dr. Lewis received a medical degree from the Georgetown University School of Medicine. He completed an internship and residency in neurosurgery at the University of Cincinnati College of Medicine. Dr. Lewis served as Chief Resident in Neurosurgery.</br></br>
As a testament of his continued education, Dr. Lewis is board-certified in neurosurgery by the American Board of Neurological Surgery (ABNS). He is an active member of the American Association of Neurological Surgeons, the Congress of Neurological Surgeons, and the American Medical Association.</br></br>
Dr. Lewis attributes his success to his focus and determination. In his free time, he enjoys bicycling, cooking, designing medical devices, missionary work, and teaching surgical techniques to surgeons throughout the United States and internationally.`,

    education: [
      "Medical Degree from Georgetown University School of Medicine",
      "Undergraduate Degree (Biology & Neurobiology) from Harvard University",
      "Residency (Neurosurgery) at University of Cincinnati"
    ],

    areasOfExpertise: `<ul>
      <li>Complex Brain Tumors</li>
      <li>Herniated Discs</li>
      <li>Hydrocephalus</li>
      <li>Lumbar Epidural Steroid Injection</li>
      <li>Minimally Invasive Spine Surgery</li>
    </ul>
    <ul>
      <li>Myelopathy</li>
      <li>Sacroiliac Joint Fusion</li>
      <li>Spinal Cord Stimulation</li>
      <li>Spondylolisthesis</li>
      <li>Trigeminal Neuralgia</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=8PpVR607tAs",
      title: "NEURO-SPINAL SURGERY",
      contentTop: "Neurosurgeons are physicians who specialize in the diagnosis and surgical treatment of disorders of the central and peripheral nervous system including congenital anomalies, trauma, tumors, vascular disorders, infections of the brain or spine, stroke, or degenerative diseases of the spine. The education and training to become a neurosurgeon is rigorous and extensive.",
      slope: true
    }
  },
    {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "NEURO-SPINAL SURGERY",
      mdName: "Davin Cordell, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },

    cardioThoracicDetailData: {
      title: "NEURO-SPINAL SURGERY",
      contentTop: "Neurospinal surgery is the surgical specialization that treats diseases and disorders of the brain and spinal cord. Back pain can sometimes produce neurological symptoms and highly trained surgeons assist in alleviating that pain via surgery. These procedures could range from minimally invasive using robotic tools and small incisions to open spine surgery. In the U.S., Neurospinal surgeons go through many years of education and extensive training to learn how to safely and accurately perform these special techniques.",
      slope: true,
      intoImgData: "/images/providers/67129589_neuro.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/N-Cordell.avif",
      title: "ORTHOPEDIC SPINE SURGEON",
      mdcontent:
        "Dr. Davin Cordell, MD is a board certified Orthopedic Surgeon in Corpus Christi, TX with 15+ years of experience. As a specialty spine surgeon, he has expertise in treating spinal fusion, arthritis, bursitis, back pain, scoliosis, and spinal stenosis.",
      mdname: "DAVIN CORDELL, MD"
    },

    id: "davin-cordell-md",
    name: "Davin Cordell, MD",
    image: "/images/providers/67129589_neuro.jpg",
    phone: "361-883-2000",
    gender: "Male",
    language: "English, Spanish",
    specialty: "Orthopaedic Surgery, Orthopedic Spine Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Orthopaedic Center of Corpus Christi",
        address: "6118 Parkway Drive, Corpus Christi, TX 78414",
        phone: "(361) 883-2000"
      },
      {
        name: "CHRISTUS Trinity Clinic",
        address: "2606 Hospital Boulevard, Suite E, Corpus Christi, TX 78405",
        phone: "(361) 902-4765"
      }
    ],

    bio_name: "About Dr. Davin Cordell",
    bio: `Dr. Cordell was born in Gainesville, Florida, but his family kept him moving around the country for the first 6 years of his life before landing in Austin, TX. He finished high school in Austin before going to Houston to attend Rice University for college.</br></br>
After college, out of a desire to give back to the community, he spent the first three years working for a non-profit residential rehabilitation facility as direct care staff and staff trainer for high-risk adolescent boys. After that, he attended Hardin-Simmons University to attain a Master's degree in Physical Therapy. His first job was working at The Institute for Rehabilitation and Research (TIRR) in Houston, TX, specializing in neurological rehabilitation.</br></br>
He completed medical school at the University of Texas Health Science Center in San Antonio, TX, and stayed for his orthopaedic surgery residency training. While in San Antonio, he was involved in research related to pediatric spinal and thoracic deformity. For further training in spine surgery, he had the great fortune of spending a year at Washington University in St. Louis, training at a premier facility for adult and pediatric spine surgery. He was also an AOSpine fellow.</br></br>
He is married to Oriana and has one daughter, Bella. He is excited to be in Corpus Christi and rekindle his love of sailing and fishing.`,

    education: [
      "Medical Degree from The University of Texas Health Science Center- San Antonio",
      "Residency (Orthopaedic Surgery) at The University of Texas Health Science Center- San Antonio",
      "Fellowship (Adult & Pediatric Spine Surgery) at Washington University at St. Louis"
    ],

    areasOfExpertise: `<ul>
      <li>Arthritis</li>
      <li>Back Pain</li>
      <li>Bursitis</li>
      <li>Coccyx or Sacrum Fracture</li>
      <li>Intervertebral Disc Disease</li>
    </ul>
    <ul>
      <li>Low Back Pain</li>
      <li>Nerve Damage</li>
      <li>Sciatica</li>
      <li>Scoliosis</li>
      <li>Spinal Stenosis</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/shutterstock_1804240711.jpg",
      title: "NEURO-SPINAL SURGERY",
      contentTop: "Neurosurgeons are physicians who specialize in the diagnosis and surgical treatment of disorders of the central and peripheral nervous system including congenital anomalies, trauma, tumors, vascular disorders, infections of the brain or spine, stroke, or degenerative diseases of the spine. The education and training to become a neurosurgeon is rigorous and extensive.",
      slope: true
    }
  },
    {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "NEURO-SPINAL SURGERY",
      mdName: "Anthony Owusu II, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },

    cardioThoracicDetailData: {
      title: "NEURO-SPINAL SURGERY",
      contentTop: "Neurospinal surgery is the surgical specialization that treats diseases and disorders of the brain and spinal cord. Back pain can sometimes produce neurological symptoms and highly trained surgeons assist in alleviating that pain via surgery. These procedures could range from minimally invasive using robotic tools and small incisions to open spine surgery. In the U.S., Neurospinal surgeons go through many years of education and extensive training to learn how to safely and accurately perform these special techniques.",
      slope: true,
      intoImgData: "/images/providers/67129589_neuro.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/N-Owusu.jpg",
      title: "ORTHOPEDIC SPINE SURGEON",
      mdcontent:
        "Anthony Owusu II, MD is a fellowship trained Orthopedic Spine Surgeon with specialization in Minimally Invasive Spine Surgery. He specializes in issues related to the back and neck and encourages a patient's participation in treatment, exhausting all conservative treatments before proceeding with surgery.",
      mdname: "ANTHONY OWUSU II, MD"
    },

    id: "anthony-owusu-ii-md",
    name: "Anthony Owusu II, MD",
    image: "/images/providers/67129589_neuro.jpg",
    phone: "832-402-1400",
    gender: "Male",
    language: "English",
    specialty: "Orthopedic Surgery, Spine Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Next Generation Orthopedic and Spine Institute",
        address: "200 Valleywood Dr., Ste 300A, The Woodlands, TX 77380",
        phone: "(832) 402-1400"
      },
      {
        name: "Next Generation Orthopedic and Spine Institute- Humble Satellite",
        address: "1485 FM 1960 Bypass Road, Ste 260, Humble, TX 77338",
        phone: "(832) 402-1400"
      }
    ],

    bio_name: "About Dr. Anthony Owusu II",
    bio: `Dr. Owusu is a distinguished spine surgeon with a wealth of experience and a passion for advancing spinal care. He completed his orthopedic residency at the Medical College of Virginia and Howard University College of Medicine. His dedication to excellence was evident throughout his training, culminating in his role as Chief Orthopedic Surgery Resident during his residency. Afterward, Dr. Owusu fellowshipped at the prestigious Texas Back Institute in Dallas, TX.</br></br>
His expertise extends beyond clinical practice, as evidenced by his involvement in various research projects and internships. Notably, he participated in the Uganda Spine Surgery Mission, where he provided crucial spinal care to patients in need.</br></br>
Throughout his career, Dr. Owusu has been actively engaged in research, exploring topics ranging from lumbar disc arthroplasty to nerve repair techniques. His contributions to the field have been recognized through presentations at esteemed conferences and publications in reputable journals.</br></br>
Dr. Owusu's leadership and considerate demeanor create the perfect mix that charms his patients. He pays attention to each of his patient's individual needs with his one-on-one patient care.`,

    education: [
      "Medical Degree from Howard University College of Medicine",
      "Undergraduate Degree from University of Maryland Eastern Shore",
      "Residency (Orthopedic Surgery) at Virginia Commonwealth University",
      "Fellowship (Orthopedic Surgery Of The Spine) at Texas Back Institute Research Foundation"
    ],

    areasOfExpertise: `<ul>
      <li>Back Pain</li>
      <li>Disc Decompression Surgery</li>
      <li>Herniated Disc</li>
      <li>Laminectomy</li>
      <li>Neck Pain</li>
    </ul>
    <ul>
      <li>Radiculopathy</li>
      <li>Sciatica</li>
      <li>Scoliosis</li>
      <li>Spinal Fusion</li>
      <li>Spondylolisthesis</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=1oE2VK55Hw0",
      title: "NEURO-SPINAL SURGERY",
      contentTop: "Neurosurgeons are physicians who specialize in the diagnosis and surgical treatment of disorders of the central and peripheral nervous system including congenital anomalies, trauma, tumors, vascular disorders, infections of the brain or spine, stroke, or degenerative diseases of the spine. The education and training to become a neurosurgeon is rigorous and extensive.",
      slope: true
    }
  },
    {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "NEURO-SPINAL SURGERY",
      mdName: "Michael Leahy, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },

    cardioThoracicDetailData: {
      title: "NEURO-SPINAL SURGERY",
      contentTop: "Neurospinal surgery is the surgical specialization that treats diseases and disorders of the brain and spinal cord. Back pain can sometimes produce neurological symptoms and highly trained surgeons assist in alleviating that pain via surgery. These procedures could range from minimally invasive using robotic tools and small incisions to open spine surgery. In the U.S., Neurospinal surgeons go through many years of education and extensive training to learn how to safely and accurately perform these special techniques.",
      slope: true,
      intoImgData: "/images/providers/67129589_neuro.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/N-Leahy.jpg",
      title: "SPINE SURGEON",
      mdcontent:
        "Michael Leahy, MD is a board certified orthopedic surgeon with 21 years of practice. He specializes in orthopedic surgery with fellowship training in spine surgery.",
      mdname: "MICHAEL LEAHY, MD"
    },

    id: "michael-leahy-md",
    name: "Michael Leahy, MD",
    image: "/images/providers/67129589_neuro.jpg",
    phone: "281-351-7261",
    gender: "Male",
    language: "English",
    specialty: "Orthopaedic Surgery, Spine Surgeon, Sports Medicine",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Texas Orthopaedic & Sports Medicine - Tomball",
        address: "13603 Michel Road, Tomball, TX 77375",
        phone: "(281) 351-7261"
      },
      {
        name: "Texas Orthopaedic & Sports Medicine - Woodlands",
        address: "9319 Pinecroft Dr., Suite 200, The Woodlands, TX 77380",
        phone: "(281) 351-7261"
      }
    ],

    bio_name: "About Dr. Michael Leahy",
    bio: `Dr. Leahy is a native Houstonian. After graduating from Memorial High School, Dr. Leahy attended Southern Methodist University. He then attended medical school at the University of Texas Medical Branch at Galveston. He completed his Orthopaedic Surgery residency at Scott & White Hospital Texas A&M Health Science Center. He ultimately completed his medical training at the Texas Back Institute in Plano, Texas obtaining subspecialty training in spinal surgery.</br></br>
Dr. Leahy believes in taking a conservative approach to treating the spine, considering surgery only after exhaustive non-surgical efforts. When surgical treatment is necessary, Dr. Leahy is a strong proponent of minimally invasive techniques, including non-fusion procedures such as artificial disc replacement and adult stem cell therapy. He is proficient in all of the most current surgical techniques in the treatment of spinal disorders.</br></br>
When Dr. Leahy is not treating spinal disorders he enjoys spending time with his wife and two children.`,

    education: [
      "Medical Degree from University of Texas Medical Branch- Galveston",
      "Undergraduate Degree from Southern Methodist University",
      "Fellowship at Texas Back Institute",
      "Residency (Orthopaedic Surgery) at Scott & White Hospital, Texas A&M Health Sciences Center"
    ],

    areasOfExpertise: `<ul>
      <li>Adult Stem Cell Therapy</li>
      <li>Anterior Cervical Discectomy & Fusion</li>
      <li>Anterior/Posterior Lumbar Interbody Fusion</li>
      <li>Cervical and Lumbar Artificial Disc Replacement</li>
      <li>Corpectomy</li>
    </ul>
    <ul>
      <li>Extreme Lateral Interbody Fusion (XLIF)</li>
      <li>Laminectomy/Laminotomy</li>
      <li>Laminoplasty</li>
      <li>Lumbar Microdiscectomy</li>
      <li>Posterior Cervical Fusion</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=ASiloDyp0s4",
      title: "NEURO-SPINAL SURGERY",
      contentTop: "Neurosurgeons are physicians who specialize in the diagnosis and surgical treatment of disorders of the central and peripheral nervous system including congenital anomalies, trauma, tumors, vascular disorders, infections of the brain or spine, stroke, or degenerative diseases of the spine. The education and training to become a neurosurgeon is rigorous and extensive.",
      slope: true
    }
  },
    {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "NEURO-SPINAL SURGERY",
      mdName: "Andre M. Samuel, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },

    cardioThoracicDetailData: {
      title: "NEURO-SPINAL SURGERY",
      contentTop: "Neurospinal surgery is the surgical specialization that treats diseases and disorders of the brain and spinal cord. Back pain can sometimes produce neurological symptoms and highly trained surgeons assist in alleviating that pain via surgery. These procedures could range from minimally invasive using robotic tools and small incisions to open spine surgery. In the U.S., Neurospinal surgeons go through many years of education and extensive training to learn how to safely and accurately perform these special techniques.",
      slope: true,
      intoImgData: "/images/providers/67129589_neuro.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/N-Samuel.jpg",
      title: "ORTHOPEDIC SPINE SURGEON",
      mdcontent:
        "Andre Samuel, MD is an orthopaedic surgeon based in Webster, TX, with a subspecialty in orthopedic spine surgery. He received his medical degree from Yale School of Medicine and has been in practice between 6-10 years.",
      mdname: "ANDRE M. SAMUEL, MD"
    },

    id: "andre-m-samuel-md",
    name: "Andre M. Samuel, MD",
    image: "/images/providers/67129589_neuro.jpg",
    phone: "281-332-9537",
    gender: "Male",
    language: "English",
    specialty: "Orthopedic Surgery, Spine Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Fondren Orthopedic Group – Clear Lake Office",
        address: "520 Blossom St., Webster, TX 77598",
        phone: "(281) 332-9537"
      },
      {
        name: "Fondren Orthopedic Group – Houston Office",
        address: "7401 Main St, Houston, TX 77030",
        phone: "(281) 332-9537"
      },
      {
        name: "Fondren Orthopedic Group – Sugar Land Office",
        address: "13440 University Blvd, Suite 100, Sugar Land, TX 77479",
        phone: "(281) 332-9537"
      }
    ],

    bio_name: "About Dr. Andre M. Samuel",
    bio: `Andre M. Samuel, MD is a Board-Certified orthopedic spine surgeon treating Houston-area and traveling patients at Fondren Orthopedic Group.</br></br>
He received his medical education and surgical training at Yale School of Medicine graduating with honors, and Hospital for Special Surgery – the #1 ranked orthopaedic hospital in the country. He then gained additional expertise in orthopedic spine surgery at the prestigious Rothman Orthopedic Institute in Philadelphia. During this time, he treated professional athletes under the world-famous Alexander Vaccaro MD (President of Rothman Institute and Team Physician for Philadelphia Eagles and Philadelphia 76ers) and served as an assistant clinical instructor to orthopedic residents.</br></br>
Dr. Samuel also has published over 70 peer-reviewed scientific articles, along with book chapters, lectures, podium presentations, and poster presentations.</br></br>
When he is not in the office or the operating room, Dr. Samuel enjoys hobbies such as Thai boxing, powerlifting, rugby, rowing, outdoor activities and investing.`,

    education: [
      "Medical Degree from Yale School of Medicine",
      "Bachelors Degree (Economics and Finance) from Baylor University",
      "Residency (Orthopedic Surgery) at Hospital for Special Surgery, New York",
      "Fellowship (Orthopedic Spinal Surgery) at Rothman Orthopaedic Institute /Thomas Jefferson University"
    ],

    areasOfExpertise: `<ul>
      <li>Cervical Motion Preservation Surgeries</li>
      <li>Cervical Fusions</li>
      <li>Discectomy/Decompression</li>
      <li>Foraminotomy</li>
      <li>Herniated Disc</li>
    </ul>
    <ul>
      <li>Minimally Invasive Microdiscectomy/Laminectomy</li>
      <li>Minimally Invasive Fusion Techniques</li>
      <li>Radiculopathy / Sciatica</li>
      <li>Thoracic Disc Herniation</li>
      <li>Thoracic Stenosis / Myelopathy</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=Xlx1yRLx2is",
      title: "NEURO-SPINAL SURGERY",
      contentTop: "Neurosurgeons are physicians who specialize in the diagnosis and surgical treatment of disorders of the central and peripheral nervous system including congenital anomalies, trauma, tumors, vascular disorders, infections of the brain or spine, stroke, or degenerative diseases of the spine. The education and training to become a neurosurgeon is rigorous and extensive.",
      slope: true
    }
  },
    {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "NEURO-SPINAL SURGERY",
      mdName: "Bonaventure Ngu, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },

    cardioThoracicDetailData: {
      title: "NEURO-SPINAL SURGERY",
      contentTop: "Neurospinal surgery is the surgical specialization that treats diseases and disorders of the brain and spinal cord. Back pain can sometimes produce neurological symptoms and highly trained surgeons assist in alleviating that pain via surgery. These procedures could range from minimally invasive using robotic tools and small incisions to open spine surgery. In the U.S., Neurospinal surgeons go through many years of education and extensive training to learn how to safely and accurately perform these special techniques.",
      slope: true,
      intoImgData: "/images/providers/67129589_neuro.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/N-Ngu.jpg",
      title: "ORTHOPEDIC SPINE SURGEON",
      mdcontent:
        "Bonaventure Ngu, MD is a board-certified and fellowship-trained orthopedic surgeon who's passionate about alleviating patient's back and neck pain, restoring mobility, and educating on how best to preserve and optimize spinal health.",
      mdname: "BONAVENTURE NGU, MD"
    },

    id: "bonaventure-ngu-md",
    name: "Bonaventure Ngu, MD",
    image: "/images/providers/67129589_neuro.jpg",
    phone: "281-719-9505",
    gender: "Male",
    language: "English",
    specialty: "Orthopedic Surgery, Spine Surgery",

    degrees: ["Doctor of Medicine"],

    clinics: [
      {
        name: "Premier Spine Institute",
        address: "411 Lantern Bend Dr, Suite 100A, Houston, TX 77090",
        phone: "(281) 719-9505"
      }
    ],

    bio_name: "About Dr. Bonaventure Ngu",
    bio: `Dr. Ngu has spent many years in The Woodlands and Humble communities of Texas, where he helped to address neck and back pain stemming from degenerative conditions, deformities, and traumatic injuries.</br></br>
Originally from Cameroon, West Africa, Dr. Ngu earned his Doctor of Medicine degree from the University of Maryland School of Medicine in Baltimore. He honed his expertise during his residency in orthopedic surgery at the University of Maryland Medical Center's Shock Trauma Center, where he developed a profound understanding of spinal issues and a fervor for aiding individuals with spinal disorders. Furthering his specialization, Dr. Ngu pursued a fellowship in spine surgery at the renowned Leatherman Spine Institute in Louisville, Kentucky.</br></br>
Dedicated to employing minimally invasive approaches whenever feasible, Dr. Ngu prioritizes techniques that offer optimal results while minimizing harm to healthy tissues. Proudly affiliated with the LESSociety, advocating for less exposure surgery, Dr. Ngu utilizes LES techniques to mitigate blood loss, radiation exposure, and surgical duration.</br></br>
A respected member of the medical community, Dr. Ngu is affiliated with prestigious organizations such as the American Academy of Orthopedic Surgeons, the North American Spine Society, and the Texas Orthopedic Association. He has been recognized as one of America's top orthopedic surgeons by the Consumers' Research Council of America in 2012 and as one of Houston's Top Doctors by H Texas Magazine in 2014.</br></br>
Outside of his practice, Dr. Ngu finds joy in his role as a proud father to four lovely daughters.`,

    education: [
      "Doctor of Medicine degree from the University of Maryland School of Medicine",
      "Bachelors Degree from Howard University",
      "Residency (Orthopedic Surgery) at the University of Maryland Medical Center's Shock Trauma Center",
      "Fellowship (Orthopedic Surgery) at the Letterman Spine Institute- Kentucky"
    ],

    areasOfExpertise: `<ul>
      <li>Back Pain</li>
      <li>Disc Decompression Surgery</li>
      <li>Fusions</li>
      <li>Herniated Disc</li>
      <li>Laminectomy</li>
    </ul>
    <ul>
      <li>Neck Pain</li>
      <li>Sciatica</li>
      <li>Scoliosis</li>
      <li>Spine Surgery</li>
      <li>Spondylolisthesis</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/shutterstock_1804240711.jpg",
      title: "NEURO-SPINAL SURGERY",
      contentTop: "Neurosurgeons are physicians who specialize in the diagnosis and surgical treatment of disorders of the central and peripheral nervous system including congenital anomalies, trauma, tumors, vascular disorders, infections of the brain or spine, stroke, or degenerative diseases of the spine. The education and training to become a neurosurgeon is rigorous and extensive.",
      slope: true
    }
  },
    {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "NEURO-SPINAL SURGERY",
      mdName: "Mathew T. Alexander, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },

    cardioThoracicDetailData: {
      title: "NEURO-SPINAL SURGERY",
      contentTop: "Neurospinal surgery is the surgical specialization that treats diseases and disorders of the brain and spinal cord. Back pain can sometimes produce neurological symptoms and highly trained surgeons assist in alleviating that pain via surgery. These procedures could range from minimally invasive using robotic tools and small incisions to open spine surgery. In the U.S., Neurospinal surgeons go through many years of education and extensive training to learn how to safely and accurately perform these special techniques.",
      slope: true,
      intoImgData: "/images/providers/67129589_neuro.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/N-Alexander.png",
      title: "NEUROSURGEON",
      mdcontent:
        "Mathew T. Alexander, MD is a board-certified Neurosurgeon with 11 years of experience. He has practiced at Texas Brain and Spine in Corpus Christi, Texas since 2004.",
      mdname: "MATHEW T. ALEXANDER, MD"
    },

    id: "mathew-t-alexander-md",
    name: "Mathew T. Alexander, MD",
    image: "/images/providers/67129589_neuro.jpg",
    phone: "361-883-4323",
    gender: "Male",
    language: "English",
    specialty: "Neurological Surgery, Spine Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "South Texas Brain and Spine Center",
        address: "1227 3rd St, Corpus Christi, TX 78404",
        phone: "(361) 883-4323"
      }
    ],

    bio_name: "About Dr. Mathew T. Alexander",
    bio: `Dr. Alexander grew up in Louisville, Kentucky and completed a six-year accelerated medical program. He attended Rensselaer Polytechnic Institute for his undergraduate studies and graduated from Albany Medical College in New York in 1995. He then completed his neurosurgery residency at the Medical College of Wisconsin in Milwaukee.</br></br>
Since 2004, Dr. Alexander has practiced at Texas Brain and Spine in Corpus Christi, Texas. He is board-certified by the American Board of Neurological Surgery.`,

    education: [
      "Medical Degree from Albany Medical College",
      "Undergraduate Degree from Rensselaer Polytechnic Institute",
      "Residency (Neurosurgery) at Medical College of Wisconsin"
    ],

    areasOfExpertise: `<ul>
      <li>Hydrocephalus</li>
      <li>Myelopathy</li>
      <li>Scoliosis</li>
      <li>Spinal Stenosis</li>
      <li>Spondylolisthesis</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=p5LisSWt9zk",
      title: "NEURO-SPINAL SURGERY",
      contentTop: "Neurosurgeons are physicians who specialize in the diagnosis and surgical treatment of disorders of the central and peripheral nervous system including congenital anomalies, trauma, tumors, vascular disorders, infections of the brain or spine, stroke, or degenerative diseases of the spine. The education and training to become a neurosurgeon is rigorous and extensive.",
      slope: true
    }
  },


  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "NEURO-SPINAL SURGERY",
      mdName: "Joshua H. Lee, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title: "NEURO-SPINAL SURGERY",
      contentTop: "Neurosurgeons specialize in treating diseases affecting the brain, spinal cord, and peripheral nerves. They perform both surgical and non-surgical treatments for conditions such as herniated discs, spinal stenosis, brain tumors, and traumatic injuries.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/N-Lee.jpg",
      title: "ORTHOPEDIC SPINE SURGEON",
      mdcontent: "Joshua H. Lee, MD is a fellowship-trained orthopedic spine surgeon whose expertise and patient-first philosophy define excellence in spinal care.    S...",
      mdname: "JOSHUA H. LEE, MD"
    },
    id: "joshua-h-lee-md",
    name: "Joshua H. Lee, MD",
    image: "/images/doctors/joshua-h-lee-md.jpg",
    phone: "281-955-7577",
    gender: "Male",
    language: "English",
    specialty: "Orthopedic Surgery, Spine Surgery",
    degrees: ["Medical Degree"],
    clinics: [{
        name: "Advanced Orthopaedics Sports Medicine",
        address: "601 Rockmead Drive, Suite 100, Kingwood, TX 77339",
        phone: "(281) 955-7577"
      }, {
        name: "Advanced Orthopaedics & Sports Medicine",
        address: "11520 Northpointe Blvd., Tomball, TX 77377",
        phone: "(281) 955-7577"
      }, {
        name: "Doctor’s Pavilion at North Cypress Medical Center",
        address: "10425 Huffmeister Road, Suite 320, Houston, TX 77065",
        phone: "(281) 955-7577"
      }],
    bio_name: "About Dr. Joshua H. Lee",
    bio: `Dr. Lee is a fellowship-trained Orthopedic Spine Surgeon specializing in the care of the cervical, thoracic, and lumbar spine.    After graduating summa cum laude from Baylor University, Dr. Lee completed his medical degree at McGovern Medical School at the University of Texas at Houston. He went on to complete his residency in Orthopedic Surgery at Baylor Scott & White Hospital and fellowship training in Orthopedic Spine Surgery at the Icahn School of Medicine at Mount Sinai in New York City under Samuel Cho, MD, and Saad Chaudhary, MD.    Dr. Lee provides both nonoperative and operative treatment for degenerative conditions such as arthritis, scoliosis, trauma, disc herniations, and spinal stenosis. He has a special interest in minimally invasive techniques, motion-preserving procedures including disc replacement and laminoplasty, and advanced technologies such as navigation-assisted and robotic spine surgery.    Dr. Lee takes a patient-centered approach, recommending nonsurgical treatments whenever possible and tailoring care plans to each patient’s goals. His career is distinguished by his dedication to advancing spine surgery and his compassionate commitment to improving the quality of life for patients with spinal conditions. He is married to his wife, Janice, and together they have a son, Weston. Dr. Lee looks forward to serving the patients of the greater Houston area with the same compassion and dedication he brings to his family.`,
    education: ["Medical Degree from McGovern Medical School at The University of Texas Health Science Center at Houston", "Residency (Orthopaedic Surgery) at Scott And White Memorial Hospital", "Fellowship (Orthopedic Spine Surgery) at Mount Sinai School of Medicine"],
    areasOfExpertise: `<ul>
<li>Cervical, Thoracic, and Lumbar Spine conditions</li>
<li>Disc Replacement and Laminoplasty</li>
<li>Laminectomy</li>
<li>Lumbar Spinal Fusion</li>
<li>Lumbosacral Stenosis</li>
</ul>
<ul>
<li>Minimally Invasive Spine Surgery</li>
<li>Robotic Spine Surgery</li>
<li>Scoliosis</li>
<li>Spinal Cord Decompression</li>
<li>Spinal Stenosis</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/shutterstock_1804240711.jpg",
      title: "NEURO-SPINAL SURGERY",
      contentTop: "Neurosurgeons specialize in treating diseases affecting the brain, spinal cord, and peripheral nerves. They perform both surgical and non-surgical treatments for conditions such as herniated discs, spinal stenosis, brain tumors, and traumatic injuries.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "NEURO-SPINAL SURGERY",
      mdName: "John M. Borkowski, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title: "NEURO-SPINAL SURGERY",
      contentTop: "Neurosurgeons specialize in treating diseases affecting the brain, spinal cord, and peripheral nerves. They perform both surgical and non-surgical treatments for conditions such as herniated discs, spinal stenosis, brain tumors, and traumatic injuries.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/N-Borkowski.jpg",
      title: "ADULT RECONSTRUCTIVE SPINE SURGEON",
      mdcontent: "John M. Borkowski, MD is an orthopaedic surgeon based in Corpus Christi, TX, with a subspecialty in orthopedic spine surgery.    He committed to excel...",
      mdname: "JOHN M. BORKOWSKI, MD"
    },
    id: "john-m-borkowski-md",
    name: "John M. Borkowski, MD",
    image: "/images/doctors/john-m-borkowski-md.jpg",
    phone: "361-854-0811",
    gender: "Male",
    language: "English",
    specialty: "Orthopedic Surgery, Orthopedic Spine Surgery, Minimally Invasive Surgery & Innovative Technology",
    degrees: ["Medical Degree"],
    clinics: [{
        name: "South Texas Bone and Joint",
        address: "601 Texan Trail, Suite 300, Corpus Christi, TX 78411",
        phone: "(361) 854-0811"
      }, {
        name: "South Texas Bone and Joint",
        address: "5917 Crosstown Expy, Corpus Christi, TX 78417",
        phone: "(361) 854-0811"
      }],
    bio_name: "About Dr. John M. Borkowski",
    bio: `Dr. Borkowski is a Board Certified Orthopedic Surgeon and was Fellowship Trained in Spine Surgery at the University of Washington, Seattle, WA. He completed Orthopedic Residency at McGill University, Montreal. Dr. Borkowski acquired his M.D. at the University of Calgary, his B.S. in Nutritional Science at the University of Manitoba, and his M.Sc. in Medical Science at the University of Calgary. Dr. Borkowski specializes in Adult Reconstructive Spine Surgery and Minimally Invasive Surgery.    Dr. Borkowski has been an orthopedic surgeon at South Texas Bone and Joint since 2001. He is the Current Director Of the Spine Excellence Program Spohn South and is actively involved in the Texas Medical Association and Nueces County Medical Society.`,
    education: ["Medical Degree from University of Calgary", "Bacehlor of Science (Nutritional Science) from University of Manitoba", "Masters in Medical Science (GI Research) from University of Calgary", "Resdiency (Orthopaedic Surgery) at McGill University", "Fellowship (Spine) at University of Washington"],
    areasOfExpertise: `<ul>
<li>Degenerative Disc Disease</li>
<li>Disc Replacement</li>
<li>Herniated Discs</li>
<li>Minimally Invasive Surgery</li>
<li>Neck Pain & Low Back Pain</li>
</ul>
<ul>
<li>Osteoporosis</li>
<li>Sacroiliac Joint Syndrome</li>
<li>Scoliosis</li>
<li>Spinal Stenosis</li>
<li>Vertebral Compression Fractures</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/shutterstock_1804240711.jpg",
      title: "NEURO-SPINAL SURGERY",
      contentTop: "Neurosurgeons specialize in treating diseases affecting the brain, spinal cord, and peripheral nerves. They perform both surgical and non-surgical treatments for conditions such as herniated discs, spinal stenosis, brain tumors, and traumatic injuries.",
      slope: true
    }
  },

  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "NEURO-SPINAL SURGERY",
      mdName: "Desmond A. Brown, MD, PhD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title:"NEURO-SPINAL SURGERY",
      contentTop:"Neurospinal surgery is the surgical specialization that treats diseases and disorders of the brain and spinal cord. Back pain can sometimes produce neurological symptoms and highly trained surgeons assist in alleviating that pain via surgery. These procedures could range from minimally invasive using robotic tools and small incisions to open spine surgery. In the U.S., Neurospinal surgeons go through many years of education and extensive training to learn how to safely and accurately perform these special techniques.",
      slope: true,
      intoImgData: "/images/providers/67129589_neuro.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/N-Brown.jpg",
      title: "NEURO-SPINAL SURGERY",
      mdcontent: `Desmond A. Brown, MD is a neurosurgeon specializing in neurosurgical oncology based in the Cypress area of Houston, Texas. A board-eligible neurosurgeon, Dr. Brown completed his residency and fellowship training in neurosurgical oncology at the world-renowned Mayo Clinic. He has passion for advancing patient care and is actively involved in clinical research, co-authoring 104 peer reviewed articles.`,
      mdname: "DESMOND A. BROWN, MD, PHD"
    },
    id: "desmond-a-brown-md-phd",
    name: "Desmond A. Brown, MD, PhD",
    image: "/images/physianDirectory/N-Brown.jpg",
    phone: "346-623-3170",
    gender: "Male",
    language: "English",
    specialty: "Spine Surgery, Neurological Surgery",
    degrees: ["Medical Degree"],
    clinics: [
      {
            "name": "HCA Houston Brain & Spine- North Cypress",
            "address": "21216 Northwest Freeway, Suite 250, Cypress, TX 77429",
            "phone": "(281) 894-5310"
      },
      {
            "name": "HCA Houston Brain & Spine- West",
            "address": "12606 W Houston Center Blvd, Suite 350, Houston, TX 77082",
            "phone": "(281) 894-5310"
      }
],
    bio_name: "About Dr. Desmond A. Brown",
    bio: `Originally from Jamaica, Dr. Brown moved to the United States after high school. He earned a Bachelor of Science in chemistry with and biochemistry with honors from Temple University. He later went on to obtain a Master of Science in biochemistry with concentration in membrane biophysics from Temple University before completing a combined MD/PhD program in molecular biology and neuroscience at Rutgers Robert Wood Johnson Medical School and Princeton University in 2014. During this time, he was awarded an NIH F30 grant and a predoctoral research fellowship from the New Jersey Commission on Cancer Research. Dr. Brown completed his neurosurgery residency at the Mayo Clinic, where he served as the chief resident and instructor of neurosurgery. He pursued fellowships in neurosurgical oncology, including an international fellowship in Montpellier, France. His clinical expertise focuses on complex resections of intra-axial brain lesions, utilizing advanced techniques such as awake resections, intraoperative speech and motor mapping, and 5-ALA fluorescence-guided resections. Previously, Dr. Brown served as an assistant clinical investigator and head of the neurosurgical oncology unit at the National Institute of Neurological Disorders and Stroke (NINDS) at the NIH. His research interests include glioma cellular and molecular biology, and he has received notable accolades for his contributions including being named a Fellow of the Congress of Neurological Surgeons. Dr. Brown is dedicated to advancing academic neurosurgery through ongoing research and innovation. While Dr. Brown specializes in treating brain and spine tumors he also treats a wide variety of neurosurgical conditions including spinal disorders, hydrocephalus, facial spasms and other neurosurgical disorders. His philosophy is guided by a patient-centered approach, earning him high patient satisfaction ratings and recognition as a patients' top choice provider.`,
    education: [
      "Medical School from Rutgers-Robert Wood Johnson Medical School",
      "Master of Science (Biochemistry- membrane biophysics) from Temple University",
      "Bachelor of Science (Chemistry & Biochemistry) from Temple University",
      "Residency (Neurosurgery) at the Mayo Clinic",
      "Fellowship (Neurosurgical Oncology) at Mayo Clinic"
],
    areasOfExpertise: `<ul>
  <li>Cerebrovascular Disorders</li>
  <li>Congenital Neurologic Disorders</li>
  <li>Cranial Nerve Disorders</li>
  <li>Craniofacial Disorders</li>
  <li>Musculoskeletal and Joint Disorders</li>
  <li>Neurologic Cancers</li>
  <li>Neurologic Conditions</li>
  <li>Orthopaedic Procedures</li>
  <li>Spine Deformities</li>
  <li>Traumatic Brain and Spine Injuries</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      link: "https://youtu.be/zWyxYm1aUzc?si=gOZAcmp9nBFNfxRD",
      introImg: "/images/MDDetails/shutterstock_1804240711.jpg",
      title: "NEURO-SPINAL SURGERY",
      contentTop:"Neurosurgeons are physicians who specializes in the diagnosis and surgical treatment of disorders of the central and peripheral nervous system including congenital anomalies, trauma, tumors, vascular disorders, infections of the brain or spine, stroke, or degenerative diseases of the spine. The education and training to become a neurosurgeon is rigorous and extensive. They use minimally invasive surgery to treat brain, nervous system and spinal nerve disorders.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "NEURO-SPINAL SURGERY",
      mdName: "Yan Michael Li, MD, PhD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title:"NEURO-SPINAL SURGERY",
      contentTop:"Neurospinal surgery is the surgical specialization that treats diseases and disorders of the brain and spinal cord. Back pain can sometimes produce neurological symptoms and highly trained surgeons assist in alleviating that pain via surgery. These procedures could range from minimally invasive using robotic tools and small incisions to open spine surgery. In the U.S., Neurospinal surgeons go through many years of education and extensive training to learn how to safely and accurately perform these special techniques.",
      slope: true,
      intoImgData: "/images/providers/67129589_neuro.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/N-YanLi.webp",
      title: "NEURO-SPINAL SURGERY",
      mdcontent: `Yan Michael Li, MD, PhD, is a board-certified and fellowship-trained neurosurgeon.`,
      mdname: "YAN MICHAEL LI, MD, PHD"
    },
    id: "yan-michael-li-md-phd",
    name: "Yan Michael Li, MD, PhD",
    image: "/images/physianDirectory/N-YanLi.webp",
    phone: "713-396-2969",
    gender: "Male",
    language: "English, Chinese",
    specialty: "Brain & Spinal Tumor, Neurosurgical Spine Surgery, Neurotrauma",
    degrees: ["Medical Degree"],
    clinics: [
      {
            "name": "Minimally Invasive Brain and Spine Institute",
            "address": "7601 W Sam Houston Pkwy S, Suite 300, Houston, TX 77072",
            "phone": "(713) 396-2969"
      }
],
    bio_name: "About Dr. Yan Michael Li",
    bio: `Dr. Li received his medical degree from Peking Union Medical College in Beijing, China. He then obtained his Doctor of Philosophy (PhD) from the University of Texas MD Anderson Cancer Center in Houston, Texas. He completed a neurosurgical residency and enfolded complex spine fellowship at the State University of New York. Dr. Li completed fellowships at Dana-Farber/Boston Children's Cancer and Blood Disorders Center and Brigham and Women's Hospital in Boston, Massachusetts. He also completed a neurosurgical oncology fellowship at the University of Texas MD Anderson Cancer Center in Houston, Texas, focusing on complex brain and spine tumor surgery. Dr. Li is an award-winning fellowship-trained spine and tumor neurosurgeon specializing in treating complex spine diseases and brain and spine tumors. He has a strong clinical interest in simple and complex spine surgery, minimally invasive spinal surgery, and computer-assisted spinal navigation and robotic surgery. Dr. Li provides the latest and most efficient treatment options for each patient with back pain, including minimally invasive herniated disk surgery through less than the one-inch incision, minimally invasive lateral or posterior spinal fusion surgery, and artificial disc implants that allow for more mobility. He has a reputation as an expert in complex spinal surgery, with more than 50 percent of his referrals originating from other surgeons who relied on him for revision surgeries or complex spine cases outside their expertise. Dr. Li's practice emphasizes an interdisciplinary approach to disease processes to achieve the best patient outcomes. He works closely with other specialists, such as pain specialists, neurologists, and physical therapists. Dr. Li has substantial experience in neuro-oncology and various spine conditions, with extensive expertise in the research field, with about 70 papers published.`,
    education: [
      "Medical Degree from Peking Union Medical College",
      "PhD (Cancer Biology and Gene Therapy) from University of Texas MD Anderson Cancer Center",
      "Residency (Neurological Surgery) at SUNY Health Sciences Center- Syracuse",
      "Post-Doctoral Fellowship at Dana-Farber Cancer Institute, Harvard Medical School",
      "Fellowship (Neurosurgical Spine Surgery) at University of Texas MD Anderson Cancer Center"
],
    areasOfExpertise: `<ul>
  <li>Craniotomy</li>
  <li>Herniated Discs</li>
  <li>Lower Back Pain</li>
  <li>Neck Pain</li>
  <li>Nerve Root Injury and Plexus Disorders</li>
  <li>Neurologic Conditions</li>
  <li>Spinal Fusion</li>
  <li>Spinal Stenosis</li>
  <li>Traumatic Brain and Spine Injuries</li>
  <li>Thoracic Spine Disorders</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      link: "https://youtu.be/Y_yNwXMt28M?si=JAU_XlqfZnEeIUkd",
      introImg: "/images/MDDetails/shutterstock_1804240711.jpg",
      title: "NEURO-SPINAL SURGERY",
      contentTop:"Neurosurgeons are physicians who specializes in the diagnosis and surgical treatment of disorders of the central and peripheral nervous system including congenital anomalies, trauma, tumors, vascular disorders, infections of the brain or spine, stroke, or degenerative diseases of the spine. The education and training to become a neurosurgeon is rigorous and extensive. They use minimally invasive surgery to treat brain, nervous system and spinal nerve disorders.",
      slope: true
    }
  }
];

export const physicianCardioData = [
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "CARDIO-THORACIC SURGERY",
      mdName: "Malcolm H. Bremer, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
  
    cardioThoracicDetailData: {
      title:"CARDIO-THORACIC SURGERY",
      contentTop:"Cardiothoracic surgery in the United States is combined with general thoracic surgery where the focus is on the heart, lungs, and esophagus. Our surgeons, with the help of our physicians and surgical assistants, perform a variety of surgeries that can be anywhere from minimally invasive to open heart transplants.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg",
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/N-Borkowski.jpg",
      title: "CARDIO-THORACIC SURGERY",
      mdcontent:
        "Malcolm H. Bremer, MD, is a Thoracic Surgeon and Vascular Surgeon in Humble, Texas. He graduated from Drexel University College of Medicine/Hahnemann University School of Medicine in 1987.",
      mdname: "MALCOLM H. BREMER, MD"
    },
  
    id: "malcolm-h-bremer",
    name: "Malcolm H. Bremer, MD",
    image: "/images/doctors/malcolm-bremer.jpg",
    phone: "(281) 446-6464",
    gender: "Male",
    language: "English",
    specialty: "Cardiovascular Disease, Thoracic Surgery, General Surgery, Vascular Surgery",
  
    degrees: [
      "Medical Degree from Drexel University College of Medicine"
    ],
  
    clinics: [
      {
        name: "Memorial Hermann Heart And Vascular Institute Southwest",
        address: "7737 Southwest Fwy, Houston, TX 77074",
        phone: "(713) 456-5000"
      },
      {
        name: "Memorial Hermann Northeast Hospital",
        address: "18951 N Memorial Dr, Ste 566, Humble, TX 77338",
        phone: "(281) 446-6464"
      },
      {
        name: "HCA Houston Kingwood",
        address: "22999 US Highway 59 N, Kingwood, TX 77339",
        phone: "(281) 348-8000"
      }
    ],
  
    bio_name: "About Dr. Malcolm H. Bremer",
    bio: `<p>
        Dr. Bremer is a thoracic surgeon and is affiliated with multiple hospitals in the Humble, Texas area.
        He received his medical degree from Drexel University College of Medicine/Hahnemann University and
        has been in practice for more than 20 years.
      </p>`,
  
    education: [
      "Ross University, Doctorate of Medicine Graduate Degree 2011",
      "North Eastern Ohio Medical University, General Surgery Residency 2018",
      "Wright State University, Surgical Critical Care Fellowship 2019",
      "Wayne State University, Vascular Surgery Fellowship 2021",
      "North Carolina State University, BA in Chemistry Undergraduate Degree 2006"
    ],
  
    areasOfExpertise: `<ul>
        <li>Active Wound Care Management</li>
        <li>Acute Pulmonary Embolism</li>
        <li>Aortic and Peripheral Arterial Embolism or Thrombosis</li>
        <li>Arteriovenous Malformations</li>
        <li>Atherosclerosis</li>
        <li>Compression therapy</li>
        <li>Embolization Procedures</li>
        <li>Endovascular Abdominal Aortic Aneurysm Stent Graft Implant</li>
        <li>Endovenous Ablation (Varicose Vein Treatment)</li>
        <li>Endovascular Laser Ablation</li>
        <li>Hemodialysis Access/Shunt Procedures</li>
        <li>Intra-Arterial Angioplasty/Stent</li>
        <li>Limb Preservation</li>
        <li>Other Specified Diseases Of Veins And Lymphatics</li>
      </ul>
      <ul>
        <li>Percutaneous Transluminal Carotid Artery Stent Placement</li>
        <li>Peripheral Vascular Disorders</li>
        <li>Phlebectomy/Vein Stripping</li>
        <li>Pulmonary Embolism</li>
        <li>Sclerotherapy</li>
        <li>Seizures</li>
        <li>Stereotactic Radiosurgery (SRS)</li>
        <li>Thoracic Outlet Syndrome</li>
        <li>Thrombectomy</li>
        <li>Vasculitis (Medical)</li>
        <li>Vascular Ultrasound Study</li>
        <li>Vasculitis</li>
        <li>Venous Catheterization</li>
      </ul>`,
  
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/22086509_xxl.jpg",
      title:"CARDIO-THORACIC SURGERY",
      contentTop:"Cardiac and thoracic surgeons specialize in treating diseases affecting the chest, lungs, esophagus and heart. Although these surgeons have the same general training and are certified by the same board, they treat different patients. Cardiac surgeons treat heart problems, including heart disease, heart transplants and heart failure. Thoracic surgeons treat issues of the lungs, such as lung cancer or emphysema.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "CARDIO-THORACIC SURGERY",
      mdName: "Steven B. Eisenberg, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
  
    cardioThoracicDetailData: {
      title:"CARDIO-THORACIC SURGERY",
      contentTop:"Cardiothoracic surgery in the United States is combined with general thoracic surgery where the focus is on the heart, lungs, and esophagus. Our surgeons, with the help of our physicians and surgical assistants, perform a variety of surgeries that can be anywhere from minimally invasive to open heart transplants.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_14.png",
      title: "CARDIO-THORACIC SURGERY",
      mdcontent:
        "Steven B. Eisenberg, MD, is a cardiothoracic surgeon and is affiliated with multiple hospitals in the Houston, Texas area. He received his medical degree from McGovern Medical School at UTHealth and has been in practice for more than 20 years.",
      mdname: "STEVEN B. EISENBERG, MD"
    },
  
    id: "steven-b-eisenberg",
    name: "Steven B. Eisenberg, MD",
    image: "/images/doctors/steven-b-eisenberg.jpg",
    phone: "(713) 486-5100",
    gender: "Male",
    language: "English",
    specialty:
      "Cardiothoracic and Vascular Surgery, Cardiovascular Surgery, Heart and Vascular Services, Thoracic Surgery, Vascular Surgery",
  
    degrees: [
      "Medical Degree from McGovern Medical School at UTHealth"
    ],
  
    clinics: [
      {
        name: "UT Physicians Cardiothoracic & Vascular Surgery – Texas Medical Center",
        address: "6400 Fannin St, Ste 2850, Houston, TX 77030",
        phone: "(713) 486-5100"
      }
    ],
  
    bio_name: "About Dr. Steven B. Eisenberg",
    bio: `
    Dr. Eisenberg earned his medical degree at McGovern Medical School at The University of Texas Health Science Center at Houston (UTHealth). He completed his residency at Washington University School of Medicine and Barnes-Jewish Hospital in St. Louis and a fellowship at Baylor College of Medicine in Houston.</br>In practice since 1982, Dr. Eisenberg is board certified in thoracic surgery and his primary clinical interest is lung cancer. He specializes in cardiothoracic and vascular surgery, which includes coronary artery bypass surgery, heart transplant, lung transplant and lung cancer surgery. He treats patients of all ages.</br>Dr. Eisenberg is a member of the American College of Surgeons, Society of Thoracic Surgeons,American College of Chest Physicians, Texas Medical Association and Harris County Medical Society. He was named by 2020 graduating seniors at McGovern Medical School as the outstanding clinical faculty member, and he also earned a 2020 Excellence in Teaching Award at McGovern.
      `,
  
    education: [
      "Medical School & Residency \nWashington University/B-JH/SLCH Consortium Residency, Surgery (1982–1989)",
      "Texas Heart Institute/Baylor College of Medicine \nFellowship, Thoracic Surgery (Independent, 1990–1992)",
      "McGovern Medical School at UTHealth \nMedical School"
    ],
  
    areasOfExpertise: `<ul>
        <li>Pleural Effusion</li>
        <li>Pericardial Disease</li>
        <li>Collapsed Lung (Pneumothorax)</li>
        <li>Coronary Artery Bypass with Robotic Assist</li>
      </ul>
      <ul>
        <li>Chest CT (Incl. Heart and Lungs)</li>
        <li>Coronary Artery Disease (CAD)</li>
        <li>Maze Procedure</li>
        <li>Hypertensive Heart with Failure</li>
      </ul>`,
  
      generalSurgeryDetaillinkData: {
        introImg: "/images/MDDetails/22086509_xxl.jpg",
        title:"CARDIO-THORACIC SURGERY",
        contentTop:"Cardiac and thoracic surgeons specialize in treating diseases affecting the chest, lungs, esophagus and heart. Although these surgeons have the same general training and are certified by the same board, they treat different patients. Cardiac surgeons treat heart problems, including heart disease, heart transplants and heart failure. Thoracic surgeons treat issues of the lungs, such as lung cancer or emphysema.",
        slope: true
      }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "CARDIO-THORACIC SURGERY",
      mdName: "Dan Loberman, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title:"CARDIO-THORACIC SURGERY",
      contentTop:"Cardiothoracic surgery in the United States is combined with general thoracic surgery where the focus is on the heart, lungs, and esophagus. Our surgeons, with the help of our physicians and surgical assistants, perform a variety of surgeries that can be anywhere from minimally invasive to open heart transplants.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_15.png",
      title: "CARDIO-THORACIC SURGERY",
      mdcontent:
        "Dan Loberman, MD, is a cardiothoracic surgeon certified by the Israeli Board of Cardiothoracic Surgery. He has been in practice for more than 20 years and resides in Houston, Texas.",
      mdname: "DAN LOBERMAN, MD"
    },
    id: "dan-loberman",
    name: "Dan Loberman, MD",
    image: "/images/doctors/dan-loberman.jpg",
    phone: "(281) 973-2738",
    gender: "Male",
    language: "English",
    specialty: "Cardiac Surgery, Thoracic Surgery",
    degrees: [
      "Medical Degree – Technion, Israel Institute of Technology"
    ],
    clinics: [
      {
        name: "Houston Heart – Northwest",
        address: "800 Peakwood Dr, Ste 201, Houston, TX 77090",
        phone: "(281) 973-2738"
      }
    ],
    bio_name: "About Dr. Dan Loberman",
    bio: `<p>
    Dr. Loberman received his medical degree from the Technion- Israel Institute of Technology, Israel in 2002. In 2010, he was certified in cardiothoracic surgery after completing the Tel Aviv Medical Center cardiothoracic surgery residency, during which he received the Ami Cohen Young Investigator in Cardiac Surgery award, and the Hanoch Mildwidsky Outstanding Cardiac Surgery Resident award. Dr. Loberman then went on to complete both a congenital cardiac surgery fellowship at Boston Children’s Hospital, Harvard Medical School, in 2012, and the advanced adult cardiac surgery program (which included a transcatheter intervention fellowship) at Brigham and Women’s Hospital, Harvard Medical School, in 2013. Dr. Loberman served as an attending cardiac surgeon at Brigham and Women’s Hospital, Harvard Medical School from 2013-2022.</br>Since 2013, as part of the Brigham and Women’s cardiac surgery division, he successfully established a minimally invasive mitral valve program and an atrial fibrillation hybrid procedure program at Cape Cod Hospital. He was appointed Director of minimally invasive valve surgery at Cape Cod Hospital in 2016, and later on, Chief of cardiac surgery at Cape Cod Hospital in 2019. Dr. Loberman authored numerous peer reviewed publications, as well as book chapters about mitral valve repair and replacement.Dr. Loberman is experienced in all aspects of adult cardiac surgery, including coronary artery bypass, valve replacement and repair, aneurism repair, re-operative surgery. He has specific interest in mitral valve repair, and the surgical hybrid procedure for treatment of atrial fibrillation.
      </p>`,
    education: [
      "Brigham and Women’s Hospital Fellowship 2013",
      "Boston Children’s Hospital Fellowship 2012",
      "Tel Aviv Medical Center Residency 2010",
      "Technion – Israel Institute of Technology Medical School 2002"
    ],
    areasOfExpertise: `<ul>
    <li>Abdominal Aortic Aneurysm (AAA) Screening</li>
    <li>Abdominal Aortic Aneurysm Repair</li>
    <li>Acute Myocardial Infarction</li>
    <li>Acute Rheumatic Heart Disease</li>
    <li>Adult Congenital Heart Disease</li>
    <li>Angina Pectoris</li>
    <li>Anomalous Left Coronary Artery</li>
    <li>Aortic Aneurysm Repair</li>
    <li>Aortic, Peripheral, and Visceral Artery Aneurysms</li>
    <li>Atherosclerosis</li>
    <li>Balloon Angioplasty</li>
    <li>CABG</li>
    <li>Cardiac Transplant / VAD</li>
    <li>Cardiac and Circulatory Congenital Anomalies</li>
    <li>Cardiac Arrhythmia & Conduction Disorders</li>
    <li>Cardiac CT Angiography</li>
    <li>Cardiac Catheterization</li>
    <li>Cardiac Stress Test</li>
    <li>Cardioversion</li>
    <li>Connective Tissue Disorders</li>
    <li>Diagnostic Cardiac Catheterization</li>
    <li>Electrocardiogram</li>
    <li>Endovascular Abdominal Aortic Aneurysm Stent Graft Implant</li>
  </ul>
  <ul>
    <li>Heart Failure</li>
    <li>Hypertension</li>
    <li>Intracardiac Echocardiography</li>
    <li>Minimally Invasive Surgery</li>
    <li>Myocarditis and Cardiomyopathy</li>
    <li>Other - Telemedicine</li>
    <li>Other and Ill-Defined Heart Disease</li>
    <li>Other Electrophysiology Procedure</li>
    <li>Other Endovascular Cardiac Valve Procedures</li>
    <li>Percutaneous Transluminal Balloon Valvuloplasty (Aortic Valve)</li>
    <li>Percutaneous Transluminal Balloon Valvuloplasty (Mitral Valve)</li>
    <li>Percutaneous Transluminal Coronary Artery Angioplasty</li>
    <li>Percutaneous Transluminal Coronary Artery Atherectomy</li>
    <li>Pericardial Procedures</li>
    <li>Pericarditis (Inflammation of the Heart Membrane)</li>
    <li>Pericarditis and Pericardial Disease</li>
    <li>Peripheral Vascular Disorders</li>
    <li>Pulmonary Embolism</li>
    <li>Pulmonary Hypertension</li>
    <li>Transesophageal Echocardiography</li>
  </ul>`,
    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=gSqOuWREGsY",
      title:"CARDIO-THORACIC SURGERY",
      contentTop:"Cardiac and thoracic surgeons specialize in treating diseases affecting the chest, lungs, esophagus and heart. Although these surgeons have the same general training and are certified by the same board, they treat different patients. Cardiac surgeons treat heart problems, including heart disease, heart transplants and heart failure. Thoracic surgeons treat issues of the lungs, such as lung cancer or emphysema.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "CARDIO-THORACIC SURGERY",
      mdName: "Rema Malik, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
  
    cardioThoracicDetailData: {
      title:"CARDIO-THORACIC SURGERY",
      contentTop:"Cardiothoracic surgery in the United States is combined with general thoracic surgery where the focus is on the heart, lungs, and esophagus. Our surgeons, with the help of our physicians and surgical assistants, perform a variety of surgeries that can be anywhere from minimally invasive to open heart transplants.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_13.png",
      title: "CARDIO-THORACIC SURGERY",
      mdcontent:
        "Dr. Rema Malik, MD is board certified in Critical Care Surgery and graduated from Ross University. She completed her residency in General Surgery. She's worked on trauma clients relating to Embolisms, Venous Embolism and Thrombosis and Venous Embolism and Thrombosis than other positions in the area.",
      mdname: "REMA MALIK, MD"
    },
  
    id: "rema-malik-md",
    name: "Rema Malik, MD",
    image: "/images/doctors/rema-malik.jpg",
    phone: "(713) 701-1410",
    gender: "Female",
    language: "English, Urdu",
  
    specialty:
      "Vascular Surgery, Surgical Critical Care, General Surgery",
  
    degrees: [
      "Bachelor of Arts in Chemistry",
      "Doctorate in Medicine"
    ],
  
    clinics: [
      {
        name: "Gulf Coast Vascular – West Houston",
        address: "12606 West Houston Center Blvd, Suite 301, Houston, TX 77082"
      },
      {
        name: "Gulf Coast Vascular – Tomball",
        address: "13635 Michel Rd, Tomball, TX 77375"
      },
      {
        name: "Gulf Coast Vascular – Sugarland",
        address: "6921 Brisbane Ct Ste 220, Sugar Land, TX 77479"
      }
    ],
  
    bio_name: "About Dr. Rema Malik",
    bio: `
    Dr. Rema Malik is a board-certified vascular surgeon with advanced fellowship training in endovascular techniques. Her passion for restoring circulation and preventing limb loss led her to specialize in the treatment of complex arterial and venous conditions, including peripheral artery disease (PAD), venous insufficiency, aneurysms, and dialysis access. Dr. Malik has served in both academic and private clinical settings, where she is known for delivering precise, minimally invasive care with deep compassion. With a strong focus on patient education, empowerment, and outcomes, she is committed to helping every individual regain mobility and improve their quality of life through expert vascular care.</br>
    Rema Malik, M.D. is a Vascular Surgeon with Gulf Coast Vascular. Dr. Malik received her BA in Chemistry from North Carolina State University. She then went on to gain her Doctorate in Medicine from Ross University. Dr. Malik completed her General Surgery residency at North Eastern Ohio Medical University followed by a Surgical Critical Care fellowship with Wright State University. She completed her Vascular Surgery training at Wayne State University.</br>
    Dr. Malik is triple board certified in General Surgery, Surgical Critical Care, and Vascular Surgery by the American Board of Surgery. She is a member of the Society of Vascular Surgeons. Dr. Malik has been a part of several publications, posters, and presentations throughout her career. She has been an instructor for the Fundamentals of Critical Care, is registered physician in vascular interpretation, as well as certified in advanced surgical skills for exposures in trauma.</br>
    She has clinical interests in vascular and endovascular surgery, thoracic outlet syndrome, abdominal and thoracoabdominal aneurysm disease, carotid, brachiocephalic and upper extremity arterial disease, aortic reconstruction of aortoiliac disease, peripheral and mesenteric occlusion/aneurysmal disease, hemodialysis access, and venous disease.
    `,
  
    education: [
      "Ross University, Doctorate of Medicine Graduate Degree 2011",
      "North Eastern Ohio Medical University, General Surgery Residency 2016",
      "Wright State University, Surgical Critical Care Fellowship 2019",
      "Wayne State University, Vascular Surgery Fellowship 2021",
      "North Carolina State University, BA in Chemistry Undergraduate Degree 2006"
    ],
  
    areasOfExpertise: `
      <ul>
        <li>Acute Wound Care Management</li>
        <li>Acute Pulmonary Embolism</li>
        <li>Aortic And Peripheral Arterial Embolism Or Thrombosis</li>
        <li>Atherosclerosis Malformations & Angiogenesis</li>
        <li>Compression therapy</li>
        <li>Endoluminal Procedures</li>
        <li>Endovascular Abdominal Aortic Aneurysm Stent Graft Implant</li>
        <li>Endovenous Ablation (Varicose Vein Treatment)</li>
        <li>Endovenous Laser Ablation</li>
        <li>Hemodialysis Access/Shunt Procedures</li>
        <li>Interventional Angioplasty/Stent</li>
        <li>Limb Preservation</li>
        <li>Other Specified Diseases Of Veins And Lymphatics</li>
      </ul>
  
      <ul>
        <li>Percutaneous Transluminal Carotid Artery Stent Placement</li>
        <li>Peripheral Vascular Disorders</li>
        <li>Phlebectomy/Vein Stripping</li>
        <li>Pulmonary Embolism</li>
        <li>Sclerotherapy</li>
        <li>Seizures</li>
        <li>Stereotactic Radiosurgery (SRS)</li>
        <li>Thoracic Outlet Syndrome</li>
        <li>Thromboendarterectomy</li>
        <li>Vascular (Medical)</li>
        <li>Vascular Ultrasound Study</li>
        <li>Vasculitis</li>
        <li>Venous Catheterization</li>
      </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=1RLVmbL9ZC4",
      title:"CARDIO-THORACIC SURGERY",
      contentTop:"Cardiac and thoracic surgeons specialize in treating diseases affecting the chest, lungs, esophagus and heart. Although these surgeons have the same general training and are certified by the same board, they treat different patients. Cardiac surgeons treat heart problems, including heart disease, heart transplants and heart failure. Thoracic surgeons treat issues of the lungs, such as lung cancer or emphysema.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "CARDIO-THORACIC SURGERY",
      mdName: "Robert L. McKowen, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
  
    cardioThoracicDetailData: {
      title:"CARDIO-THORACIC SURGERY",
      contentTop:"Cardiothoracic surgery in the United States is combined with general thoracic surgery where the focus is on the heart, lungs, and esophagus. Our surgeons, with the help of our physicians and surgical assistants, perform a variety of surgeries that can be anywhere from minimally invasive to open heart transplants.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_16.png",
      title: "CARDIO-THORACIC SURGERY",
      mdcontent:
        "Robert L. McKowen, MD is a cardiothoracic surgeon in Houston, TX and has over 45 years of experience in the medical field. He graduated from Medical College Of Virginia in 1978.",
      mdname: "ROBERT L. MCKOWEN, MD"
    },
  
    id: "robert-l-mckowen-md",
    name: "Robert L. McKowen, MD",
    image: "/images/doctors/robert-l-mckowen.jpg",
    phone: "(281) 496-1700",
    gender: "Male",
    language: "English, Spanish",
  
    specialty:
      "Vascular Surgery, Cardiac Surgery, Thoracic Surgery, Cardiovascular Disease",
  
    degrees: [
      "Medical Degree — Medical College of Virginia, 1978"
    ],
  
    clinics: [
      {
        name: "West Houston Cardiovascular Associates",
        address: "12121 Richmond Ave Ste 328, Houston, TX 77082",
        phone: "(281) 496-1700"
      }
    ],
  
    bio_name: "About Dr. Robert L. McKowen",
    bio: `
      Dr. McKowen is a thoracic surgeon in Houston, Texas. He received his medical degree from Virginia Commonwealth University School of Medicine and completed a residency in Thoracic and Cardiovascular Surgery at Allegheny General Hospital.  
  
      He has been in practice for more than 20 years and has expertise in treating heart bypass surgery, heart valve replacement, lung surgery, aneurysms, and cardiothoracic disorders.  
    `,
  
    education: [
      "Medical College of Virginia – Graduate Degree 1978",
      "Thoracic and Cardiovascular Surgery Denver Children’s Hospital – Fellowship 1986",
      "Thoracic and Cardiovascular Surgery Allegheny General Hospital – Residency 1985"
    ],
  
    areasOfExpertise: `
      <ul>
        <li>Aortic, Peripheral, and Visceral Artery Aneurysms</li>
        <li>CABG</li>
        <li>Cardiac Congenital & Valvular Disorders</li>
        <li>Cardiovascular Surgery</li>
        <li>Carotid Artery Disease</li>
        <li>Chronic Obstructive Pulmonary Disease</li>
        <li>Endovascular Abdominal Aortic Aneurysm Stent Graft Implant</li>
        <li>Hernia</li>
        <li>Lung disease</li>
        <li>Medical Cardiology</li>
      </ul>
  
      <ul>
        <li>Neuralplasty – Cranial Nerve Transposition</li>
        <li>Other Endovascular Cardiac Valve Procedures</li>
        <li>Peripheral Vascular Disorders</li>
        <li>Post-Thrombotic Syndrome And Venous Insufficiency/Hypertension</li>
        <li>Respiratory Cancers</li>
        <li>Respiratory Congenital Malformations</li>
        <li>Thyroid/Parathyroid/Thymus/Tracheal Procedures</li>
        <li>Tracheostomy</li>
        <li>Varicose Veins Of Lower Extremity</li>
        <li>Venous Catheterization</li>
        <li>Venous Thrombectomy</li>
      </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/22086509_xxl.jpg",
      title:"CARDIO-THORACIC SURGERY",
      contentTop:"Cardiac and thoracic surgeons specialize in treating diseases affecting the chest, lungs, esophagus and heart. Although these surgeons have the same general training and are certified by the same board, they treat different patients. Cardiac surgeons treat heart problems, including heart disease, heart transplants and heart failure. Thoracic surgeons treat issues of the lungs, such as lung cancer or emphysema.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "CARDIO-THORACIC SURGERY",
      mdName: "Scott E. Olsson, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
  
    cardioThoracicDetailData: {
      title:"CARDIO-THORACIC SURGERY",
      contentTop:"Cardiothoracic surgery in the United States is combined with general thoracic surgery where the focus is on the heart, lungs, and esophagus. Our surgeons, with the help of our physicians and surgical assistants, perform a variety of surgeries that can be anywhere from minimally invasive to open heart transplants.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_17.png",
      title: "CARDIO-THORACIC SURGERY",
      mdcontent:
        "Dr. Scott E. Olsson, MD received his medical degree from State University of New York Downstate Medical Center College of Medicine and has been in practice for more than 20 years. He frequently treats conditions like Collapsed Lung (Pneumothorax) and Pleural Effusion along with other conditions at varying frequencies.",
      mdname: "SCOTT E. OLSSON, MD"
    },
  
    id: "scott-e-olsson-md",
    name: "Scott E. Olsson, MD",
    image: "/images/doctors/scott-e-olsson.jpg",
    phone: "(832) 522-8600",
    gender: "Male",
    language: "English, Spanish",
  
    specialty:
      "Cardiac Surgery, Thoracic Surgery, Vascular Surgery, Cardiovascular Surgery",
  
    degrees: [
      "Medical Degree, SUNY Health Science Center at Brooklyn College of Medicine",
      "Post-Doctoral – MedL, Columbia University"
    ],
  
    clinics: [
      {
        name: "Houston Methodist West Hospital – Cardiovascular Surgery Associates",
        address: "18400 Katy Fwy, Ste 640, Houston, TX 77094",
        phone: "(832) 522-8600"
      },
      {
        name: "Houston Methodist Willowbrook Hospital – Cardiovascular Surgery Associates",
        address: "13300 Hargrave Rd, Ste 340, Houston, TX 77070",
        phone: "(281) 737-2180"
      }
    ],
  
    bio_name: "About Dr. Scott E. Olsson",
    bio: `
      Dr. Olsson, MD is a highly respected cardiothoracic surgeon and the founder of LoneStar Elite Cardiothoracic PLLC in Houston, Texas.  
  
      Renowned for his expertise in advanced robotic-assisted surgery, Dr. Olsson is committed to redefining patient care through precision, innovation, and compassion. </br>Recognized by peers and patients alike, Dr. Olsson is regarded as one of the leading specialists in minimally invasive cardiothoracic procedures.  
  
      His proficiency in cutting-edge robotic technologies allows him to perform complex surgeries with greater accuracy, smaller incisions, and faster recovery times, helping patients return to their lives with improved outcomes and fewer complications.  
  
      </br>Dr. Olsson's approach combines state-of-the-art surgical techniques with personalized treatment plans tailored to each patient’s unique needs. With a steadfast dedication to advancing the field, he continues to set a new standard for excellence in cardiothoracic surgery across the Houston area and beyond.
    `,
  
    education: [
      "BOARD CERTIFICATION – Thoracic and Cardiovascular Surgery | American Board of Thoracic Surgery | 2002: Surgery | American Board of Surgery",
      "RESIDENCY – Thoracic & Cardiovascular Surgery | Alvin Oneal Methodist Foundation (General Surgery) | North Shore University Hospital",
      "MEDICAL SCHOOL – SUNY Health Science Center at Brooklyn College of Medicine | 1993",
      "AFFILIATED HOSPITALS – Houston Methodist Hospital",
      "CENTER MEMBERSHIP – Houston Methodist DeBakey Heart & Vascular Center | Houston Methodist Dr. Mary and Ron Neal Cancer Center"
    ],
  
    areasOfExpertise: `
      <ul>
        <li>Angioplasty Surgery</li>
        <li>Cardiovascular Disease</li>
        <li>Coronary Disease</li>
        <li>Diseases of the Diaphragm</li>
        <li>Esophageal Cancer</li>
        <li>Oncological Cancer</li>
        <li>Lung Cancer</li>
      </ul>
  
      <ul>
        <li>Mediastinal Tumors</li>
        <li>Minimally Invasive Cardiovascular Techniques</li>
        <li>Peripheral Vascular Disease</li>
        <li>Robotic Thoracic Surgery</li>
        <li>Thoracic and Vascular Endoscopy</li>
      </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      link: "https://player.vimeo.com/video/392076059",
      title:"CARDIO-THORACIC SURGERY",
      contentTop:"Cardiac and thoracic surgeons specialize in treating diseases affecting the chest, lungs, esophagus and heart. Although these surgeons have the same general training and are certified by the same board, they treat different patients. Cardiac surgeons treat heart problems, including heart disease, heart transplants and heart failure. Thoracic surgeons treat issues of the lungs, such as lung cancer or emphysema.",
      slope: true
    }
  },
    {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "CARDIO-THORACIC SURGERY",
      mdName: "Cristian S. Sarateanu, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
 
    cardioThoracicDetailData: {
      title: "CARDIO-THORACIC SURGERY",
      contentTop: "Cardiothoracic surgery in the United States is combined with general thoracic surgery where the focus is on the heart, lungs, and esophagus. Our surgeons, with the help of our physicians and surgical assistants, perform a variety of surgeries that can be anywhere from minimally invasive to open heart transplants.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },
 
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/CT-Sarateanu.jpg",
      title: "THORACIC SURGEON",
      mdcontent:
        "Cristian S. Sarateanu, MD, is a board-certified cardiothoracic and vascular surgeon with expertise in minimally invasive thoracic surgery.",
      mdname: "CRISTIAN S. SARATEANU, MD"
    },
 
    id: "cristian-s-sarateanu-md",
    name: "Cristian S. Sarateanu, MD",
    image: "/images/providers/37006109_cardio.jpg",
    phone: "713-864-2710",
    gender: "Male",
    language: "English, Romanian, French, Spanish",
    specialty: "Cardiothoracic Surgery, Cardiovascular Surgery",
 
    degrees: ["Medical Degree"],
 
    clinics: [
      {
        name: "Center for Advanced Cardiology in Greater Heights",
        address: "1631 North Loop West, Suite 250, Houston, TX 77008",
        phone: "(713) 864-2710"
      }
    ],
 
    bio_name: "About Dr. Cristian S. Sarateanu",
    bio: `Dr. Sarateanu completed his surgical training at George Washington University Medical Center and the cardiothoracic surgery training at Texas Heart Institute/Baylor College of Medicine. He has also completed cardiac surgery training in Paris, France.</br></br>
Board certified in Surgery and Cardiothoracic surgery and elected Fellow of the American College of Surgeons, Dr. Sarateanu has clinical interests that include cardiac surgery for coronary artery disease, valvular disease and atrial fibrillation, also thoracic surgery with a focus on lung disorders and vascular surgery for arterial pathology. He is skilled in minimally invasive thoracic surgery.</br></br>
An assistant professor of cardiothoracic and vascular surgery at McGovern Medical School at UTHealth in Houston, Dr. Sarateanu participated in basic science research projects including the autologous skeletal myoblasts transplant in myocardial infarction scar and angiogenesis for peripheral arterial disease and myocardial ischemia. He published in leading journals including the Journal of Thoracic and Cardiovascular Surgery.</br></br>
Dr. Sarateanu is from Romania and enjoys travelling, biking and photography in his free time.`,
 
    education: [
      "Medical Degree from Carol Davila University of Medicine And Pharmacy",
      "Internship at Tufts- New England Medical Center",
      "Residency at Institute for Cardiovascular Diseases C.C. Iliescu",
      "Residency at University Hospitals Pitie Salpetriere",
      "Residency at George Washington University Medical Center",
      "Residency at Baylor College of Medicine- Texas Heart Institute"
    ],
 
    areasOfExpertise: `<ul>
      <li>Advanced Heart Failure and Transplantation</li>
      <li>Arterial Pathology</li>
      <li>Atrial Fibrillation</li>
      <li>Cardiac Surgery</li>
      <li>Coronary Artery Disease</li>
    </ul>
    <ul>
      <li>Heart Bypass Surgery</li>
      <li>Lung Disorders</li>
      <li>Thoracic Surgery</li>
      <li>Valvular Heart Disease</li>
      <li>Vascular Surgery</li>
    </ul>`,
 
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/22086509_xxl.jpg",
      title: "CARDIO-THORACIC SURGERY",
      contentTop: "Cardiac and thoracic surgeons specialize in treating diseases affecting the chest, lungs, esophagus and heart. Although these surgeons have the same general training and are certified by the same board, they treat different patients. Cardiac surgeons treat heart problems, including heart disease, heart transplants and heart failure. Thoracic surgeons treat issues of the lungs, such as lung cancer or emphysema.",
      slope: true
    }
  },
    {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "CARDIO-THORACIC SURGERY",
      mdName: "Eve Grace Cieutat, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },

    cardioThoracicDetailData: {
      title: "CARDIO-THORACIC SURGERY",
      contentTop: "Cardiothoracic surgery in the United States is combined with general thoracic surgery where the focus is on the heart, lungs, and esophagus. Our surgeons, with the help of our physicians and surgical assistants, perform a variety of surgeries that can be anywhere from minimally invasive to open heart transplants.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/CT-Cieutat.jpg",
      title: "THORACIC SURGEON",
      mdcontent:
        "Dr. Eve G. Cieutat is a thoracic surgeon in Corpus Christi, Texas and is affiliated with multiple hospitals in the area. She received her medical degree from Tulane University School of Medicine and has been in practice for more than 20 years.",
      mdname: "EVE GRACE CIEUTAT, MD"
    },

    id: "eve-grace-cieutat-md",
    name: "Eve Grace Cieutat, MD",
    image: "/images/providers/37006109_cardio.jpg",
    phone: "361-761-1000",
    gender: "Female",
    language: "English",
    specialty: "Thoracic Surgery, Cardiovascular Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Corpus Christi Medical Center Bay Area",
        address: "7101 S Padre Island Dr, Corpus Christi, TX 78412",
        phone: "(361) 761-1000"
      }
    ],

    bio_name: "About Dr. Eve Grace Cieutat",
    bio: `Dr. Cieutat, MD, is a respected physician specializing in Thoracic Surgery (Cardiothoracic Vascular Surgery), dedicated to providing exceptional care to patients. With her extensive medical training and compassionate approach, Dr. Cieutat offers personalized healthcare solutions tailored to each patient's unique needs.</br></br>
Her commitment to patient well-being extends beyond traditional medical practice, as she prioritizes building trusting relationships and fostering open communication.</br></br>
Patients can expect comprehensive and supportive care from Dr. Cieutat, who is deeply invested in staying abreast of the latest advancements in the field. Dr. Cieutat welcomes individuals of all ages and backgrounds to her practice, where they can receive the highest standard of medical attention in a warm and welcoming environment.`,

    education: [
      "Medical Degree from Tulane University School Of Medicine, New Orleans",
      "Residency (Surgery) at University of Texas Southwestern Medical Center",
      "Fellowship (Thoracic Surgery) at University of Texas Southwestern Medical Center"
    ],

    areasOfExpertise: `<ul>
      <li>Abscess or Cyst Drainage or Aspiration</li>
      <li>Aneurysm</li>
      <li>Decortication and Pleurectomy</li>
      <li>Esophagectomy</li>
      <li>Esophagogastric Fundoplasty</li>
      <li>Excision of Tracheal Tumor or Stenosis</li>
    </ul>
    <ul>
      <li>Lung Cancer</li>
      <li>Non-Coronary Angioplasty, Atherectomy, and Stenting</li>
      <li>Open Diaphragmatic or Paraesophageal Hiatal Hernia Repair</li>
      <li>Open Lobectomy</li>
      <li>Port Placements or Replacements</li>
      <li>Valve Repair or Replacement (Aortic, Mitral, Tricuspid, and Pulmonary)</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/22086509_xxl.jpg",
      title: "CARDIO-THORACIC SURGERY",
      contentTop: "Cardiac and thoracic surgeons specialize in treating diseases affecting the chest, lungs, esophagus and heart. Although these surgeons have the same general training and are certified by the same board, they treat different patients. Cardiac surgeons treat heart problems, including heart disease, heart transplants and heart failure. Thoracic surgeons treat issues of the lungs, such as lung cancer or emphysema.",
      slope: true
    }
  },
    {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "CARDIO-THORACIC SURGERY",
      mdName: "Hannan Chaugle, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },

    cardioThoracicDetailData: {
      title: "CARDIO-THORACIC SURGERY",
      contentTop: "Cardiothoracic surgery in the United States is combined with general thoracic surgery where the focus is on the heart, lungs, and esophagus. Our surgeons, with the help of our physicians and surgical assistants, perform a variety of surgeries that can be anywhere from minimally invasive to open heart transplants.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/CT-Chaugle.jpg",
      title: "CARDIOTHORACIC SURGEON",
      mdcontent:
        "Hannan Chaugle, MD, is a board certified Cardiothoracic and Vascular Surgeon in Webster, Texas. In practice for more than 20 years, he has expertise in treating heart bypass surgery and other conditions relating to the heart.",
      mdname: "HANNAN CHAUGLE, MD"
    },

    id: "hannan-chaugle-md",
    name: "Hannan Chaugle, MD",
    image: "/images/providers/37006109_cardio.jpg",
    phone: "281-332-4596",
    gender: "Male",
    language: "English",
    specialty: "Cardiac Surgery, Thoracic Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Houston Heart - Clear Lake",
        address: "450 W Medical Center Blvd Suite 600, Webster, TX 77598",
        phone: "(281) 332-4596"
      }
    ],

    bio_name: "About Dr. Hannan Chaugle",
    bio: `Dr. Chaugle received his medical degree from the University of Bombay, India. He obtained his Master Chirugiae in Cardiothoracic Surgery from the University of Bombay in 1993, and studied at the Royal College of Surgeons of Glasgow, United Kingdom. He then went on to complete his internship and residency at Grant Medical College in Bombay, India.</br></br>
Dr. Chaugle continued his training in the United States completing his Cardiothoracic Surgery fellowship at St. Vincent Hospital in Portland, OR. Dr. Chaugle went to Oregon Health & Science University where he completed his General Surgery residency and Cardiothoracic surgery fellowship. Lastly, Dr. Chaugle completed his Endovascular surgery fellowship at the Arizona Heart Hospital in Phoenix, AZ.</br></br>
Dr. Chaugle is board certified with the American Board of Surgery and the American Board of Thoracic Surgery. He has authored numerous publications in his field as well as participated in several clinical research projects.`,

    education: [
      "Medical Degree at University of Bombay",
      "Residency (General Surgery) at Oregon Health & Science University",
      "Fellowship (Cardiothoracic Surgery) at St. Vincent Hospital",
      "Fellowship (Cardiothoracic Surgery) at Oregon Health & Science University",
      "Fellowship (Endovascular Surgery) at Arizona Heart Hospital"
    ],

    areasOfExpertise: `<ul>
      <li>Aortic Aneurysm Repair</li>
      <li>Balloon Angioplasty</li>
      <li>Cardiac Congenital & Valvular Disorders</li>
      <li>Endovascular Abdominal Aortic Aneurysm Stent Graft Implant</li>
      <li>Hypertension</li>
    </ul>
    <ul>
      <li>Myocarditis And Cardiomyopathy</li>
      <li>Percutaneous Transluminal Coronary Artery Atherectomy</li>
      <li>Pericarditis And Pericardial Disease</li>
      <li>Pulmonary Embolism</li>
      <li>Transesophageal Echocardiography</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/22086509_xxl.jpg",
      title: "CARDIO-THORACIC SURGERY",
      contentTop: "Cardiac and thoracic surgeons specialize in treating diseases affecting the chest, lungs, esophagus and heart. Although these surgeons have the same general training and are certified by the same board, they treat different patients. Cardiac surgeons treat heart problems, including heart disease, heart transplants and heart failure. Thoracic surgeons treat issues of the lungs, such as lung cancer or emphysema.",
      slope: true
    }
  },
    {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "CARDIO-THORACIC SURGERY",
      mdName: "Manish K. Patel, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },

    cardioThoracicDetailData: {
      title: "CARDIO-THORACIC SURGERY",
      contentTop: "Cardiothoracic surgery in the United States is combined with general thoracic surgery where the focus is on the heart, lungs, and esophagus. Our surgeons, with the help of our physicians and surgical assistants, perform a variety of surgeries that can be anywhere from minimally invasive to open heart transplants.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/CT-Patel.jpg",
      title: "CARDIOTHORACIC AND VASCULAR SURGEON",
      mdcontent:
        "Manish K. Patel, MD is a thoracic surgeon in Houston, Texas and has been in practice for more than 20 years.",
      mdname: "MANISH K. PATEL, MD"
    },

    id: "manish-k-patel-md",
    name: "Manish K. Patel, MD",
    image: "/images/providers/37006109_cardio.jpg",
    phone: "713-704-4300",
    gender: "Male",
    language: "English, Gujarati, Hindi",
    specialty: "Thoracic Surgery, Cardiovascular Surgery, Organ Transplant Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Center for Advanced Heart Failure – Texas Medical Center",
        address: "6400 Fannin St, Ste 2500, Houston, TX 77030",
        phone: "(713) 704-4300"
      }
    ],

    bio_name: "About Dr. Manish K. Patel",
    bio: `Dr. Patel earned his medical degree at Pramukhswami Medical College in Gujarat, India. He completed a residency in thoracic surgery at Wayne State University School of Medicine in Detroit and a fellowship in thoracic transplant and mechanical circulatory support at the Texas Heart Institute-Baylor College of Medicine in Houston.</br></br>
An associate professor of medicine in the Center for Advanced Cardiopulmonary Therapies and Transplantation at McGovern Medical School at The University of Texas Health Science Center at Houston (UTHealth), Dr. Patel has been in practice since 1998 and is board certified in thoracic surgery. He specializes in thoracic surgery, cardiothoracic surgery, vascular surgery, cardiovascular surgery and organ transplant surgery, and his primary clinical interests are cardiovascular and thoracic surgery.`,

    education: [
      "Medical Degree at Pramukhswami Medical College, India",
      "Residency (Thoracic Surgery) at Wayne State University School of Medicine",
      "Residency (Thoracic Surgery) at Texas Heart Institute, Baylor College of Medicine",
      "Fellowship (Thoracic Transplant and Mechanical Circulatory Support) at the Texas Heart Institute"
    ],

    areasOfExpertise: `<ul>
      <li>Aneurysm</li>
      <li>Aortic Stent Grafts</li>
      <li>Deep Vein Thrombosis</li>
      <li>Diabetes Complications</li>
      <li>Endovascular Aneurysm Repair</li>
    </ul>
    <ul>
      <li>Heart Transplant and Mechanical Circulatory Support</li>
      <li>Lung Transplant</li>
      <li>Peripheral Vascular Surgery</li>
      <li>Thoracic Surgery, VATS</li>
      <li>Transcatheter Aortic Valve Implantation</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/22086509_xxl.jpg",
      title: "CARDIO-THORACIC SURGERY",
      contentTop: "Cardiac and thoracic surgeons specialize in treating diseases affecting the chest, lungs, esophagus and heart. Although these surgeons have the same general training and are certified by the same board, they treat different patients. Cardiac surgeons treat heart problems, including heart disease, heart transplants and heart failure. Thoracic surgeons treat issues of the lungs, such as lung cancer or emphysema.",
      slope: true
    }
  },
   {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "CARDIO-THORACIC SURGERY",
      mdName: "Mark Mettauer, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },

    cardioThoracicDetailData: {
      title: "CARDIO-THORACIC SURGERY",
      contentTop: "Cardiothoracic surgery in the United States is combined with general thoracic surgery where the focus is on the heart, lungs, and esophagus. Our surgeons, with the help of our physicians and surgical assistants, perform a variety of surgeries that can be anywhere from minimally invasive to open heart transplants.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/CT-Mettauer.jpg",
      title: "THORACIC SURGEON",
      mdcontent:
        "Mark Mettauer, MD specializes in Cardiothoracic Surgery. He has over 25 years of experience in the medical field and graduated from Texas A & M Health Science Center in 1997.",
      mdname: "MARK METTAUER, MD"
    },

    id: "mark-mettauer-md",
    name: "Mark Mettauer, MD",
    image: "/images/providers/37006109_cardio.jpg",
    phone: "713-798-7717",
    gender: "Male",
    language: "English, Spanish",
    specialty: "Cardiac Surgery, Congenital Cardiac Surgery, General Surgery, Thoracic Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Baylor St. Luke's Medical Group Woodlands North Houston Heart Center",
        address: "521 I-45 S, Suite 1, Huntsville, TX 77340",
        phone: "(281) 444-3278"
      },
      {
        name: "St. Luke's Health - The Woodlands Hospital",
        address: "17350 St Lukes Way Ste 330, Conroe, TX 77384",
        phone: "(713) 798-7717"
      }
    ],

    bio_name: "About Dr. Mark Mettauer",
    bio: `Dr. Mettauer, MD is a Thoracic Surgery Specialist in Conroe, TX. Dr. Mettauer specializes in Thoracic Surgery, has 28 years of experience, and is board certified in Thoracic Cardiovascular Surgery. Dr. Mettauer graduated from Texas A & M Health Science Center and is affiliated with St. Luke's Health - The Woodlands Hospital. Dr. Mettauer completed a residency at Scott And White Memorial Hospital and Texas Heart Institute.`,

    education: [
      "Medical Degree from Texas A&M College of Medicine- Texas Heart Institute",
      "Undergraduate Degree from Texas A&M University",
      "Residency (General Surgery) at Scott & White Memorial Hospital",
      "Residency (Cardiothoracic Surgery) at Texas Heart Institute"
    ],

    areasOfExpertise: `<ul>
      <li>Aortic Aneurysm</li>
      <li>Benign Heart Tumors</li>
      <li>Cardiac Tamponade</li>
      <li>Coronary Artery Disease (CAD)</li>
      <li>Endovascular Repair of Thoracic Aorta</li>
    </ul>
    <ul>
      <li>Heart Attack</li>
      <li>Pulmonary Disease</li>
      <li>Thrombosis</li>
      <li>Valve Repair or Replacement</li>
      <li>Vascular Disease</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=FgOfxDiCHgY",
      title: "CARDIO-THORACIC SURGERY",
      contentTop: "Cardiac and thoracic surgeons specialize in treating diseases affecting the chest, lungs, esophagus and heart. Although these surgeons have the same general training and are certified by the same board, they treat different patients. Cardiac surgeons treat heart problems, including heart disease, heart transplants and heart failure. Thoracic surgeons treat issues of the lungs, such as lung cancer or emphysema.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "CARDIO-THORACIC SURGERY",
      mdName: "Stephen P. Maniscalco, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },

    cardioThoracicDetailData: {
      title: "CARDIO-THORACIC SURGERY",
      contentTop: "Cardiothoracic surgery in the United States is combined with general thoracic surgery where the focus is on the heart, lungs, and esophagus. Our surgeons, with the help of our physicians and surgical assistants, perform a variety of surgeries that can be anywhere from minimally invasive to open heart transplants.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/CT-Maniscalco.jpg",
      title: "CARDIOVASCULAR SURGEON",
      mdcontent:
        "Stephen Maniscalco, MD is a cardiothoracic surgeon in Shenandoah, TX and has over 30 years of experience in the medical field. Dr. Maniscalco has extensive experience in Carotid Artery Disease, Peripheral Vascular Procedures, and Peripheral Vascular Disease.",
      mdname: "STEPHEN P. MANISCALCO, MD"
    },

    id: "stephen-p-maniscalco-md",
    name: "Stephen P. Maniscalco, MD",
    image: "/images/providers/37006109_cardio.jpg",
    phone: "713-486-0460",
    gender: "Male",
    language: "English",
    specialty: "Cardiothoracic and Vascular Surgery, Cardiovascular Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Elite Heart Surgeons",
        address: "920 Medical Plaza Dr, Ste 360, The Woodlands, TX 77380",
        phone: "(713) 486-0460"
      }
    ],

    bio_name: "About Dr. Stephen P. Maniscalco",
    bio: `Dr. Maniscalco attended school at the University of Texas Southwestern Medical School in Dallas, Texas. He has been in practice since 2002 and was part of the Baylor Faculty for surgery before this time. In addition to performing the most advanced and ground-breaking cardiac procedures, he also has vast experience in the more standard cardiac and vascular surgeries.</br></br>
Dr. Maniscalco believes in finding the best solution for the patient during what can be some of the most difficult times in their lives. He takes his time explaining procedures thoroughly and making sure the patient and family members are comfortable before moving forward with surgery. He is always expanding his knowledge with the latest, most cutting-edge treatments available.</br></br>
In addition to his surgical practice, he also teaches at conferences and seminars for physicians, patients, and communities on his progressive surgical techniques.</br></br>
When not performing surgeries, he enjoys spending time on the track with his sports car, doing projects around the house, and working with computers. He and his wife Jill have recently welcomed their first grandchild, Roman, who has become their pride and joy.`,

    education: [
      "Medical Degree from University of Texas Southwestern Medical",
      "Residency (General Surgery) at University of Louisville School of Medicine",
      "Fellowship (Thoracic Surgery) at Baylor College of Medicine"
    ],

    areasOfExpertise: `<ul>
      <li>Aortic Aneurysms Repair</li>
      <li>Aortic Valve Disease</li>
      <li>Carotid Surgery</li>
      <li>Endoscopic Vein Harvest</li>
      <li>Endovascular Abdominal Aortic Aneurysm Repair</li>
    </ul>
    <ul>
      <li>Mechanical Circulatory Assistance</li>
      <li>Mitral Valve Repair</li>
      <li>Off-pump Coronary Artery Bypass Surgery</li>
      <li>Stentless Aortic Valve Surgery</li>
      <li>Thoracic Oncology</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=SRChWLZQaaE",
      title: "CARDIO-THORACIC SURGERY",
      contentTop: "Cardiac and thoracic surgeons specialize in treating diseases affecting the chest, lungs, esophagus and heart. Although these surgeons have the same general training and are certified by the same board, they treat different patients. Cardiac surgeons treat heart problems, including heart disease, heart transplants and heart failure. Thoracic surgeons treat issues of the lungs, such as lung cancer or emphysema.",
      slope: true
    }
  },
      {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "CARDIO-THORACIC SURGERY",
      mdName: "Carlos O. Encarnacion, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },

    cardioThoracicDetailData: {
      title: "CARDIO-THORACIC SURGERY",
      contentTop: "Cardiothoracic surgery in the United States is combined with general thoracic surgery where the focus is on the heart, lungs, and esophagus. Our surgeons, with the help of our physicians and surgical assistants, perform a variety of surgeries that can be anywhere from minimally invasive to open heart transplants.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/CT-Encarnacion.jpg",
      title: "CARDIOTHORACIC SURGEON",
      mdcontent:
        "Carlos O. Encarnacion, MD is a cardiothoracic surgeon in Cypress, Texas. He specializes in minimally invasive and endovascular procedures for heart and chest conditions, including valve, coronary, and thoracic surgery. Dedicated to innovation and patient care, he also serves as a U.S. Army Reserve Captain.",
      mdname: "CARLOS O. ENCARNACION, MD"
    },

    id: "carlos-o-encarnacion-md",
    name: "Carlos O. Encarnacion, MD",
    image: "/images/providers/37006109_cardio.jpg",
    phone: "832-478-2216",
    gender: "Male",
    language: "English, Spanish",
    specialty: "Cardiac Surgery, Thoracic Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Houston Heart - Cypress",
        address: "21216 Northwest Freeway Suite 670, Cypress, TX 77429",
        phone: "(832) 478-2216"
      },
      {
        name: "Houston Heart - Med Center",
        address: "1200 Binz Street Suite 900, Houston, TX 77004",
        phone: "(832) 478-2216"
      }
    ],

    bio_name: "About Dr. Carlos O. Encarnacion",
    bio: `Dr. Encarnacion is from a military family and calls San Antonio home. He attended Baylor University for undergraduate studies and the Texas Tech University Paul L. Foster School of Medicine before leaving Texas for residency. He completed general surgical internship at Harvard Medical School Beth Israel Deaconess Medical Center then continued training in an integrated cardiothoracic surgical residency at the Medical College of Wisconsin followed by the University of Maryland Medical Center.</br></br>
        He has held several leadership positions in training such as a clinical fellow in Surgery, Harvard Medical School, and chief resident in cardiothoracic surgery at University of Maryland Medical Center and holds the rank of Captain in the U.S. Army Reserve Medical Corp.</br></br>
Dr. Encarnacion has 18 publications ranging the scope of cardiothoracic surgery and has presented at national and international conferences. Dr. Encarnacion's interests include endovascular aortic interventions and minimally invasive approaches ranging from anti-arrhythmia, valvular, coronary and thoracic oncology surgery.`,

    education: [
      "Medical Degree from MD Paul L Foster School, Texas Tech University Health Science Center of Medicine",
      "Undergraduate Degree from Baylor University",
      "Internship at Beth Israel Deaconess Medical Center, Harvard Medical School",
      "Residency (Thoracic Surgery) at Medical College of Wisconsin",
      "Residency at University of Maryland"
    ],

    areasOfExpertise: `<ul>
      <li>Acute Myocardial Infarction</li>
      <li>Aortic Aneurysm Repair</li>
      <li>Atherosclerosis</li>
      <li>Balloon Angioplasty</li>
      <li>Collapsed Lung (Pneumothorax)</li>
    </ul>
    <ul>
      <li>Coronary Artery Bypass Grafting (CABG)</li>
      <li>Endovascular Abdominal Aortic Aneurysm Stent Graft</li>
      <li>Percutaneous Transluminal Coronary Artery Angioplasty</li>
      <li>Peripheral Vascular Disorders</li>
      <li>Transesophageal Echocardiography</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=G90TEdBtJyI",
      title: "CARDIO-THORACIC SURGERY",
      contentTop: "Cardiac and thoracic surgeons specialize in treating diseases affecting the chest, lungs, esophagus and heart. Although these surgeons have the same general training and are certified by the same board, they treat different patients. Cardiac surgeons treat heart problems, including heart disease, heart transplants and heart failure. Thoracic surgeons treat issues of the lungs, such as lung cancer or emphysema.",
      slope: true
    }
  },
    {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "CARDIO-THORACIC SURGERY",
      mdName: "Devinder S. Bhatia, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },

    cardioThoracicDetailData: {
      title: "CARDIO-THORACIC SURGERY",
      contentTop: "Cardiothoracic surgery in the United States is combined with general thoracic surgery where the focus is on the heart, lungs, and esophagus. Our surgeons, with the help of our physicians and surgical assistants, perform a variety of surgeries that can be anywhere from minimally invasive to open heart transplants.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/CT-Bhatia.jpg",
      title: "CARDIOTHORACIC SURGEON",
      mdcontent:
        "Devinder S. Bhatia, MD is a renowned Cardiovascular and Thoracic Surgeon and is the founder, CEO, and president of Southeast Texas Cardiovascular P.A., certified by the American Board of thoracic surgery and currently serves as chief of cardiovascular surgery at HCA Houston Healthcare Tomball.",
      mdname: "DEVINDER S. BHATIA, MD"
    },

    id: "devinder-s-bhatia-md",
    name: "Devinder S. Bhatia, MD",
    image: "/images/providers/37006109_cardio.jpg",
    phone: "281-397-7000",
    gender: "Male",
    language: "English, Spanish",
    specialty: "Cardiac Surgery, Congenital Cardiac Surgery, Thoracic Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Southeast TX Cardiovascular",
        address: "8901 FM 1960 Bypass Rd, Ste 303, Humble, TX 77338",
        phone: "(281) 397-7000"
      },
      {
        name: "Dr Bhatia's Office",
        address: "455 School St Ste 12, Tomball, TX 77375",
        phone: "(281) 397-7000"
      }
    ],

    bio_name: "About Dr. Devinder S. Bhatia",
    bio: `Originally from Little Rock, Arkansas, Dr. Bhatia graduated from the University of Arkansas for Medical Sciences in 1991. He has completed studies under Dr. Micheal DeBakey at Baylor College of Medicine, Dr. John Ochsner at Ochsner Clinic and Dr. Francis Robiscek at the Carolinas Heart Institute. His residencies and fellowships include, General Surgery, Vascular Surgery, Cardiac and Thoracic Surgery.</br></br>
He is a Fellow of the American College of Surgeons and a Fellow of the Federation of State Medical Boards. He is a member of the Society of Thoracic Surgeons, Society for Vascular Surgery, and the Harris County Medical Society. He currently serves on the board of directors for the Houston Symphony and is a former board member of the Health Museum.</br></br>
Dr Bhatia is widely published in his field and is often sought out by local and national television news programs to provide medical commentary. He has authored or co-authored over 20 publications. He was a guest speaker on the Dr. Oz show in New York in 2008 and has participated in several local news stations providing education and information in the medical fields.</br></br>
He has served as Chairman of several hospital Surgery Departments, Chairman of the Credentials committees, and Member of the Medical Executive Committees. He established his own practice in Houston in 2000.`,

    education: [
      "Doctor of Medicine from the University of Arkansas for Medical Sciences",
      "Bachelor of Science (Chemistry) from the University of Arkansas",
      "Internship (General Surgery) at University of Arkansas",
      "Residency (General Surgery) at Baylor College of Medicine",
      "Residency (General Surgery) at Ochsner Medical Foundation",
      "Fellowship (Peripheral Vascular Surgery) at Carolinas Medical Center",
      "Fellowship (Cardiothoracic Surgery) at Carolinas Medical Center"
    ],

    areasOfExpertise: `<ul>
      <li>Aneurysms</li>
      <li>Angiograms</li>
      <li>Angioplasty</li>
      <li>Cardiothoracic Surgery</li>
      <li>Cardiovascular Disease</li>
    </ul>
    <ul>
      <li>Cardiovascular Surgery</li>
      <li>Carotid Endarterectomy</li>
      <li>Coronary Artery Disease</li>
      <li>Lung Biopsy/Surgery</li>
      <li>Minor Surgery</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/22086509_xxl.jpg",
      title: "CARDIO-THORACIC SURGERY",
      contentTop: "Cardiac and thoracic surgeons specialize in treating diseases affecting the chest, lungs, esophagus and heart. Although these surgeons have the same general training and are certified by the same board, they treat different patients. Cardiac surgeons treat heart problems, including heart disease, heart transplants and heart failure. Thoracic surgeons treat issues of the lungs, such as lung cancer or emphysema.",
      slope: true
    }
  },
    {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "CARDIO-THORACIC SURGERY",
      mdName: "Eyal E. Porat, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },

    cardioThoracicDetailData: {
      title: "CARDIO-THORACIC SURGERY",
      contentTop: "Cardiothoracic surgery in the United States is combined with general thoracic surgery where the focus is on the heart, lungs, and esophagus. Our surgeons, with the help of our physicians and surgical assistants, perform a variety of surgeries that can be anywhere from minimally invasive to open heart transplants.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/CT-Porat.jpg",
      title: "THORACIC SURGEON",
      mdcontent:
        "Eyal E. Porat, MD specializes in Cardiovascular Medicine and practices in Houston, TX. He is trained and experienced in a wide variety of health conditions and clinical disorders associated with Cardiovascular Medicine providing the highest standard of patient care.",
      mdname: "EYAL E. PORAT, MD"
    },

    id: "eyal-e-porat-md",
    name: "Eyal E. Porat, MD",
    image: "/images/providers/37006109_cardio.jpg",
    phone: "713-522-0220",
    gender: "Male",
    language: "English, Hebrew",
    specialty: "Cardiac Surgery, Thoracic Surgery, Aortic Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Houston Heart - Med Center",
        address: "1200 Binz Street Suite 900, Houston, TX 77004",
        phone: "(713) 522-0220"
      }
    ],

    bio_name: "About Dr. Eyal E. Porat",
    bio: `Dr. Porat serves as the Director of Cardiothoracic Surgery at HCA Houston Healthcare Medical Center and Houston Heart. Prior to attaining this position, he served as a professor with the Department of Cardiothoracic and Vascular Surgery with the University of Texas Health Science Center at Houston, the McGovern Medical School.</br></br>
Dr. Porat specializes in complex and high-risk cardiac surgery as well as complex aortic surgery. His clinical and research interests include coronary artery bypass grafting, valvular heart disease, aortic aneurysms and dissections, adult congenital cardiac anomalies and circulatory support.</br></br>
Dr. Porat is active in scientific, research and professional communications. He is a member of leading professional societies including the American Association for Thoracic Surgery (AATS), the Society of Thoracic Surgery (STS), the European Association for Cardio-Thoracic Surgery (EACTS), the Southern Thoracic Surgical Association (STSA), the International Society for Minimally Invasive Cardiothoracic Surgery (ISMICS), the Israeli Heart Society, and the Cardio-Thoracic Surgery network (CTSNET).</br></br>
He has published over 80 articles and book chapters in peer-reviewed medical journals and textbooks, and was named one of Houston's Top Doctors by Houstonia Magazine.`,

    education: [
      "Medical Degree from Ben Gurion University of the Negev",
      "Internship at Sheba Medical Center",
      "Residency (Cardiothoracic Surgery) at Carmel Medical Center",
      "Fellowship (Advanced Aortic Surgery) UT Houston Health Science Center"
    ],

    areasOfExpertise: `<ul>
      <li>Aortic Aneurysm Repair</li>
      <li>Coronary Artery Bypass Grafting (CABG)</li>
      <li>Cardiac And Circulatory Congenital Anomalies</li>
      <li>Cardiac Arrhythmia & Conduction Disorders</li>
      <li>Cardiac Congenital & Valvular Disorders</li>
    </ul>
    <ul>
      <li>Endovascular Abdominal Aortic Aneurysm Stent Graft</li>
      <li>Myocarditis And Cardiomyopathy</li>
      <li>Percutaneous Transluminal Balloon Valvuloplasty</li>
      <li>Pericarditis And Pericardial Disease</li>
      <li>Pulmonary Embolism</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=_-OY1p6WzZk",
      title: "CARDIO-THORACIC SURGERY",
      contentTop: "Cardiac and thoracic surgeons specialize in treating diseases affecting the chest, lungs, esophagus and heart. Although these surgeons have the same general training and are certified by the same board, they treat different patients. Cardiac surgeons treat heart problems, including heart disease, heart transplants and heart failure. Thoracic surgeons treat issues of the lungs, such as lung cancer or emphysema.",
      slope: true
    }
  },
    {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "CARDIO-THORACIC SURGERY",
      mdName: "Ibrahim Yazji, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },

    cardioThoracicDetailData: {
      title: "CARDIO-THORACIC SURGERY",
      contentTop: "Cardiothoracic surgery in the United States is combined with general thoracic surgery where the focus is on the heart, lungs, and esophagus. Our surgeons, with the help of our physicians and surgical assistants, perform a variety of surgeries that can be anywhere from minimally invasive to open heart transplants.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/CT-Yazji.jpg",
      title: "THORACIC SURGEON",
      mdcontent:
        "Ibrahim Yazji, MD, is a board-certified cardiothoracic surgeon with Houston Heart in Kingwood, Texas. He received his medical degree from University of Florida College of Medicine and has been in practice between 11-20 years.",
      mdname: "IBRAHIM YAZJI, MD"
    },

    id: "ibrahim-yazji-md",
    name: "Ibrahim Yazji, MD",
    image: "/images/providers/37006109_cardio.jpg",
    phone: "281-899-0229",
    gender: "Male",
    language: "English, Arabic",
    specialty: "Thoracic Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Quality Surgical Heart & Vascular",
        address: "24044 Highway 59 N, Kingwood, TX 77339",
        phone: "(281) 899-0229"
      }
    ],

    bio_name: "About Dr. Ibrahim Yazji",
    bio: `Dr. Yazji began his medical studies at the University of Florida, and went on to complete his residency at the University of Pittsburgh Medical Center in General Surgery. He completed his Aortic Surgery fellowship at the University of Texas as well as Cardiothoracic Surgery, TAVR, TEVAR, and Post-Doctoral Research at the University of Pittsburgh.</br></br>
Dr Yazji's approach to patient care is centered around the patient's safety and well-being. He considers cardiac surgery as one tool in the overall therapeutic armamentarium, where it is only offered when appropriate and for those who would benefit from it. He highly values the patient-physician partnership and two-way conversation in order to establish trust and create the individualized treatment plan that is best for every patient.</br></br>
Dr Yazji chose to specialize in cardiovascular surgery in order to help the tremendous amount of Americans affected by this disease. In his spare time, he enjoys spending time with his family and attending sports events.`,

    education: [
      "Medical Degree from University of Florida College of Medicine",
      "B.S (Chemistry) from University of North Florida",
      "Residency (Surgery) at University of Pittsburgh Medical Center",
      "Fellowship (Thoracic Surgery) at University of Pittsburgh Medical Center",
      "Fellowship (Aortic Surgery) at University of Texas Health Science Center at Houston"
    ],

    areasOfExpertise: `<ul>
      <li>Acute Coronary Syndrome</li>
      <li>Aortic Aneurysm</li>
      <li>Cardiac Tamponade</li>
      <li>Carotid Artery Surgery</li>
      <li>Coronary Artery Disease</li>
    </ul>
    <ul>
      <li>Coronary Artery Bypass Surgery (CABG)</li>
      <li>Heart Valve Disease</li>
      <li>Parapneumonic Pleural Effusion</li>
      <li>Pericardial Disorder</li>
      <li>Vascular Disease</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/22086509_xxl.jpg",
      title: "CARDIO-THORACIC SURGERY",
      contentTop: "Cardiac and thoracic surgeons specialize in treating diseases affecting the chest, lungs, esophagus and heart. Although these surgeons have the same general training and are certified by the same board, they treat different patients. Cardiac surgeons treat heart problems, including heart disease, heart transplants and heart failure. Thoracic surgeons treat issues of the lungs, such as lung cancer or emphysema.",
      slope: true
    }
  },
    {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "CARDIO-THORACIC SURGERY",
      mdName: "John W. Davis, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },

    cardioThoracicDetailData: {
      title: "CARDIO-THORACIC SURGERY",
      contentTop: "Cardiothoracic surgery in the United States is combined with general thoracic surgery where the focus is on the heart, lungs, and esophagus. Our surgeons, with the help of our physicians and surgical assistants, perform a variety of surgeries that can be anywhere from minimally invasive to open heart transplants.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/CT-Davis.png",
      title: "CARDIOVASCULAR SURGEON",
      mdcontent:
        "John W. Davis, MD is a board certified Cardiothoracic and Vascular Surgeon and has been a diplomate of the American Board of Thoracic Surgery. Dr. Davis currently specializes in complex procedures involving blood vessels of the upper and lower extremity with a particular interest in arterial limb ischemia and limb salvage.",
      mdname: "JOHN W. DAVIS, MD"
    },

    id: "john-w-davis-md",
    name: "John W. Davis, MD",
    image: "/images/providers/37006109_cardio.jpg",
    phone: "936-441-1010",
    gender: "Male",
    language: "English",
    specialty: "Cardiac Surgery, Vascular Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Davis Vein & Vascular Center",
        address: "24040 Hwy 59 North, Kingwood, TX 77339",
        phone: "(936) 441-1010"
      },
      {
        name: "Davis Vein and Vascular Clinic",
        address: "20320 Northwest Fwy Suite 600, Houston, TX 77065",
        phone: "(936) 441-1010"
      },
      {
        name: "Davis Vein and Vascular Clinic",
        address: "21848 Holzwarth Road, Suite 110, Spring, TX 77388",
        phone: "(936) 441-1010"
      },
      {
        name: "Davis Vein and Vascular Clinic",
        address: "690 S Loop 336 W, Suite 150, Conroe, TX 77304",
        phone: "(936) 441-1010"
      }
    ],

    bio_name: "About Dr. John W. Davis",
    bio: `Dr. Davis trained at world-renowned Texas Heart Institute under the tutelage of Dr. Denton Cooley, one of the founding fathers of heart surgery. Since residency Dr. Davis has over 19 years of experience in all surgical disorders of the heart and lungs and has performed thousands of open chest procedures including coronary artery bypass, aortic valve replacement, mitral valve repair and replacement, and complex operations of the aortic root.</br></br>
In addition to his busy practice as a cardiothoracic surgeon he has taken a very keen interest in caring for patients suffering from vascular diseases of the lower extremity including critical limb ischemia (CLI) and chronic venous reflux (CVR). He understands the devastating complications that lower extremity amputations cause and will go beyond what other interventionalists may think possible regarding limb salvage.</br></br>
Over his career, Dr. Davis has developed minimally invasive strategies for limb salvage that can be performed without surgery in a safe and comfortable setting for patients. Dr. Davis has completed over 15,000 of these cases, most very complex and time-consuming. In the last three years he has performed over 1200 of these procedures in his office-based lab (OBL) in Kingwood, Texas.`,

    education: [
      "Medical Degree at McGovern Medical School at UTHealth",
      "Residency (General Surgery) at University of Tennessee College of Medicine",
      "Fellowship (Thoracic Surgery) at Texas Heart Institute"
    ],

    areasOfExpertise: `<ul>
      <li>Angioplasty/Atherectomy/Stenting/Intravascular US (IVUS)</li>
      <li>Arteriogram/CO2 arteriogram (for Chronic Renal Failure)</li>
      <li>Carotid Endarterectomy and TCAR for Carotid Stenosis</li>
      <li>Genicular Artery Embolization (GAE) for Osteoarthritic Knee Pain</li>
      <li>Limb salvage for Critical Limb Ischemia (CLI)</li>
    </ul>
    <ul>
      <li>Open and Endovascular Abdominal Aortic Aneurysm (AAA) repair</li>
      <li>Venous Ablation for Chronic Venous Reflux (CVR)</li>
      <li>Vein ablation/Foam Sclerotherapy/Microphlebectomy</li>
      <li>Venous stenting for Pelvic Pain/May Thurner's Syndrome</li>
      <li>Wound Care/Debridement/Lymphedema pumps/Tissue grafts</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/22086509_xxl.jpg",
      title: "CARDIO-THORACIC SURGERY",
      contentTop: "Cardiac and thoracic surgeons specialize in treating diseases affecting the chest, lungs, esophagus and heart. Although these surgeons have the same general training and are certified by the same board, they treat different patients. Cardiac surgeons treat heart problems, including heart disease, heart transplants and heart failure. Thoracic surgeons treat issues of the lungs, such as lung cancer or emphysema.",
      slope: true
    }
  },
    {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "CARDIO-THORACIC SURGERY",
      mdName: "Khaja Moinuddeen, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },

    cardioThoracicDetailData: {
      title: "CARDIO-THORACIC SURGERY",
      contentTop: "Cardiothoracic surgery in the United States is combined with general thoracic surgery where the focus is on the heart, lungs, and esophagus. Our surgeons, with the help of our physicians and surgical assistants, perform a variety of surgeries that can be anywhere from minimally invasive to open heart transplants.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/CT-Moinudeen.jpg",
      title: "THORACIC SURGEON",
      mdcontent:
        "Khaja Moinuddeen, MD is a board-certified cardiothoracic surgeon in Pasadena, TX and has over 29 years of experience in the medical field.",
      mdname: "KHAJA MOINUDDEEN, MD"
    },

    id: "khaja-moinuddeen-md",
    name: "Khaja Moinuddeen, MD",
    image: "/images/providers/37006109_cardio.jpg",
    phone: "713-942-2536",
    gender: "Male",
    language: "English, Spanish",
    specialty: "Thoracic Surgery, Vascular Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Surgical Specialists of Clear Lake",
        address: "450 Medical Center Blvd, Ste 600, Webster, TX 77598",
        phone: "(281) 332-9610"
      },
      {
        name: "Houston Heart - Southeast",
        address: "3801 Vista Road, Ste 300, Pasadena, TX 77504",
        phone: "(713) 942-2536"
      }
    ],

    bio_name: "About Dr. Khaja Moinuddeen",
    bio: `Dr. Moinuddeen specializes in thoracic surgery and general surgery, bringing 38 years of experience to his practice. He focuses on surgical procedures involving the chest, lungs, and other thoracic organs, providing comprehensive surgical care for patients with complex conditions affecting these vital areas.</br></br>
Dr. Moinuddeen completed his early surgical training from the Post Graduate Institute of Medical Education and Research, Chandigarh and King Edward Memorial Hospital, Mumbai, India. He completed his general surgical residency in Pennsylvania. His residency training in Cardiovascular and Thoracic Surgery and Fellowship training in Heart Transplantation was completed at Yale University Hospital. He gained his expertise in Endovascular Surgery from the Arizona Heart Institute, in Phoenix, Arizona. He has been trained in percutaneous valve surgery in Munich and Leipzig, Germany.</br></br>
Dr. Moinuddeen is a Fellow of the American College of Surgeons and holds memberships in the Society of Thoracic Surgeons, American Heart Association, Yale Surgical Society and the American Medical Association. He has been practicing in the Houston area since the year 2011.</br></br>
In his leisure time, Dr. Moinuddeen enjoys bicycling and reading. He has held an adult leadership role in the Boy Scouts of America for the previous 10 years.`,

    education: [
      "Medical Degree from Karnataka Institute of Medical Sciences Rajiv Gandhi University of Health Sciences",
      "Internship at Yale University",
      "Residency at Guthrie Robert Packer Hospital",
      "Fellowship at Yale-New Haven Hospital",
      "Fellowship at Arizona Heart Institute"
    ],

    areasOfExpertise: `<ul>
      <li>Aortic Aneurysm Repair</li>
      <li>Atherosclerosis</li>
      <li>Carotid Artery Disease</li>
      <li>Coronary Artery Bypass Graft (CABG) Surgery</li>
      <li>Non-Coronary Angioplasty</li>
    </ul>
    <ul>
      <li>Peripheral Artery Catheterization</li>
      <li>Pleural Effusion</li>
      <li>Stenting</li>
      <li>Thoracotomy</li>
      <li>Video-Assisted Thoracoscopic Surgery (VATS)</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/22086509_xxl.jpg",
      title: "CARDIO-THORACIC SURGERY",
      contentTop: "Cardiac and thoracic surgeons specialize in treating diseases affecting the chest, lungs, esophagus and heart. Although these surgeons have the same general training and are certified by the same board, they treat different patients. Cardiac surgeons treat heart problems, including heart disease, heart transplants and heart failure. Thoracic surgeons treat issues of the lungs, such as lung cancer or emphysema.",
      slope: true
    }
  },
    {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "CARDIO-THORACIC SURGERY",
      mdName: "Shuab Omer, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },

    cardioThoracicDetailData: {
      title: "CARDIO-THORACIC SURGERY",
      contentTop: "Cardiothoracic surgery in the United States is combined with general thoracic surgery where the focus is on the heart, lungs, and esophagus. Our surgeons, with the help of our physicians and surgical assistants, perform a variety of surgeries that can be anywhere from minimally invasive to open heart transplants.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/CT-Omer.jpg",
      title: "CARDIAC SURGEON",
      mdcontent:
        "Shuab Omer, MD, is a board-certified cardiothoracic surgeon with Houston Heart. He frequently treats conditions like Heart Attack, Acute Coronary Syndrome, and Aortic Aneurysm along with other conditions at varying frequencies.",
      mdname: "SHUAB OMER, MD"
    },

    id: "shuab-omer-md",
    name: "Shuab Omer, MD",
    image: "/images/providers/37006109_cardio.jpg",
    phone: "936-539-5000",
    gender: "Male",
    language: "English, Hindi, Urdu, Kashmiri",
    specialty: "Cardiac Surgery, Thoracic Surgery",

    degrees: ["Doctorate of Medicine"],

    clinics: [
      {
        name: "Houston Heart - Conroe",
        address: "500 Medical Center Blvd Suite 300, Conroe, TX 77304",
        phone: "(936) 539-5000"
      },
      {
        name: "Houston Heart - Tomball",
        address: "13635 Michel Road, Tomball, TX 77375",
        phone: "(936) 539-5000"
      },
      {
        name: "Houston Heart - Cypress",
        address: "21216 Northwest Freeway, Cypress, TX 77429",
        phone: "(936) 539-5000"
      }
    ],

    bio_name: "About Dr. Shuab Omer",
    bio: `Dr. Omer began his medical education at the University of Kashmir, obtaining his Doctorate of Medicine. He completed his general surgery residency at the University of Toledo, Ohio and rounded out his training with a residency in cardiothoracic surgery from the Texas Heart Institute Baylor College of Medicine.</br></br>
He was assistant professor of cardiothoracic surgery at The University of Toledo, Ohio from 2010 to 2011. Following this he practiced in St. Louis, Missouri from 2011 to 2012. He then moved back to Houston and was faculty at The Baylor College of Medicine/MEDVAMC from 2012 to 2019. Thereafter he was Associate professor at The University of Texas, Center of Advanced Cardiopulmonary Therapies and Transplantation, McGovern Medical school from 2019-2020.</br></br>
Dr. Omer is double board-certified in both cardiothoracic surgery and general surgery. He has extensive experience in field of complex cardiothoracic surgery and has special interest in thoracic aortic surgery especially aortic root and complex aortic arch aneurysm surgery.</br></br>
Dr. Omer has always been an avid mountain climber and adventurer since childhood. When not operating, he spends time with his wife, an interventional nephrologist, and his three children. He also enjoys mountain climbing and painting.`,

    education: [
      "Medical Degree from University of Kashmir, Government Medical College",
      "Residency (General Surgery) at University of Toledo",
      "Residency (Thoracic Surgery) at Texas Heart Institute/ Baylor College of Medicine"
    ],

    areasOfExpertise: `<ul>
      <li>Abdominal Aortic Aneurysm</li>
      <li>Aortic Valve Replacement & Repairs</li>
      <li>Carotid Stenosis Management</li>
      <li>Coronary Artery Bypass Grafting (CABG)</li>
      <li>Mitral Valve Replacement & Repairs</li>
    </ul>
    <ul>
      <li>Pericardial Procedures</li>
      <li>Peripheral Vascular Disease</li>
      <li>Robot VATS</li>
      <li>Thoracic Aortic Aneurysm Repair</li>
      <li>Tricuspid Valve Repair and Replacement</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/22086509_xxl.jpg",
      title: "CARDIO-THORACIC SURGERY",
      contentTop: "Cardiac and thoracic surgeons specialize in treating diseases affecting the chest, lungs, esophagus and heart. Although these surgeons have the same general training and are certified by the same board, they treat different patients. Cardiac surgeons treat heart problems, including heart disease, heart transplants and heart failure. Thoracic surgeons treat issues of the lungs, such as lung cancer or emphysema.",
      slope: true
    }
  },
    {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "CARDIO-THORACIC SURGERY",
      mdName: "Uttam Tripathy, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },

    cardioThoracicDetailData: {
      title: "CARDIO-THORACIC SURGERY",
      contentTop: "Cardiothoracic surgery in the United States is combined with general thoracic surgery where the focus is on the heart, lungs, and esophagus. Our surgeons, with the help of our physicians and surgical assistants, perform a variety of surgeries that can be anywhere from minimally invasive to open heart transplants.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/CT-Tripathy.png",
      title: "CARDIAC SURGEON",
      mdcontent:
        "Uttam Tripathy, MD, is a highly accomplished, board-certified cardiovascular and thoracic surgeon with over 30 years of experience. Dr. Tripathy pioneered several minimally invasive procedures in Fort Bend County and actively contributes to national clinical trials in cardiovascular innovation.",
      mdname: "UTTAM TRIPATHY, MD"
    },

    id: "uttam-tripathy-md",
    name: "Uttam Tripathy, MD",
    image: "/images/providers/37006109_cardio.jpg",
    phone: "281-232-1908",
    gender: "Male",
    language: "English",
    specialty: "Thoracic Surgery, Cardiac Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Uttam Tripathy MD",
        address: "16605 Southwest Fwy, Medical Building 3, Suite 575, Sugar Land, TX 77479",
        phone: "(281) 232-1908"
      }
    ],

    bio_name: "About Dr. Uttam Tripathy",
    bio: `Dr. Tripathy graduated from SCB Medical College in 1986 with top honors, consistently ranking among the top three in his class. Following his undergraduate education, he pursued an MS in General Surgery at PGIMER, Chandigarh, and gained invaluable experience through a two-year registrarship in General and Vascular Surgery at PGI, Chandigarh. He went on to earn his MCh in Cardiovascular and Thoracic Surgery from Bombay University before relocating to the United States.</br></br>
Dr. Tripathy continued his education and training, completing accredited programs at the University of California, San Diego, as well as in Boston and Portland, Oregon Health Sciences. These endeavors led to his board certifications in both General Surgery and Thoracic Surgery.</br></br>
Presently, Dr. Uttam Tripathy serves as an attending Cardiovascular and Thoracic Surgeon at Houston Methodist Hospital and the DeBakey Heart and Vascular Center. He individually performs over 800 cases annually, earning the peer-reviewed accolade of "America's Top Surgeon" for the past ten consecutive years. He has been recognized as the top Cardiothoracic Surgeon in Fort Bend County for the last five years.</br></br>
Dr. Tripathy played a pivotal role in introducing the first minimally invasive coronary artery bypass, innovating the first minimally invasive treatment for pulmonary embolism, and spearheading TransCarotid arterial revascularization (TCAR) in the county. In his academic pursuits, he serves as a national investigator focusing on the minimally invasive treatment of Pulmonary Embolism.`,

    education: [
      "Medical Degree from Sriram Chandra Bhanja Medical College",
      "Graduate Degree from Boston Medical Center",
      "Internship/Residency at Boston Medical Center",
      "Residency (General Surgery) at University of California",
      "Fellowship (Thoracic Surgery) at Oregon Health Sciences University"
    ],

    areasOfExpertise: `<ul>
      <li>Aneurysm Repair</li>
      <li>Aortic Aneurysm</li>
      <li>Cardiovascular Surgery</li>
      <li>Coronary Artery Bypass Surgery (CABG)</li>
      <li>Coronary Artery Disease (CAD)</li>
    </ul>
    <ul>
      <li>Deep Venous Thrombosis (DVT)</li>
      <li>Hyperbaric Medicine</li>
      <li>Lung Biopsy</li>
      <li>Lung Resection</li>
      <li>Pulmonary Embolism</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/22086509_xxl.jpg",
      title: "CARDIO-THORACIC SURGERY",
      contentTop: "Cardiac and thoracic surgeons specialize in treating diseases affecting the chest, lungs, esophagus and heart. Although these surgeons have the same general training and are certified by the same board, they treat different patients. Cardiac surgeons treat heart problems, including heart disease, heart transplants and heart failure. Thoracic surgeons treat issues of the lungs, such as lung cancer or emphysema.",
      slope: true
    }
  },
    {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "CARDIO-THORACIC SURGERY",
      mdName: "Viacheslav Bobovnikov, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },

    cardioThoracicDetailData: {
      title: "CARDIO-THORACIC SURGERY",
      contentTop: "Cardiothoracic surgery in the United States is combined with general thoracic surgery where the focus is on the heart, lungs, and esophagus. Our surgeons, with the help of our physicians and surgical assistants, perform a variety of surgeries that can be anywhere from minimally invasive to open heart transplants.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/CT-Bobovnikov.webp",
      title: "CARDIOTHORACIC SURGEON",
      mdcontent:
        "Viacheslav Bobovnikov, MD is a thoracic surgeon in Houston, Texas and has been in practice for more than 20 years. He has expertise in treating heart bypass surgery, among other cardiovascular conditions. His focus is on providing high-quality, comprehensive health care to his patients.",
      mdname: "VIACHESLAV BOBOVNIKOV, MD"
    },

    id: "viacheslav-bobovnikov-md",
    name: "Viacheslav Bobovnikov, MD",
    image: "/images/providers/37006109_cardio.jpg",
    phone: "713-486-5100",
    gender: "Male",
    language: "English",
    specialty: "Cardiothoracic Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "UT Physicians Cardiothoracic & Vascular Surgery – Texas Medical Center",
        address: "6400 Fannin St, Ste 2850, Houston, TX 77030-1540",
        phone: "(713) 486-5100"
      },
      {
        name: "UT Physicians Cardiothoracic & Vascular Surgery – Northeast",
        address: "18955 N Memorial Dr, Ste 340, Humble, TX 77338-4263",
        phone: "(713) 486-1510"
      }
    ],

    bio_name: "About Dr. Viacheslav Bobovnikov",
    bio: `Dr. Bobovnikov is a Physician and Assistant Professor for the Department of Cardiovascular and Vascular Surgery at McGovern Medical School. Dr. Bobovnikov focuses on providing high quality comprehensive healthcare to his patients. He is also active in teaching residents, fellows and medical students.</br></br>
He has several professional interests including: total arterial revascularization in Coronary Artery Bypass Surgery (which provides a more superior outcome for patients in comparison to conventional bypass surgery), minimal invasive (heart valve repair, replacement) procedures, and ascending aorta and aortic root reconstruction surgery.</br></br>
He is an active member of the Israel Medical Association, the Israel Society for Cardiothoracic Surgery, and the Israel Heart Society.</br></br>
Outside of work, he enjoys spending time with his wife and two children.`,

    education: [
      "Medical Degree from Smolensk State Medical Academy",
      "Internship at Smolensk Regional Hospital",
      "Residency at Asaf Harofe Government Hospital Israel",
      "Fellowship (Cardiothoracic Surgery) Rabin Medical Center Campus Beilinson"
    ],

    areasOfExpertise: `<ul>
      <li>Advanced techniques for internal mammary artery skeletonization</li>
      <li>Aortic Surgery</li>
      <li>Ascending Aortic Aneurysm Repair</li>
      <li>Cardiac Surgery</li>
      <li>Cardiothoracic Surgery</li>
    </ul>
    <ul>
      <li>Minimally Invasive Direct Coronary Artery Bypass Grafting (MIDCAB)</li>
      <li>Short-term Cardiac Assist Devices</li>
      <li>Total Arterial Revascularization</li>
      <li>Transcatheter Valve Replacement (TAVR)</li>
      <li>Valve Repair and Replacement</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=CVa4hX-42cc",
      title: "CARDIO-THORACIC SURGERY",
      contentTop: "Cardiac and thoracic surgeons specialize in treating diseases affecting the chest, lungs, esophagus and heart. Although these surgeons have the same general training and are certified by the same board, they treat different patients. Cardiac surgeons treat heart problems, including heart disease, heart transplants and heart failure. Thoracic surgeons treat issues of the lungs, such as lung cancer or emphysema.",
      slope: true
    }
  },


  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "CARDIO-THORACIC SURGERY",
      mdName: "Imran T. Mohiuddin, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title: "CARDIO-THORACIC SURGERY",
      contentTop: "Cardiac and thoracic surgeons specialize in treating diseases affecting the chest, lungs, esophagus and heart. Although these surgeons have the same general training and are certified by the same board, they treat different patients. Cardiac surgeons treat heart problems, including heart disease, heart transplants and heart failure. Thoracic surgeons treat issues of the lungs, such as lung cancer or emphysema.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/CT-Mohiuddin.jpg",
      title: "VASCULAR SURGEON",
      mdcontent: "Imran T. Mohiuddin, MD, is an esteemed vascular surgery specialist based in Sugar Land, TX, boasting an extensive 29 years of experience in the field. Dr. Mohiuddin is board-certified in Vascular Surgery, further solidifying his dedication to accessible and comprehensive healthcare.",
      mdname: "IMRAN T. MOHIUDDIN, MD"
    },
    id: "imran-t-mohiuddin-md",
    name: "Imran T. Mohiuddin, MD",
    image: "/images/doctors/imran-t-mohiuddin-md.jpg",
    phone: "281-397-2967",
    gender: "Male",
    language: "English, Hindi, Spanish, Urdu",
    specialty: "Vascular Surgery",
    degrees: ["Medical Degree"],
    clinics: [
      {
        name: "Texas Advanced Surgery Center",
        address: "6927 Brisbane Ct. STE 100, Sugar Land, TX 77479",
        phone: "(281) 937-2967"
      },
      {
        name: "South Texas Vascular Center",
        address: "20403 University Blvd, Ste 600, Sugar Land, TX 77478",
        phone: "(281) 302-6292"
      }
    ],
    bio_name: "About Dr. Imran T. Mohiuddin",
    bio: `Dr. Mohiuddin is a board-certified surgeon. He received his medical degree from Tufts University School of Medicine and his residency at UTMB. He has expertise in treating diseases of the veins and blood vessels, such as aneurysms, varicose veins and peripheral artery diseases, and treating lymphedema. He has authored multiple peer reviewed clinical research papers and a member of the American College of Surgeons.`,
    education: [
      "Medical Degree from Tufts University School of Medicine",
      "Residency (General Surgery) at University of Texas Medical School",
      "Fellowship (Vascular Surgery) at Baylor College of Medicine"
    ],
    areasOfExpertise: `<ul>
<li>Ablation Procedures</li>
<li>Aneurysms</li>
<li>Angioplasty</li>
<li>Aortic Aneurysms</li>
<li>Atherosclerosis/Lipoprotein</li>
</ul>
<ul>
<li>Brain Arteriovenous Malformation (AVM)</li>
<li>Cardiovascular Disease</li>
<li>Cardiovascular Surgery</li>
<li>Dialysis</li>
<li>Varicose Veins</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      link: "https://vimeo.com/320376078?autoplay=1&muted=1&stream_id=Y2xpcHN8NDQ0MDEzMjB8aWQ6ZGVzY3xbXQ%3D%3D",
      title: "CARDIO-THORACIC SURGERY",
      contentTop: "Cardiac and thoracic surgeons specialize in treating diseases affecting the chest, lungs, esophagus and heart. Although these surgeons have the same general training and are certified by the same board, they treat different patients. Cardiac surgeons treat heart problems, including heart disease, heart transplants and heart failure. Thoracic surgeons treat issues of the lungs, such as lung cancer or emphysema.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "CARDIO-THORACIC SURGERY",
      mdName: "Kenneth E. Otah, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    cardioThoracicDetailData: {
      title: "CARDIO-THORACIC SURGERY",
      contentTop:
        "Cardiothoracic surgery in the United States is combined with general thoracic surgery where the focus is on the heart, lungs, and esophagus. Our surgeons, with the help of our physicians and surgical assistants, perform a variety of surgeries that can be anywhere from minimally invasive to open heart transplants.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg",
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/CT-Otah.webp",
      title: "Cardiologist",
      mdcontent:
        "Kenneth E. Otah is board certified in internal medicine and cardiovascular disease, with a clinical focus on invasive cardiovascular, vascular, and endovascular medicine.",
      mdname: "KENNETH E. OTAH, MD",
    },

    id: "kenneth-e-otah",
    name: "Kenneth E. Otah, MD",
    image: "/images/physianDirectory/CT-Otah.webp",
    phone: "281-302-5838",
    gender: "Male",
    language: "English, Spanish, Igbo, Yoruba",

    specialty: "Cardiovascular Diseases, Cardiology, Heart and Vascular Services",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Total Heart Cardiovascular Consultants",
        address: "138 Eldridge Road, Ste E, Sugar Land, TX 77478",
        phone: "(281) 302-5838",
      },
    ],

    bio_name: "About Dr. Kenneth E. Otah",
    bio: `
    Dr. Otah was born in London in the United Kingdom and grew up in the UK and Nigeria. He trained in the College of Medical Science at the University of Maiduguri. He obtained vascular medicine training at the Imperial College of Science, Technology, and Medicine at the University of London. He graduated MB.BS MD with distinction and Master of Science in Vascular Technology and Medicine.</br></br>
He completed both his residency in Internal Medicine and his Fellowship in Cardiovascular Medicine at the SUNY Health Science Center in Brooklyn (Downstate Medical Center). He further obtained advanced fellowship training in Invasive Cardiology and Endovascular Medicine at Johns Hopkins Hospital in Baltimore, Maryland. He is board certified in Cardiovascular Medicine, Endovascular/Invasive Cardiovascular Medicine, Vascular Medicine, and CT Cardiovascular imaging. He has been in practice for 19 years and began practicing in 2003.</br></br>
Dr. Otah participates in community outreach projects including education and speaking at health events and forums. Dr. Kenneth Otah has been married to Dr. Ese Otah for over 21 years. They have two sons Kenny Jr. and Jason, and three dogs.
    `,

    education: [
      "Medical Degree from College of Medical Science at the University of Maiduguri",
      "Master of Science (Vascular Technology and Medicine) at Imperial College of Science, Technology, and Medicine at the University of London",
      "Residency (Internal Medicine) at the SUNY Health Science Center in Brooklyn",
      "Fellowship (Cardiovascular Medicine) at the SUNY Health Science Center in Brooklyn",
      "Fellowship training (Invasive Cardiology and Endovascular Medicine) at Johns Hopkins Hospital",
    ],

    areasOfExpertise: `<ul>
        <li>Arrhythmias</li>
        <li>Aneurysms</li>
        <li>Chest Pain</li>
        <li>Congestive Heart Failure</li>
        <li>Heart Attack</li>
      </ul>
      <ul>
        <li>Hypertension</li>
        <li>Palpitations</li>
        <li>Peripheral Vascular Disease</li>
        <li>Stroke</li>
        <li>Varicose Veins</li>
      </ul>`,

    generalSurgeryDetaillinkData: {
      title: "CARDIO-THORACIC SURGERY",
      contentTop:
        "Cardiologists diagnose and manage diseases of the heart and blood vessels, combining invasive and non-invasive diagnostic tools with aggressive risk-factor modification to optimize long-term cardiovascular health.",
      slope: true,
    },
  },
];

export const physicianOrthoPedicData = [
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Mohammed Tarek Al-Fahl, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },
  
    cardioThoracicDetailData: {
      title:"ORTHOPEDIC SURGERY",
      contentTop:"Orthopedic Surgery focuses on treatments and repairs of the musculoskeletal system; joints, bones, ligaments, tendons and more. These surgeries can range from minimally invasive procedures to amputation. In America, our surgeons are highly trained and certified in this field and people come all over the world to receive care here. They operate with an entire team to ensure the safety of each patient and use tedious measures to make sure all surgeries are successful.",
      slope: true,
      intoImgData: "/images/providers/46444454_ortho.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_39.png",
      title: "ORTHOPEDIC SURGERY",
      mdcontent:
        "Mohammed Tarek Al-Fahl, MD works in Tomball, TX as an Orthopedic Surgeon and has 29 years of experience.  He has worked on more claims relating to Joint Pain and Shoulder Impingement Syndrome than other providers in the area.",
      mdname: "MOHAMMED TAREK AL-FAHL, MD"
    },
  
    id: "mohammed-tarek-al-fahl-md",
    name: "Mohammed Tarek Al-Fahl, MD",
    image: "/images/doctors/mohammed-tarek-al-fahl.jpg",
    phone: "(281) 351-7261",
    gender: "Male",
    language: "English",
  
    specialty: "Orthopedic Surgery, Sports Medicine",
  
    degrees: [
      "Doctor of Medicine – Temple University"
    ],
  
    clinics: [
      {
        name: "Texas Orthopedic & Sports Medicine – Tomball",
        address: "13603 Michel Rd, Tomball, TX 77375"
      },
      {
        name: "Texas Orthopedic & Sports Medicine – The Woodlands",
        address: "9319 Pinecroft Dr Ste 200, The Woodlands, TX 77380"
      }
    ],
  
    bio_name: "About Dr. Mohammed Tarek Al-Fahl",
    bio: `
    Dr. Al-Fahl is an arthroscopy and sports medicine surgeon with a focus on shoulder and knee injuries. Throughout his career, he has cared for patients and athletes of all ages and activity levels. You may see him on the sidelines at local high school football games, but Dr. Fahl’s experience includes caring for professional athletes as well, such as the Houston Rockets and Astros.</br>
    Dr. Fahl feels most fulfilled when his patients return to their pre-injury level of activity. His practice includes surgical and non-surgical treatment of shoulder and knee injuries. He has extensive experience in shoulder SLAP repairs, Bankart repairs and rotator cuff repairs. He is also experienced in knee ACL reconstructions, meniscal surgery and complicated cartilage and ligament reconstructive cases. Other orthopaedic surgeons in the area routinely refer difficult shoulder and knee surgical procedures to Dr. Fahl for his expertise.</br>
    Dr. Fahl completed his residency at Temple University Hospital in Philadelphia and trained there under world renowned surgeon, Dr. Lachmann. Dr. Fahl also completed a fellowship in Arthroscopy and Sports Medicine at Baylor College of Medicine in the Houston Medical Center. He has published research in the Journal of Arthroscopic and Related Surgery and provided numerous presentations and lectures to physicians, trainers and students. Additionally, Dr. Fahl has published a surgical technique guide to assist orthopaedic surgeons in MCL Allograft Reconstruction.
    `,
    education: [
      "Graduate Degree from UMDNJ - Rutgers Robert Wood Johnson Medical School",
      "Undergraduate Degree from Temple University",
      "Residency at Temple University Hospital",
      "Fellowship at Baylor College of Medicine"
    ],
  
    areasOfExpertise: `
    <ul>
    <li>AC joint separations</li>
    <li>ACL tears</li>
    <li>Articular cartilage defects / cartilage restoration</li>
    <li>Bankart tears</li>
    <li>Dislocations</li>
    <li>Impingement</li>
    <li>Joint instability</li>
    </ul>
    <ul>
    <li>Knee injuries</li>
    <li>Labral tears</li>
    <li>LCL tears / posterolateral corner injuries</li>
    <li>Meniscus tears</li>
    <li>Pectoralis tears</li>
    <li>Rotator cuff tears</li>
    <li>Shoulder injuries</li>
    </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=Gd8WSb-U4hQ",
      title: "ORTHOPEDIC SURGERY",
      contentTop:"Orthopedic surgeons diagnose and treat conditions of the human body, focusing on injuries and diseases of the body's musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active. They often treat sports injuries, degenerative diseases, tumors, infections and birth defects. ",
      slope: true
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Miguel A. Berastain, Jr.",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },
  
    cardioThoracicDetailData: {
      title:"ORTHOPEDIC SURGERY",
      contentTop:"Orthopedic Surgery focuses on treatments and repairs of the musculoskeletal system; joints, bones, ligaments, tendons and more. These surgeries can range from minimally invasive procedures to amputation. In America, our surgeons are highly trained and certified in this field and people come all over the world to receive care here. They operate with an entire team to ensure the safety of each patient and use tedious measures to make sure all surgeries are successful.",
      slope: true,
      intoImgData: "/images/providers/46444454_ortho.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_40.png",
      title: "ORTHOPEDIC SURGERY",
      mdcontent:
        "Miguel Berastain, Jr, MD works in Corpus Christi, TX as an Orthopedic Surgeon and has been in practice for more than 20 years.",
      mdname: "Miguel A. Berastain, Jr."
    },
  
    id: "Miguel A. Berastain, Jr.",
    name: "Miguel A. Berastain, Jr.",
    image: "/images/doctors/mohammed-tarek-al-fahl.jpg",
    phone: "361-883-2000",
    gender: "Male",
    language: "English, Spanish",
  
    specialty: "General Orthopaedics, Orthopedic Surgery, Sports Medicine",
  
    degrees: [
      "Doctor of Medicine"
    ],
  
    clinics: [
      {
        name: "The Orthopaedic Center of Corpus Christi",
        address: "6118 Parkway Drive, Corpus Christi, TX 78414",
        phone: "(361) 883-2000",
      },
    ],
  
    bio_name: "About Dr. Miguel A. Berastain",
    bio: `
    Dr. Berastain Jr. was born in Zaragoza, Spain while his father was in medical school. He was raised most of his life in the Corpus Christi area completed his Orthopaedic residency at The University of Texas at Houston, Department of Orthopaedics.</br></br>
​
He joined his father in practice in 2006 and remained in joint practice for 9 years. He learned a tremendous amount from Dr. Berastain Sr. and his years of experience. In February of 2014 he became affiliated with the Orthopaedic Center of Corpus Christi.</br></br>
​
Dr. Berastain Jr. works to develop a partnership with his patients by helping them make informed decisions about their health. He offers both non‐operative and operative treatment options and he understands that listening and clear communications are essential for quality patient care. Honesty and transparency have worked in helping patients make the best decision for themselves.</br></br>
​
He has an interest in knee and shoulder arthroscopy and replacement, and hip replacement using the anterior approach. He believes in using technology to give the most precise surgical results with both computer navigation and robotic surgery.</br></br>
​
Dr. Berastain Jr. is Board Certified in Orthopaedic Surgery. He is a Diplomate of the American Academy of Orthopaedic Surgeons. He is a member of the Texas Orthopaedic Association, Texas Medical Association and the Nueces County Medical Society.
    `,
    education: [
      "Medical Degree from Case Western Reserve University School of Medicine",
      "Undergraduate Degree from University of Notre Dame",
      "Residency (Orthopaedic Surgery) at The University of Texas at Houston, Department of Orthopaedics"
    ],
  
    areasOfExpertise: `
    <ul>
    <li>Computer Navigation and Robotic Surgery</li>
    <li>Hip Replacement with Anterior Approach</li>
    <li>Knee Arthroscopy</li>
    <li>Knee Replacement</li>
    <li>Shoulder Arthroscopy</li>
    <li>Shoulder Replacement</li>
  </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/33691769_xxl.jpg",
      title: "ORTHOPEDIC SURGERY",
      contentTop:"Orthopedic surgeons diagnose and treat conditions of the human body, focusing on injuries and diseases of the body's musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active. They often treat sports injuries, degenerative diseases, tumors, infections and birth defects. ",
      slope: true
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Michael L. Blackwell, MD",
      content:
        "Michael Blackwell, MD, is the orthopaedic surgeon and sports medicine specialist leading the team at the Center for Orthopaedic and Sports Medicine. He has been in practice for more than 20 years and has expertise in treating knee injury, arthritis, knee arthroscopy, among other conditions."
    },
  
    cardioThoracicDetailData: {
      title:"ORTHOPEDIC SURGERY",
      contentTop:"Orthopedic Surgery focuses on treatments and repairs of the musculoskeletal system; joints, bones, ligaments, tendons and more. These surgeries can range from minimally invasive procedures to amputation. In America, our surgeons are highly trained and certified in this field and people come all over the world to receive care here. They operate with an entire team to ensure the safety of each patient and use tedious measures to make sure all surgeries are successful.",
      slope: true,
       intoImgData: "/images/providers/46444454_ortho.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_41.jpg",
      title: "ORTHOPEDIC SURGERY",
      mdcontent:
        "Michael Blackwell, MD, is the orthopaedic surgeon and sports medicine specialist leading the team at the Center for Orthopaedic and Sports Medicine. He has been in practice for more than 20 years and has expertise in treating knee injury, arthritis, knee arthroscopy, among other conditions.",
      mdname: "Michael L. Blackwell, MD"
    },
  
    id: "Michael L. Blackwell, MD",
    name: "Michael L. Blackwell, MD",
    image: "/images/doctors/md_41.jpg",
    phone: "281-357-5515",
    gender: "Male",
    language: "English, Spanish",
  
    specialty: "Orthopaedic Surgery, Sports Medicine",
  
    degrees: [
      "Doctor of Medicine"
    ],
  
    clinics: [
      {
        name: "Center for Orthopaedic and Sports Medicine",
        address: "425 Holderrieth Boulevard, Suite 208, Tomball, TX 77375",
        phone: "(281) 357-5515",
      },
      {
        name: "Center for Orthopaedic and Sports Medicine",
        address: "22751 Professional Dr., Suite 140, Kingwood, TX 77339",
        phone: "(281) 357-5515",
      },
    ],
  
    bio_name: "About Dr. Michael L. Blackwell",
    bio: `
    Dr. Blackwell, who has practiced medicine for over two decades, completed medical school at the University Of Texas Medical Branch at Galveston in 1991. He then went on to complete his internship and residency at the same institution.</br>Today, Dr. Blackwell and his team at the Center for Orthopaedic and Sports Medicine treat an array of orthopaedic injuries, including ACL tears, fractures, sports-related injuries, foot and ankle issues, hand and wrist problems, and much more.</br>The state-of-the-art facilities at the Center for Orthopaedic and Sports Medicine are outfitted with the most advanced equipment available today so that Dr. Blackwell can treat your injuries and help you get back to the activities you love. Dr. Blackwell uses Mako Robotic-Arm Assisted Technology to help carry out many minimally invasive orhtopaedic procedures, including knee replacement and hip replacement surgeries. The Mako system allows Dr. Blackwell to perform advanced orthopaedic procedures with greater accuracy than traditional surgery would afford. This helps to reduce trauma and minimize your post-surgical recovery time.,
    `,
    education: [
 "Medical Degree from University of Texas Medical Branch School of Medicine",
  "Residency (Orthopaedic Surgery) at The University of Texas Medical Branch"
    ],
  
    areasOfExpertise: `
    <ul>
  <li>Broken or dislocated ankle/foot</li>
  <li>Bursitis</li>
  <li>Carpal tunnel syndrome</li>
  <li>Enthesopathy in arms</li>
  <li>Hand joint or tendon inflammation</li>
  <li>Hip replacement</li>
  <li>Joint cyst</li>
  <li>Knee arthroscopy</li>
  
  </ul>
  <ul>
  <li>Knee replacement</li>
  <li>Lower back pain</li>
  <li>Muscle pain, fibromyalgia, and limb pain</li>
  <li>Pelvic and hip fracture</li>
  <li>Rotator cuff injury</li>
  <li>Shoulder arthroscopy / rotator cuff repair</li>
  <li>Traumatic arthropathy</li>
  <li>Thoracic spine disorders</li>
  </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/33691769_xxl.jpg",
      title: "ORTHOPEDIC SURGERY",
      contentTop:"Orthopedic surgeons diagnose and treat conditions of the human body, focusing on injuries and diseases of the body's musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active. They often treat sports injuries, degenerative diseases, tumors, infections and birth defects. ",
      slope: true
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Nikoletta Carayannopoulos, DO",
      content:
        "Nikoletta L. Carayannopoulos, DO is an orthopedist in Houston, Texas and is affiliated with multiple hospitals in the area. She received her medical degree from TCU and UNTHSC School of Medicine and has been in practice for more than 20 years. Dr. Niki Carayannopoulos has expertise in treating knee replacement, knee arthroscopy, rotator cuff injury, among other conditions."
    },
  
    cardioThoracicDetailData: {
      title:"ORTHOPEDIC SURGERY",
      contentTop:"Orthopedic Surgery focuses on treatments and repairs of the musculoskeletal system; joints, bones, ligaments, tendons and more. These surgeries can range from minimally invasive procedures to amputation. In America, our surgeons are highly trained and certified in this field and people come all over the world to receive care here. They operate with an entire team to ensure the safety of each patient and use tedious measures to make sure all surgeries are successful.",
      slope: true,
      intoImgData: "/images/providers/46444454_ortho.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_42.png",
      title: "ORTHOPEDIC SURGERY",
      mdcontent:
        "Nikoletta L. Carayannopoulos, DO is an orthopedist in Houston, Texas and is affiliated with multiple hospitals in the area. She received her medical degree from TCU and UNTHSC School of Medicine and has been in practice for more than 20 years. Dr. Niki Carayannopoulos has expertise in treating knee replacement, knee arthroscopy, rotator cuff injury, among other conditions.",
      mdname: "Nikoletta Carayannopoulos, DO"
    },
  
    id: "Nikoletta Carayannopoulos, DO",
    name: "Nikoletta Carayannopoulos, DO",
    image: "/images/doctors/mohammed-tarek-al-fahl.jpg",
    phone: "281-496-2482",
    gender: "Female",
    language: "English, Spanish, Greek",
  
    specialty: "Orthopaedic Trauma, General Surgical Orthopedics, Sports Medicine",
  
    degrees: [
      "Doctor of Osteopathy"
    ],
  
    clinics: [
      {
        name: "West Houston Orthopedics",
        address: "12606 West Houston Center Blvd Ste 350, Houston, TX 77082",
        phone: "(281) 496-2482",
      },
    ],
  
    bio_name: "About Dr. Nikoletta Carayannopoulos",
    bio: `
    Dr. Carayannopoulos is a fellowship-trained, board-certified orthopedic surgeon specializing in trauma/acute injury and reconstructive surgery in the pediatric and adult population. She also has over a decade of experience with minimally invasive surgery including arthroscopy of the upper and lower extremity and endoscopic carpal tunnel release surgery. Her knowledge and expertise led to her selection (through a peer-reviewed process) as a prestigious AO Trauma faculty that helps teach residents and practicing orthopedic surgeons about state-of-the-art surgical techniques both nationally and internationally. In addition to her technical and educational expertise as a physician, Dr. Carayannopoulos is a published researcher with numerous publications in peer-reviewed journals and has given many regional and national presentations. She also has participated in research funded by the Department of Defense addressing the management/treatment of long bone defects.,
    `,
    education: [
      "Medical Degree from the University of North Texas Health Science Center",
      "Residency at University of Texas Medical Branch",
      "Fellowship at Duke University School of Medicine"
    ],
  
    areasOfExpertise: `
    <ul>
    <li>ACL reconstruction surgery</li>
    <li>Arthroplasty (Elbow, Hip, Knee, Shoulder)</li>
    <li>Arthroscopy (Ankle, Heel)</li>
    <li>Fracture / Dislocation (Hips, Knees, Shoulders)</li>
    <li>Meniscus repair surgery</li>
    </ul>
    <ul>
    <li>Osteoarthritis</li>
    <li>Rotator Cuff Repair Surgery</li>
    <li>Shin Splints</li>
    <li>Sprains and Strains</li>
    <li>Total Knee Replacement Surgery</li>
  </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/33691769_xxl.jpg",
      title: "ORTHOPEDIC SURGERY",
      contentTop:"Orthopedic surgeons diagnose and treat conditions of the human body, focusing on injuries and diseases of the body's musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active. They often treat sports injuries, degenerative diseases, tumors, infections and birth defects. ",
      slope: true
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "John J. Eager, MD",
      content:
        "Nikoletta L. Carayannopoulos, DO is an orthopedist in Houston, Texas and is affiliated with multiple hospitals in the area. She received her medical degree from TCU and UNTHSC School of Medicine and has been in practice for more than 20 years. Dr. Niki Carayannopoulos has expertise in treating knee replacement, knee arthroscopy, rotator cuff injury, among other conditions."
    },
  
    cardioThoracicDetailData: {
      title:"ORTHOPEDIC SURGERY",
      contentTop:"Orthopedic Surgery focuses on treatments and repairs of the musculoskeletal system; joints, bones, ligaments, tendons and more. These surgeries can range from minimally invasive procedures to amputation. In America, our surgeons are highly trained and certified in this field and people come all over the world to receive care here. They operate with an entire team to ensure the safety of each patient and use tedious measures to make sure all surgeries are successful.",
      slope: true,
      intoImgData: "/images/providers/46444454_ortho.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_43.png",
      title: "ORTHOPEDIC SURGERY",
      mdcontent:
        "John J. Eager, MD is an orthopedist in Texas and Tennessee and is affiliated with multiple hospitals in those areas. He received his medical degree from McGovern Medical School at UTHealth and has been in practice between 11-20 years. Dr. John J. Eager has expertise in treating spinal fusion, spinal stenosis and spondylosis, hip replacement, among other conditions.",
      mdname: "John J. Eager, MD"
    },
  
    id: "John J. Eager, MD",
    name: "John J. Eager, MD",
    image: "/images/doctors/mohammed-tarek-al-fahl.jpg",
    phone: "901-641-3000",
    gender: "Male",
    language: "English",
  
    specialty: "Orthopaedic Surgery, Orthopedic Spine Surgery",
  
    degrees: [
      "Doctor of Medicine"
    ],
  
    clinics: [
      {
        name: "West Houston Orthopedics",
        address: "12606 West Houston Center Blvd Ste 350, Houston, TX 77082",
        phone: "(281) 496-2482",
      },
      {
        name: "OrthoSouth",
        address: "3045 Kate Bond Rd., Bartlett, TN 38133",
        phone: "(901) 641-3000",
      },
      {
        name: "Poplar Office",
        address: "4515 Poplar Ave Ste 206, Memphis, TN 38117",
        phone: "(901) 641-3000",
      },
    ],
  
  
    bio_name: "About Dr. John J. Eager",
    bio: `
    Dr. Eager is one of a few surgeons in the country to be dual-fellowship trained in spine surgery and musculoskeletal oncology. His unique expertise enables him to treat a variety of complex spinal disorders as well as adult and pediatric bone and soft tissue tumors.</br>
Dr. Eager specializes in the diagnosis and treatment of spinopelvic disorders, including degenerative spine surgery, spine trauma, tumors of the spine, adult spinal deformity, revision spine surgery, and minimally invasive surgery techniques. His additional expertise includes surgical management of bone and soft tissue sarcoma, skeletal/spinal metastatic disease, and complex limb salvage to include hip/knee/pelvis reconstruction.</br>
Dr. Eager believes in a conservative approach to spine surgery, incorporating nonsurgical options when appropriate. He is committed to improving the quality of life for his patients with an emphasis on providing a tailored treatment strategy to meet the individual needs of each patient. Dr. Eager completed a combined orthopaedic and neurosurgical complex spine surgery fellowship at the prestigious Texas Medical Center in Houston, TX. He completed his musculoskeletal oncology fellowship at Emory University in Atlanta, GA. He earned his medical degree and completed his orthopaedic surgery residency at University of Texas Health Science Center at Houston (TX).
    `,
    education: [
      "Medical Degree from University of Texas Health Science Center at Houston",
      "Residency at University of Texas Health Science Center at Houston",
      "Fellowship (Spine Surgery) Houston Methodist Texas Medical Center",
      "Fellowship (Musculoskeletal Oncology) at Emory University"
    ],
  
    areasOfExpertise: `
    <ul>
      <li>Complex Spine Surgery</li>
      <li>Minimally Invasive Spine Surgery</li>
      <li>Motion Preservation Spine Surgery</li>
      <li>Spine</li>
      <li>Spine Oncology</li>
      <li>Spine Surgery</li>
    </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=OX43geV5jmU",
      title: "ORTHOPEDIC SURGERY",
      contentTop:"Orthopedic surgeons diagnose and treat conditions of the human body, focusing on injuries and diseases of the body's musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active. They often treat sports injuries, degenerative diseases, tumors, infections and birth defects. ",
      slope: true
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Nicholas Fiore II, MD",
      content:
        "Nicholas Fiore II, MD is an orthopedic hand surgeon in Houston, TX. He specializes in hand and wrist pain- including carpal tunnel, hand, wrist and finger fractures, nerve injuries and other extremity conditions."
    },
  
    cardioThoracicDetailData: {
      title:"ORTHOPEDIC SURGERY",
      contentTop:"Orthopedic Surgery focuses on treatments and repairs of the musculoskeletal system; joints, bones, ligaments, tendons and more. These surgeries can range from minimally invasive procedures to amputation. In America, our surgeons are highly trained and certified in this field and people come all over the world to receive care here. They operate with an entire team to ensure the safety of each patient and use tedious measures to make sure all surgeries are successful.",
      slope: true,
     intoImgData: "/images/providers/46444454_ortho.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_44.png",
      title: "ORTHOPEDIC SURGERY",
      mdcontent:
        "John J. Eager, MD is an orthopedist in Texas and Tennessee and is affiliated with multiple hospitals in those areas. He received his medical degree from McGovern Medical School at UTHealth and has been in practice between 11-20 years. Dr. John J. Eager has expertise in treating spinal fusion, spinal stenosis and spondylosis, hip replacement, among other conditions.",
      mdname: "Nicholas Fiore II, MD"
    },
  
    id: "Nicholas Fiore II, MD",
    name: "Nicholas Fiore II, MD",
    image: "/images/doctors/mohammed-tarek-al-fahl.jpg",
    phone: "281-970-8002",
    gender: "Male",
    language: "English",
  
    specialty: "Orthopedics, Surgery of the Hand",
  
    degrees: [
      "Doctor of Medicine"
    ],
  
    clinics: [
      {
        name: "Fiore Hand & Wrist",
        address: "11307 FM 1960 Rd W #250, Houston, TX 77065-4917",
        phone: "(281) 970 8002"
      },
    ],
  
    bio_name: "About Dr. Nicholas Fiore II",
    bio: `
    Dr. Fiore is board certified by the American Board of Surgery in hand surgery. He initially developed his interest in hand surgery after fracturing his wrist, wrestling for the Duke University Blue Devils. Forced to undergo surgery and placed in a cast for several weeks, he truly recognized the profound impact having a hand injury can have on a person’s physical, emotional, and financial well-being.</br>
    After obtaining his medical degree from Ross University School of Medicine he entered general surgery residency at the University of Medicine and Dentistry-NJ Medical School where he achieved both local and national recognition in his ability to teach.</br>
    This teaching ability translated well with his doctor/patient relationships as most patients found him able to break down a complex condition and make it more understandable. Graduating from residency, he proceeded to acquire additional training in hand surgery from the Baylor College of Medicine accredited fellowship where he performed well over 500 operations.</brr>
    The training was diverse to say the least and included elective, non emergent hand surgery as well as limb threatening or mangling trauma. Upon graduation he was invited to stay as faculty for which he was hired as an Assistant Professor in the Division of Plastic Surgery. It was a productive year clinically (performed about 400 procedures) as well as academically as he literally wrote the chapter’ on hand surgery which he co-authored in Sabiston’s Textbook of Surgery 18th edition.</br>
    In addition, to his busy clinical practice, Dr. Fiore is a speaker for Auxilium Pharmaceuticals and a medical technology consultant.    
    `,
    education: [
      "Medical Degree from Baylor College of Medicine",
      "Undergraduate Degree from Ross University - School Of Medicine",
      "Residency at University of Medicine and Dentistry- NJ Medical School"
    ],
  
    areasOfExpertise: `
    <ul>
    <li>Carpal Tunnel Syndrome</li>
    <li>Elbow Arthroscopy</li>
    <li>Hand and Upper Extremity Fracture &amp; Surgery</li>
    <li>Hand and Wrist Masses</li>
    <li>Hand Fractures</li>
    </ul>
    <ul>
    <li>Hand Procedures for Injuries</li>
    <li>Joint Pain</li>
    <li>Orthopedics</li>
    <li>Osteoarthritis of the Hand</li>
    <li>Wrist Fracture</li>
  </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=M5SnAKnQ9Pc",
      title: "ORTHOPEDIC SURGERY",
      contentTop:"Orthopedic surgeons diagnose and treat conditions of the human body, focusing on injuries and diseases of the body's musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active. They often treat sports injuries, degenerative diseases, tumors, infections and birth defects. ",
      slope: true
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Enrique J. Garcia-Pena, MD",
      content:
        "Enrique J. Garcia-Pena, MD, is a board-certified orthopedic surgeon at Texas Bone & Joint and practices in Houston, Texas. He specializes in arthroscopic and minimally invasive procedures of the shoulder, elbow, hip, and knee with particular interest in the treatment and prevention of ACL injuries and cartilage restoration procedures."
    },
  
    cardioThoracicDetailData: {
      title:"ORTHOPEDIC SURGERY",
      contentTop:"Orthopedic Surgery focuses on treatments and repairs of the musculoskeletal system; joints, bones, ligaments, tendons and more. These surgeries can range from minimally invasive procedures to amputation. In America, our surgeons are highly trained and certified in this field and people come all over the world to receive care here. They operate with an entire team to ensure the safety of each patient and use tedious measures to make sure all surgeries are successful.",
      slope: true,
      intoImgData: "/images/providers/46444454_ortho.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_45.png",
      title: "ORTHOPEDIC SURGERY",
      mdcontent:
        "John J. Eager, MD is an orthopedist in Texas and Tennessee and is affiliated with multiple hospitals in those areas. He received his medical degree from McGovern Medical School at UTHealth and has been in practice between 11-20 years. Dr. John J. Eager has expertise in treating spinal fusion, spinal stenosis and spondylosis, hip replacement, among other conditions.",
      mdname: "Enrique J. Garcia-Pena, MD"
    },
  
    id: "Enrique J. Garcia-Pena, MD",
    name: "Enrique J. Garcia-Pena, MD",
    image: "/images/doctors/mohammed-tarek-al-fahl.jpg",
    phone: "281-895-2065",
    gender: "Male",
    language: "English, Spanish",
  
    specialty: "Orthopaedic Surgery, Sports Medicine",
  
    degrees: [
      "Doctor of Medicine"
    ],
  
    clinics: [
      {
        name: "Texas Bone & Joint - North Houston",
        address: "800 Peakwood Drive 5D, Houston, TX 77090",
        phone: "(281) 895-2065",
      },
      {
        name: "Texas Bone and Joint - West Houston",
        address: "12606 West Houston Center Blvd Ste 350, Houston, TX 77082",
        phone: "",
      },
    ],
  
    bio_name: "About Dr. Enrique J. Garcia-Pena",
    bio: `
    Dr. Garcia-Pena was born and raised on the island of Puerto Rico and is a native Spanish speaker. He received a bachelor’s degree in Biology from the prestigious University of Chicago and then obtained a Master’s degree in Medical Sciences and Research from Boston University. He then returned home to Puerto Rico to continue his lifelong dream of practicing medicine and graduated Summa Cum Laude from the University of Puerto Rico School of Medicine. Dr. Garcia-Pena completed his residency program in Orthopedic Surgery at one of the busiest trauma hospitals in the Caribbean and well-known throughout the region: the Medical Sciences Center from the University of Puerto Rico School of Medicine.</br></br>

He completed his fellowship training at the Baylor College of Medicine and Ironman Sports Medicine Institute in Houston, Texas. Dr. Garcia-Pena served as assistant to the Team Physician of the Houston Texans, Houston Astros, Houston Rockets, Houston Dynamo, University of Houston Athletics, and area high schools.</br></br>

Dr. Garcia-Pena specializes in arthroscopic procedures and joint reconstruction of the shoulder, elbow, hip, and knee with particular interest in sports medicine and helping patients maintain an active lifestyle. He focuses on building a strong patient-physician relationship and works closely with patients, therapists and trainers to optimize both surgical and non-surgical outcomes. His main goal is to get patients back to whatever sport or activity they enjoy the most, whether they are a competitive athlete, a weekend warriors, or an individual with an active lifestyle.
    `,
    education: [
      "Medical Degree from University of Puerto Rico School of Medicine",
      "Residency (Orthopaedic Surgery) at  University of Puerto Rico School of Medicine",
      "Fellowship (Orthopaedic Sports Medicine) at Baylor College of Medicine"
    ],
  
    areasOfExpertise: `
    <ul>
  <li>ACL reconstruction surgery</li>
  <li>Fracture</li>
  <li>Medical Trauma (Orthopedics)</li>
  <li>Minimally Invasive Surgery</li>
  </ul>
  <ul>
  <li>Orthopedics – Sports Medicine</li>
  <li>Osteoarthritis</li>
  <li>Rotator Cuff Repair Surgery</li>
  <li>Sports Medicine Treatment</li>
</ul>
    `,
  
    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=Z6WtAyJVKtI",
      title: "ORTHOPEDIC SURGERY",
      contentTop:"Orthopedic surgeons diagnose and treat conditions of the human body, focusing on injuries and diseases of the body's musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active. They often treat sports injuries, degenerative diseases, tumors, infections and birth defects. ",
      slope: true
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Cristin Mathew, DO",
      content:
        "Cristin John Mathew, DO is an Orthopedic Hip and Knee Surgeon who works with patients of various backgrounds and ailments. He performs, non-operative, minimally invasive, and complex reconstruction surgery in Houston, Texas."
    },
  
    cardioThoracicDetailData: {
      title:"ORTHOPEDIC SURGERY",
      contentTop:"Orthopedic Surgery focuses on treatments and repairs of the musculoskeletal system; joints, bones, ligaments, tendons and more. These surgeries can range from minimally invasive procedures to amputation. In America, our surgeons are highly trained and certified in this field and people come all over the world to receive care here. They operate with an entire team to ensure the safety of each patient and use tedious measures to make sure all surgeries are successful.",
      slope: true,
      intoImgData: "/images/providers/46444454_ortho.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_46.png",
      title: "ORTHOPEDIC SURGERY",
      mdcontent:
        "Cristin John Mathew, DO is an Orthopedic Hip and Knee Surgeon who works with patients of various backgrounds and ailments. He performs, non-operative, minimally invasive, and complex reconstruction surgery in Houston, Texas.",
      mdname: "Cristin Mathew, DO"
    },
  
    id: "Cristin Mathew, DO",
    name: "Cristin Mathew, DO",
    image: "/images/doctors/mohammed-tarek-al-fahl.jpg",
    phone: "281-335-1111",
    gender: "Male",
    language: "English, Malayalam",
  
    specialty: "Orthopedic Surgeon, Hip & Knee Orthopedic Specialist",
  
    degrees: [
      "Doctor of Osteopathy"
    ],
  
    clinics: [
      {
        name: "All American Orthopedics & Sports Medicine- Clear Lake Main Campus",
        address: "1045 Gemini Ste 100, Houston, TX 77058",
      },
      {
        name: "All American Orthopedics & Sports Medicine- Lake Jackson Campus",
        address: "201 Oak Dr S, Ste 104, Lake Jackson, TX 77566",
      },
    ],
  
    bio_name: "About Dr. Cristin Mathew",
    bio: `
    Dr. Mathew went to medical school at the Edward Via College of Osteopathic Medicine on the Virginia Tech Campus in Blacksburg Virginia.  As a student he began to foster his interest in sports medicine through his involvement with Virginia Tech Athletics.  While he was also a student, he served his classmates and the national student body as Class President and 2nd Vice Chair of the Council of Osteopathic Student Government Presidents.</br>
After his obtaining his doctorate, he went on to complete an Orthopedic Residency at Northwell Health in New York.  While a resident, he served his residency as a Chief Resident and participated in several research projects and publications. While at Northwell he had the privilege to train under several physicians that are pioneers in the field of Orthopedics. His accomplishments during residency paved the way for him to enter a prestigious fellowship at Houston Methodist Hospital.</br>
As a fellow, Dr. Mathew was a member of the medical staff for the 2017 World Series Champions Houston Astros.  He also works with the Houston Texans, Rockets, Dynamo, and Sabercats. He continues to serve several local teams and schools and maintains his presence within the Houston rugby community.</br>
Dr. Mathew distinguishes himself in the Houston community through his arthroscopic joint preservation procedures and minimally invasive muscle sparing robotically assisted hip and knee replacement surgeries.  He believes that preservation and repairs are ideal however in instances of joint replacements; muscle sparing robotically assisted procedures reduce trauma, decrease pain, improve motion and longevity of the joint replacement.  All these factors drastically create a more natural feel and improve the recovery process with more function and less pain.
    `,
    education: [
      "Medical Degree from Edward Via College of Osteopathic Medicine",
      "Undergraduate Degree- Ursinus College",
      "Residency (Orthopedic Surgery) at Northwell Health",
      "Fellowship (Arthroscopic Surgery & Sports Medicine) at Houston Methodist Hospital"
    ],
  
    areasOfExpertise: `
    <ul>
    <li>ACL, MCL, PCL injury</li>
    <li>Arthritis</li>
    <li>Arthroscopy &amp; Arthroplasty</li>
    <li>Chronic Pain</li>
    <li>Fracture</li>
    </ul>
<ul>
    <li>Hip Pain</li>
    <li>Knee Pain</li>
    <li>Muscle, Ligament, Meniscus, and Labral Injuries</li>
    <li>Rotator Cuff Repair</li>
    <li>Total Joint Replacement</li>
  </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=Io2PapwzbVk",
      title: "ORTHOPEDIC SURGERY",
      contentTop:"Orthopedic surgeons diagnose and treat conditions of the human body, focusing on injuries and diseases of the body's musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active. They often treat sports injuries, degenerative diseases, tumors, infections and birth defects. ",
      slope: true
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Paul F. Merkle, MD",
      content:
        "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support.",
    },

    cardioThoracicDetailData: {
      title: "ORTHOPEDIC SURGERY",
      contentTop:
        "Orthopedic Surgery focuses on treatments and repairs of the musculoskeletal system; joints, bones, ligaments, tendons and more. These surgeries can range from minimally invasive procedures to amputation. In America, our surgeons are highly trained and certified in this field and people come all over the world to receive care here. They operate with an entire team to ensure the safety of each patient and use tedious measures to make sure all surgeries are successful.",
      slope: true,
      intoImgData: "/images/providers/46444454_ortho.jpg",
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Orth-Merkle.webp",
      title: "ORTHOPEDIC SURGERY",
      mdcontent:
        "Paul F. Merkle, MD is an orthopedic surgeon with 37 years of experience treating bone, joint, and muscle conditions. He specializes in surgical and non-surgical treatments for injuries and disorders affecting the musculoskeletal system. He has extensive experience that allows him to care for patients with a wide range of orthopedic needs, from sports injuries to complex joint problems.",
      mdname: "Paul F. Merkle, MD",
    },

    id: "Paul F. Merkle, MD",
    name: "Paul F. Merkle, MD",
    image: "/images/doctors/mohammed-tarek-al-fahl.jpg",
    phone: "361-761-1000",
    gender: "Male",
    language: "English, Spanish",

    specialty: "Orthopedic Surgery, Pediatric Orthopedics",

    degrees: ["Doctor of Medicine"],

    clinics: [
      {
        name: "Corpus Christi Medical Center Bay Area",
        address: "7101 S Padre Island Dr, Corpus Christi, TX 78412",
        phone: "(361) 761-1000",
      },
    ],

    bio_name: "About Dr. Paul F. Merkle",
    bio: `Dr. Merkle is a board-certified orthopedic trauma surgeon with over 37 years of experience. He is trained in advanced orthopaedics (trauma/pelvis acetabulum). He has an extensive background in clinical leadership and academic settings serving as a Resident Clinical Instructor and as Assistant Professor of Clinical Orthopaedics at the University of Southern California, Department of Orthopaedics for nearly twenty years.</br>
Paul Merkle received his medical degree from the University of Southern California School of Medicine in 1990 and completed his internship and residency at the Los Angeles County and USC Medical Center, Department of Orthopaedic Surgery. Orthopaedics fellowships include pelvis, acetabulum, spine, and spine trauma. He has a Bachelor of Arts degree in business economics from the University of California, Santa Barbara, and he is as well-versed in the business aspects of the specialty as in its clinical components. He is Board-certified by the American Board of Orthopaedic Surgeons.</br>

As an expert in acute care orthopaedic traumatology and acute care surgery, Paul Merkle has a passion for reconstructive and trauma surgery, complex fracture care, hip surgery acute fractures and the care of complex polytrauma (multiply-injured) patients. His experience includes pediatric pelvis and acetabular trauma ankle fractures, pelvis and acetabular surgery. Areas of research include small fragment fixation of the pubic symphysis, nutritional supplementation as related to tibial fracture healing, and the posterior approach to the pelvis.</br>

Paul Merkle has served on the Board of Directors of the USC Graduate Orthopaedic Society California Medical Association where he held numerous leadership positions. He is also a member of Alpha Omega Alpha Honor Medical Society, the American Medical Association, American Academy of Orthopaedic Surgeons and the Orthopaedic Trauma Association which is devoted to improving treatments for orthopaedic trauma patients.</br>`,

    education: ["Medical Degree from Keck School of Medicine of the University of Southern California",
      "Residency at LAC/USC Medical Center",
      "Fellowship at Keck School of Medicine of the University of Southern California",
      "Fellowship at Rancho Los Amigos Hospital"
    ],

    areasOfExpertise: `
    <ul>
      <li>Achilles Tendon</li>
      <li>Ankle Sprain</li>
      <li>Broken Arm</li>
      <li>Debridement of Bone</li>
      <li>Femur Fracture</li>
    </ul>
    <ul>
      <li>Hip Fracture</li>
      <li>Internal Derangement of Knee</li>
      <li>Partial or Complete Resection of Bone</li>
      <li>Resection or Ablation of Bone Tumor</li>
      <li>Ulnar Nerve Transposition</li>
    </ul>
    `,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/33691769_xxl.jpg",
      title: "ORTHOPEDIC SURGERY",
      contentTop:
        "Orthopedic surgeons diagnose and treat conditions of the human body, focusing on injuries and diseases of the body's musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active. They often treat sports injuries, degenerative diseases, tumors, infections and birth defects.",
      slope: true,
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Tyler Roberts, MD",
      content:
        "Tyler Roberts, MD is an Orthopedic Surgeon in Houston, TX. He works at Advanced Orthopaedics & Sports Medicine of Houston in Houston, TX with other offices in Cypress, TX. He has worked on more claims relating to Joint Pain and Osteoarthritis of Hip than other providers in the area."
    },
  
    cardioThoracicDetailData: {
      title:"ORTHOPEDIC SURGERY",
      contentTop:"Orthopedic Surgery focuses on treatments and repairs of the musculoskeletal system; joints, bones, ligaments, tendons and more. These surgeries can range from minimally invasive procedures to amputation. In America, our surgeons are highly trained and certified in this field and people come all over the world to receive care here. They operate with an entire team to ensure the safety of each patient and use tedious measures to make sure all surgeries are successful.",
      slope: true,
      intoImgData: "/images/providers/46444454_ortho.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_47.png",
      title: "ORTHOPEDIC SURGERY",
      mdcontent:
        "Tyler Roberts, MD is an Orthopedic Surgeon in Houston, TX. He works at Advanced Orthopaedics & Sports Medicine of Houston in Houston, TX with other offices in Cypress, TX. He has worked on more claims relating to Joint Pain and Osteoarthritis of Hip than other providers in the area.",
      mdname: "Tyler Roberts, MD"
    },
  
    id: "Tyler Roberts, MD",
    name: "Tyler Roberts, MD",
    image: "/images/doctors/md_41.jpg",
    phone: "281-955-2650",
    gender: "Male",
    language: "English, Spanish",
  
    specialty: "Orthopedic Surgery",
  
    degrees: [
      "Doctor of Medicine"
    ],
  
    clinics: [
      {
        name: "Advanced Orthopaedics & Sports Medicine of Houston",
        address: "10425 Huffmeister Rd Ste 320, Houston, TX 77065",
      },
      {
        name: "Advanced Orthopaedics & Sports Medicine",
        address: "22485 Tomball Pkwy Ste 2100, Houston, TX 77070",
      },
      {
        name: "Advanced Orthopaedics & Sports Medicine",
        address: "9645 Barker Cypress Rd Ste 110, Cypress, TX 77433",
      },
    ],
  
    bio_name: "About Dr. Tyler Roberts",
    bio: `
    Dr. Roberts is a board-certified Orthopedic Surgeon specializing in adult hip and knee reconstruction. After graduating from medical school at Texas A&M Health Science Center, Dr. Roberts completed his residency training at John Peter Smith Hospital in Fort Worth, TX. He completed his fellowship training in Adult Reconstruction at Loma Linda University Medical Center, where he then served on the faculty for two years until returning back to Texas.</br>
Dr. Roberts' clinical practice includes fracture care, partial knee replacement, total knee replacement, total hip replacement and revision of total hip and knee replacements. He is well trained in muscle preserving and minimally invasive surgical techniques, including the anterior approach, which promotes faster healing and improved outcomes. His comprehensive patient care approach includes both non-operative and operative approaches tailored to the needs of each individual patient.
    `,
    education: [
      "Medical Degree from Texas A&M Health Science Center",
      "Fellowship (Adult Reconstruction) at Loma Linda University Medical Center",
      "Residency at John Peter Smith Hospital",
      "Internship at John Peter Smith Hospital"
    ],
  
    areasOfExpertise: `
    <ul>
  <li>Avascular Necrosis</li>
  <li>Hip Replacement</li>
  <li>Joint Pain</li>
  <li>Knee Fracture and Dislocations</li>
  </ul>
  <ul>
  <li>Knee Replacement</li>
  <li>Osteoarthritis of Hip &amp; Knee</li>
  <li>Peripheral &amp; Somatic Nerve Block</li>
  <li>Tendon &amp; Ligament Injury</li>
</ul>
    `,
  
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/33691769_xxl.jpg",
      title: "ORTHOPEDIC SURGERY",
      contentTop:"Orthopedic surgeons diagnose and treat conditions of the human body, focusing on injuries and diseases of the body's musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active. They often treat sports injuries, degenerative diseases, tumors, infections and birth defects. ",
      slope: true
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Matthew D. Weldon, MD",
      content:
        "Matthew Weldon, MD is based in Houston, TX with Texas Bone & Joint as a board-certified Orthopedic Surgeon.  He has extensive experience in Shoulder & Upper Arm Surgery."
    },
  
    cardioThoracicDetailData: {
      title:"ORTHOPEDIC SURGERY",
      contentTop:"Orthopedic Surgery focuses on treatments and repairs of the musculoskeletal system; joints, bones, ligaments, tendons and more. These surgeries can range from minimally invasive procedures to amputation. In America, our surgeons are highly trained and certified in this field and people come all over the world to receive care here. They operate with an entire team to ensure the safety of each patient and use tedious measures to make sure all surgeries are successful.",
      slope: true,
      intoImgData: "/images/providers/46444454_ortho.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_48.png",
      title: "ORTHOPEDIC SURGERY",
      mdcontent:
        "Matthew Weldon, MD is based in Houston, TX with Texas Bone & Joint as a board-certified Orthopedic Surgeon.  He has extensive experience in Shoulder & Upper Arm Surgery.",
      mdname: "Matthew D. Weldon, MD"
    },
  
    id: "Matthew D. Weldon, MD",
    name: "Matthew D. Weldon, MD",
    image: "/images/doctors/md_41.jpg",
    phone: "281-836-9020",
    gender: "Male",
    language: "English",
  
    specialty: "Orthopedic Surgery, Sports Medicine, Pediatric Orthopaedic Surgery, Pediatric Sports Medicine",
  
    degrees: [
      "Doctor of Medicine"
    ],
  
    clinics: [
      {
        name: "Texas Bone and Joint - Houston",
        address: "1200 Binz St Ste 580, Houston, TX 770045",
      },
      {
        name: "Texas Bone and Joint - West Houston",
        address: "12606 West Houston Center Blvd Ste 350, Houston, TX 77082",
      },
    ],
  
    bio_name: "About Dr. Matthew D. Weldon",
    bio: `
    Dr. Weldon specializes in sports medicine with an emphasis on arthroscopic and minimally invasive surgery of the shoulder, elbow, knee and ankle. He has expertise in the latest and most advanced techniques for minimally invasive surgery and reconstructive treatments, as well as nonsurgical management and rehabilitation.</br>
Dr. Weldon has a special interest in joint preservation, focusing on limb alignment and correction. Additionally, he also performs joint replacement, encompassing the entire spectrum of joint disease. Dr. Weldon was previously an assistant professor at McGovern Medical School at The University of Texas Health Science Center at Houston (UTHealth).</br>
He received his undergraduate degree from Trinity University in San Antonio, Texas where he was an All-Conference football player and graduated with a Bachelor of Science in Biology, as well as a Bachelor of Science in Economics and a Bachelor of Arts in Business Administration. He completed medical school at Ross University, graduating Summa Cum Laude. After completing an internship in general surgery at Methodist Hospital in Dallas, Texas, Dr. Weldon then completed his orthopedic surgery residency at UTHealth. Upon completion of training, he went on to complete an additional fellowship year of specialty training in orthopedic sports medicine at UTHealth where he was selected as the administrative fellow. Dr. Weldon is a member of the American Academy of Orthopedic Surgeons and the American Orthopedic Society for Sports Medicine.
He has extensive hands-on experience in sports medicine treating high school, collegiate, professional and recreational athletes. He has worked with the Houston Dash, Houston Texans, Houston Rockets, Houston Astros, Houston Dynamo and the athletic teams at the University of Houston. Dr. Weldon was previously the team physician for North Shore High School in Houston and both Bridgeland and Cypress Ranch High Schools in Cypress, Texas, and he participates in the care of many athletes at other local high schools as well.
    `,
    education: [
      "Medical Degree from Ross University School of Medicine",
      "Bachelor of Science Degree (Biology) from Trinity University",
      "Fellowship at UTHealth Science Center at Houston",
      "Residency at UTHealth Science Center at Houston",
      "Residency at Methodist Health System Dallas",
      "Sports Medicine Training at Memorial Hermann- Texas Medical Center"
    ],
  
    areasOfExpertise: `
    <ul>
    <li>ACL reconstruction surgery</li>
    <li>Degenerative Disc Disease</li>
    <li>Fractures (Femur, Fibular, Pelvic, Hip, Ankles)</li>
    <li>Osteoarthritis</li>
    <li>Pediatric Orthopedic Surgery</li>
    </ul>
    <ul>
    <li>Robotic Knee Replacement</li>
    <li>Rotator Cuff Repair Surgery</li>
    <li>Sports Hernia</li>
    <li>Sports Medicine Treatment</li>
    <li>Traumatic Foot and Ankle Injuries</li>
  </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/33691769_xxl.jpg",
      title: "ORTHOPEDIC SURGERY",
      contentTop:"Orthopedic surgeons diagnose and treat conditions of the human body, focusing on injuries and diseases of the body's musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active. They often treat sports injuries, degenerative diseases, tumors, infections and birth defects. ",
      slope: true
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Craig A. Winkler, MD",
      content:
        "Matthew Weldon, MD is based in Houston, TX with Texas Bone & Joint as a board-certified Orthopedic Surgeon.  He has extensive experience in Shoulder & Upper Arm Surgery."
    },
  
    cardioThoracicDetailData: {
      title:"ORTHOPEDIC SURGERY",
      contentTop:"Orthopedic Surgery focuses on treatments and repairs of the musculoskeletal system; joints, bones, ligaments, tendons and more. These surgeries can range from minimally invasive procedures to amputation. In America, our surgeons are highly trained and certified in this field and people come all over the world to receive care here. They operate with an entire team to ensure the safety of each patient and use tedious measures to make sure all surgeries are successful.",
      slope: true,
       intoImgData: "/images/providers/46444454_ortho.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/md_49.png",
      title: "ORTHOPEDIC SURGERY",
      mdcontent:
        "Craig Winkler, MD is board certified Orthopedic Surgeon in the Tomball, TX.  He graduated from Texas Technical University and is affiliated with the Texas Orthopaedic & Sports Medicine.  He has worked on more claims relating to Joint Pain, Knee Sprain and Medial Collateral Ligament (MCL) Sprain than other providers in the area.",
      mdname: "Craig A. Winkler, MD"
    },
  
    id: "Craig A. Winkler, MD",
    name: "Craig A. Winkler, MD",
    image: "/images/doctors/md_41.jpg",
    phone: "281-351-7261",
    gender: "Male",
    language: "English",
  
    specialty: "Orthopaedic Surgery, Orthopedics and Sports Medicine",
  
    degrees: [
      "Doctor of Medicine"
    ],
  
    clinics: [
      {
        name: "Texas Orthopaedic & Sports Medicine - Tomball",
        address: "13603 Michel Rd., Houston, TX 77375",
      },
      {
        name: "Texas Orthopaedic & Sports Medicine - Woodlands",
        address: "9319 Pinecroft Dr., Suite 200, The Woodlands, TX 77380",
      },
    ],
  
    bio_name: "About Dr. Craig A. Winkler",
    bio: `
    Dr. Winkler’s goal as an orthopaedic surgeon is to make each patient and their family members feel that they are part of the decision-making team. He takes time to explain every treatment option and relies heavily on patient and family member input to select the best treatment plan.</br>
Dr. Winkler is among the few surgeons in North Houston performing outpatient hip and knee replacement. Additionally, he practices innovative regenerative medicine, using stem cells to treat arthritis, cartilage damage and chronic tendonitis.
    `,
    education: [
      "Medical Degree from Texas Tech University Health Science Center",
"Residency (Orthopedic Surgery) at Texas Tech University Health Sciences Center",
"Fellowship (Adult Reconstruction) at Mississippi Sports Medicine and Orthopedic Surgery"
    ],
  
    areasOfExpertise: `
    <ul>
    <li>Direct Anterior / Posterior Total Hip Replacement</li>
    <li>Femur, Tibia, and Ankle Fractures</li>
    <li>Humerus, Forearm, and Wrist Fractures</li>
    <li>Knee Replacement (Partial or Total)</li>
    </ul>
    <ul>
    <li>Revision Total Hip</li>
    <li>Revision Total Knee</li>
    <li>Total Joint Replacement</li>
  </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      link:"https://www.youtube.com/watch?v=SECBJjSYofc",
      title: "ORTHOPEDIC SURGERY",
      contentTop:"Orthopedic surgeons diagnose and treat conditions of the human body, focusing on injuries and diseases of the body's musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active. They often treat sports injuries, degenerative diseases, tumors, infections and birth defects. ",
      slope: true
    },
  },
  // new surgeons
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Alexander Nguyen, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },

    cardioThoracicDetailData: {
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic Surgery focuses on treatments and repairs of the musculoskeletal system; joints, bones, ligaments, tendons and more. These surgeries can range from minimally invasive procedures to amputation. In America, our surgeons are highly trained and certified in this field and people come all over the world to receive care here. They operate with an entire team to ensure the safety of each patient and use tedious measures to make sure all surgeries are successful.",
      slope: true,
      intoImgData: "/images/providers/46444454_ortho.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Orth-Nguyen.jpg",
      title: "ORTHOPEDIC SURGEON",
      mdcontent:
        "Alexander Nguyen, MD specializes in the treatment of sports-related injuries and advanced arthroscopic procedures. He also provides treatment for general orthopaedic conditions and trauma.",
      mdname: "ALEXANDER NGUYEN, MD"
    },

    id: "alexander-nguyen-md",
    name: "Alexander Nguyen, MD",
    image: "/images/physianDirectory/O-Nguyen.jpg",
    phone: "281-351-7261",
    gender: "Male",
    language: "English, Vietnamese, Spanish",
    specialty: "Orthopedic Surgery, Orthopedics and Sports Medicine",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Texas Orthopaedic & Sports Medicine - Woodlands",
        address: "9319 Pinecroft Dr., Ste 200, The Woodlands, TX 77380",
        phone: "(281) 351-7261"
      },
      {
        name: "Texas Orthopaedic & Sports Medicine - Tomball",
        address: "13603 Michel Road, Tomball, TX 77375",
        phone: "(281) 351-7261"
      }
    ],

    bio_name: "About Dr. Alexander Nguyen",
    bio: `Dr. Nguyen is a proud native Texan who grew up locally in The Woodlands. He has authored various articles and presented at national conferences in the field of orthopaedics. During his fellowship at the acclaimed Lenox Hill Hospital, he helped care for the New York Jets, New York Islanders, Manhattanville College and local high schools. There he received specialty training in minimally invasive and advanced arthroscopic techniques for the treatment of sports-related shoulder, elbow, hip, knee and ankle injuries.</br></br>
As an avid marathon runner and outdoor enthusiast, Dr. Nguyen understands the importance of getting patients back to their active pursuits. He uses a collaborative approach to develop personalized treatment plans that help patients return to their athletic lifestyles.`,

    education: [
      "Medical Degree from Baylor College of Medicine",
      "Undergraduate Degree from University of Texas",
      "Residency (Orthopedics) at UT Health-San Antonio",
      "Fellowship (Sports Medicine & Arthroscopic Surgery) at Lenox Hill Hospital- New York"
    ],

    areasOfExpertise: `<ul>
      <li>ACL Reconstruction</li>
      <li>Arthroscopic Surgery of the shoulder, elbow, hip, knee and ankle</li>
      <li>Carpal Tunnel Syndrome</li>
      <li>Cartilage Repair/transplant</li>
      <li>Joint Replacement – shoulder, hip and knee</li>
    </ul>
    <ul>
      <li>Knee Ligament Reconstruction</li>
      <li>Meniscus Tears/ Transplant</li>
      <li>Quadriceps Tendon Rupture</li>
      <li>Total shoulder replacement</li>
      <li>Tendinopathy</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/33691769_xxl.jpg",
      // link: "https://youtu.be/HJIL4fyKgQ4",
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons diagnose and treat conditions of the human body, focusing on injuries and diseases of the body's musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active. They often treat sports injuries, degenerative diseases, tumors, infections and birth defects.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Anthony P. Gualtieri, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },

    cardioThoracicDetailData: {
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic Surgery focuses on treatments and repairs of the musculoskeletal system; joints, bones, ligaments, tendons and more. These surgeries can range from minimally invasive procedures to amputation. In America, our surgeons are highly trained and certified in this field and people come all over the world to receive care here. They operate with an entire team to ensure the safety of each patient and use tedious measures to make sure all surgeries are successful.",
      slope: true,
      intoImgData: "/images/providers/46444454_ortho.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Orth-Gualtieri.webp",
      title: "ORTHOPEDIC SURGEON",
      mdcontent:
        "Anthony Gualtieri, MD is a fellowship-trained Orthopedic Surgeon specializing in total joint replacements of the hip and knee, revision total joint replacement surgery, minimally invasive surgery, and fracture care. He has trained and practiced extensively with all of the most recent technologies being utilized in hip and knee replacement surgery.",
      mdname: "ANTHONY P. GUALTIERI, MD"
    },

    id: "anthony-gualtieri-md",
    name: "Anthony P. Gualtieri, MD",
    image: "/images/physianDirectory/O-Gualtieri.jpg",
    phone: "346-571-7500",
    gender: "Male",
    language: "English",
    specialty: "Orthopedic Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "INOV8 Orthopedics",
        address: "10496 Katy Fwy, Ste 101, Houston, TX 77043",
        phone: "(346) 571-7500"
      }
    ],

    bio_name: "About Dr. Anthony P. Gualtieri",
    bio: `A native of Chapel Hill, N.C., Dr. Gualtieri received his Bachelor of Science from Bucknell University before graduating with honors from Medical School at Columbia University College of Physicians & Surgeons in New York City. Dr. Gualtieri did his internship and residency at the New York University School of Medicine Langone Orthopedic Hospital for Joint Diseases. He then completed fellowship training in adult reconstruction orthopedic surgery at New England Baptist Hospital in Boston. While practicing on Massachusetts' North Shore, he was one of the first orthopedic surgeons in the area to perform Direct Anterior Total Hip Replacement and to use the MAKO Robotics Platform to assist in revision total knee replacement surgery.</br></br>
Dr. Gualtieri specializes in total joint replacements of the hip and knee as well as revision total joint replacement surgery, minimally invasive surgery and fracture care. By leveraging the newest technologies with the most minimally invasive surgical techniques, he helps his patients to recover faster and stronger from surgery.</br></br>
Dr. Gualtieri moved to Houston in 2024 with his wife, who is a Gynecologic Oncology surgeon. They are looking forward to milder winters in their new home.`,

    education: [
      "Medical Degree from Medical School at Columbia University Vagelos College of Physicians and Surgeons",
      "Bachelor of Science Degree from Bucknell University",
      "Residency (Orthopaedic Surgery) at the NYU Grossman School of Medicine/NYU Langone Orthopedic Hospital",
      "Fellowship (Hip & Knee Reconstructive Surgery) at New England Baptist Hospital"
    ],

    areasOfExpertise: `<ul>
      <li>Femur Fracture</li>
      <li>Hip & Pelvic Fractures</li>
      <li>Hip Replacement</li>
      <li>Joint Pains</li>
      <li>Muscle Pain, Fibromyalgia, and Limb Pain</li>
    </ul>
    <ul>
      <li>Osteoarthritis of Hip</li>
      <li>Osteoarthritis of Knee</li>
      <li>Steroid Injection</li>
      <li>Tendon and Ligament Injury</li>
      <li>Tibial Fracture</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/33691769_xxl.jpg",
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons diagnose and treat conditions of the human body, focusing on injuries and diseases of the body's musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active. They often treat sports injuries, degenerative diseases, tumors, infections and birth defects.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Barkha Chhabra, MD, MPH",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },

    cardioThoracicDetailData: {
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic Surgery focuses on treatments and repairs of the musculoskeletal system; joints, bones, ligaments, tendons and more. These surgeries can range from minimally invasive procedures to amputation. In America, our surgeons are highly trained and certified in this field and people come all over the world to receive care here. They operate with an entire team to ensure the safety of each patient and use tedious measures to make sure all surgeries are successful.",
      slope: true,
      intoImgData: "/images/providers/46444454_ortho.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Orth-Chhabra.jpg",
      title: "ORTHOPEDIC SURGEON",
      mdcontent:
        "Barkha Chhabra, MD is a fellowship trained Orthopaedic surgeon with expertise in Pediatric Orthopaedic Surgery. Her clinical interests include the treatment of Scoliosis and Spinal Deformities, as well as a broad range of pediatric orthopaedic conditions including clubfeet, congenital hip and foot problems, and the orthopedic treatment of Cerebral Palsy.",
      mdname: "BARKHA CHHABRA, MD, MPH"
    },

    id: "barkha-chhabra-md",
    name: "Barkha Chhabra, MD, MPH",
    image: "/images/physianDirectory/O-Chhabra.jpg",
    phone: "281-985-9342",
    gender: "Female",
    language: "English, Hindi, Punjabi",
    specialty: "Pediatric Orthopaedic Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Pediatric Orthopedic Clear Lake",
        address: "600 North Kobayashi, Suite 208, Webster, TX 77598",
        phone: "(281) 985-9342"
      }
    ],

    bio_name: "About Dr. Barkha Chhabra",
    bio: `Dr. Chhabra was born in Elyria, Ohio, while her father was in his Orthopedic Surgery training. She grew up in Southern California and attended Johns Hopkins University where she graduated Phi Beta Kappa. She was awarded a Fulbright Scholarship and spent a year in Mumbai, India working with HIV/AIDS widows.</br></br>
After earning a Master's in Public Health from Johns Hopkins University and a medical degree from UCLA School of Medicine, Dr. Chhabra completed her Orthopaedic surgery residency at UTMB. During her residency, she earned the Resident Research award, Golden Bone Excellence in Teaching and Open Growth Plate Excellence in Pediatric Orthopaedic Surgery awards two years in a row. She has completed 10 surgical mission trips around the world, including Mexico, India, Guatemala, Ecuador and Haiti.</br></br>
Dr. Chhabra then completed her Pediatric Orthopaedic Surgery fellowship at the prestigious Baylor College of Medicine, training with leaders within the field at Texas Children's Hospital and Shriners Hospitals for Children Houston.`,

    education: [
      "Medical Degree from UCLA School of Medicine",
      "Master's in Public Health from Johns Hopkins University",
      "Residency (Orthopaedic Surgery) at University of Texas Medical Branch",
      "Fellowship (Orthopaedic & Pediatric Surgery) Baylor College of Medicine"
    ],

    areasOfExpertise: `<ul>
      <li>Ankle Joint Stabilization</li>
      <li>Ankle Sprain</li>
      <li>Arthroscopy- Ankle/Heel Procedures</li>
      <li>Bone Repair/Revision - Foot, Tibia/Fibula</li>
      <li>Bone and Joint Diseases</li>
    </ul>
    <ul>
      <li>Cerebral Palsy</li>
      <li>Congenital Conditions/ Deformities</li>
      <li>Dislocated Hip, Leg, Foot</li>
      <li>Dislocated Shoulder, Arm, Wrist, Hand</li>
      <li>Scoliosis and other Postural Dorsopathic Deformities</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=-bjMMSmmYqM",
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons diagnose and treat conditions of the human body, focusing on injuries and diseases of the body's musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active. They often treat sports injuries, degenerative diseases, tumors, infections and birth defects.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Caleb Jones, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },

    cardioThoracicDetailData: {
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic Surgery focuses on treatments and repairs of the musculoskeletal system; joints, bones, ligaments, tendons and more. These surgeries can range from minimally invasive procedures to amputation. In America, our surgeons are highly trained and certified in this field and people come all over the world to receive care here. They operate with an entire team to ensure the safety of each patient and use tedious measures to make sure all surgeries are successful.",
      slope: true,
      intoImgData: "/images/providers/46444454_ortho.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Orth-Jones.webp",
      title: "ORTHOPEDIC SURGEON",
      mdcontent:
        "Caleb Jones, MD is a highly skilled Orthopedic Surgeon with fellowship training in Shoulder & Elbow surgery serving the Houston/Clear Lake area. With years of experience and a dedication to excellence, Dr. Caleb Jones is committed to providing top-quality care for his patients.",
      mdname: "CALEB JONES, MD"
    },

    id: "caleb-jones-md",
    name: "Caleb Jones, MD",
    image: "/images/physianDirectory/O-Jones.jpg",
    phone: "281-335-1111",
    gender: "Male",
    language: "English",
    specialty: "Orthopedic Surgery, Elbow Surgery, Hand Surgery, Shoulder Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "All American Orthopedics & Sports Medicine- Clear Lake Main Campus",
        address: "1045 Gemini Ste 100, Houston, TX 77058",
        phone: "(281) 335-1111"
      }
    ],

    bio_name: "About Dr. Caleb Jones",
    bio: `Dr. Jones, MD is a highly skilled Orthopedic Surgeon in the Houston/Clear Lake area. Originally from Tyler, TX., Dr. Jones attended the University of Texas at Austin where he completed an undergraduate Bachelor of Science degree in Neurobiology. He then went to University of Texas Health Science Center Medical School in San Antonio where he served as president of his class.</br></br>
Dr. Jones went on to complete his residency training at the world-renowned Campbell Clinic in Memphis, TN. Following residency, Dr. Jones completed a Shoulder & Elbow surgery fellowship at the Florida Orthopaedic Institute in Tampa, FL. During fellowship, he performed a variety of shoulder and elbow replacements (including many revision surgeries), shoulder scopes, and fracture repairs.</br></br>
Dr. Jones has multiple publications in peer-reviewed journals, most related to shoulder arthroplasty. His areas of expertise include upper extremity fractures/trauma, arthroscopy, and reconstruction of the shoulder and elbow.`,

    education: [
      "Medical Degree from University of Texas Health Science Center Medical School at San Antonio",
      "Bachelor of Science Degree (Neurobiology) from University of Texas at Austin",
      "Residency (Orthopaedic Surgery) at University of Tennessee- Campbell Clinic",
      "Fellowship (Shoulder & Elbow Surgery) at Florida Orthopaedic Institute"
    ],

    areasOfExpertise: `<ul>
      <li>Carpal Tunnel Release</li>
      <li>Cubital Tunnel Decompression</li>
      <li>Distal Radius Fractures</li>
      <li>Elbow Arthroscopy</li>
      <li>Ganglion Cyst Excision</li>
    </ul>
    <ul>
      <li>Hand/Finger Fractures</li>
      <li>Rotator Cuff Repair</li>
      <li>Shoulder Fractures</li>
      <li>Shoulder Replacement</li>
      <li>Total Elbow Replacement</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/33691769_xxl.jpg",
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons diagnose and treat conditions of the human body, focusing on injuries and diseases of the body's musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active. They often treat sports injuries, degenerative diseases, tumors, infections and birth defects.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Connor Armstrong, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },

    cardioThoracicDetailData: {
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic Surgery focuses on treatments and repairs of the musculoskeletal system; joints, bones, ligaments, tendons and more. These surgeries can range from minimally invasive procedures to amputation. In America, our surgeons are highly trained and certified in this field and people come all over the world to receive care here. They operate with an entire team to ensure the safety of each patient and use tedious measures to make sure all surgeries are successful.",
      slope: true,
      intoImgData: "/images/providers/46444454_ortho.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Orth-Armstrong.webp",
      title: "ORTHOPEDIC SURGEON",
      mdcontent:
        "Connor Armstrong, MD is a fellowship-trained orthopaedic surgeon in adult hip and knee reconstructive surgery, focusing on the most up-to-date surgical and non-surgical options for osteoarthritis, post-traumatic arthritis, rheumatoid arthritis, and lower extremity deformity around the hip and knee.",
      mdname: "CONNOR ARMSTRONG, MD"
    },

    id: "connor-armstrong-md",
    name: "Connor Armstrong, MD",
    image: "/images/physianDirectory/O-Armstrong.jpg",
    phone: "361-854-0811",
    gender: "Male",
    language: "English",
    specialty: "Hip & Knee Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "South Texas Bone & Joint",
        address: "5917 Crosstown Expressway SH 286, Corpus Christi, TX 78417",
        phone: "(361) 854-0811"
      },
      {
        name: "South Texas Bone & Joint - Bay Area",
        address: "7121 S Padre Island Dr, Ste 306, Corpus Christi, TX 78412"
      }
    ],

    bio_name: "About Dr. Connor Armstrong",
    bio: `Dr. Armstrong, MD is a fellowship-trained orthopaedic surgeon in adult hip and knee reconstructive surgery. He specializes in knee arthroplasty, including partial and total knee replacement using standard and minimally invasive approaches, as well as complex revision knee replacement. He also has a passion for computer-assisted navigation and robotic knee replacement. He specializes in hip replacement utilizing the direct anterior approach, a muscle-sparing and minimally invasive technique allowing for more rapid recovery.</br></br>
Dr Armstrong was born and raised in the great state of Texas. He received his Chemical Engineering degree from Texas A&M University. He went on to earn his medical degree from the Long School of Medicine at the University of Texas Health Science Center in San Antonio. Dr Armstrong was fortunate enough to stay at UT Health San Antonio to complete his residency in Orthopaedic Surgery. He completed his Adult Reconstruction Fellowship at Emory Healthcare in Atlanta, Georgia, a high-volume primary and revision hip and knee replacement center.</br></br>
Outside of work, Dr Armstrong is a dedicated family man and enjoys spending time with his wife, Julia, an OB-GYN in Corpus Christi, and their children.`,

    education: [
      "Medical Degree from University of Texas Health San Antonio Long School of Medicine",
      "Bachelor of Science (Chemical Engineering) from Texas A&M University",
      "Residency (Orthopaedic Surgery) at University of Texas Health San Antonio",
      "Fellowship (Adult reconstruction / Joint replacement) at Emory Healthcare"
    ],

    areasOfExpertise: `<ul>
      <li>Femur Fracture</li>
      <li>Gluteus Medius Repair</li>
      <li>Hip Abductor Tears</li>
      <li>Hip Fracture</li>
      <li>Hip Replacement</li>
    </ul>
    <ul>
      <li>Knee Replacement</li>
      <li>Limb Pain</li>
      <li>Miner's Knee</li>
      <li>Osteoarthritis</li>
      <li>Patellar/Quadriceps Tendon Repairs</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=0bkjq8b3D0w",
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons diagnose and treat conditions of the human body, focusing on injuries and diseases of the body's musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active. They often treat sports injuries, degenerative diseases, tumors, infections and birth defects.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Dhvanil K. Thakor, DPM",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },

    cardioThoracicDetailData: {
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic Surgery focuses on treatments and repairs of the musculoskeletal system; joints, bones, ligaments, tendons and more. These surgeries can range from minimally invasive procedures to amputation. In America, our surgeons are highly trained and certified in this field and people come all over the world to receive care here. They operate with an entire team to ensure the safety of each patient and use tedious measures to make sure all surgeries are successful.",
      slope: true,
      intoImgData: "/images/providers/46444454_ortho.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Orth-Thakor.png",
      title: "PODIATRIST",
      mdcontent:
        "Dhvanil Thakor, DPM works in Pearland, TX as a Podiatry Specialist. He's well trained medically and surgically to treat any disorders of the foot and ankle. His philosophy is to exhaust all avenues of conservative therapy before considering surgery.",
      mdname: "DHVANIL K. THAKOR, DPM"
    },

    id: "dhvanil-thakor-dpm",
    name: "Dhvanil K. Thakor, DPM",
    image: "/images/physianDirectory/O-Thakor.jpg",
    phone: "281-901-1133",
    gender: "Male",
    language: "English",
    specialty: "Podiatry, Foot & Ankle Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Foot & Ankle Doctors PLLC",
        address: "3129 Kingsley Drive, Ste 640, Pearland, TX 77584",
        phone: "(281) 901-1133"
      },
      {
        name: "Foot & Ankle Doctors PLLC",
        address: "3326 Watters Rd, Bldg C, Pasadena, TX 77504"
      }
    ],

    bio_name: "About Dr. Dhvanil K. Thakor",
    bio: `Dr. Thakor, a native from Dallas, Texas, earned a dual Bachelors degree in Biology and Chemistry from Austin College in Sherman, Texas.</br></br>
He received his medical degree from the California School of Podiatric Medicine at Samuel Merritt University. He then went on to pursue an extensive three-year foot and ankle clinical and surgical residency at West Houston Medical Center, where he was part of the research committee and enjoyed teaching his junior residents. During his residency, he worked closely with over 70 renowned foot and ankle clinicians and surgeons and performed over 1,000 foot and ankle cases. He is currently a certified provider for the FDA approved Scandinavian Total Ankle Replacement (STAR) procedure.</br></br>
Dr. Thakor is an avid Houston Rockets fan and during his spare time, he enjoys running, hiking, biking, sketching and photography.`,

    education: [
      "Medical Degree from California School of Podiatric Medicine, Samuel Merritt University",
      "Bachelors Degree (Biology & Chemistry) from Austin College",
      "Residency (Foot & Ankle Surgery) at HCA Houston Healthcare-West"
    ],

    areasOfExpertise: `<ul>
      <li>Arthritis of the foot and ankle</li>
      <li>Bunions</li>
      <li>Complex limb deformities and limb salvage</li>
      <li>Diabetic Charcot Reconstruction</li>
      <li>Flatfoot/High Arch Reconstruction</li>
    </ul>
    <ul>
      <li>Hammertoes</li>
      <li>Heel pain</li>
      <li>Ingrown toenails</li>
      <li>Nail fungus</li>
      <li>Sport Injuries/ Trauma</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/33691769_xxl.jpg",
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons diagnose and treat conditions of the human body, focusing on injuries and diseases of the body's musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active. They often treat sports injuries, degenerative diseases, tumors, infections and birth defects.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Eugene F. Stautberg III, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },

    cardioThoracicDetailData: {
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic Surgery focuses on treatments and repairs of the musculoskeletal system; joints, bones, ligaments, tendons and more. These surgeries can range from minimally invasive procedures to amputation. In America, our surgeons are highly trained and certified in this field and people come all over the world to receive care here. They operate with an entire team to ensure the safety of each patient and use tedious measures to make sure all surgeries are successful.",
      slope: true,
      intoImgData: "/images/providers/46444454_ortho.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Orth-Stautberg.jpg",
      title: "FOOT & ANKLE SURGEON",
      mdcontent:
        "Eugene F. Stautberg III, MD is board-certified and specializes in Orthopedic Surgery. He is fellowship trained in advanced foot and ankle surgery.",
      mdname: "EUGENE F. STAUTBERG III, MD"
    },

    id: "eugene-stautberg-md",
    name: "Eugene F. Stautberg III, MD",
    image: "/images/physianDirectory/O-Stautberg.jpg",
    phone: "281-977-4870",
    gender: "Male",
    language: "English, Spanish",
    specialty: "Orthopedic Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Southwest Orthopedic Group- Pearland",
        address: "10970 Shadow Creek Parkway, Suite 130, Pearland, TX 77584",
        phone: "(281) 977-4870"
      },
      {
        name: "Southwest Orthopedic Group- Houston",
        address: "6560 Fannin Street, Suite 1016, Houston, TX 77030"
      },
      {
        name: "Southwest Orthopedic Group- Sugar Land",
        address: "1350 Creekway Drive, Sugar Land, TX 77478"
      },
      {
        name: "Southwest Orthopedic Group- Baytown",
        address: "3711 Garth Road, Suite E, Baytown, TX 77521"
      }
    ],

    bio_name: "About Dr. Eugene F. Stautberg III",
    bio: `Dr. Stautberg, a native Houstonian, enjoys serving the community near his hometown in Pearland, TX. He is a graduate of The University of Texas at Austin, where he obtained a Bachelor of Science in chemical engineering. He graduated from The University of Texas Medical School at Houston, now known as McGovern Medical School.</br></br>
He completed his orthopedic surgery residency at The University of Texas Medical Branch in Galveston, Texas, where he received numerous awards including the 'Orthopedic In-Training Master Award', the 'Resident Excellence in Research' award, and the 'Golden Bone Award'. After residency, Dr. Stautberg completed a foot and ankle fellowship at Washington University in St. Louis under Dr. Jeffrey Johnson, a former president of the American Orthopedic Foot and Ankle Society.</br></br>
Dr. Stautberg sits on the Board of Directors of the Texas Orthopedic Association and is a member of the American Orthopedic Foot and Ankle Society (AOFAS) and the American Academy of Orthopedic Surgeons (AAOS).`,

    education: [
      "Medical Degree at University Of Texas Health Sciences Center At Houston McGovern Medical School",
      "Internship at University Of Texas Medical Branch",
      "Residency at University Of Texas Medical Branch- Galveston",
      "Fellowship at Washington University School of Medicine- St. Louis"
    ],

    areasOfExpertise: `<ul>
      <li>Achilles Tendon</li>
      <li>Ankle Sprains</li>
      <li>Arthritis</li>
      <li>Bunions</li>
      <li>Bursitis</li>
      <li>Fractures (Ankle, Foot, Femur)</li>
    </ul>
    <ul>
      <li>Gout</li>
      <li>Knee Arthroscopy</li>
      <li>Knee Pain</li>
      <li>Plantar Fasciitis</li>
      <li>Tarsal Tunnel Syndrome</li>
      <li>Tendonitis</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/33691769_xxl.jpg",
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons diagnose and treat conditions of the human body, focusing on injuries and diseases of the body's musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active. They often treat sports injuries, degenerative diseases, tumors, infections and birth defects.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "James M. Saucedo, MD, MBA",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },

    cardioThoracicDetailData: {
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic Surgery focuses on treatments and repairs of the musculoskeletal system; joints, bones, ligaments, tendons and more. These surgeries can range from minimally invasive procedures to amputation. In America, our surgeons are highly trained and certified in this field and people come all over the world to receive care here. They operate with an entire team to ensure the safety of each patient and use tedious measures to make sure all surgeries are successful.",
      slope: true,
      intoImgData: "/images/providers/46444454_ortho.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Orth-Saucedo.jpg",
      title: "ORTHOPEDIC SURGEON",
      mdcontent:
        "James M. Saucedo, MD is a board-certified and fellowship-trained orthopedic surgeon caring for patients with hand and upper extremity injuries and disorders. He emphasizes patient-centered care and clear communication.",
      mdname: "JAMES M. SAUCEDO, MD, MBA"
    },

    id: "james-saucedo-md",
    name: "James M. Saucedo, MD, MBA",
    image: "/images/physianDirectory/O-Saucedo.jpg",
    phone: "713-486-8800",
    gender: "Male",
    language: "English",
    specialty: "Orthopaedic Surgery, Hand Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "UT Physicians Orthopedics at Memorial Hermann | Rockets Sports Medicine Institute – The Woodlands",
        address: "9305 Pinecroft Dr, Ste 400, The Woodlands, TX 77380-3482",
        phone: "(713) 486-8800"
      },
      {
        name: "UT Physicians Orthopedics at Memorial Hermann | Rockets Sports Medicine Institute – Texas Medical Center",
        address: "6400 Fannin St, Ste 1700, Houston, TX 77030-1526",
        phone: "(713) 486-7500"
      }
    ],

    bio_name: "About Dr. James M. Saucedo",
    bio: `Dr. Saucedo grew up near Houston in Rosenberg, Texas. He received his Master of Business Administration degree from the Jesse H. Jones School of Business at Rice University in 2006, and his medical degree from Baylor College of Medicine in 2008.</br></br>
In 2013, he completed his orthopedic surgery residency at Northwestern Feinberg School of Medicine in Chicago, where he was awarded the Brian Hartigan, MD Award for compassionate care, clinical excellence, and commitment to teaching. In 2014, he completed his hand and microvascular surgery fellowship at the University of Washington and Harborview Medical Center in Seattle.</br></br>
He's an associate professor in the Department of Orthopedic Surgery at McGovern Medical School at UTHealth Houston. Outside of work, Saucedo enjoys spending time with his family, listening to music, roasting coffee, and teaching and presenting in various settings.`,

    education: [
      "Medical Degree at Baylor College of Medicine",
      "MBA at Rice University",
      "Residency (Orthopedic Surgery) at Northwestern Feinberg School of Medicine",
      "Fellowship (Hand and Microvascular Surgery) University of Washington and Harborview Medical Center"
    ],

    areasOfExpertise: `<ul>
      <li>Arthritis- Hand and wrist</li>
      <li>Carpal Tunnel Syndrome</li>
      <li>Cubital Tunnel Syndrome</li>
      <li>de Quervain's Tendonitis</li>
      <li>Tendon and Nerve Injuries</li>
    </ul>
    <ul>
      <li>Fractures, Dislocations, Lacerations- Hand and wrist</li>
      <li>Sports Injuries of Hand/Wrist</li>
      <li>Hand surgery</li>
      <li>Scaphoid fractures and other carpal bone fractures</li>
      <li>Tennis elbow</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/33691769_xxl.jpg",
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons diagnose and treat conditions of the human body, focusing on injuries and diseases of the body's musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active. They often treat sports injuries, degenerative diseases, tumors, infections and birth defects.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Jonathan P. Behrens, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },

    cardioThoracicDetailData: {
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic Surgery focuses on treatments and repairs of the musculoskeletal system; joints, bones, ligaments, tendons and more. These surgeries can range from minimally invasive procedures to amputation. In America, our surgeons are highly trained and certified in this field and people come all over the world to receive care here. They operate with an entire team to ensure the safety of each patient and use tedious measures to make sure all surgeries are successful.",
      slope: true,
      intoImgData: "/images/providers/46444454_ortho.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Orth-Behrens.webp",
      title: "ORTHOPEDIC SURGEON",
      mdcontent:
        "Jonathan Behrens, MD is an orthopedic surgeon in Houston, Texas. He received his medical degree from Indiana University School of Medicine and has been in practice for 10+ years. He has expertise in treating hip replacement, among other orthopedic conditions.",
      mdname: "JONATHAN P. BEHRENS, MD"
    },

    id: "jonathan-behrens-md",
    name: "Jonathan P. Behrens, MD",
    image: "/images/physianDirectory/O-Behrens.jpg",
    phone: "281-922-9979",
    gender: "Male",
    language: "English",
    specialty: "Orthopaedic Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Fondren Orthopedic Group",
        address: "520 Blossom Street, Webster, TX 77598",
        phone: "(281) 332-9537"
      },
      {
        name: "Fondren Orthopedic Group",
        address: "7401 Main Street, Houston, TX 77030",
        phone: "(832) 957-9360"
      }
    ],

    bio_name: "About Dr. Jonathan P. Behrens",
    bio: `Dr. Behrens, MD is an orthopedic surgeon who completed a fellowship at Stanford University and completed a residency at St. Louis University Hospital.</br></br>
Dr. Behrens works at Fondren Orthopedic Group in Houston, TX with other offices in Webster, TX. Dr. Behrens frequently treats conditions like Joint Pain and Osteoarthritis of Hip along with other conditions at varying frequencies.`,

    education: [
      "Doctor of Medicine Degree from Indiana University School of Medicine",
      "Bachelor of Science (Biology) from University of Southern Indiana",
      "Residency (Orthopedic Surgery) at St. Louis University Hospital",
      "Fellowship (Orthopedic Surgery Adult Reconstruction) at Stanford University"
    ],

    areasOfExpertise: `<ul>
      <li>Arthroplasty Hip /Joint / Knee</li>
      <li>Aseptic Necrosis/ Osteonecrosis</li>
      <li>Hip Reconstruction</li>
      <li>Joint Replacement</li>
      <li>Knee and Leg Fractures</li>
    </ul>
    <ul>
      <li>Osteoarthritis</li>
      <li>Orthopaedic Surgery</li>
      <li>Rheumatoid Arthritis</li>
      <li>Somatic Nerve Block</li>
      <li>Steroid Injection</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/33691769_xxl.jpg",
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons diagnose and treat conditions of the human body, focusing on injuries and diseases of the body's musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active. They often treat sports injuries, degenerative diseases, tumors, infections and birth defects.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Kenneth Brooks, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },

    cardioThoracicDetailData: {
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic Surgery focuses on treatments and repairs of the musculoskeletal system; joints, bones, ligaments, tendons and more. These surgeries can range from minimally invasive procedures to amputation. In America, our surgeons are highly trained and certified in this field and people come all over the world to receive care here. They operate with an entire team to ensure the safety of each patient and use tedious measures to make sure all surgeries are successful.",
      slope: true,
      intoImgData: "/images/providers/46444454_ortho.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Orth-Brooks.webp",
      title: "ORTHOPEDIC SURGEON",
      mdcontent:
        "Kenneth Brooks, MD is a board-certified orthopedic surgeon specializing in sports medicine and joint replacement, practicing in the Clear Lake and Sugar Land areas of Texas.",
      mdname: "KENNETH BROOKS, MD"
    },

    id: "kenneth-brooks-md",
    name: "Kenneth Brooks, MD",
    image: "/images/physianDirectory/O-Brooks.jpg",
    phone: "281-985-9342",
    gender: "Male",
    language: "English",
    specialty: "Orthopedic Sports Medicine, Hip and Knee Orthopedic Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "CLS Health Orthopedics & Sports Medicine Associates - Clear Lake",
        address: "905 West Medical Center Blvd, Ste 404, Webster, TX 77598",
        phone: "(281) 985-9342"
      },
      {
        name: "CLS Health Orthopedics & Sports Medicine Associates - Sugar Land",
        address: "14100 Southwest Freeway, Suite 500, Sugar Land, TX 77478",
        phone: "(281) 985-9342"
      }
    ],

    bio_name: "About Dr. Kenneth Brooks",
    bio: `Dr. Brooks is board certified and focuses on sports medicine and joint replacement. He is active professionally as a Fellow of the American Academy of Orthopaedic Surgeons and a member of the American Orthopedic Society for Sports Medicine and Texas Orthopaedic Association.</br></br>
While in medical school, Dr. Brooks discovered his true desire to help people of all ages return to the sports and activities they love. He earned a fellowship in sports medicine from Wayne State University/Detroit Medical Center in Michigan, and a second fellowship in joint replacement and adult reconstruction from the University of Texas Health Science Center-Houston.</br></br>
Dr. Brooks believes effective communication is the foundation for a successful physician-patient partnership. He empowers his patients with information to make the treatment decision that is right for them.`,

    education: [
      "Medical Degree from The Chicago Medical School, Finch University of Health Sciences",
      "Residency at University of Medicine and Dentistry of New Jersey",
      "Fellowship at Wayne State University, Detroit Medical Center",
      "Fellowship at University of Texas Health Science Center"
    ],

    areasOfExpertise: `<ul>
      <li>ACL/ Knee Ligament Injuries</li>
      <li>Arthritis of Knee, Hip, Shoulder</li>
      <li>Cartilage Repair & Restoration</li>
      <li>Fractures</li>
      <li>Knee Replacements</li>
    </ul>
    <ul>
      <li>Meniscus Repair</li>
      <li>Patellofemoral Pain & Disorders</li>
      <li>Rotator Cuff Tears</li>
      <li>Shoulders Replacements & Resurfacing</li>
      <li>Sports Medicine</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=9KNJsYUKKsc",
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons diagnose and treat conditions of the human body, focusing on injuries and diseases of the body's musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active. They often treat sports injuries, degenerative diseases, tumors, infections and birth defects.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Kenneth L. Caldwell, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },

    cardioThoracicDetailData: {
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic Surgery focuses on treatments and repairs of the musculoskeletal system; joints, bones, ligaments, tendons and more. These surgeries can range from minimally invasive procedures to amputation. In America, our surgeons are highly trained and certified in this field and people come all over the world to receive care here. They operate with an entire team to ensure the safety of each patient and use tedious measures to make sure all surgeries are successful.",
      slope: true,
      intoImgData: "/images/providers/46444454_ortho.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Orth-Caldwell.jpg",
      title: "ORTHOPEDIC SURGEON",
      mdcontent:
        "Kenneth L. Caldwell, MD is a board-certified orthopedic surgeon based in Pasadena, Texas and has over 15 years of experience in the medical field. He is committed to providing exceptional orthopedic care with a patient-centered approach.",
      mdname: "KENNETH L. CALDWELL, MD"
    },

    id: "kenneth-caldwell-md",
    name: "Kenneth L. Caldwell, MD",
    image: "/images/physianDirectory/O-Caldwell.jpg",
    phone: "713-359-2221",
    gender: "Male",
    language: "English",
    specialty: "Orthopedic Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Multi-Specialty Clinic of HCA Houston Healthcare Southeast",
        address: "3801 Vista Road, Suite 360, Pasadena, TX 77504",
        phone: "(713) 359-2221"
      }
    ],

    bio_name: "About Dr. Kenneth L. Caldwell",
    bio: `Dr. Kenneth Caldwell is a native Houstonian who has proudly served the orthopedic needs of the Pasadena area for many years. After graduating in the top of his class with a medical degree from the University of Texas Medical Branch in Galveston, he went on to complete a residency in Orthopedic Surgery at the University of Kansas Medical Center and a fellowship in Orthopedic Oncology at UT MD Anderson Cancer Center. He has extensive experience in orthopedic trauma, orthopedic oncology and joint replacement.</br></br>
Though he primarily sees patients in Pasadena, TX, his practice has expanded to include patients from all over the Houston Metropolis. He places a high priority on compassion and active listening during patient encounters as he has found this to be a key factor in accurately diagnosing complex cases.`,

    education: [
      "Medical Degree from University of Texas Medical Branch-Galveston",
      "Undergraduate Degree from Texas Southern University",
      "Residency (Orthopaedic Surgery) at University of Kansas Hospital",
      "Fellowship (Orthopaedic Oncology) at University of Texas MD Anderson Cancer Center"
    ],

    areasOfExpertise: `<ul>
      <li>Bone and Joint diseases</li>
      <li>Dislocations</li>
      <li>Fractures</li>
      <li>Hip Reconstruction</li>
      <li>Joint Replacement</li>
    </ul>
    <ul>
      <li>Musculoskeletal Deformities</li>
      <li>Orthopedics</li>
      <li>Osteoarthritis</li>
      <li>Revision Of Hip Or Knee Replacement</li>
      <li>Rotator Cuff Repair</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/33691769_xxl.jpg",
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons diagnose and treat conditions of the human body, focusing on injuries and diseases of the body's musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active. They often treat sports injuries, degenerative diseases, tumors, infections and birth defects.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Kevin A. West, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },

    cardioThoracicDetailData: {
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic Surgery focuses on treatments and repairs of the musculoskeletal system; joints, bones, ligaments, tendons and more. These surgeries can range from minimally invasive procedures to amputation. In America, our surgeons are highly trained and certified in this field and people come all over the world to receive care here. They operate with an entire team to ensure the safety of each patient and use tedious measures to make sure all surgeries are successful.",
      slope: true,
      intoImgData: "/images/providers/46444454_ortho.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Orth-West.jpg",
      title: "ORTHOPEDIC SURGEON",
      mdcontent:
        "Kevin A. West, MD is a sports medicine specialist dedicated to providing exceptional care for athletes and active individuals. Dr. West is an expert in treating sports-related injuries and soft tissue conditions of the knee, shoulder, and elbow.",
      mdname: "KEVIN A. WEST, MD"
    },

    id: "kevin-west-md",
    name: "Kevin A. West, MD",
    image: "/images/physianDirectory/O-West.jpg",
    phone: "361-761-1000",
    gender: "Male",
    language: "English",
    specialty: "Orthopedic Surgery, Sports Medicine",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Corpus Christi Medical Center- Bay Area",
        address: "7101 S Padre Island Dr, Corpus Christi, TX 78412",
        phone: "(361) 761-1000"
      }
    ],

    bio_name: "About Dr. Kevin A. West",
    bio: `Dr. West is an experienced and highly skilled orthopedic sports medicine specialist. He is also a leading expert in shoulder arthroplasty, specializing in shoulder replacement surgery for patients with degenerative joint disease or severe injuries.</br></br>
Dr. West strongly emphasizes non-surgical and minimally invasive treatment options, utilizing cutting-edge techniques to address soft tissue injuries, ligament tears, tendonitis, and other musculoskeletal conditions. When surgery is necessary, he offers advanced surgical procedures designed to promote faster recovery and better functional outcomes.</br></br>
Dr. West is passionate about educating his patients on injury prevention, rehabilitation, and maintaining long-term joint health. He works closely with physical therapists and athletic trainers to ensure each patient's recovery plan is tailored to their specific needs and goals. When he's not treating patients, Dr West enjoys spending time with his wife and two children and participating in outdoor activities like hunting and snowboarding.`,

    education: [
      "Medical Degree at University of Texas Health Sciences Center at San Antonio- Long School of Medicine",
      "Undergraduate Degree at Texas A&M University",
      "Residency (Orthopaedic Surgery) at Texas Tech University Health Sciences Center at Lubbock"
    ],

    areasOfExpertise: `<ul>
      <li>Anterior Cruciate Ligament (ACL) Tear</li>
      <li>Hip Replacement</li>
      <li>Humerus Fracture</li>
      <li>Internal Derangement of Knee</li>
      <li>Joint Pain</li>
    </ul>
    <ul>
      <li>Knee Ligament Tears</li>
      <li>Knee Sprain</li>
      <li>Meniscus Tear</li>
      <li>Robotic-arm Assisted Total Knee Surgery</li>
      <li>Shoulder Fracture</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=JdM-_Tkg6A4",
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons diagnose and treat conditions of the human body, focusing on injuries and diseases of the body's musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active. They often treat sports injuries, degenerative diseases, tumors, infections and birth defects.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Laura Linscheid, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },

    cardioThoracicDetailData: {
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic Surgery focuses on treatments and repairs of the musculoskeletal system; joints, bones, ligaments, tendons and more. These surgeries can range from minimally invasive procedures to amputation. In America, our surgeons are highly trained and certified in this field and people come all over the world to receive care here. They operate with an entire team to ensure the safety of each patient and use tedious measures to make sure all surgeries are successful.",
      slope: true,
      intoImgData: "/images/providers/46444454_ortho.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Orth-Linscheid.webp",
      title: "ORTHOPEDIC SURGEON",
      mdcontent:
        "Laura Linscheid, MD is an orthopedist in Sugar Land, Texas. She provides comprehensive, patient-centered care with a focus on injury prevention, surgical and non-surgical treatments, and long-term musculoskeletal health.",
      mdname: "LAURA LINSCHEID, MD"
    },

    id: "laura-linscheid-md",
    name: "Laura Linscheid, MD",
    image: "/images/physianDirectory/O-Linscheid.jpg",
    phone: "281-985-9342",
    gender: "Female",
    language: "English",
    specialty: "Orthopaedic Surgery, Orthopedic Sports Medicine",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "CLS Health Orthopedics & Sports Medicine Associates - Sugar Land",
        address: "14100 Southwest Freeway, Suite 500, Sugar Land, TX 77478",
        phone: "(281) 985-9342"
      },
      {
        name: "CLS Health Orthopedics & Sports Medicine Associates - Clear Lake",
        address: "905 West Medical Center Boulevard, Suite 404, Webster, TX 77598",
        phone: "(281) 985-9342"
      }
    ],

    bio_name: "About Dr. Laura Linscheid",
    bio: `Dr. Linscheid is a board-eligible orthopedic surgeon specializing in sports medicine. She completed her orthopedic surgery residency at the University of Texas Medical Branch and her fellowship in orthopedic sports medicine at the Ochsner Sports Medicine Institute.</br></br>
She provides comprehensive, patient-centered care with a focus on injury prevention, surgical and non-surgical treatments, and long-term musculoskeletal health. Known for her collaborative, evidence-based approach, she is dedicated to developing personalized treatment plans that support each patient's mobility, recovery, and overall function.</br></br>
Dr. Linscheid has authored multiple peer-reviewed publications and is active in ongoing research on advanced surgical techniques. She has been recognized with awards for excellence in research and teaching.`,

    education: [
      "Medical Degree from University of Texas Medical Branch School of Medicine",
      "Residency (Orthopaedic Surgery) at University of Texas Medical Branch Hospitals",
      "Fellowship (Orthopaedic Sports Medicine) at Ochsner Clinic Foundation"
    ],

    areasOfExpertise: `<ul>
      <li>ACL Tears</li>
      <li>Achilles Tear/Rupture</li>
      <li>Ankle Fracture and Sprains</li>
      <li>Anterior Cruciate Ligament Repair and Reconstruction</li>
      <li>Arthritis of the Knee and Shoulder</li>
      <li>Arthroscopic Rotator Cuff and Labral Repair</li>
      <li>Arthroscopic Surgery of the Knee and Shoulder</li>
      <li>Articular Cartilage Repair and Restoration</li>
    </ul>
    <ul>
      <li>Bicep Tendon Reattachment</li>
      <li>Bursitis</li>
      <li>Carpal Tunnel Syndrome</li>
      <li>Fractures</li>
      <li>Ligament and Tendon Injuries</li>
      <li>Meniscus Tears</li>
      <li>Rotator Cuff Tears</li>
      <li>Shoulder Dislocation/Instability</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=dXaLmyA7qQI",
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons diagnose and treat conditions of the human body, focusing on injuries and diseases of the body's musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active. They often treat sports injuries, degenerative diseases, tumors, infections and birth defects.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Matthew Darlow, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },

    cardioThoracicDetailData: {
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic Surgery focuses on treatments and repairs of the musculoskeletal system; joints, bones, ligaments, tendons and more. These surgeries can range from minimally invasive procedures to amputation. In America, our surgeons are highly trained and certified in this field and people come all over the world to receive care here. They operate with an entire team to ensure the safety of each patient and use tedious measures to make sure all surgeries are successful.",
      slope: true,
      intoImgData: "/images/providers/46444454_ortho.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Orth-Darlow.jpg",
      title: "ORTHOPEDIC SURGEON",
      mdcontent:
        "Matthew Darlow, MD is a board-certified orthopedic surgeon in Webster, TX. He specializes in the diagnosis, treatment, and surgical management of musculoskeletal disorders, including fractures, joint injuries, and spinal conditions.",
      mdname: "MATTHEW DARLOW, MD"
    },

    id: "matthew-darlow-md",
    name: "Matthew Darlow, MD",
    image: "/images/physianDirectory/O-Darlow.jpg",
    phone: "281-316-0121",
    gender: "Male",
    language: "English",
    specialty: "Orthopaedic Surgery, Spine Surgeon",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Orthopedic Specialists of Texas - Webster",
        address: "450 W Medical Center Blvd # 600B, Webster, TX 77598",
        phone: "(281) 316-0121"
      }
    ],

    bio_name: "About Dr. Matthew Darlow",
    bio: `Dr. Darlow, a Houstonian by birth, began his familiarity with medicine early on when he was able to shadow a general surgeon in high school. Traveling East to Duke University, he majored in neuroscience and discovered a love of the brain and spine. He earned his medical degree from McGovern Medical School at UTHealth in Houston, and completed a rigorous residency in orthopedic surgery at LSU Health Science Center in New Orleans.</br></br>
An active contributor to orthopedic research, Dr. Darlow has co-authored several peer-reviewed articles. His work focuses on advancing surgical techniques and improving patient safety, particularly in spine and trauma surgery.</br></br>
Outside of his clinical and academic endeavors, Dr. Darlow is passionate about helping patients restore mobility and enhance their quality of life, tailoring treatment plans to meet individual needs and goals.`,

    education: [
      "Medical Degree from University of Texas Medical School - Houston",
      "Undergraduate Degree (Neuroscience) from Duke University",
      "Residency at LSU Health New Orleans",
      "Fellowship (Spine) at Florida Orthopaedic Institute"
    ],

    areasOfExpertise: `<ul>
      <li>Arthritis</li>
      <li>Degenerative Spine Disorders</li>
      <li>Fracture Treatment- Spine</li>
      <li>Joint Care</li>
      <li>Muscle Disorders</li>
    </ul>
    <ul>
      <li>Muscle Strain and Sprains</li>
      <li>Neck Pain</li>
      <li>Osteoarthritis</li>
      <li>Sports Medicine</li>
      <li>Stress Fractures</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/33691769_xxl.jpg",
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons diagnose and treat conditions of the human body, focusing on injuries and diseases of the body's musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active. They often treat sports injuries, degenerative diseases, tumors, infections and birth defects.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Michael Maier, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },

    cardioThoracicDetailData: {
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic Surgery focuses on treatments and repairs of the musculoskeletal system; joints, bones, ligaments, tendons and more. These surgeries can range from minimally invasive procedures to amputation. In America, our surgeons are highly trained and certified in this field and people come all over the world to receive care here. They operate with an entire team to ensure the safety of each patient and use tedious measures to make sure all surgeries are successful.",
      slope: true,
      intoImgData: "/images/providers/46444454_ortho.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Orth-Maier.jpg",
      title: "ORTHOPEDIC SURGEON",
      mdcontent:
        "Michael Maier, MD is a board-certified orthopedic surgeon with expertise in comprehensive musculoskeletal care. Dr. Maier has over 20 years of experience in the medical field and specializes in diagnosing and treating joint, bone, and soft tissue conditions.",
      mdname: "MICHAEL MAIER, MD"
    },

    id: "michael-maier-md",
    name: "Michael Maier, MD",
    image: "/images/physianDirectory/O-Maier.jpg",
    phone: "281-491-7111",
    gender: "Male",
    language: "English, Spanish",
    specialty: "Orthopedics and Sports Medicine, Orthopedic Surgery, Spine Care",

    degrees: ["Doctor of Medicine"],

    clinics: [
      {
        name: "Baylor College of Medicine Dr. Maier",
        address: "14090 Southwest Fwy #130, Sugar Land, TX 77478",
        phone: "(281) 491-7111"
      }
    ],

    bio_name: "About Dr. Michael Maier",
    bio: `Dr. Maier practices orthopedic surgery with Baylor St. Luke's Medical Group. Board-certified by the American College of Orthopedic Surgery and a member of the American Academy of Orthopedic Surgeons, Piedmont Orthopedic Society, and Notre Dame Orthopedic Society, Dr. Maier plays an active role in the Houston and Richmond area community.</br></br>
Dr. Maier graduated cum laude with a Bachelor of Science degree from the University of Notre Dame. He earned his medical degree from the University of Texas Southwestern Medical School and graduated the top ranking in his medical school graduating class. He completed his internship and orthopedic surgery residency at Duke University in Durham, North Carolina.</br></br>
Dr. Maier enjoys sports and is an avid golfer. He resides in Richmond, Texas with his wife and four children.`,

    education: [
      "Medical Degree from University of Texas Southwestern Medical School",
      "Bachelor of Science Degree from University of Notre Dame",
      "Residency (Orthopaedic Surgery) at Duke University Hospital",
      "Internship (General Surgery) at Duke University Hospital"
    ],

    areasOfExpertise: `<ul>
      <li>Arthritis</li>
      <li>Dislocation Treatments</li>
      <li>Fractures (Femur, Fibular, Pelvic, Hip, Ankles)</li>
      <li>Genu Varum</li>
      <li>Hip Replacement</li>
    </ul>
    <ul>
      <li>Knee Replacement</li>
      <li>Lower back pain</li>
      <li>Muscle pain, fibromyalgia, and limb pain</li>
      <li>Rotator Cuff Injury</li>
      <li>Wrist Sprain or Strain</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=Ql7RplOs3Ss",
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons diagnose and treat conditions of the human body, focusing on injuries and diseases of the body's musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active. They often treat sports injuries, degenerative diseases, tumors, infections and birth defects.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Nileshkumar M. Chaudhari, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },

    cardioThoracicDetailData: {
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic Surgery focuses on treatments and repairs of the musculoskeletal system; joints, bones, ligaments, tendons and more. These surgeries can range from minimally invasive procedures to amputation. In America, our surgeons are highly trained and certified in this field and people come all over the world to receive care here. They operate with an entire team to ensure the safety of each patient and use tedious measures to make sure all surgeries are successful.",
      slope: true,
      intoImgData: "/images/providers/46444454_ortho.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Orth-Chaudhari.jpg",
      title: "ORTHOPEDIC SURGEON",
      mdcontent:
        "Nilesh Chaudhari, MD is a board certified Orthopedic Surgeon with more than 20 years in practice. He specializes in Hand, Upper Extremity, Foot and Ankle and Microsurgery.",
      mdname: "NILESHKUMAR M. CHAUDHARI, MD"
    },

    id: "nileshkumar-chaudhari-md",
    name: "Nileshkumar M. Chaudhari, MD",
    image: "/images/physianDirectory/O-Chaudhari.jpg",
    phone: "281-456-4412",
    gender: "Male",
    language: "English, Gujarati, Hindi",
    specialty: "Orthopedic Surgery Hand, Upper Extremity and Microvascular Surgery Foot and Ankle Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Houston Hand & Foot Orthopedics- Pearland",
        address: "9804 Broadway Street, Pearland, TX 77584",
        phone: "(281) 456-4412"
      },
      {
        name: "Houston Hand & Foot Orthopedics- Pasadena",
        address: "4211 Fairmont Pkway, Pasadena, TX 77504"
      },
      {
        name: "Houston Hand & Foot Orthopedics- Friendswood",
        address: "1505 Winding Way Drive, Ste 200, Friendswood, TX 77546"
      }
    ],

    bio_name: "About Dr. Nileshkumar M. Chaudhari",
    bio: `Dr. Chaudhari earned his medical degree at Government Medical College in Amritsar, India. He underwent fellowship training in musculoskeletal oncology at Rutgers New Jersey Medical School, foot and ankle surgery at the American Sports Medicine Institute in Birmingham, Ala., and hand, upper extremity and microvascular surgery at the University of Alabama Hospital.</br></br>
Board certified in both orthopedic surgery and hand surgery, Dr. Chaudhari has been in practice in the United States since 2009. He sees both adult and pediatric patients and treats hand, wrist, upper extremity, foot and ankle pathologies and injuries; benign and malignant tumors; and congenital hand and wrist deformities.</br></br>
Prior to moving to the Houston area, Dr. Chaudhari was an associate professor and associate program director in the Department of Orthopedics at the University of Alabama at Birmingham.`,

    education: [
      "Medical Degree from South Gujarat University, Government Medical College",
      "Residency (Orthopedics - Master of Surgery) at South Gujarat University Government Medical College",
      "Fellowship (Musculoskeletal Oncology) at Rutgers New Jersey Medical School",
      "Fellowship (Foot and Ankle Surgery) at the American Sports Medicine Institute in Birmingham",
      "Fellowship (Upper Extremity and Microvascular Surgery) at the University of Alabama Hospital"
    ],

    areasOfExpertise: `<ul>
      <li>Achilles Tendon Rupture</li>
      <li>Carpal Tunnel</li>
      <li>Bunion</li>
      <li>Foot Deformity</li>
      <li>Pediatric and Adult Fractures</li>
    </ul>
    <ul>
      <li>Pediatric Hand Deformities</li>
      <li>Plantar Fasciitis</li>
      <li>Rheumatoid Arthritis</li>
      <li>Sports Related Ankle Injuries</li>
      <li>Tennis/Golfer's Elbow</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/33691769_xxl.jpg",
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons diagnose and treat conditions of the human body, focusing on injuries and diseases of the body's musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active. They often treat sports injuries, degenerative diseases, tumors, infections and birth defects.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Rohan Anup Gheewala, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },

    cardioThoracicDetailData: {
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic Surgery focuses on treatments and repairs of the musculoskeletal system; joints, bones, ligaments, tendons and more. These surgeries can range from minimally invasive procedures to amputation. In America, our surgeons are highly trained and certified in this field and people come all over the world to receive care here. They operate with an entire team to ensure the safety of each patient and use tedious measures to make sure all surgeries are successful.",
      slope: true,
      intoImgData: "/images/providers/46444454_ortho.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Orth-Gheewala.jpg",
      title: "ORTHOPEDIC SURGEON",
      mdcontent:
        "Rohan A. Gheewala, MD is an orthopaedic surgeon with fellowship training in adult reconstruction (hip and knee replacement surgery). He specializes in Primary and Revision Hip and Knee Replacement, Trauma.",
      mdname: "ROHAN ANUP GHEEWALA, MD"
    },

    id: "rohan-gheewala-md",
    name: "Rohan Anup Gheewala, MD",
    image: "/images/physianDirectory/O-Gheewala.jpg",
    phone: "936-272-0790",
    gender: "Male",
    language: "English",
    specialty: "Hip and Knee Reconstructive Surgery, Orthopedic Trauma",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Sterling Ridge Orthopaedics & Sports Medicine- Woodforest",
        address: "750 Fish Creek Thoroughfare, Montgomery, TX 77316",
        phone: "(936) 272-0790"
      },
      {
        name: "Sterling Ridge Orthopaedics & Sports Medicine- The Woodlands",
        address: "6767 Lake Woodlands Drive, #F, The Woodlands, TX 77382",
        phone: "(281) 364-1122"
      },
      {
        name: "Sterling Ridge Orthopaedics & Sports Medicine- Spring",
        address: "20639 Kuykendahl Road, #200, Spring, TX 77379",
        phone: "(832) 698-0111"
      }
    ],

    bio_name: "About Dr. Rohan Anup Gheewala",
    bio: `Dr. Gheewala is originally from New York and graduated cum laude from SUNY Binghamton. He proceeded to earn his MD from SUNY Upstate Medical University in Syracuse, NY. He completed his orthopaedic surgery residency at Albany Medical Center in Albany, NY, where he trained at the highest volume Level 1 trauma center in New York State, receiving extensive training in fracture care and management.</br></br>
After residency, Dr. Gheewala completed an adult reconstruction fellowship at the Baylor College of Medicine in the heart of Houston's Texas Medical Center, under the tutelage of Dr. Melvyn A. Harrington. He became facile with complex primary and revision hip and knee arthroplasty and gained a great interest in calipered, kinematically aligned total knee arthroplasty and total hip arthroplasty through a direct anterior approach.</br></br>
Dr. Gheewala is a member of the American Academy of Orthopaedic Surgeons and the American Academy of Hip and Knee Surgeons. He is married to his wife, Nicole, who is also a physician.`,

    education: [
      "Medical Degree from SUNY Upstate Medical University",
      "Graduated cum laude from SUNY Binghamton",
      "Residency (Orthopaedic Surgery) at Albany Medical Center",
      "Fellowship (Adult Reconstruction) at Baylor College of Medicine"
    ],

    areasOfExpertise: `<ul>
      <li>Arthroscopic Surgery of the Knee</li>
      <li>Articular Cartilage Repair and Restoration</li>
      <li>Degenerative Condition Management</li>
      <li>Fracture Care</li>
      <li>Joint Reconstruction</li>
    </ul>
    <ul>
      <li>Patellofemoral Syndrome</li>
      <li>Revision Joint Surgery</li>
      <li>Tendonitis</li>
      <li>Total and Partial Hip Replacement</li>
      <li>Total and Partial Knee Replacement</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/33691769_xxl.jpg",
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons diagnose and treat conditions of the human body, focusing on injuries and diseases of the body's musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active. They often treat sports injuries, degenerative diseases, tumors, infections and birth defects.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Taggart Gauvain, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },

    cardioThoracicDetailData: {
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic Surgery focuses on treatments and repairs of the musculoskeletal system; joints, bones, ligaments, tendons and more. These surgeries can range from minimally invasive procedures to amputation. In America, our surgeons are highly trained and certified in this field and people come all over the world to receive care here. They operate with an entire team to ensure the safety of each patient and use tedious measures to make sure all surgeries are successful.",
      slope: true,
      intoImgData: "/images/providers/46444454_ortho.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Orth-Gauvain.webp",
      title: "ORTHOPEDIC SURGEON",
      mdcontent:
        "Taggart Gauvain, MD is board certified in orthopedic surgery in Houston, Texas. In practice since 2010, he specializes in surgery of the foot and ankle with special clinical interest in reconstructive surgery, fractures, arthroscopic surgery, total ankle arthroplasty and treatment of sports injuries.",
      mdname: "TAGGART GAUVAIN, MD"
    },

    id: "taggart-gauvain-md",
    name: "Taggart Gauvain, MD",
    image: "/images/physianDirectory/O-Gauvain.jpg",
    phone: "713-486-6000",
    gender: "Male",
    language: "English",
    specialty: "Orthopedic Surgery, Foot and Ankle Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Memorial Hermann Sports Park",
        address: "11049 Memorial Hermann Drive, Suite 200, Pearland, TX 77584",
        phone: "(713) 486-6000"
      },
      {
        name: "UT Physicians Orthopedics – League City",
        address: "2555 Gulf Fwy S, Ste 500, League City, TX 77573-6742",
        phone: "(713) 486-6000"
      }
    ],

    bio_name: "About Dr. Taggart Gauvain",
    bio: `Dr. Gauvain, MD earned his undergraduate degree at St. Edward's University in Austin and his medical degree at UT Health San Antonio Medical School. He completed his residency in orthopedic surgery at McGovern Medical School at The University of Texas Health Science Center at Houston and a fellowship in foot and ankle surgery at The Foundation for Orthopedic, Athletic and Reconstructive Research in Houston.</br></br>
Board certified in orthopedic surgery, he specializes in foot and ankle surgery with special clinical interests in reconstructive surgery, fractures, arthroscopic surgery, sports injury and treatment and total ankle arthroplasty. Dr. Gauvain utilizes operative and non-operative treatments. His goal is to restore function and increase his patients' ability to participate in the activities they love most.</br></br>
Dr. Gauvain is an assistant professor at McGovern Medical School at UTHealth and a member of the American Academy of Orthopaedic Surgeons and the American Orthopaedic Foot and Ankle Society.`,

    education: [
      "Medical Degree from University of Texas Health Science Center at San Antonio",
      "Undergraduate Degree from St. Edward's University in Austin",
      "Residency (Orthopedic Surgery) at McGovern Medical School - The University of Texas Health Science Center at Houston",
      "Fellowship (Foot and Ankle Surgery) at The Foundation for Orthopaedic, Athletic and Reconstruction Research in Houston"
    ],

    areasOfExpertise: `<ul>
      <li>Arm, Wrist, Hand Fracture</li>
      <li>Arthroscopic Surgery of the Ankle</li>
      <li>Broken/Dislocated Ankle or Foot</li>
      <li>Joint or Bone Infection</li>
      <li>Knee Injury</li>
    </ul>
    <ul>
      <li>Pelvic and Hip Fracture</li>
      <li>Reconstruction of Foot Deformity</li>
      <li>Sports Injury</li>
      <li>Tendon and Ligament Injury</li>
      <li>Total Ankle Arthroplasty</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=qRceJEO9gDc",
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons diagnose and treat conditions of the human body, focusing on injuries and diseases of the body's musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active. They often treat sports injuries, degenerative diseases, tumors, infections and birth defects.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Victor Van Phan, DO",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },

    cardioThoracicDetailData: {
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic Surgery focuses on treatments and repairs of the musculoskeletal system; joints, bones, ligaments, tendons and more. These surgeries can range from minimally invasive procedures to amputation. In America, our surgeons are highly trained and certified in this field and people come all over the world to receive care here. They operate with an entire team to ensure the safety of each patient and use tedious measures to make sure all surgeries are successful.",
      slope: true,
      intoImgData: "/images/providers/46444454_ortho.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Orth-Phan.jpg",
      title: "ORTHOPEDIC SURGEON",
      mdcontent:
        "Board certified by the American Osteopathic Board of Orthopedic Surgery, Dr. Victor Van Phan has been in practice since 2003. His clinical interests include joint reconstruction and replacement, sports medicine, trauma and fracture care.",
      mdname: "VICTOR VAN PHAN, DO"
    },

    id: "victor-van-phan-do",
    name: "Victor Van Phan, DO",
    image: "/images/physianDirectory/O-VanPhan.jpg",
    phone: "281-922-1800",
    gender: "Male",
    language: "English, Vietnamese",
    specialty: "Orthopedic Surgery",

    degrees: ["Doctor of Osteopathy"],

    clinics: [
      {
        name: "Premier Orthopaedics",
        address: "11920 Astoria Blvd, Suite 390, Houston, TX 77089",
        phone: "(281) 922-1800"
      }
    ],

    bio_name: "About Dr. Victor Van Phan",
    bio: `Dr. Phan received his medical education at Des Moines University in Iowa. He completed his internship and residency at Horizons Health System/Henry Ford Hospital in Detroit, Michigan, where he served as chief intern and chief resident.</br></br>
Dr. Phan's patient philosophy is to be straight forward, honest and empathetic. He has served as chief of Orthopedics at Memorial Hermann Southeast Hospital where he currently serves as Joint medical director. He is a member of the American Academy of Orthopaedic Surgeons, Osteopathic Medical Association and serves as a board examiner for the American Osteopathic Academy Orthopedics.</br></br>
Married to his elementary school sweetheart, Dr. Phan and his wife have three daughters. In his spare time, he enjoys vintage car racing and working on old cars, but most of all he loves being with his family.`,

    education: [
      "Medical Degree from Des Moines University",
      "Undergraduate Degree from University of Houston",
      "Residency (Orthopaedic Surgery) at Horizons Health Systems/Henry Ford Hospital"
    ],

    areasOfExpertise: `<ul>
      <li>Achilles Tendon Injuries</li>
      <li>Ankle Fractures</li>
      <li>Carpal Tunnel Syndrome</li>
      <li>Hip Fractures</li>
      <li>Meniscus Tear</li>
    </ul>
    <ul>
      <li>Osteoarthritis</li>
      <li>Plantar Fasciitis</li>
      <li>Rotator Cuff Injuries</li>
      <li>Shoulder Dislocation</li>
      <li>Tibial Fractures</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/33691769_xxl.jpg",
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons diagnose and treat conditions of the human body, focusing on injuries and diseases of the body's musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active. They often treat sports injuries, degenerative diseases, tumors, infections and birth defects.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "William J. Jordan, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },

    cardioThoracicDetailData: {
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic Surgery focuses on treatments and repairs of the musculoskeletal system; joints, bones, ligaments, tendons and more. These surgeries can range from minimally invasive procedures to amputation. In America, our surgeons are highly trained and certified in this field and people come all over the world to receive care here. They operate with an entire team to ensure the safety of each patient and use tedious measures to make sure all surgeries are successful.",
      slope: true,
      intoImgData: "/images/providers/46444454_ortho.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Orth-Jordan.jpg",
      title: "ORTHOPEDIC SURGEON",
      mdcontent:
        "William J. Jordan, MD works in The Woodlands and Willis, Texas. He is board-certified in orthopedic surgery and specializes in sports medicine and trauma with clinical interest in general orthopedic surgery, arthroscopy and arthroplasty of all major joints.",
      mdname: "WILLIAM J. JORDAN, MD"
    },

    id: "william-jordan-md",
    name: "William J. Jordan, MD",
    image: "/images/physianDirectory/O-Jordan.jpg",
    phone: "936-242-1437",
    gender: "Male",
    language: "English",
    specialty: "Orthopedic Surgery, Sports Medicine",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Woodlands Center for Special Surgery",
        address: "134 Vision Park Blvd, Ste 100, The Woodlands, TX 77384",
        phone: "(936) 242-1437"
      },
      {
        name: "Woodlands Center for Special Surgery",
        address: "9851 FM 1097, Ste 110, Willis, TX 77318",
        phone: "(936) 228-7670"
      }
    ],

    bio_name: "About Dr. William J. Jordan",
    bio: `After earning his undergraduate degrees at Houston Baptist University, Dr. Jordan was commissioned as a second lieutenant in the United States Army, assigned to the 1st Battalion, 26th Infantry Regiment of the Army's 1st Infantry Division in Schweinfurt, Germany.</br></br>
After four years as an infantry officer, Dr. Jordan studied at the prestigious University of Texas Health Science Center at Houston, completing his orthopaedic surgery residency at William Beaumont Army Medical Center and Texas Tech University Health Sciences Center in El Paso. He served as staff orthopedic surgeon at Ft. Hood, Texas, and is a two-time Bronze Star Medal recipient who oversaw the treatment of hundreds of combat casualties in Afghanistan.</br></br>
Dr. Jordan's commitment to providing the highest quality of care is shown through his careful and educational demeanor with every patient. He prides himself on taking the time necessary to sit down with each patient and listen to their concerns and questions.`,

    education: [
      "Medical Degree from University of Texas Health Science Center",
      "Undergraduate Degree (Chemistry & Biology) from Houston Baptist University",
      "Residency (Orthopaedic Surgery) at William Beaumont Army Medical Center",
      "Residency (Orthopaedic Surgery) at Texas Tech University Health Sciences Center"
    ],

    areasOfExpertise: `<ul>
      <li>ACL</li>
      <li>Arthritis</li>
      <li>Bunion Correction</li>
      <li>Heel Pain</li>
      <li>Knee Replacements</li>
    </ul>
    <ul>
      <li>Meniscus Tear</li>
      <li>Rotator Cuff Repairs</li>
      <li>Shoulder Impingement</li>
      <li>Tendonitis</li>
      <li>Total Shoulder Replacement</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/33691769_xxl.jpg",
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons diagnose and treat conditions of the human body, focusing on injuries and diseases of the body's musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active. They often treat sports injuries, degenerative diseases, tumors, infections and birth defects.",
      slope: true
    }
  },

  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "James Shaw, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons specialize in the musculoskeletal system, treating bones, joints, ligaments, tendons, and muscles. They perform both surgical and non-surgical treatments for injuries, arthritis, sports injuries, and degenerative conditions.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Orth-Shaw.jpg",
      title: "ORTHOPEDIC SURGEON",
      mdcontent: "James Shaw, MD is an orthopaedic surgeon with the medical practice of Orthopedic Specialists of Texas in Webster, Texas.   Dr. Shaw's extensive traini...",
      mdname: "JAMES SHAW, MD"
    },
    id: "james-shaw-md",
    name: "James Shaw, MD",
    image: "/images/doctors/james-shaw-md.jpg",
    phone: "281-316-0121",
    gender: "Male",
    language: "English",
    specialty: "Orthopedic Surgery, Spine Surgery",
    degrees: ["Doctor of Medicine"],
    clinics: [{
        name: "Orthopedic Specialists of Texas - Webster",
        address: "450 Medical Center Blvd ,Suite 600B, Webster, TX 77598",
        phone: "(281) 316-0121"
      }],
    bio_name: "About Dr. James Shaw",
    bio: `Dr. Shaw was born in Austin, Texas. He completed his undergraduate degree at the University of Texas at Austin in Biomedical Engineering. He also spent time his junior year studying abroad in Cambridge, England. His studies led him to pursue a career in medicine, and he completed his medical degree at the University of Texas McGovern Medical School in Houston. He completed a residency in Orthopedic Surgery at the University of Texas Health and Science center at Houston. While there, he quickly cultivated a passion for trauma surgery. Dr. Shaw spent two months of his chief year in Santiago, Chile and Cape Town, South Africa as an invited trauma fellow. During that time, he had a unique experience observing the challenges of delivering orthopedic care in international healthcare systems. Dr. Shaw subsequently completed his final year of formal training at the Hospital for Special Surgery in Manhattan, New York, serving as a trauma fellow.    Dr. Shaw is active in orthopedic research and has been published in peer-reviewed journals, invited chapters in orthopedic textbooks, and presented his work at national meetings. He is an active member of the Orthopedic Trauma Association and the American Academy of Orthopedic Surgeons.    Dr. Shaw has spent the past decade in Houston, which he now calls home. When he is not caring for his patients, he and his wife, Tahlia, enjoy spending time with their families and traveling the world together.`,
    education: ["Medical Degree from University of Texas McGovern Medical School", "Undergraduate Degree (Biomedical Engineering) from University of Texas at Austin", "Residency (Orthopedic Surgery) at The University of Texas Health Science Center at Houston", "Fellowship (Trauma Surgery) at Hospital for Special Surgery / N.Y. Presbyterian"],
    areasOfExpertise: `<ul>
<li>Amputation</li>
<li>Arthroplasty</li>
<li>Dislocated Shoulder</li>
<li>Elbow Surgery</li>
<li>Fracture/Dislocation Treatment</li>
</ul>
<ul>
<li>Hip and Pelvis Fractures</li>
<li>Muscle Strain and Sprains</li>
<li>Osteoporosis and Pathologic Fractures</li>
<li>Pediatric Femoral Fractures</li>
<li>Tendonitis- Myositis & Bursitis</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/37187126_xl.jpg",
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons specialize in the musculoskeletal system, treating bones, joints, ligaments, tendons, and muscles. They perform both surgical and non-surgical treatments for injuries, arthritis, sports injuries, and degenerative conditions.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Dr. Jeffrey R. Schlimmer, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons specialize in the musculoskeletal system, treating bones, joints, ligaments, tendons, and muscles. They perform both surgical and non-surgical treatments for injuries, arthritis, sports injuries, and degenerative conditions.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Orth-Schlimmer.avif",
      title: "ORTHOPEDIC SURGEON",
      mdcontent: "Jeffrey Schlimmer, MD is an orthopedic surgeon in Corpus Christi, Texas. Dr. Schlimmer has extensive experience in shoulder & upper arm surgery.",
      mdname: "DR. JEFFREY R. SCHLIMMER, MD"
    },
    id: "dr-jeffrey-r-schlimmer-md",
    name: "Dr. Jeffrey R. Schlimmer, MD",
    image: "/images/doctors/dr-jeffrey-r-schlimmer-md.jpg",
    phone: "361-883-2000",
    gender: "Male",
    language: "English, Spanish",
    specialty: "Orthopedic Surgery, Sports Medicine",
    degrees: ["Medical Degree"],
    clinics: [{
        name: "The Orthopaedic Center of Corpus Christi",
        address: "6118 Parkway Drive, Corpus Christi, TX 78414",
        phone: "(361) 883-2000"
      }],
    bio_name: "About Dr. Jeffrey R. Schlimmer",
    bio: `A native of Portland, Texas, Dr. Schlimmer is a board-certified, fellowship-trained orthopaedic surgeon. He earned his medical degree and completed his orthopaedic surgery residency at the University of Texas Health Science Center at San Antonio. During his residency, Dr. Schlimmer served as both Administrative Chief Resident of Pediatric Orthopaedics and Administrative Chief Resident.  Following his residency, Dr. Schlimmer completed an arthroscopy and sports medicine fellowship at Greater Chesapeake Orthopaedic Associates/Union Memorial Hospital in Baltimore, Maryland. While in Baltimore, he served as acting team physician for Johns Hopkins University, Morgan State University and Gaucher College.    Dr. Schlimmer has completed postgraduate training in numerous orthopaedic trauma and joint reconstruction courses, and has presented papers at orthopaedic meetings and conferences throughout the United States.    ​Dr. Schlimmer is actively involved with the Athletic Training Program at Texas A&M University Corpus Christi and Kingsville where he provides clinical education experience to students who are enrolled in the Bachelor of Science Degree Program in Athletic Training.`,
    education: ["Medical Degree from University of Texas Health Science Center", "Residency (Orthopaedic Surgery) from University of Texas Health Science Center San Antonio Joe and Teresa Lozano Long School of Medicine", "Fellowship (Arthroscopy and Sports Medicine) from Greater Chesapeake Orthopaedic Associates/Union Memorial Hospital"],
    areasOfExpertise: `<ul>
<li>Arthroscopy</li>
<li>Computer Navigation and Robotic Surgery</li>
<li>Internal Derangement of Knee</li>
<li>Joint Reconstruction</li>
<li>Knee Ligament Tears</li>
</ul>
<ul>
<li>Meniscus Tear</li>
<li>Rotator Cuff Teninosis</li>
<li>Shoulder Dislocation</li>
<li>Sports Medicine</li>
<li>Orthopaedic Trauma</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/37187126_xl.jpg",
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons specialize in the musculoskeletal system, treating bones, joints, ligaments, tendons, and muscles. They perform both surgical and non-surgical treatments for injuries, arthritis, sports injuries, and degenerative conditions.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Kyle F. Dickson, MD, MBA",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons specialize in the musculoskeletal system, treating bones, joints, ligaments, tendons, and muscles. They perform both surgical and non-surgical treatments for injuries, arthritis, sports injuries, and degenerative conditions.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Orth-Dickson.png",
      title: "ORTHOPEDIC TRAUMA SURGEON",
      mdcontent: "Dr. Kyle F. Dickson, MD is a board-certified orthopedic surgeon practicing in the Houston, Sugar Land, and Pearland, Texas, offices. He specializes in...",
      mdname: "KYLE F. DICKSON, MD, MBA"
    },
    id: "kyle-f-dickson-md-mba",
    name: "Kyle F. Dickson, MD, MBA",
    image: "/images/doctors/kyle-f-dickson-md-mba.jpg",
    phone: "713-800-1080",
    gender: "Male",
    language: "English, Spanish",
    specialty: "Orthopedic Surgery",
    degrees: ["Medical Degree"],
    clinics: [{
        name: "Southwest Orthopaedic Group",
        address: "6560 Fannin, Suite 1016, Houston, Texas 77030",
        phone: "(713) 800-1080"
      }, {
        name: "Southwest Orthopedic Group, LLP",
        address: "10970 Shadow Creek Pkwy Ste 130, Pearland, TX 77584",
        phone: ""
      }, {
        name: "Multispecialty Clinic for Surgery",
        address: "3801 Vista Road Ste 360, Pasadena, TX 77504",
        phone: ""
      }],
    bio_name: "About Dr. Kyle F. Dickson",
    bio: `Dr. Dickson graduated from the University of California, San Diego, School of Medicine and completed his orthopedic residency at the University of California, San Francisco. His fellowship training at the University of Southern California focused on trauma, pelvic, and acetabular surgery. Dr. Dickson furthered his expertise by completing an additional fellowship in Ilizarov limb lengthening and deformities and an AOTrauma fellowship in trauma centers in Germany and Switzerland.    Dr. Dickson is a calm, collected physician with years of experience in treating patients with orthopedic trauma. For over 15 years, he has restored thousands of patients back to health and function. Dr. Dickson’s areas of specialty care include complex orthopedic trauma, disorders of the hip, acetabular fractures, and pelvic injuries, as well as post-traumatic malunions, nonunions, and infections.    Dr. Dickson is a known expert in the field of orthopedic trauma and reconstruction, and has served as a president of both the New Orleans Orthopaedic Society and the Houston Orthopaedic Society.    He values teaching and mentoring the next generation of physicians, and was formerly a professor and chairman of orthopedic surgery at the University of Texas Medical School at Houston, as well as a tenured professor of orthopedics at Tulane University in New Orleans.    Dr. Dickson gives back to the community by working in underprivileged hospitals and volunteering with Boy Scouts of America. He also has done medical missionary work in Africa, South America, and India.`,
    education: ["Medical Degree from University of California, San Diego, School of Medicine", "Bachelor of Arts Degree (Zoology) from University of California, Berkeley", "Executive Masters in Business Administration Degree from Tulane University", "Residency (Orthopaedic Surgery) at University of California, San Francisco", "Fellowship (Acetabular/Pelvic Reconstruction) at Hip & Pelvis Institute"],
    areasOfExpertise: `<ul>
<li>ACL Tear</li>
<li>Arthritis</li>
<li>Carpal Tunnel Syndrome</li>
<li>Elbow Bursitis</li>
<li>Joint Pain/ Dislocation</li>
</ul>
<ul>
<li>Knee and Leg Fracture</li>
<li>Lumbar Radiculopathy</li>
<li>Osteoarthritis of Hip</li>
<li>Rotator Cuff Tear</li>
<li>Shoulder Replacement</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/embed/fXaC-sJCwMU",
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons specialize in the musculoskeletal system, treating bones, joints, ligaments, tendons, and muscles. They perform both surgical and non-surgical treatments for injuries, arthritis, sports injuries, and degenerative conditions.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Marilyn E. Copeland, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons specialize in the musculoskeletal system, treating bones, joints, ligaments, tendons, and muscles. They perform both surgical and non-surgical treatments for injuries, arthritis, sports injuries, and degenerative conditions.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Orth-Copeland.avif",
      title: "ORTHOPEDIC SURGEON",
      mdcontent: "Marilyn E. Copeland, MD is a fellowship-trained sports orthopedic surgeon who specializes in helping athletes of all ages and competition levels recup...",
      mdname: "MARILYN E. COPELAND, MD"
    },
    id: "marilyn-e-copeland-md",
    name: "Marilyn E. Copeland, MD",
    image: "/images/doctors/marilyn-e-copeland-md.jpg",
    phone: "281-985-9342",
    gender: "Female",
    language: "English",
    specialty: "Orthopedic Surgery, Sports Medicine",
    degrees: ["Medical Degree"],
    clinics: [{
        name: "CLS Health",
        address: "905 W. Medical Center Blvd Ste. 404, Webster, TX 77598",
        phone: "(281) 985-9342"
      }],
    bio_name: "About Dr. Marilyn E. Copeland",
    bio: `Dr. Copeland began her training at Southern Methodist University in Dallas, where she graduated summa cum laude with a bachelor’s degree in psychology. She earned her medical degree from the University of Texas Medical Branch in Galveston.    While completing a five-year orthopedic residency at the University of Missouri, Dr. Copeland served the nationally ranked Mizzou Tigers football program as well as other school athletic departments. She completed an additional fellowship in sports medicine at Wake Forest University (WFU) in Winston-Salem, North Carolina.    During her fellowship year, Dr. Copeland worked at the WFU Hospital, served as team doctor for the University’s football program, and traveled as team doctor for their Atlantic Coast Conference men’s basketball team.    Dr. Copeland has contributed to orthopedic research as both a lead investigator and research associate, with a focus on biomechanics and sports-related injuries.    Through Faith in Practice, a Houston based non-profit organization, Dr. Copeland has volunteered her orthopedic services multiple times to men, women, and children living in extreme poverty in Guatemala.  ​  Dr. Copeland enjoys running, competing in triathlons, and reading. She also loves spending time with her husband, children, and puppy Dasher.`,
    education: ["Medical Degree from the University of Texas Medical Branch, Galveston", "Bachelor’s Degree (Psychology) from Southern Methodist University", "Residencey (Orthopedics) at University of Missouri", "Fellowship (Sports Medicine) at Wake Forest University"],
    areasOfExpertise: `<ul>
<li>ACL Tears</li>
<li>Achilles Tear/Rupture</li>
<li>Ankle Fracture and Sprains</li>
<li>Arthritis of the Knee and Shoulder</li>
<li>Biceps Tendon Tear/Rupture</li>
<li>Bursitis</li>
<li>Carpal Tunnel Syndrome</li>
</ul>
<ul>
<li>Cartilage Injuries/Disorders</li>
<li>Hand and Wrist Tendinitis</li>
<li>Ligament and Tendon Injuries</li>
<li>Meniscus Tears</li>
<li>Patellofemoral Disorders</li>
<li>Rotator Cuff Tears</li>
<li>Shoulder Dislocation/Instability</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/embed/-l-UT0Ojhnk",
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons specialize in the musculoskeletal system, treating bones, joints, ligaments, tendons, and muscles. They perform both surgical and non-surgical treatments for injuries, arthritis, sports injuries, and degenerative conditions.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Venkata Karthik Jonna, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons specialize in the musculoskeletal system, treating bones, joints, ligaments, tendons, and muscles. They perform both surgical and non-surgical treatments for injuries, arthritis, sports injuries, and degenerative conditions.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Orth-Jonna.webp",
      title: "ORTHOPEDIC SURGEON",
      mdcontent: "Dr. V. Karthik Jonna, MD is a board-certified, fellowship-trained orthopedic surgeon with his practice located in Webster, TX.    He specializes in hi...",
      mdname: "VENKATA KARTHIK JONNA, MD"
    },
    id: "venkata-karthik-jonna-md",
    name: "Venkata Karthik Jonna, MD",
    image: "/images/doctors/venkata-karthik-jonna-md.jpg",
    phone: "281-985-9342",
    gender: "Male",
    language: "English",
    specialty: "Orthopedic Surgery, Joint Replacement Surgery, Hip and Knee Orthopedic Surgery",
    degrees: ["Medical Degree"],
    clinics: [{
        name: "Houston Advanced Orthopedics",
        address: "600 N Kobayashi Rd., Suite 114, Webster, TX 77598",
        phone: "(281) 985-9342"
      }, {
        name: "CLS Health Orthopedics & Sports Medicine Associates - Clear Lake",
        address: "905 West Medical Center Boulevard, Suite 404, Webster, TX 77598",
        phone: "(346) 476-0760"
      }],
    bio_name: "About Dr. Venkata Karthik Jonna",
    bio: `Dr. Jonna is a board-certified orthopedic surgeon specializing in hip and knee replacement surgery, revision joint replacements, fracture care, and sports medicine. He is committed to delivering personalized, high-quality orthopedic care using the latest surgical techniques to help patients regain mobility and return to their daily activities with confidence.    Dr. Jonna is a member of the American Association of Hip and Knee Surgeons (AAHKS) and the American Academy of Orthopedic Surgeons (AAOS). He has authored multiple peer-reviewed articles and abstracts that contribute to advancements in orthopedic care and surgical innovation.    Known for his compassionate approach and focus on patient-centered outcomes, Dr. Jonna provides tailored treatment plans that prioritize safety, recovery, and long-term function. He is a trusted orthopedic expert dedicated to improving the quality of life for his patients.`,
    education: ["Medical Degree from Robert Wood Johnson Medical School", "Bachelors Degree (Biological Sciences) from Rutgers University", "Residency (Orthopaedic Surgery) at Maimonides Medical Center", "Fellowship (Joint Reconstruction ) at Columbia University Medical Center"],
    areasOfExpertise: `<ul>
<li>Computer navigated joint replacement</li>
<li>Hip pain and injury</li>
<li>Hip replacement</li>
<li>Hip labrum tear</li>
<li>Hip disorders</li>
</ul>
<ul>
<li>Knee pain and injury</li>
<li>Knee fractures</li>
<li>Knee cartilage lesions</li>
<li>Open (compound) fractures</li>
<li>Rapid recovery knee replacement</li>
<li>Simple fractures</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/embed/d2vrnWugS7o",
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons specialize in the musculoskeletal system, treating bones, joints, ligaments, tendons, and muscles. They perform both surgical and non-surgical treatments for injuries, arthritis, sports injuries, and degenerative conditions.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Jesus A. Juarez, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons specialize in the musculoskeletal system, treating bones, joints, ligaments, tendons, and muscles. They perform both surgical and non-surgical treatments for injuries, arthritis, sports injuries, and degenerative conditions.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Orth-Juarez.jpg",
      title: "ORTHOPEDIC SURGEON",
      mdcontent: "Jesus Armando Juarez, MD is a board-certified orthopedic surgeon specializing in foot and ankle reconstructive surgery.",
      mdname: "JESUS A. JUAREZ, MD"
    },
    id: "jesus-a-juarez-md",
    name: "Jesus A. Juarez, MD",
    image: "/images/doctors/jesus-a-juarez-md.jpg",
    phone: "281-985-9342",
    gender: "Male",
    language: "English, Spanish",
    specialty: "Orthopedic Surgery",
    degrees: ["Medical Degree"],
    clinics: [{
        name: "CLS Health Orthopedics & Sports Medicine Associates- Clear Lake",
        address: "905 W. Medical Center Blvd Ste 404, Webster, TX 77598",
        phone: "(281) 985-9342"
      }, {
        name: "CLS Health Orthopedics & Sports Medicine Associates- Pasadena Vista",
        address: "3801 Vista Road, Suite 100, Pasadena, TX 77504",
        phone: "(281) 985-9342"
      }],
    bio_name: "About Dr. Jesus A. Juarez",
    bio: `Dr. Juarez completed his orthopedic surgery residency at Rutgers New Jersey Medical School and a fellowship in foot and ankle reconstructive surgery at UTHealth Houston.     Dr. Juarez holds multiple academic appointments, including Clinical Assistant Professor roles at the University of Houston College of Medicine, HCA Houston Healthcare West, and UTMB School of Medicine.   Widely affiliated with Houston-area hospital systems, he has been recognized for excellence in clinical care and education, including honors such as HCA Clear Lake Surgeon of the Month and a Golden Apple nomination. Fluent in English and Spanish, Dr. Juarez is committed to advancing orthopedic care through teaching, research, and community service.`,
    education: ["Medical Degree from University of Texas Health Science Center at San Antonio", "Residency (Orthopedic Surgery) at Rutgers New Jersey Medical School", "Fellowship (Foot & Ankle Reconstructive Surgery) at The University of Texas Health Science Center at Houston"],
    areasOfExpertise: `<ul>
<li>Arthroscopic Surgery</li>
<li>Arthritis Injections</li>
<li>Ankle Replacement Surgery</li>
<li>Charcot Arthropathy</li>
<li>Fractures of the Lower leg, Foot, and Ankle</li>
</ul>
<ul>
<li>Ligament Reconstruction</li>
<li>Limb Deformity Correction</li>
<li>Neuromas</li>
<li>Reconstruction of High Arch or Flat Foot</li>
<li>Tendon Repairs</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/37187126_xl.jpg",
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons specialize in the musculoskeletal system, treating bones, joints, ligaments, tendons, and muscles. They perform both surgical and non-surgical treatments for injuries, arthritis, sports injuries, and degenerative conditions.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ORTHOPEDIC SURGERY",
      mdName: "Robert S. Williams, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons specialize in the musculoskeletal system, treating bones, joints, ligaments, tendons, and muscles. They perform both surgical and non-surgical treatments for injuries, arthritis, sports injuries, and degenerative conditions.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/Orth-Williams.webp",
      title: "ORTHOPEDIC SURGEON",
      mdcontent: "Robert S. Williams, MD is a skilled orthopedic surgeon who is board-certified in orthopedic sports medicine by the American Board of Orthopaedic Surge...",
      mdname: "ROBERT S. WILLIAMS, MD"
    },
    id: "robert-s-williams-md",
    name: "Robert S. Williams, MD",
    image: "/images/doctors/robert-s-williams-md.jpg",
    phone: "361-994-1166",
    gender: "Male",
    language: "English, Spanish",
    specialty: "Orthopedic Surgery, Sports Medicine, Spine Surgery",
    degrees: ["Medical Degree"],
    clinics: [{
        name: "Coastal Orthopedics",
        address: "5920 Saratoga Boulevard, Suite 600A, Corpus Christi, TX 78414",
        phone: "(361) 994-1166"
      }, {
        name: "Coastal Orthopedics - Portland",
        address: "1810 Billy G. Webb Dr Ste A, Portland, TX 78374",
        phone: ""
      }],
    bio_name: "About Dr. Robert S. Williams",
    bio: `Dr. Williams, is an ABOS board-certified orthopedic surgeon with ABOS subspecialty certification in Sports Medicine. He is a Fellow of the American Academy of Orthopaedic Surgeons (FAAOS).    Dr. Williams completed his Orthopedic Surgery Residency and Fellowship in Spine Surgery at the prestigious Campbell Clinic, University of Tennessee. He earned his medical degree and completed a General Surgery Internship at the University of Texas Health Science Center at San Antonio. He graduated with honors from Texas Tech University, majoring in accounting and finance.    He serves as the team physician for Flour Bluff High School and supports the Corpus Christi Sharks Football Club. Dr. Williams is committed to providing an exceptional patient-centered experience both in the office and the surgery suite.`,
    education: ["Medical Degree from University of Texas Health Science Center at San Antonio", "Undergraduate Degree with honors from Texas Tech University", "Residency (Orthopedic Surgery) at Campbell Clinic, University of Tennessee", "Fellowship (Spine Surgery) at Campbell Clinic, University of Tennessee"],
    areasOfExpertise: `<ul>
<li>Anterior Cruciate Ligament (ACL) Injury</li>
<li>Carpal Tunnel Release</li>
<li>Distal Radius Fractrue (Broken Wrist)</li>
<li>Hip Dislocation</li>
<li>Hip Replacement Surgery</li>
</ul>
<ul>
<li>Knee Replacement Surgery</li>
<li>Osteoarthritis</li>
<li>Rotator Cuff Tear Repair</li>
<li>Spine Surgery</li>
<li>Tendonitis</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/embed/Ow2m1GfuM3M",
      title: "ORTHOPEDIC SURGERY",
      contentTop: "Orthopedic surgeons specialize in the musculoskeletal system, treating bones, joints, ligaments, tendons, and muscles. They perform both surgical and non-surgical treatments for injuries, arthritis, sports injuries, and degenerative conditions.",
      slope: true
    }
  },
];

export const physicianRoboticData = [
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Ata Ahmad, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },
  
    cardioThoracicDetailData: {
      title:"ROBOTIC SURGERY",
      contentTop:"Robotic surgery enhances surgical precision, flexibility, and control, enabling our team to perform complex procedures with greater accuracy. This advanced, minimally invasive technology allows for smaller incisions and improved patient outcomes compared to traditional techniques.",
      slope: true,
      intoImgData: "/images/providers/426157522_robo.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      mdcontent:
        "Ata Ahmad, MD is a native of New Orleans, Louisiana. He attended Baylor University in Waco, Texas where he graduated with a Bachelor's Degree in Biology. He went on to attend medical school at Louisiana State University in New Orleans.",
      mdname: "Ata Ahmad, MD"
    },
  
    id: "Ata Ahmad, MD",
    name: "Ata Ahmad, MD",
    image: "/images/doctors/mohammed-tarek-al-fahl.jpg",
    phone: "281-970-8484",
    gender: "Male",
    language: "English, Urdu",
  
    specialty: "General Surgery, Bariatric Surgery, Breast Surgery",
  
    degrees: [
      "Doctor of Medicine"
    ],
  
    clinics: [
      {
        name: "Cy-Fair Location",
        address: "11740 FM 1960,  Houston, TX 77065"
      },
      {
        name: "Tomball Location",
        address: "13624 Michel Rd, Suite 101, Tomball, TX 77375"
      },
      {
        name: "Woodlands Location",
        address: "17189 Interstate 45 South, Suite 305,  The Woodlands, TX 77385"
      },
      {
        name: "HCA Houston Kingwood",
        address: "22999 US-59 N, Kingwood, TX 77339",
        phone:"(281) 348-8000"
      }
    ],
  
    bio_name: "About Dr. Ata Ahmad",
    bio: `
    Dr. Ahmad completed his surgical training at the Louisiana State  University Health Science Center in New Orleans, Louisiana. After  completing his surgical training, Dr. Ahmad opened his own private  practice in Bay City, Texas where he spent the next five years  specializing in general and laparoscopic surgery. While in Bay City, Dr. Ahmad developed a special interest in Bariatric Surgery.</br>
He has successfully completed extensive training and certification  for laparoscopic gastric sleeve and banding. Currently, Dr. Ahmad  practices in Northwest Houston with surgical privileges at Houston  Northwest Medical Center, Humble Surgical Hospital, Cypress Fairbanks  Medical Center, Methodist Willowbrook Hospital, and Tomball Regional  Medical Center, North Cypress Medical Center, The Methodist Hospital –  Med Center, and St. Luke’s Hospital at the Vintage.</br>
He is one of the most experienced  laparoscopic surgeons in Houston and has performed many laparoscopic  procedures. Dr. Ahmad has performed surgeries in New Orleans, Dallas,  Baton Rouge, Houston, and various cities across the country and is a  recipient of the SRC Surgeon of Excellence in Robotic Surgery, and has been named #1 Robotic Surgeon in Houston in 2020.</br>
Dr. Ata Ahmad is a Board Certified General Surgeon by the American  Board of Surgery. Whether you need a surgical consult, outpatient  surgery, or bariatric surgery, you can be confident that you will be  treated by a highly trained physician and staff, utilizing the latest  and most innovative methods.
    `,
    education: [
      "Graduate Degree from Louisiana State University School Of Medicine",
      "Undergraduate Degree from Baylor University",
      "Residency at Louisiana State University Health Science Center",
      "Fellowship Louisiana State University Health Science Center",
      "Internship at Louisiana State University Health Science Center"
    ],
  
    areasOfExpertise: `
    <ul>
  <li>Colon Surgery</li>
  <li>Gallbladder Surgery</li>
  <li>GERD / Reflux Surgery</li>
  <li>Hernia Surgery</li>
  <li>Lumpectomy</li>
  <li>Mastectomy</li>
  <li>Weight Loss Surgeries</li>
</ul>
    `,
  
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      contentTop:"Robotic-assisted surgery is the latest development in minimally invasive surgery (MIS). Surgeons uses a robotic platform as a tool during the procedure. The surgical robot has interactive arms that serve as extensions of the surgeon's hands. These arms are equipped with surgical tools and cameras. They can suture, dissect, clamp and manipulate tissue. It provides surgeons the flexibility of traditional open surgery while operating through tiny incisions, which can lead to fewer complications during surgery and a shorter recovery period for patients.",
      slope: true
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Abimbola Ayangbesan, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },
  
    cardioThoracicDetailData: {
      title:"ROBOTIC SURGERY",
      contentTop:"Robotic surgery enhances surgical precision, flexibility, and control, enabling our team to perform complex procedures with greater accuracy. This advanced, minimally invasive technology allows for smaller incisions and improved patient outcomes compared to traditional techniques.",
      slope: true,
      intoImgData: "/images/providers/426157522_robo.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      mdcontent:
        "Abimbola Ayangbesan, MD graduated from the Weill Cornell Medical College in 2018. He works in Houston, TX and specializes in Urology.",
      mdname: "Abimbola Ayangbesan, MD"
    },
  
    id: "Abimbola Ayangbesan, MD",
    name: "Abimbola Ayangbesan, MD",
    image: "/images/doctors/mohammed-tarek-al-fahl.jpg",
    phone: "281-351-5174",
    gender: "Male",
    language: "English, Spanish, Yoruba",
  
    specialty: "Urology",
  
    degrees: [
      "Doctor of Medicine"
    ],
  
    clinics: [
      {
        name: "Texas Urology Specialists-Houston Willowbrook",
        address: "13215 Dotson Road, Suite 170B, Houston, TX 77070",
        phone:"281-351-5174"
      },
      {
        name: "Texas Urology Specialists-The Woodlands",
        address: "17189 I-45, MOB II, Suite 305, The Woodlands, TX 77385",
        phone:"281-351-5174"
      }
    ],
  
    bio_name: "About Dr. Abimbola Ayangbesan",
    bio: `
    Dr. Ayangbesan is an urologist in Tomball, Texas and is affiliated with multiple hospitals in the area.  He received his medical degree from Weill Cornell Medicine and has been in practice between 6-10 years. Dr. Abimbola Ayangbesan has expertise in treating kidney removal surgery, among other conditions.
    `,
    education: [
      "Medical Doctorate from Cornell University",
      "Residency (Urology) at Vanderbilt University Medical Center",
      "Internship (General Surgery) at Vanderbilt University Medical Center"
    ],
  
    areasOfExpertise: `
    <ul>
  <li>Acute Kidney Infection</li>
  <li>Kidney Infection</li>
  <li>Lithotripsy</li>
  <li>Prostate Cancer Screening Exam (DRE)</li>
  <li>Pyonephrosis</li>
  <li>Tubulointerstitial Nephritis</li>
  <li>Urinary Incontinence</li>
  <li>Uroflowmetry</li>
</ul>
    `,
  
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      contentTop:"Robotic-assisted surgery is the latest development in minimally invasive surgery (MIS). Surgeons uses a robotic platform as a tool during the procedure. The surgical robot has interactive arms that serve as extensions of the surgeon's hands. These arms are equipped with surgical tools and cameras. They can suture, dissect, clamp and manipulate tissue. It provides surgeons the flexibility of traditional open surgery while operating through tiny incisions, which can lead to fewer complications during surgery and a shorter recovery period for patients.",
      slope: true
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Linh T. Do, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },
  
    cardioThoracicDetailData: {
      title:"ROBOTIC SURGERY",
      contentTop:"Robotic surgery enhances surgical precision, flexibility, and control, enabling our team to perform complex procedures with greater accuracy. This advanced, minimally invasive technology allows for smaller incisions and improved patient outcomes compared to traditional techniques.",
      slope: true,
      intoImgData: "/images/providers/426157522_robo.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      mdcontent:
        "Linh Do, MD, MS, is fellowship-trained in urogynecology and reconstructive pelvic surgery. She primarily performs minimally invasive surgeries, including vaginal, laparoscopic and robotic procedures, but Dr. Do also performs open surgical procedures.",
      mdname: "Linh T. Do, MD"
    },
  
    id: "Linh T. Do, MD",
    name: "Linh T. Do, MD",
    image: "/images/doctors/mohammed-tarek-al-fahl.jpg",
    phone: "281-493-9966",
    gender: "Female",
    language: "English, Vietnamese",
  
    specialty: "Female Pelvic Medicine & Reconstructive Surgery, Obstetrics and Gynecology",
  
    degrees: [
      "Doctor of Medicine"
    ],
  
    clinics: [
      {
        name: "Houston Metro Urology",
        address: "12121 Richmond Ave Ste 100, Houston, TX 77082",
        phone:"(281) 493-9966"
      },
      {
        name: "Houston Metro Urology",
        address: "9230 Katy Fwy Ste 510, Houston, TX 77055",
        phone:"(713) 634-4441"
      }
    ],
  
    bio_name: "About Dr. Linh T. Do",
    bio: `
    Dr. Do combines her obstetrics and gynecology skills with her specialized training in pelvic health to treat women's unique issues. She provides female patients with specialized diagnostic and treatment skills to help them cope with problems like pelvic organ prolapse, urinary incontinence and fistulas.</br>
    She attended Texas Tech University Health Sciences Center for medical school and remained at Texas Tech University for her medical residency training in obstetrics and gynecology.</br>
    Dr. Do continued her training with a fellowship in urogynecology and reconstructive pelvic surgery and a Master of Science in clinical and translational science at the University of Oklahoma Health Sciences Center.
    `,
    education: [
      "Medical School at Texas Tech University Health Sciences Center, Paul L. Foster School of Medicine",
      "Master of Science, Clinical and Translational Science at University of Oklahoma Health Sciences Center",
      "Undergraduate Degree at Houston Baptist University",
      "Residency (Obstetrics and Gynecology) at Texas Tech University Health Sciences Center",
      "Fellowship (Urogynecology and Reconstructive Pelvic Surgery) at University of Oklahoma Health Sciences Center"
    ],
  
    areasOfExpertise: `
    <ul>
      <li>Fistulas</li>
      <li>Mesh complications</li>
      <li>Dysfunctional or abnormal uterine bleeding</li>
      <li>Pelvic organ prolapse of the uterus, vagina, bladder, and rectum</li>
      <li>Urinary leakage – urge and stress incontinence</li>
      <li>Vaginal and vulvar cysts</li>
    </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=umpl1ssc_ws",
      title: "ROBOTIC SURGERY",
      contentTop:"Robotic-assisted surgery is the latest development in minimally invasive surgery (MIS). Surgeons uses a robotic platform as a tool during the procedure. The surgical robot has interactive arms that serve as extensions of the surgeon's hands. These arms are equipped with surgical tools and cameras. They can suture, dissect, clamp and manipulate tissue. It provides surgeons the flexibility of traditional open surgery while operating through tiny incisions, which can lead to fewer complications during surgery and a shorter recovery period for patients.",
      slope: true
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Caroline K. Fiser, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },
  
    cardioThoracicDetailData: {
      title:"ROBOTIC SURGERY",
      contentTop:"Robotic surgery enhances surgical precision, flexibility, and control, enabling our team to perform complex procedures with greater accuracy. This advanced, minimally invasive technology allows for smaller incisions and improved patient outcomes compared to traditional techniques.",
      slope: true,
      intoImgData: "/images/providers/426157522_robo.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      mdcontent:
        "Caroline K. Fiser, MD is a Surgical Oncologist and a General Surgeon in the northern Houston, Texas area. Her top areas of expertise are Breast Cancer and Mastectomy.",
      mdname: "Caroline K. Fiser, MD"
    },
  
    id: "Caroline K. Fiser, MD",
    name: "Caroline K. Fiser, MD",
    image: "/images/doctors/mohammed-tarek-al-fahl.jpg",
    phone: "281-296-0365",
    gender: "Female",
    language: "English",
  
    specialty: "Breast Surgery, Breast Surgical Oncology, General Surgery",
  
    degrees: [
      "Doctor of Medicine"
    ],
  
    clinics: [
      {
        name: "Texas Breast Specialists-The Woodlands",
        address: "9180 Pinecroft, Suite 600, The Woodlands, TX 77380",
        phone:"(281) 822-3390"
      },
      {
        name: "Texas Oncology- Humble",
        address: "18980 W Memorial Dr, Ste 440, Humble, TX  77338",
        phone:"(832) 616-5190"
      }
    ],
  
    bio_name: "About Dr. Caroline K. Fiser",
    bio: `
    Dr. Fiser treats patients with any breast issue - whether that be an abnormal mammogram, nipple discharge, benign breast disease (abscess, cyst, fibroadenoma, fistula) or breast cancer. She also treat patients who are at high risk of developing breast cancer and patients with genetic mutations.</br>
She was born and raised in Albuquerque, New Mexico. She completed medical school at University of New Mexico and went on to complete a residency in General Surgery at University of Miami/Jackson Memorial Hospital in Miami, Florida. She then completed a fellowship in Breast Surgical Oncology at Emory University in Atlanta, Georgia. She moved to Houston to be closer to family and is practicing at Texas Oncology in the Woodlands.
    `,
    education: [
      "Medical Doctorate from The University of New Mexico",
      "Fellowship (Breast Surgical Oncology) at Emory University",
      "Residency (General Surgery) at Jackson Memorial Hospital/University of Miami",
      "Internship (General Surgery) at Jackson Memorial Hospital/University of Miami"
    ],
  
    areasOfExpertise: `
    <ul>
    <li>Axillary Lymph Node Dissection</li>
    <li>Excision of Chest Wall Tumors</li>
    <li>Mastectomy</li>
    <li>Mediport Placement</li>
    <li>Nipple Duct Excision</li>
    </ul>
    <ul>
    <li>Oncoplastic Partial Mastectomy</li>
    <li>Oncoplastic Tissue Rearrangement</li>
    <li>Radical Excision of Metastatic Lesions</li>
    <li>Reconstructive Surgery</li>
    <li>Sentinel Lymph Node Biopsy</li>
  </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      contentTop:"Robotic-assisted surgery is the latest development in minimally invasive surgery (MIS). Surgeons uses a robotic platform as a tool during the procedure. The surgical robot has interactive arms that serve as extensions of the surgeon's hands. These arms are equipped with surgical tools and cameras. They can suture, dissect, clamp and manipulate tissue. It provides surgeons the flexibility of traditional open surgery while operating through tiny incisions, which can lead to fewer complications during surgery and a shorter recovery period for patients.",
      slope: true
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Kelly K. Gilmore, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },
  
    cardioThoracicDetailData: {
      title:"ROBOTIC SURGERY",
      contentTop:"Robotic surgery enhances surgical precision, flexibility, and control, enabling our team to perform complex procedures with greater accuracy. This advanced, minimally invasive technology allows for smaller incisions and improved patient outcomes compared to traditional techniques.",
      slope: true,
      intoImgData: "/images/providers/426157522_robo.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      mdcontent:
        "Kelly K. Gilmore, MD is an Obstetrician Gynecologist and a Gynecologic Oncologist in Houston, Texas. Dr. Gilmore has been practicing medicine for over 20 years.",
      mdname: "Kelly K. Gilmore, MD"
    },
  
    id: "Kelly K. Gilmore, MD",
    name: "Kelly K. Gilmore, MD",
    image: "/images/doctors/mohammed-tarek-al-fahl.jpg",
    phone: "833-437-1707",
    gender: "Female",
    language: "English, Spanish",
  
    specialty: "Colon and Rectal Surgery, General Surgery",
  
    degrees: [
      "Doctor of Medicine"
    ],
  
    clinics: [
      {
        name: " Texas Colon & Rectal Specialists–Conroe",
        address: "500 Medical Center Blvd, Suite 340, Conroe, Texas 77304",
        phone:"(833) 437-1707"
      }
    ],
  
    bio_name: "About Dr. Kelly K. Gilmore",
    bio: `
    Dr. Gilmore received her undergraduate degree in biology from Sam Houston State University in Huntsville, Texas, and completed her medical degree at the Universidad State Autonoma de Guadalajara, in Mexico, followed by a Fifth Pathway Certificate at New York Medical College in Valhalla, N.Y. She completed a general surgery internship at Sound Shore Medical Center in New Rochelle, N.Y., followed by residency in general surgery and fellowship in colon and rectal surgery at The University of Texas Health Science Center at Houston. Dr. Gilmore is board certified by the American Board of Surgery and the American Board of Colon and Rectal Surgery. She is a member of the American Medical Association, the Harris County Medical Society, the American College of Surgeons, the American Society of Colon and Rectal Surgeons, the Texas Society of Colon and Rectal Surgeons and the Texas Medical Association. Dr. Gilmore specializes in colon and rectal surgery. She has special interests in pelvic floor disorders, rectal prolapse, fecal incontinence, constipation, as well as surgeries of anal disorders to include hemorrhoids, anal fissures, fistulas, anal warts, abscesses and pilonidal disease. She also treats full spectrum of colon and rectal disease to include colonoscopies and surgeries for cancer and benign disease. She performs laparoscopic, single incision laparoscopic surgery, as well as robotic surgeries. Her research into the short-term efficacy and safety in patients undergoing transanal hemorrhoidopexy with dearterialization (THD) has been submitted for publication by The University of Texas Affiliated Hospitals in Houston. Dr. Gilmore has proudly served in the United States Army as an enlisted soldier as well as a commissioned officer. She served in multiple locations stateside as well as overseas with a deployment to Saudi Arabia. She received multiple commendations and medals to include ROTC Corps Commander, George C. Marshall Award and Parachutist Badge.
    `,
    education: [
      "Medical Doctorate from Universidad Autónoma de Guadalajara",
      "Fellowship (Colon and Rectal Surgery) at The University of Texas Health Science Center at Houston",
      "Residency (General Surgery) at The University of Texas Health Science Center at Houston",
      "Internship (General Surgery) at Sound Shore Medical Center",
      "Fifth Pathway Certificate from New York Medical College"
    ],
  
    areasOfExpertise: `
    <ul>
  <li>Appendectomy</li>
  <li>Carotid Artery Disease</li>
  <li>Colonoscopy</li>
  <li>Colorectal Diseases (Crohn's Disease, Inflammatory Bowel Disease)</li>
  <li>Diverticulitis</li>
  </ul>
  <ul>
  <li>Gallbladder Removal</li>
  <li>Liver Biopsy</li>
  <li>Ruptured Bowel</li>
  <li>Splenectomy</li>
  <li>Temporal Artery Biopsy</li>
</ul>
    `,
  
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      contentTop:"Robotic-assisted surgery is the latest development in minimally invasive surgery (MIS). Surgeons uses a robotic platform as a tool during the procedure. The surgical robot has interactive arms that serve as extensions of the surgeon's hands. These arms are equipped with surgical tools and cameras. They can suture, dissect, clamp and manipulate tissue. It provides surgeons the flexibility of traditional open surgery while operating through tiny incisions, which can lead to fewer complications during surgery and a shorter recovery period for patients.",
      slope: true
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Zishan Hirani, MD, MS, FACOG",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },
  
    cardioThoracicDetailData: {
      title:"ROBOTIC SURGERY",
      contentTop:"Robotic surgery enhances surgical precision, flexibility, and control, enabling our team to perform complex procedures with greater accuracy. This advanced, minimally invasive technology allows for smaller incisions and improved patient outcomes compared to traditional techniques.",
      slope: true,
      intoImgData: "/images/providers/426157522_robo.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      mdcontent:
        "Zishan Hirani, MD, MS, FACOG, received his medical degree from the University of Texas Southwestern Medical School in 2015. He went on to complete his Obstetrics and Gynecology residency at the University of Texas Rio Grande Valley at Doctors Hospital at Renaissance in 2019.",
      mdname: "Zishan Hirani, MD, MS, FACOG"
    },
  
    id: "Zishan Hirani, MD, MS, FACOG",
    name: "Zishan Hirani, MD, MS, FACOG",
    image: "/images/doctors/mohammed-tarek-al-fahl.jpg",
    phone: "713-442-8000",
    gender: "Male",
    language: "English, Hindi",
  
    specialty: "General Obstetrics & Gynecology, Minimally Invasive / Endoscopic Surgery, Urogynecology & Pelvic Reconstructive Surgery",
  
    degrees: [
      "Doctor of Medicine"
    ],
  
    clinics: [
      {
        name: "Stafford Clinic",
        address: "11211 Nexus Ave, Stafford, TX 77477",
      },
    ],
  
    bio_name: "About Dr. Zishan Hirani",
    bio: `
    Dr. Hirani treats women from adolescence and beyond for common gynecological conditions and issues, including annual well-woman exams, irregular menstrual cycles, premenstrual syndrome (PMS), vaginitis, other vaginal or pelvic pain or infections, and more.</br>
He provides obstetric care for all stages of pregnancy, including childbirth and post-partum care, as well as family planning. His clinical interests include minimally invasive gynecological surgery, urinary incontinence, pelvic organ prolapse surgery, and high-risk obstetrics.
    `,
    education: [
 "Medical Degree from University of Texas Southwestern Medical School",
"Internship at University of Texas Rio Grande Valley at Doctors Hospital at Renaissance",
"Residency at University of Texas Rio Grande Valley at Doctors Hospital at Renaissance"
    ],
  
    areasOfExpertise: `
    <ul>
    <li>C-sections</li>
    <li>Excessive Menstrual Bleeding</li>
    <li>Gestational Diabetes</li>
    <li>Hysterosalpingo Sonography</li>
    <li>Menstrual Disorders</li>
    </ul>
    <ul>
    <li>Obstetric Ultrasound</li>
    <li>Pelvic Prolapse</li>
    <li>Pregestational Diabetes Mellitus</li>
    <li>Uterine Cancer</li>
    <li>Uterine Fibroids</li>
  </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=6lDyanlgzWw",
      title: "ROBOTIC SURGERY",
      contentTop:"Robotic-assisted surgery is the latest development in minimally invasive surgery (MIS). Surgeons uses a robotic platform as a tool during the procedure. The surgical robot has interactive arms that serve as extensions of the surgeon's hands. These arms are equipped with surgical tools and cameras. They can suture, dissect, clamp and manipulate tissue. It provides surgeons the flexibility of traditional open surgery while operating through tiny incisions, which can lead to fewer complications during surgery and a shorter recovery period for patients.",
      slope: true
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "John C. Hardaway, MD, PhD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },
  
    cardioThoracicDetailData: {
      title:"ROBOTIC SURGERY",
      contentTop:"Robotic surgery enhances surgical precision, flexibility, and control, enabling our team to perform complex procedures with greater accuracy. This advanced, minimally invasive technology allows for smaller incisions and improved patient outcomes compared to traditional techniques.",
      slope: true,
      intoImgData: "/images/providers/426157522_robo.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      mdcontent:
        "John C. Hardaway, MD, PhD is a Urologist in Houston, TX and has over 20 years of experience in the medical field.",
      mdname: "John C. Hardaway, MD, PhD"
    },
  
    id: "John C. Hardaway, MD, PhD",
    name: "John C. Hardaway, MD, PhD",
    image: "/images/doctors/mohammed-tarek-al-fahl.jpg",
    phone: "832-616-5180",
    gender: "Male",
    language: "English",
  
    specialty: "Hepatobiliary Surgery, Surgical Oncology, General Surgery",
  
    degrees: [
      "Doctor of Medicine"
    ],
  
    clinics: [
      {
        name: "Texas Oncology Surgical Specialists - Kingwood",
        address: "18980 W. Memorial Drive, Suite 440, Humble, TX 77338",
        phone: "(281) 822-3390",
      },
      {
        name: "Texas Oncology Surgical Specialists - The Woodlands",
        address: "920 Medical Plaza Dr., Suite 100, The Woodlands, TX 77380",
        phone: "(281) 822-3390",
      },
      {
        name: "Texas Oncology Surgical Specialists - Willowbrook",
        address: "13215 Dotson Road, Suite 170, Houston, TX 77070",
        phone: "(281) 822-3390",
      },
    ],
  
    bio_name: "About Dr. John C. Hardaway",
    bio: `
    Dr. Hardaway's clinical practice is primarily focused on cancers of the gastrointestinal tract, including diseases of the esophagus, stomach, liver, and pancreas. However, he also treats patients with thyroid, breast, and skin/soft tissue cancers. When possible, Dr. Hardaway uses the DaVinci robotic surgery platform to perform minimally invasive surgical procedures, which allow his patients to recover faster with less pain and shorter hospital stays.</br>
    Dr. Hardaway earned his M.D. and Ph.D. degrees at the University of Missouri in Columbia, where he attended medical school and was trained as a cellular immunologist. From there he was a general surgery resident at the University of Washington in Seattle and at Michigan State University before completing a fellowship in Complex General Surgical Oncology at Roger Williams Medical Center/Boston University in Providence, Rhode Island. As a result, he is double board-certified in general surgery and surgical oncology.</br>
    Outside of his surgical practice, Dr. Hardaway serves as an immunotherapy consultant, where he is focused on developing novel immunotherapies against solid tumors, to include multiple active clinical trials.    
    `,
    education: [
      "Medical Doctorate from University of Missouri",
      "Doctor of Philosophy, Molecular Microbiology and Immunology at University of Missouri",
      "Fellowship (Surgical Oncology) at Boston University, Boston, MA and Roger Williams Medical Center",
      "Residency (General Surgery, Chief Resident) at Michigan State University",
      "Internship (General Surgery) at University of Washington"
    ],
  
    areasOfExpertise: `
    <ul>
  <li>Breast Cancer Resections, Oncoplastic Breast Reconstruction</li>
  <li>Robotic/Minimally Invasive Gastric Cancer Surgery</li>
  <li>Robotic/Minimally Invasive Liver Resection/Ablation</li>
  <li>Robotic/Minimally Invasive Pancreas Surgery</li>
  </ul>
  <ul>
  <li>Sarcoma Resection</li>
  <li>Sentinel Lymph Node Biopsy</li>
  <li>Skin Cancer Excision</li>
  <li>Whipple Procedure (Pancreatoduodenectomy)</li>
</ul>
    `,
  
    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=zI50NT2rEZI",
      title: "ROBOTIC SURGERY",
      contentTop:"Robotic-assisted surgery is the latest development in minimally invasive surgery (MIS). Surgeons uses a robotic platform as a tool during the procedure. The surgical robot has interactive arms that serve as extensions of the surgeon's hands. These arms are equipped with surgical tools and cameras. They can suture, dissect, clamp and manipulate tissue. It provides surgeons the flexibility of traditional open surgery while operating through tiny incisions, which can lead to fewer complications during surgery and a shorter recovery period for patients.",
      slope: true
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Daniel L. Phillips, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },
  
    cardioThoracicDetailData: {
      title:"ROBOTIC SURGERY",
      contentTop:"Robotic surgery enhances surgical precision, flexibility, and control, enabling our team to perform complex procedures with greater accuracy. This advanced, minimally invasive technology allows for smaller incisions and improved patient outcomes compared to traditional techniques.",
      slope: true,
      intoImgData: "/images/providers/426157522_robo.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      mdcontent:
        "Daniel L. Phillips, MD is a Urologist in Houston, TX and has over 30 years of experience in the medical field.",
      mdname: "Daniel L. Phillips, MD"
    },
  
    id: "Daniel L. Phillips, MD",
    name: "Daniel L. Phillips, MD",
    image: "/images/doctors/mohammed-tarek-al-fahl.jpg",
    phone: "281-725-5970",
    gender: "Male",
    language: "English",
  
    specialty: "Urological Surgery, General Surgery",
  
    degrees: [
      "Doctor of Medicine"
    ],
  
    clinics: [
      {
        name: "Memorial Hermann Medical Group Sugar Land Multi-Specialty",
        address: "17520 West Grand Pkwy South, Suite 350, Sugar Land, TX 77479",
        phone:"(281) 725-5970"
      },
    ],
  
    bio_name: "About Dr. Daniel L. Phillips",
    bio: `
    Dr. Phillips earned his undergraduate degree in biochemistry and cellular and molecular biology at the University of Tennessee in Knoxville and his medical degree at the University of Tennessee Health Science Center in Memphis. He completed his residency in urology at The University of Texas Medical Branch at Galveston.</br>
    He treats patients for urologic conditions including kidney stones, urinary problems (men’s and women’s), cancers of the urinary tract and men’s sexual health issues. His primary clinical interest is minimally invasive robotic surgery, which allows him to treat conditions like enlarged prostate or cancers of the urinary tract in a way that can decrease post-operative pain and improve the patient experience.</br>
    Because Dr. Phillips often deals with delicate or difficult-to-discuss areas, he works to make patients comfortable and at ease. He applies the most up-to-date evidence-based medicine to help them solve their particular problems.</br>
    Dr. Phillips is a member of the American Urologic Association, Society of International Urology and Texas Medical Association and was elected to Phi Beta Kappa at the University of Tennessee.</br>
    In his leisure time, he enjoys playing the clarinet, cooking and building computers.
    `,
    education: [
      "Residency (Urology) at University of Texas Medical Branch Hospitals",
      "Medical Degree from University of Tennessee Health Science Center College of Medicine"
    ],
  
    areasOfExpertise: `
    <ul>
      <li>Enlarged Prostate (BPH)</li>
      <li>Prostate Cancer Screening Exam (DRE)</li>
      <li>Scrotal Pain</li>
      <li>Sexual Disorders</li>
      <li>Uroflowmetry</li>
    </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      link: "https://embed-cloudfront.wistia.com/deliveries/6e7ed7f981a4eee03185ace04cdb1a951ddba03e",
      // introImg: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      contentTop:"Robotic-assisted surgery is the latest development in minimally invasive surgery (MIS). Surgeons uses a robotic platform as a tool during the procedure. The surgical robot has interactive arms that serve as extensions of the surgeon's hands. These arms are equipped with surgical tools and cameras. They can suture, dissect, clamp and manipulate tissue. It provides surgeons the flexibility of traditional open surgery while operating through tiny incisions, which can lead to fewer complications during surgery and a shorter recovery period for patients.",
      slope: true
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Kumaran Sathyamoorthy, MD, MPH",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },
  
    cardioThoracicDetailData: {
      title:"ROBOTIC SURGERY",
      contentTop:"Robotic surgery enhances surgical precision, flexibility, and control, enabling our team to perform complex procedures with greater accuracy. This advanced, minimally invasive technology allows for smaller incisions and improved patient outcomes compared to traditional techniques.",
      slope: true,
      intoImgData: "/images/providers/426157522_robo.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      mdcontent:
        "Kumaran Sathyamoorthy, MD, MPH is a Urologist in Houston, TX and has over 20 years of experience in the medical field.",
      mdname: "Kumaran Sathyamoorthy, MD, MPH"
    },
  
    id: "Kumaran Sathyamoorthy, MD, MPH",
    name: "Kumaran Sathyamoorthy, MD, MPH",
    image: "/images/doctors/mohammed-tarek-al-fahl.jpg",
    phone: "281-890-0911",
    gender: "Male",
    language: "English",
  
    specialty: "Urology",
  
    degrees: [
      "Doctor of Medicine"
    ],
  
    clinics: [
      {
        name: "North Cypress Urology",
        address: "10425 Huffmeister Rd Ste 210, Houston, TX 77065",
        phone:"(281) 890-0911"
      },
    ],
  
    bio_name: "About Dr. Kumaran Sathyamoorthy",
    bio: `
    Dr. Sathyamoorthy isa urologist practicing primarily at HCA Houston Healthcare North Cypress in Cypress, Texas. In addition to practicing General Urology, he offer laparoscopic and da Vinci robotic assisted Prostate, Renal, Bladder and Pelvic Floor Reconstructive Surgery. He has been trained and regularly operate on the most challenging surgical patients using laparoscopic and robotic assisted minimally invasive procedures. He believes that such an approach enables patients to recover more quickly and with fewer side effects when compared to traditional open surgery.</br>
He graduated Magna Cum Laude from Duke University and has a master's degree in Public Health from Columbia University. He earned his Medical Degree from the State University of New York in Brooklyn where he received the honor of being inducted into the Alpha Omega Alpha (AOA) society. He completed his Urology residency at the prestigious Scott Department of Urology at the Baylor College of Medicine in the Texas Medical Center.</br>
Dr. Sathyamoorthy has lived in Houston for 17 years and enjoys spending his time with his wife Monica, and his two young boys, Keshav and Arjun. They enjoy outdoor activities, bike rides and swimming.</br>
    `,
    education: [
      "Medical Degree from SUNY Downstate Medical School-New York",
      "Undergraduate Degree from Duke University",
      "Internship at Bayor College of Medicine",
      "Residency at Baylor College of Medicine"
    ],
  
    areasOfExpertise: `
    <ul>
    <li>Benign Prostatic Hypertrophy</li>
    <li>Bladder Surgeries</li>
    <li>Incontinence</li>
    <li>Kidney Stone Removal</li>
    <li>Oncology (Surgical) - Prostate</li>
    </ul>
    <ul>
    <li>Prostatectomy</li>
    <li>Removal - Kidney - Laparoscopic</li>
    <li>Urinary Stones W/O Extracorporeal Shock Wave Lithotripsy</li>
    <li>Urinary System Cancers - Bladder</li>
    <li>Urinary Tract Infections</li>
  </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      contentTop:"Robotic-assisted surgery is the latest development in minimally invasive surgery (MIS). Surgeons uses a robotic platform as a tool during the procedure. The surgical robot has interactive arms that serve as extensions of the surgeon's hands. These arms are equipped with surgical tools and cameras. They can suture, dissect, clamp and manipulate tissue. It provides surgeons the flexibility of traditional open surgery while operating through tiny incisions, which can lead to fewer complications during surgery and a shorter recovery period for patients.",
      slope: true
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Penner T. Schraudenbach, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },
  
    cardioThoracicDetailData: {
      title:"ROBOTIC SURGERY",
      contentTop:"Robotic surgery enhances surgical precision, flexibility, and control, enabling our team to perform complex procedures with greater accuracy. This advanced, minimally invasive technology allows for smaller incisions and improved patient outcomes compared to traditional techniques.",
      slope: true,
      intoImgData: "/images/providers/426157522_robo.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      mdcontent:
        "Penner T. Schraudenbach, MD is a Urologist in Houston, TX and has over 15 years of experience in the medical field.",
      mdname: "Penner T. Schraudenbach, MD"
    },
  
    id: "Penner T. Schraudenbach, MD",
    name: "Penner T. Schraudenbach, MD",
    image: "/images/doctors/mohammed-tarek-al-fahl.jpg",
    phone: "281-351-5174",
    gender: "Male",
    language: "English",
  
    specialty: "Urology",
  
    degrees: [
      "Doctor of Medicine"
    ],
  
    clinics: [
      {
        name: "Texas Urology Specialists-Houston Willowbrook",
        address: "13215 Dotson Road, Suite 170B, Houston, TX 77070",
        phone:"(281) 351-5174"
      },
      {
        name: "Texas Urology Specialists-Tomball",
        address: "506 Graham Dr., Suite 150, Tomball, TX 77375",
        phone:"(281) 351-5174"
      },
    ],
  
    bio_name: "About Dr. Penner T. Schraudenbach",
    bio: `
    Dr. Schraudenbach is board certified in urology and specializes in pediatric and adult urology including the treatment of low testosterone, erectile dysfunction, kidney stones, benign prostatic hyperplasia, and urinary incontinence. He also focuses on cancers of the prostate, bladder, kidneys, and testicles. Dr. Schraudenbach sees patients of all ages and specializes in minimally invasive and robotic surgery.</br>
    Dr. Schraudenbach is originally from Philadelphia and is married with four children. He enjoys traveling. Dr. Schraudenbach gives frequent talks in the community to promote awareness of urologic disorders.
    `,
    education: [
      "Medical Doctorate from The University of Texas Medical School",
      "Residency (Urology) at The University of Texas Medical School",
      "Fellowship at University of Texas Medical Center at San Antonio"
    ],
  
    areasOfExpertise: `
    <ul>
      <li>Bladder Cancer</li>
      <li>Prostate Cancer</li>
      <li>Rezum Procedure</li>
      <li>Sexual Dysfunction</li>
      <li>Testosterone Therapy</li>
      </ul>
      <ul>
      <li>TURP Procedure</li>
      <li>Ureteroscopy</li>
      <li>Urolift Procedure</li>
      <li>Urology Oncology</li>
      <li>Vasectomy / Vasectomy Reversal</li>
    </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      contentTop:"Robotic-assisted surgery is the latest development in minimally invasive surgery (MIS). Surgeons uses a robotic platform as a tool during the procedure. The surgical robot has interactive arms that serve as extensions of the surgeon's hands. These arms are equipped with surgical tools and cameras. They can suture, dissect, clamp and manipulate tissue. It provides surgeons the flexibility of traditional open surgery while operating through tiny incisions, which can lead to fewer complications during surgery and a shorter recovery period for patients.",
      slope: true
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Nicholai Stephens, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },
  
    cardioThoracicDetailData: {
      title:"ROBOTIC SURGERY",
      contentTop:"Robotic surgery enhances surgical precision, flexibility, and control, enabling our team to perform complex procedures with greater accuracy. This advanced, minimally invasive technology allows for smaller incisions and improved patient outcomes compared to traditional techniques.",
      slope: true,
      intoImgData: "/images/providers/426157522_robo.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      mdcontent:
        "Nicholai Stephens, MD is a Urologist in Houston, TX and has over 10 years of experience in the medical field.",
      mdname: "Nicholai Stephens, MD"
    },
  
    id: "Nicholai Stephens, MD",
    name: "Nicholai Stephens, MD",
    image: "/images/doctors/mohammed-tarek-al-fahl.jpg",
    phone: "832-672-6266",
    gender: "Male",
    language: "English",
  
    specialty: "General Surgery",
  
    degrees: [
      "Doctor of Medicine"
    ],
  
    clinics: [
      {
        name: "Surgical Associates of Houston",
        address: "12121 Richmond Ave, Ste 103, Houston, TX 77082",
        phone:"713-935-9758"
      },
      {
        name: "Surgical Associates of Houston- Vein Institute",
        address: "1140 Business Center Dr #403, Houston, TX 77043",
        phone:"713-935-9758"
      },
    ],
  
    bio_name: "About Dr.Nicholai Stephens",
    bio: `
    Dr. Stephens is a board-certified general surgeon who has been practicing for over 10 years, most of that in the Houston area.  Having grown up in northern Texas, he moved to Houston to attend college at Rice University and medical school at University of Texas-Houston (McGovern) Medical School.  He then spent a five-year sojourn in Long Island, New York to complete his general surgery training at Nassau University Medical Center before returning to Houston to finish fellowships in Minimally Invasive-Bariatric surgery and Minimally Invasive-Colorectal surgery.  He has a passion for laparoscopic and robotic surgery, helping to minimize patients’ post operative pain and hasten recovery.  He has special interests in hernia repair, reflux surgery and colon surgery. 
    `,
    education: [
      "Medical Degree from M.P. Shah Medical College- India",
      "Fellowship at Vanderbuilt University Medical Center",
      "Residency at Long Island Jewish Medical Center",
      "Internship at St. Vincent's Hospital and Medical Center of NY"
    ],
  
    areasOfExpertise: `
    <ul>
    <li>Abdominal Hernia Repair Surgery</li>
    <li>Appendicitis / Appendectomy</li>
    <li>Colon Removal</li>
    <li>Gallstones / Gallbladder Removal</li>
    </ul>
    <ul>
    <li>Inguinal Hernia</li>
    <li>Intestinal / Bowel Obstruction</li>
    <li>Lipomas</li>
    <li>Ventral Hernia</li>
  </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      contentTop:"Robotic-assisted surgery is the latest development in minimally invasive surgery (MIS). Surgeons uses a robotic platform as a tool during the procedure. The surgical robot has interactive arms that serve as extensions of the surgeon's hands. These arms are equipped with surgical tools and cameras. They can suture, dissect, clamp and manipulate tissue. It provides surgeons the flexibility of traditional open surgery while operating through tiny incisions, which can lead to fewer complications during surgery and a shorter recovery period for patients.",
      slope: true
    },
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Karen Tart, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },
  
    cardioThoracicDetailData: {
      title:"ROBOTIC SURGERY",
      contentTop:"Robotic surgery enhances surgical precision, flexibility, and control, enabling our team to perform complex procedures with greater accuracy. This advanced, minimally invasive technology allows for smaller incisions and improved patient outcomes compared to traditional techniques.",
      slope: true,
      intoImgData: "/images/providers/426157522_robo.jpg"
    },
  
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/R-Tart.jpg",
      title: "ROBOTIC SURGERY",
      mdcontent:
        "Karen Tart, MD is a urologist in Sugar Land, Texas and is affiliated with multiple hospitals in the area. She received her medical degree from McGovern Medical School at UTHealth and has been in practice between 11-20 years. She has expertise in treating kidney removal surgery, among other urological conditions.",
      mdname: "Karen Tart, MD"
    },
  
    id: "Karen Tart, MD",
    name: "Karen Tart, MD",
    image: "/images/home/R-Tart.jpg",
    phone: "281-725-5970",
    gender: "Female",
    language: "English",
  
    specialty: "Urological Surgery",
  
    degrees: [
      "Doctor of Medicine"
    ],
  
    clinics: [
      {
        name: "Memorial Hermann Medical Group Sugar Land Multi-Specialty",
        address: "17520 West Grand Pkwy South, Suite 350, Sugar Land, TX 77479",
        phone:"(281) 725-5970"
      },
    ],
  
    bio_name: "About Dr.Karen Tart",
    bio: `
    Dr. Tart treats all general urological conditions for male and female patients 18 years and older. Her medical training and minimally invasive surgical expertise allows her to evaluate and treat a wide range of urological problems such as kidney stones, incontinence, enlarged prostates, overactive bladder, obstructions of the urinary tract, sexual dysfunction as well as cancers of the kidney, bladder and prostate. Dr. Tart understands the sensitive nature of seeking care for urological conditions as she creates a caring and comfortable environment for her patients. Her goal is to partner with her patients by listening closely to understand their symptoms and reach an outcome to improve their quality of life.
    `,
    education: [
      "Medical Degree from McGovern Medical School at UTHealth",
      "Bachelor of Science, Biology, Cum Laude from University of Texas",
      "Residency (Urology) from University of Arkansas for Medical Sciences (UAMS) College of Medicine"
    ],
  
    areasOfExpertise: `
    <ul>
    <li>Bladder Disease</li>
    <li>Erectile Dysfunction</li>
    <li>Kidney Cysts</li>
    <li>Kidney Removal Surgery</li>
    </ul>
    <ul>
    <li>Kidney Stone Disease</li>
    <li>Testicular Dysfunction</li>
    <li>Transurethral Procedures</li>
    <li>Urinary Tract Infection (UTI)</li>
  </ul>
    `,
  
    generalSurgeryDetaillinkData: {
      link: "https://embed-cloudfront.wistia.com/deliveries/0ba19d2080642fe0e6c7525ba1a5f94766f6df3c.m3u8",
      // introImg: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      contentTop:"Robotic-assisted surgery is the latest development in minimally invasive surgery (MIS). Surgeons uses a robotic platform as a tool during the procedure. The surgical robot has interactive arms that serve as extensions of the surgeon's hands. These arms are equipped with surgical tools and cameras. They can suture, dissect, clamp and manipulate tissue. It provides surgeons the flexibility of traditional open surgery while operating through tiny incisions, which can lead to fewer complications during surgery and a shorter recovery period for patients.",
      slope: true
    },
  },
  // new surgeons 
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Alan E. Hananel, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },

    cardioThoracicDetailData: {
      title: "ROBOTIC SURGERY",
      contentTop: "Robotic surgery enhances surgical precision, flexibility, and control, enabling our team to perform complex procedures with greater accuracy. This advanced, minimally invasive technology allows for smaller incisions and improved patient outcomes compared to traditional techniques.",
      slope: true,
      intoImgData: "/images/providers/426157522_robo.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/R-Hanamel.png",
      title: "UROLOGIST",
      mdcontent:
        "Alan E. Hananel, MD has been in practice since 1994. Understanding that urology involves matters that many people feel uneasy discussing, Dr. Hananel offers a relaxing environment where patients feel comfortable to share their problems.",
      mdname: "ALAN E. HANANEL, MD"
    },

    id: "alan-hananel-md",
    name: "Alan E. Hananel, MD",
    image: "/images/physianDirectory/R-Hananel.jpg",
    phone: "281-325-1090",
    gender: "Male",
    language: "English, Spanish",
    specialty: "Urological Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Houston Metro Urology- Sugar Land",
        address: "16605 Southwest Fwy, Ste 250, Sugar Land, TX 77479",
        phone: "(281) 325-1090"
      },
      {
        name: "Houston Metro Urology- Southwest",
        address: "7777 Southwest Freeway, Ste 1032, Medical Plaza 1, Houston, TX 77074",
        phone: "(713) 771-9224"
      },
      {
        name: "Houston Metro Urology- West Houston",
        address: "12121 Richmond Ave, Ste 112, Houston, TX 77082",
        phone: "(281) 493-9966"
      }
    ],

    bio_name: "About Dr. Alan E. Hananel",
    bio: `Dr. Hananel earned his Bachelor of Arts degree in biology and chemistry at the University of Texas at Austin. He moved to San Antonio for medical school at the University of Texas Health Science Center. He then completed his training in general surgery and his urology residency at Louisiana State University Medical Center/Alton Ochsner Medical Foundation in New Orleans.</br></br>
He treats conditions affecting the male and female urinary tract and male reproductive organs, including bladder or prostate cancer, kidney stones, urinary tract infections and other genitourinary disorders. One of his main goals is to create a relaxing environment where people feel comfortable enough to share their problems.</br></br>
Dr. Hananel is a member of the American Medical Association, American Urological Association, American Association of Clinical Urologists and Texas Medical Association. When he's not working, Alan Hananel MD enjoys spending time with his wife and two sons. His outdoor interests include diving, skiing and fishing.`,

    education: [
      "Medical Degree from University of Texas Health Science Center- San Antonio",
      "Bachelor of Arts Degree (Biology and Chemistry) from University of Texas- Austin",
      "Residency (General Surgery and Urology) at Louisiana State University Medical Center- Tulane",
      "Fellowship (Urology) at Alton Ochsner Medical Foundation"
    ],

    areasOfExpertise: `<ul>
      <li>Bladder Cancer</li>
      <li>Kidney Stones</li>
      <li>Nighttime Urination</li>
      <li>Prostate Cancer</li>
      <li>Prostate Stones</li>
    </ul>
    <ul>
      <li>Transurethral Resection of Prostate (TURP)</li>
      <li>Urinary Endoscopy</li>
      <li>Urinary Incontinence</li>
      <li>Urinary Tract Cancer</li>
      <li>Urinary Tract Infection (UTI)</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      contentTop: "Robotic-assisted surgery is the latest development in minimally invasive surgery (MIS). Surgeons uses a robotic platform as a tool during the procedure. The surgical robot has interactive arms that serve as extensions of the surgeon's hands. These arms are equipped with surgical tools and cameras. They can suture, dissect, clamp and manipulate tissue. It provides surgeons the flexibility of traditional open surgery while operating through tiny incisions, which can lead to fewer complications during surgery and a shorter recovery period for patients.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Antonio N. Villamor III, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },

    cardioThoracicDetailData: {
      title: "ROBOTIC SURGERY",
      contentTop: "Robotic surgery enhances surgical precision, flexibility, and control, enabling our team to perform complex procedures with greater accuracy. This advanced, minimally invasive technology allows for smaller incisions and improved patient outcomes compared to traditional techniques.",
      slope: true,
      intoImgData: "/images/providers/426157522_robo.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/R-Villamor.avif",
      title: "COLORECTAL SURGEON",
      mdcontent:
        "Antonio Nathan Villamor III, MD, is board certified in colon and rectal surgery and general surgery. Dr. Villamor is a fellowship-trained colon and rectal surgeon practicing in the Houston area. He is well versed in a range of colon and rectal diseases, with a focus on minimally invasive laparoscopic and robotic surgery.",
      mdname: "ANTONIO N. VILLAMOR III, MD"
    },

    id: "antonio-villamor-md",
    name: "Antonio N. Villamor III, MD",
    image: "/images/physianDirectory/R-Villamor.jpg",
    phone: "832-220-3018",
    gender: "Male",
    language: "English, Tagalog",
    specialty: "Colon & Rectal Surgery, Surgical Oncology",

    degrees: ["Medical Doctorate"],

    clinics: [
      {
        name: "Texas Colon & Rectal Specialists-Pasadena",
        address: "4000 Spencer Highway, Suite 200, Pasadena, TX 77504",
        phone: "(832) 220-3018"
      },
      {
        name: "Texas Colon & Rectal Specialists - Webster",
        address: "400 W. Medical Center Blvd., Ste 205, Webster, TX 77598",
        phone: "(832) 932-1720"
      }
    ],

    bio_name: "About Dr. Antonio N. Villamor III",
    bio: `Dr. Villamor is Board Certified by the American Board of Surgery and board eligible for the American Board of Colon and Rectal Surgeons. He completed his undergraduate training at Villanova University, where he graduated summa cum laude in Biology with a minor in Computer Science. He received his medical degree from the Stony Brook School of Medicine (now Renaissance School of Medicine). He completed his general surgery internship and residency at the UT Southwestern/Parkland program in Dallas, Texas.</br></br>
He pursued further training in colon and rectal surgery, completing an Advanced Colorectal Surgery Fellowship in July 2022 and the ACGME Colorectal Surgery Fellowship in July 2023 at the Orlando Health Colon and Rectal Institute at Orlando, FL.</br></br>
He is well versed in the management of a range of colon and rectal disease, with a focus on minimally invasive laparoscopic as well as robotic surgery.`,

    education: [
      "Medical Doctorate from Renaissance School of Medicine at Stony Brook University",
      "Bachelor of Science Degree (Biology), Summa Cum Laude from Villanova University",
      "Residency (General Surgery) at The University of Texas Southwestern Medical Center, Dallas",
      "Fellowship (Colon and Rectal Surgery) at Orlando Health Colon and Rectal Institute",
      "Fellowship (Minimally Invasive Surgery-Advanced Colon and Rectal Surgery) at Orlando Health Colon and Rectal Institute"
    ],

    areasOfExpertise: `<ul>
      <li>Appendicitis</li>
      <li>Colon & Rectal Cancer</li>
      <li>Colorectal Diseases</li>
      <li>Diverticulitis</li>
      <li>Fistulas and Fissures</li>
    </ul>
    <ul>
      <li>Hemorrhoidectomy & Excision of Tags</li>
      <li>Incontinence</li>
      <li>Lower GI Conditions and Repairs</li>
      <li>Rectal Prolapse</li>
      <li>Ulcerative Colitis</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=_ctWFhdxogU",
      title: "ROBOTIC SURGERY",
      contentTop: "Robotic-assisted surgery is the latest development in minimally invasive surgery (MIS). Surgeons uses a robotic platform as a tool during the procedure. The surgical robot has interactive arms that serve as extensions of the surgeon's hands. These arms are equipped with surgical tools and cameras. They can suture, dissect, clamp and manipulate tissue. It provides surgeons the flexibility of traditional open surgery while operating through tiny incisions, which can lead to fewer complications during surgery and a shorter recovery period for patients.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Bryan Pham, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },

    cardioThoracicDetailData: {
      title: "ROBOTIC SURGERY",
      contentTop: "Robotic surgery enhances surgical precision, flexibility, and control, enabling our team to perform complex procedures with greater accuracy. This advanced, minimally invasive technology allows for smaller incisions and improved patient outcomes compared to traditional techniques.",
      slope: true,
      intoImgData: "/images/providers/426157522_robo.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/R-BryanPham.webp",
      title: "UROLOGIST",
      mdcontent:
        "Bryan Pham, MD is an urologist in Houston, Texas. He received his medical degree from Baylor College of Medicine and has expertise in treating surgical removal of the bladder, kidney removal surgery, among other conditions.",
      mdname: "BRYAN PHAM, MD"
    },

    id: "bryan-pham-md",
    name: "Bryan Pham, MD",
    image: "/images/physianDirectory/R-BPham.jpg",
    phone: "713-366-7831",
    gender: "Male",
    language: "English",
    specialty: "Urological Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Crescent Urology Institute",
        address: "1200 Binz St Ste 690, Houston, TX 77004",
        phone: "(713) 366-7831"
      }
    ],

    bio_name: "About Dr. Bryan Pham",
    bio: `Dr. Bryan Pham is a native Texan who grew up in Arlington, Texas, where he earned his undergraduate degree in biology summa cum laude from the University of Texas at Arlington. He then completed his medical degree at Baylor College of Medicine and his urologic residency at Washington University in St. Louis.</br></br>
Dr. Pham is a general urologic surgeon with specific interests in robotic and minimally invasive surgery for the treatment of benign and malignant conditions. He is trained in the da Vinci surgical system but understands that surgery should be tailored to each individual patient's needs.</br></br>
Dr. Pham strongly believes there is a lack of awareness for men's health and advocates for comprehensive care for men. When he is not devoting his time to his patients, Dr. Pham enjoys running, weight training, video games, fishing, and spending time with his French bulldog.`,

    education: [
      "Medical Degree from Baylor College of Medicine",
      "Undergraduate Degree (Biology) from University of Texas at Arlington",
      "Residency (Surgery) at Washington University School of Medicine in St. Louis"
    ],

    areasOfExpertise: `<ul>
      <li>Bladder Disease</li>
      <li>Enlarged Prostate</li>
      <li>Hydronephrosis</li>
      <li>Kidney Removal Surgery</li>
      <li>Kidney Stone Disease</li>
    </ul>
    <ul>
      <li>Testicular Dysfunction</li>
      <li>Transurethral Procedures</li>
      <li>Urinary Incontinence</li>
      <li>Urinary Tract Infection (UTI)</li>
      <li>Urine Flow Blockage</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      contentTop: "Robotic-assisted surgery is the latest development in minimally invasive surgery (MIS). Surgeons uses a robotic platform as a tool during the procedure. The surgical robot has interactive arms that serve as extensions of the surgeon's hands. These arms are equipped with surgical tools and cameras. They can suture, dissect, clamp and manipulate tissue. It provides surgeons the flexibility of traditional open surgery while operating through tiny incisions, which can lead to fewer complications during surgery and a shorter recovery period for patients.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Denis K. Hoasjoe, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },

    cardioThoracicDetailData: {
      title: "ROBOTIC SURGERY",
      contentTop: "Robotic surgery enhances surgical precision, flexibility, and control, enabling our team to perform complex procedures with greater accuracy. This advanced, minimally invasive technology allows for smaller incisions and improved patient outcomes compared to traditional techniques.",
      slope: true,
      intoImgData: "/images/providers/426157522_robo.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/R-Hoasjoe.jpg",
      title: "OTOLARYNGOLOGIST",
      mdcontent:
        "Denis K. Hoasjoe, MD is an ENT-otolaryngologist in Baytown, Texas and has been in practice for more than 20 years.",
      mdname: "DENIS K. HOASJOE, MD"
    },

    id: "denis-hoasjoe-md",
    name: "Denis K. Hoasjoe, MD",
    image: "/images/physianDirectory/R-Hoasjoe.jpg",
    phone: "281-422-9167",
    gender: "Male",
    language: "English, Chinese",
    specialty: "Otolaryngology-Head & Neck Surgery, Plastic Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Baytown Clinic",
        address: "4301 Garth Rd Ste 216, Baytown, TX 77521",
        phone: "(281) 422-9167"
      }
    ],

    bio_name: "About Dr. Denis K. Hoasjoe",
    bio: `Dr. Hoasjoe is a Board-certified otolaryngology specialist who spent 7 years on staff at LSU Medical Center. Having a background in hearing-loss and sinus casework, Dr. Hoasjoe has provided effective, compassionate care to his patients for over 20 years.</br></br>
His strong academic background and decades of clinical experience enable him to stay at the forefront of ENT medicine. His thoughtful, methodical approach to diagnosis and treatment has earned the trust of generations of families across the Greater Houston area.</br></br>
Dr. Hoasjoe is a married, father of two who spends his free time fishing and hunting with his dogs.`,

    education: [
      "Medical Degree from University of Toronto Faculty of Medicine",
      "Residency (Surgery) at St. Elizabeth Youngstown Hospital"
    ],

    areasOfExpertise: `<ul>
      <li>Acute Sinusitis</li>
      <li>Chronic Allergies</li>
      <li>Endoscopic Sinus Surgery</li>
      <li>Head and Neck Tumors</li>
      <li>Hearing Loss and Impairment</li>
    </ul>
    <ul>
      <li>Laryngitis</li>
      <li>Neck lymph node metastases</li>
      <li>Sleep Apnea</li>
      <li>Thyroid Disorders</li>
      <li>Tracheal dilation or resection for stenosis</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      contentTop: "Robotic-assisted surgery is the latest development in minimally invasive surgery (MIS). Surgeons uses a robotic platform as a tool during the procedure. The surgical robot has interactive arms that serve as extensions of the surgeon's hands. These arms are equipped with surgical tools and cameras. They can suture, dissect, clamp and manipulate tissue. It provides surgeons the flexibility of traditional open surgery while operating through tiny incisions, which can lead to fewer complications during surgery and a shorter recovery period for patients.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Dung Q. Pham, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },

    cardioThoracicDetailData: {
      title: "ROBOTIC SURGERY",
      contentTop: "Robotic surgery enhances surgical precision, flexibility, and control, enabling our team to perform complex procedures with greater accuracy. This advanced, minimally invasive technology allows for smaller incisions and improved patient outcomes compared to traditional techniques.",
      slope: true,
      intoImgData: "/images/providers/426157522_robo.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/R-DungPham.webp",
      title: "PEDIATRIC UROLOGIST",
      mdcontent:
        "Dung Q. Pham, MD is the only Pediatric Urologist in the Houston, Texas area. He has over 20 years of experience and consistently performs the majority of his surgery for babies under a spinal block, which cuts out the need for general anesthesia.",
      mdname: "DUNG Q. PHAM, MD"
    },

    id: "dung-pham-md",
    name: "Dung Q. Pham, MD",
    image: "/images/physianDirectory/R-DPham.jpg",
    phone: "713-366-7831",
    gender: "Male",
    language: "English",
    specialty: "Pediatric Urology, Urological Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Crescent Urology Institute",
        address: "1200 Binz St Ste 690, Houston, TX 77004",
        phone: "(713) 366-7831"
      }
    ],

    bio_name: "About Dr. Dung Q. Pham",
    bio: `Dr. Pham graduated magna cum laude from The University of Texas in Arlington and received his medical degree from The University of Texas Health Science Center at Houston (UT Health) Medical School, where he also completed his residency. He continued his training in pediatric urology at Baylor College of Medicine and Texas Children's Hospital.</br></br>
Dr. Pham is a member of many regional and national societies, including the American Urological Society and The Society of Pediatric Urology. He currently serves as Chief of Pediatric Urology at Children's Memorial Hermann Hospital. He treats all pediatric urologic conditions using minimally invasive laparoscopic and single port surgical techniques.</br></br>
Dr. Pham recognizes that his patients and their parents may be anxious, so he stresses compassionate listening in his practice. He also participates in missionary work, training doctors in other countries how to care for their youngest citizens.`,

    education: [
      "Medical Degree from University of Texas Medical School- Houston",
      "Bachelor Degree (Biology) magna cum laude from University of Texas- Arlington",
      "Residency (General Urology) at University of Texas Medical School- Houston",
      "Fellowship (Pediatric Urology) at Baylor College of Medicine",
      "Fellowship (Pediatric Urology) at Texas Children's Hospital"
    ],

    areasOfExpertise: `<ul>
      <li>Balanitis</li>
      <li>Balanoposthitis</li>
      <li>Chordee</li>
      <li>Circumcision</li>
      <li>Complex Penile Surgery</li>
    </ul>
    <ul>
      <li>Diphallia</li>
      <li>Hypospadias</li>
      <li>Phimosis</li>
      <li>Post-Circumcision Adhesions</li>
      <li>Testicular Dysfunction</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      contentTop: "Robotic-assisted surgery is the latest development in minimally invasive surgery (MIS). Surgeons uses a robotic platform as a tool during the procedure. The surgical robot has interactive arms that serve as extensions of the surgeon's hands. These arms are equipped with surgical tools and cameras. They can suture, dissect, clamp and manipulate tissue. It provides surgeons the flexibility of traditional open surgery while operating through tiny incisions, which can lead to fewer complications during surgery and a shorter recovery period for patients.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Leo Lapuerta, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },

    cardioThoracicDetailData: {
      title: "ROBOTIC SURGERY",
      contentTop: "Robotic surgery enhances surgical precision, flexibility, and control, enabling our team to perform complex procedures with greater accuracy. This advanced, minimally invasive technology allows for smaller incisions and improved patient outcomes compared to traditional techniques.",
      slope: true,
      intoImgData: "/images/providers/426157522_robo.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/R-Lapuerta.webp",
      title: "PLASTIC & RECONSTRUCTIVE SURGEON",
      mdcontent:
        "Leopoldo Lapuerta, MD is known as one of the top cosmetic surgeons in Houston, Texas. Over his 30+ years as a surgeon, he has performed more than 30,000 non-invasive cosmetic treatments and surgical procedures with an excellent safety record.",
      mdname: "LEO LAPUERTA, MD"
    },

    id: "leo-lapuerta-md",
    name: "Leo Lapuerta, MD",
    image: "/images/physianDirectory/R-Lapuerta.jpg",
    phone: "713-701-7608",
    gender: "Male",
    language: "English, Spanish",
    specialty: "Plastic Surgery, Hand Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "The Plastic Surgery Institute of Southeast Texas",
        address: "2360 Country Road 94, Ste 104, Pearland, TX 77584",
        phone: "(713) 574-1249"
      },
      {
        name: "Plastic Surgery Houston",
        address: "1919 La Branch Street, Houston, TX 77002",
        phone: "(832) 479-9179"
      },
      {
        name: "Leo Lapuerta, MD, Plastic Surgery",
        address: "21312 Provincial Blvd #B, Katy, TX 77450",
        phone: "(281) 694-4939"
      }
    ],

    bio_name: "About Dr. Leo Lapuerta",
    bio: `Dr. Lapuerta is board certified in three areas: general surgery, plastic surgery and surgery of the hand. He has performed over 30,000 plastic surgery procedures and thousands of non-invasive cosmetic treatments with an excellent safety record.</br></br>
His practice includes the full spectrum of aesthetic plastic surgery with expertise in procedures for the face and body as well as reconstructive surgery. He offers the skill only experience can bring and the most current knowledge and techniques available through his continuing commitment to plastic surgery education. He is the Chief of Plastic Surgery at St. Joseph Hospital and a member of the teaching faculty for the Methodist Hospital and UTMB Plastic Surgery Residency programs.`,

    education: [
      "Medical Degree from University of Texas Southwestern Medical School",
      "Undergraduate Degree from Stanford University",
      "Residency (General Surgery) at St. John Medical Center in Detroit",
      "Fellowship (Plastic & Reconstructive Surgery) at St. Joseph Hospital in Houston"
    ],

    areasOfExpertise: `<ul>
      <li>Facial Reconstruction</li>
      <li>Fracture of the Hand</li>
      <li>Hand Surgery</li>
      <li>Mastectomy</li>
      <li>Plastic Surgery</li>
    </ul>
    <ul>
      <li>Reconstructive Surgery</li>
      <li>Rheumatoid Arthritis</li>
      <li>Rhinoplasty</li>
      <li>Skin Tightening</li>
      <li>Tummy Tuck</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      contentTop: "Robotic-assisted surgery is the latest development in minimally invasive surgery (MIS). Surgeons uses a robotic platform as a tool during the procedure. The surgical robot has interactive arms that serve as extensions of the surgeon's hands. These arms are equipped with surgical tools and cameras. They can suture, dissect, clamp and manipulate tissue. It provides surgeons the flexibility of traditional open surgery while operating through tiny incisions, which can lead to fewer complications during surgery and a shorter recovery period for patients.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "M. Brian Harkins, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },

    cardioThoracicDetailData: {
      title: "ROBOTIC SURGERY",
      contentTop: "Robotic surgery enhances surgical precision, flexibility, and control, enabling our team to perform complex procedures with greater accuracy. This advanced, minimally invasive technology allows for smaller incisions and improved patient outcomes compared to traditional techniques.",
      slope: true,
      intoImgData: "/images/providers/426157522_robo.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/R-Harkins.webp",
      title: "GENERAL SURGEON",
      mdcontent:
        "Brian Harkins, MD is a renowned surgeon specializing in advanced, minimally invasive, and robotic surgical techniques. He is currently the Medical Director of Robotics for the Gulf Coast Division of HCA and is proud to be certified by the American Board of Surgery and to be a Fellow of the American College of Surgeons.",
      mdname: "M. BRIAN HARKINS, MD"
    },

    id: "m-brian-harkins-md",
    name: "M. Brian Harkins, MD",
    image: "/images/physianDirectory/R-Harkins.jpg",
    phone: "281-801-7207",
    gender: "Male",
    language: "English",
    specialty: "General Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Surgical Advanced Specialty Center",
        address: "455 School Street, Bldg 1, Suite 10, Tomball, TX 77375",
        phone: "(281) 247-0495"
      }
    ],

    bio_name: "About Dr. M. Brian Harkins",
    bio: `Dr. Harkins began his professional journey in 1978 when he joined the U.S. Air Force. He earned his medical degree from LSU Medical School in 1984, gaining valuable clinical experience at Charity Hospital in New Orleans. Dr. Harkins completed his general surgery residency at Eisenhower Army Medical Center in Augusta, Georgia, where he received awards for Outstanding Graduating Resident and Outstanding Resident Laparoscopic Surgeon.</br></br>
After 16 years of military service, Dr. Harkins established his surgical practice in Tomball, Texas in 1997. In 2014, Dr. Harkins embraced the latest DaVinci surgical system platform, making him a leader in robotic surgery and earning him recognition as one of the top 1% of general surgeons globally for his experience with the technology.</br></br>
Since moving to Tomball, Texas, in 1997, he has embraced the warm, community-oriented atmosphere of the area and considers it his permanent home.`,

    education: [
      "Medical Degree from LSU Medical School- New Orleans",
      "Residency (General Surgery) at Eisenhower Army Medical Center- Georgia"
    ],

    areasOfExpertise: `<ul>
      <li>Breast Surgery</li>
      <li>Robotic Appendix Surgery</li>
      <li>Robotic Colorectal Surgery</li>
      <li>Robotic Gallbladder Surgery</li>
      <li>Robotic Hernia Surgery</li>
    </ul>
    <ul>
      <li>Robotic Spleen Surgery</li>
      <li>Skin Lumps & Bump Removal</li>
      <li>Surgical Colonoscopies</li>
      <li>Surgical Endoscopies</li>
      <li>Thyroid Surgery</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=bF7bAD2TQX8",
      title: "ROBOTIC SURGERY",
      contentTop: "Robotic-assisted surgery is the latest development in minimally invasive surgery (MIS). Surgeons uses a robotic platform as a tool during the procedure. The surgical robot has interactive arms that serve as extensions of the surgeon's hands. These arms are equipped with surgical tools and cameras. They can suture, dissect, clamp and manipulate tissue. It provides surgeons the flexibility of traditional open surgery while operating through tiny incisions, which can lead to fewer complications during surgery and a shorter recovery period for patients.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Ori Hampel, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },

    cardioThoracicDetailData: {
      title: "ROBOTIC SURGERY",
      contentTop: "Robotic surgery enhances surgical precision, flexibility, and control, enabling our team to perform complex procedures with greater accuracy. This advanced, minimally invasive technology allows for smaller incisions and improved patient outcomes compared to traditional techniques.",
      slope: true,
      intoImgData: "/images/providers/426157522_robo.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/R-Hampel.jpg",
      title: "UROLOGIST",
      mdcontent:
        "Ori Hampel, MD is an urologist in Pasadena, Texas. He received his medical degree from Case Western Reserve University School of Medicine and has been in practice for more than 20 years. He has expertise in treating kidney disease, kidney removal surgery, prostate cancer, among other conditions.",
      mdname: "ORI HAMPEL, MD"
    },

    id: "ori-hampel-md",
    name: "Ori Hampel, MD",
    image: "/images/physianDirectory/R-Hampel.jpg",
    phone: "713-477-8600",
    gender: "Male",
    language: "English",
    specialty: "Urology",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Adult and Pediatric Urology of Houston- Pasadena Office",
        address: "3230 Strawberry Rd., Pasadena, TX 77504",
        phone: "(713) 477-8600"
      },
      {
        name: "Adult and Pediatric Urology of Houston- Webster Office",
        address: "534 Orchard Street, Webster, TX 77598",
        phone: "(713) 477-8600"
      }
    ],

    bio_name: "About Dr. Ori Hampel",
    bio: `Dr. Hampel earned his BA degree from Case Western Reserve University, where he was elected into Phi Beta Kappa as he completed a triple major in biochemistry, English, and chemistry. He then received his MD degree from Case Western Reserve University School of Medicine. Upon completing medical school, Dr. Hampel moved to Houston to obtain his graduate training in General Surgery and Urology at Baylor College of Medicine. He is a Diplomate of the American Board of Urology.</br></br>
Since finishing his training in 1998, Dr. Hampel has been practicing adult and pediatric urology and urologic surgery in the Greater Houston Area. He was named one of "Houston's Top Docs" by H Texas Magazine.</br></br>
Dr. Hampel has served the Harris County Medical Society on the Board of Socioeconomics and on the Managed Care Committee, and has been serving as a Delegate to the Texas Medical Association House of Delegates.`,

    education: [
      "Medical Degree from Case Western Reserve University School of Medicine",
      "BA Degree from Case Western Reserve University",
      "Residency (General Surgery) at Baylor College of Medicine",
      "Residency (Urology) at Baylor College of Medicine"
    ],

    areasOfExpertise: `<ul>
      <li>Erectile Dysfunction</li>
      <li>Hydronephrosis</li>
      <li>Incontinence</li>
      <li>Kidney Stones</li>
      <li>Lithotripsy</li>
    </ul>
    <ul>
      <li>Overactive Bladder</li>
      <li>Prostate Cancer</li>
      <li>Prolapse Surgery</li>
      <li>Urinary Tract Infection</li>
      <li>Vasectomy</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      contentTop: "Robotic-assisted surgery is the latest development in minimally invasive surgery (MIS). Surgeons uses a robotic platform as a tool during the procedure. The surgical robot has interactive arms that serve as extensions of the surgeon's hands. These arms are equipped with surgical tools and cameras. They can suture, dissect, clamp and manipulate tissue. It provides surgeons the flexibility of traditional open surgery while operating through tiny incisions, which can lead to fewer complications during surgery and a shorter recovery period for patients.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Robert A. Darling, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },

    cardioThoracicDetailData: {
      title: "ROBOTIC SURGERY",
      contentTop: "Robotic surgery enhances surgical precision, flexibility, and control, enabling our team to perform complex procedures with greater accuracy. This advanced, minimally invasive technology allows for smaller incisions and improved patient outcomes compared to traditional techniques.",
      slope: true,
      intoImgData: "/images/providers/426157522_robo.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/R-Darling.jpg",
      title: "OTOLARYNGOLOGIST",
      mdcontent:
        "Robert A. Darling, MD is an ENT-otolaryngologist in Friendswood, Texas. He is affiliated with multiple hospitals in the area and has been in practice between 11-20 years.",
      mdname: "ROBERT A. DARLING, MD"
    },

    id: "robert-darling-md",
    name: "Robert A. Darling, MD",
    image: "/images/physianDirectory/R-Darling.jpg",
    phone: "281-895-2150",
    gender: "Male",
    language: "English",
    specialty: "Otolaryngology",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Darling ENT",
        address: "1106 S. Friendswood Dr., Ste C, Friendswood, TX 77546",
        phone: "(281) 895-2150"
      }
    ],

    bio_name: "About Dr. Robert A. Darling",
    bio: `Dr. Darling is board-certified in otolaryngology from Friendswood, TX. He completed his ENT residency at UTMB in Galveston, Texas, and underwent his medical training at Chicago Medical School. Focusing on head and neck surgeries, he frequently treats conditions like nosebleeds and tonsillitis, and has extensive experience in upper respiratory conditions of the body.`,

    education: [
      "Medical Degree from Rosalind Franklin University of Medicine and Science",
      "Residency (Otolaryngology - Head and Neck Surgery) at University of Texas Medical Branch Hospital- Galveston"
    ],

    areasOfExpertise: `<ul>
      <li>Chronic Nasal Allergies</li>
      <li>Chronic Sinusitis</li>
      <li>Endoscopic Nasal/Sinus Procedures</li>
      <li>External Ear Procedures</li>
      <li>Hearing Loss</li>
    </ul>
    <ul>
      <li>Larynx and Vocal Cord Disease</li>
      <li>Parathyroid/ Thyroid Diseases</li>
      <li>Tonsillitis</li>
      <li>Tracheal Surgery</li>
      <li>Vertigo</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=K3FyMXbi4IE",
      title: "ROBOTIC SURGERY",
      contentTop: "Robotic-assisted surgery is the latest development in minimally invasive surgery (MIS). Surgeons uses a robotic platform as a tool during the procedure. The surgical robot has interactive arms that serve as extensions of the surgeon's hands. These arms are equipped with surgical tools and cameras. They can suture, dissect, clamp and manipulate tissue. It provides surgeons the flexibility of traditional open surgery while operating through tiny incisions, which can lead to fewer complications during surgery and a shorter recovery period for patients.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Robert C. Dillard, DO",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },

    cardioThoracicDetailData: {
      title: "ROBOTIC SURGERY",
      contentTop: "Robotic surgery enhances surgical precision, flexibility, and control, enabling our team to perform complex procedures with greater accuracy. This advanced, minimally invasive technology allows for smaller incisions and improved patient outcomes compared to traditional techniques.",
      slope: true,
      intoImgData: "/images/providers/426157522_robo.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/R-Dillard.webp",
      title: "GENERAL SURGEON",
      mdcontent:
        "Robert C. Dillard, DO is a general surgeon in Houston, Texas. He received his medical degree from William Carey University College of Osteopathic Medicine and has been in practice between 11-20 years. He has expertise in treating colon removal, upper GI endoscopy, bariatric surgery, among other conditions.",
      mdname: "ROBERT C. DILLARD, DO"
    },

    id: "robert-dillard-do",
    name: "Robert C. Dillard, DO",
    image: "/images/physianDirectory/R-Dillard.jpg",
    phone: "281-516-8184",
    gender: "Male",
    language: "English",
    specialty: "General Surgery, Bariatric Surgery, Robotic Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "North Texas Surgical Specialists- West Houston",
        address: "12121 Richmond Ave, Ste 103D, Houston, TX 77082",
        phone: "(281) 516-8184"
      },
      {
        name: "North Texas Surgical Specialists – Pearland",
        address: "10970 Shadow Creek Pkwy, Suite 250, Pearland, TX 77584",
        phone: "(281) 516-8184"
      }
    ],

    bio_name: "About Dr. Robert C. Dillard",
    bio: `Dr. Dillard is a native of Alabama where he attended the University of South Alabama before earning his medical doctorate from William Carey University College of Osteopathic Medicine. He then completed his surgical residency training at the University of Texas Health Science Center at Houston.</br></br>
He pursued specialty training in surgical robotics and bariatrics at the Tower Health Reading Hospital minimally invasive surgical fellowship, where he received extensive training in the comprehensive care of the obese patient population.</br></br>
Dr. Dillard is board certified in General Surgery by the American Osteopathic Board of Surgery. He is certified in bariatric surgery and advanced upper endoscopy by the American Society of Metabolic and Bariatric Surgery, and is certified in the use of robotic surgical devices by Intuitive Surgical.`,

    education: [
      "Medical Degree from William Carey University College of Osteopathic Medicine",
      "Undergraduate Degree from University of South Alabama",
      "Residency (Surgery) at the University of Texas Health Science Center- Houston",
      "Fellowship (Bariatric & Robotic Surgery) at Tower Health Reading Hospital"
    ],

    areasOfExpertise: `<ul>
      <li>Abdominal Pain</li>
      <li>Appendicitis</li>
      <li>Diaphragmatic and Hiatal Hernia</li>
      <li>Duodenal Polypectomy</li>
    </ul>
    <ul>
      <li>Endoscopy</li>
      <li>Laparoscopic Appendectomy</li>
      <li>Laparoscopic Gastric Bypass Surgery</li>
      <li>Sleeve Gastrectomy</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=49AmWTcIMhI",
      title: "ROBOTIC SURGERY",
      contentTop: "Robotic-assisted surgery is the latest development in minimally invasive surgery (MIS). Surgeons uses a robotic platform as a tool during the procedure. The surgical robot has interactive arms that serve as extensions of the surgeon's hands. These arms are equipped with surgical tools and cameras. They can suture, dissect, clamp and manipulate tissue. It provides surgeons the flexibility of traditional open surgery while operating through tiny incisions, which can lead to fewer complications during surgery and a shorter recovery period for patients.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Ryan D. Gunter, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },

    cardioThoracicDetailData: {
      title: "ROBOTIC SURGERY",
      contentTop: "Robotic surgery enhances surgical precision, flexibility, and control, enabling our team to perform complex procedures with greater accuracy. This advanced, minimally invasive technology allows for smaller incisions and improved patient outcomes compared to traditional techniques.",
      slope: true,
      intoImgData: "/images/providers/426157522_robo.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/R-Gunter.jpg",
      title: "COLORECTAL SURGEON",
      mdcontent:
        "Ryan D. Gunter, MD is a fellowship-trained colorectal surgeon in Houston, TX. His top areas of expertise are Diverticular Disease, Secondary Peritonitis, Peritonitis, and Retroperitoneal Inflammation.",
      mdname: "RYAN D. GUNTER, MD"
    },

    id: "ryan-gunter-md",
    name: "Ryan D. Gunter, MD",
    image: "/images/physianDirectory/R-Gunter.jpg",
    phone: "713-790-0600",
    gender: "Male",
    language: "English",
    specialty: "Colon and Rectal Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Houston Colon - Pearland",
        address: "10970 Shadow Creek Parkway Ste 250, Pearland, TX 77584",
        phone: "(713) 790-0600"
      },
      {
        name: "Houston Colon - Sugarland",
        address: "16902 Southwest Fwy, STE 100, Sugarland, TX 77479",
        phone: "(713) 790-0600"
      }
    ],

    bio_name: "About Dr. Ryan D. Gunter",
    bio: `Dr. Gunter attended Texas A&M University where he received a Bachelor of Science in Biomedical Science. He then attended the Texas A&M Health Science Center School of Public Health where he attained a Master's in Public Health in Epidemiology, followed by his Doctor of Medicine at the University of Texas Health Science Center at Houston. Dr. Gunter completed General Surgery residency training and his Colorectal Surgery Fellowship at the same institution.</br></br>
Dr. Gunter treats a broad spectrum of colorectal diseases including colorectal and anal cancer screening, benign anorectal diseases such as hemorrhoids, diverticular disease, fecal incontinence, rectal prolapse, and colorectal cancer. He performs minimally invasive surgery using robotic, laparoscopic, and natural orifice approaches.</br></br>
When not in the hospital, Dr. Gunter spends time with his wife Sarah, son John, and dog Red. He is a Texas A&M Aggie, shade-tree mechanic, amateur pit boss, and loves nothing more than spending time with family and friends.`,

    education: [
      "Doctorate in Medicine Degree from McGovern Medical School, University of Texas",
      "Master of Public Health Degree from Texas A&M University",
      "Bachelor of Science Degree (Biomedical Science) from Texas A&M University",
      "Residency at University of Texas McGovern Medical School",
      "Fellowship (Colon & Rectal Surgery) at University of Texas McGovern Medical School"
    ],

    areasOfExpertise: `<ul>
      <li>Abdominal Hernia</li>
      <li>Appendicitis And Other Appendiceal Conditions</li>
      <li>Colon & Rectal Cancer</li>
      <li>Crohn's Disease</li>
      <li>Diverticulitis</li>
    </ul>
    <ul>
      <li>Fecal Incontinence/Rectal Prolapse Procedures</li>
      <li>Hemorrhoids</li>
      <li>Neurostimulator - Implant/Removal</li>
      <li>Regional Enteritis And Ulcerative Colitis</li>
      <li>Tumor Destruction/Excision - Anus/Rectum</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      contentTop: "Robotic-assisted surgery is the latest development in minimally invasive surgery (MIS). Surgeons uses a robotic platform as a tool during the procedure. The surgical robot has interactive arms that serve as extensions of the surgeon's hands. These arms are equipped with surgical tools and cameras. They can suture, dissect, clamp and manipulate tissue. It provides surgeons the flexibility of traditional open surgery while operating through tiny incisions, which can lead to fewer complications during surgery and a shorter recovery period for patients.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Seyed S. Pairawan, MD",
      content:
        "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },

    cardioThoracicDetailData: {
      title: "ROBOTIC SURGERY",
      contentTop: "Robotic surgery enhances surgical precision, flexibility, and control, enabling our team to perform complex procedures with greater accuracy. This advanced, minimally invasive technology allows for smaller incisions and improved patient outcomes compared to traditional techniques.",
      slope: true,
      intoImgData: "/images/providers/426157522_robo.jpg"
    },

    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/R-Pairawan.jpg",
      title: "VASCULAR SURGEON",
      mdcontent:
        "Seyed S. Pairawan, MD is a general surgeon in Pearland, Texas. He received his medical degree from Charles University in Prague Faculty of Medicine and has been in practice between 11-20 years.",
      mdname: "SEYED S. PAIRAWAN, MD"
    },

    id: "seyed-pairawan-md",
    name: "Seyed S. Pairawan, MD",
    image: "/images/physianDirectory/R-Pairawan.jpg",
    phone: "346-207-6820",
    gender: "Male",
    language: "English",
    specialty: "Vascular Surgery",

    degrees: ["Medical Degree"],

    clinics: [
      {
        name: "Gulf Coast Vascular - Pearland",
        address: "10970 Shadow Creek Pkwy, Suite 370, Pearland, TX 77584",
        phone: "(346) 207-6820"
      }
    ],

    bio_name: "About Dr. Seyed S. Pairawan",
    bio: `Dr. Pairawan is a vascular surgeon with Gulf Coast Vascular. After receiving his doctorate in medicine at Charles University in the Czech Republic, Dr. Pairawan completed his clinical residency in general surgery at Loma Linda University Health in California followed by a National Institute of Health-funded research fellowship in surgical oncology at the MD Anderson Cancer Center. He then completed a clinical fellowship in vascular surgery at Henry Ford Health in Detroit, Michigan.</br></br>
During his research training at MD Anderson, he designed and tested genomic-driven combinatorial therapies in multiple different cancer models, which resulted in Phase 1 clinical trials in patients with breast cancer. He received the Merit Award, a prestigious recognition given to researchers who have made significant contributions to clinical oncology.</br></br>
Dr. Pairawan is a member of the Society of Vascular Surgery, the American College of Surgeons and the American Venous Forum. When he is not treating patients, Dr. Pairawan spends most of his time with his wife and three children, hiking, exercising and traveling.`,

    education: [
      "Medical Degree from Charles University, Czech Republic",
      "Residency (General Surgery) at Loma Linda University Health, Loma Linda, California",
      "Fellowship (Vascular Surgery) at Henry Ford Health, Detroit, Michigan"
    ],

    areasOfExpertise: `<ul>
      <li>Abdominal Aortic Aneurysm</li>
      <li>Arteriovenous Malformations</li>
      <li>Carotid Artery Disease</li>
      <li>Complex Open Aorta Repair</li>
      <li>Deep Vein Thrombosis</li>
      <li>Hemodialysis Access/Shunt Procedures</li>
    </ul>
    <ul>
      <li>Limb Preservation</li>
      <li>Pulmonary Embolism</li>
      <li>Sclerotherapy</li>
      <li>Transcarotid Artery Revascularization</li>
      <li>Varicose Vein Treatment</li>
      <li>Vasculitis</li>
    </ul>`,

    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      contentTop: "Robotic-assisted surgery is the latest development in minimally invasive surgery (MIS). Surgeons uses a robotic platform as a tool during the procedure. The surgical robot has interactive arms that serve as extensions of the surgeon's hands. These arms are equipped with surgical tools and cameras. They can suture, dissect, clamp and manipulate tissue. It provides surgeons the flexibility of traditional open surgery while operating through tiny incisions, which can lead to fewer complications during surgery and a shorter recovery period for patients.",
      slope: true
    }
  },

  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Rohan Kulangara, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title: "ROBOTIC SURGERY",
      contentTop: "Robotic surgery utilizes advanced robotic systems to perform minimally invasive procedures with enhanced precision, flexibility, and control. Surgeons control robotic arms from a console, allowing for smaller incisions, reduced pain, and faster recovery times.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/R-Kulangara.jpg",
      title: "GENERAL SURGEON",
      mdcontent: "Rohan Kulangara, MD, is a board-certified general surgeon at Southwest Surgical Associates, serving the community in Cypress, Memorial City and Katy, ...",
      mdname: "ROHAN KULANGARA, MD"
    },
    id: "rohan-kulangara-md",
    name: "Rohan Kulangara, MD",
    image: "/images/doctors/rohan-kulangara-md.jpg",
    phone: "713-772-1200",
    gender: "Male",
    language: "English, Hindi",
    specialty: "General Laparoscopic Procedures, Minimally Invasive and Robotic Surgery",
    degrees: ["Doctor of Medicine"],
    clinics: [{
        name: "Memorial Hermann Katy",
        address: "23920 Katy Fwy, Ste 410, Katy, TX 77494",
        phone: "(713) 772-1200"
      }, {
        name: "Memorial Hermann- Memorial City",
        address: "915 Gessner Road, Suite 670, Houston, TX 77024",
        phone: "(713) 772-1200"
      }, {
        name: "Memorial Hermann Cypress",
        address: "27700 Northwest Fwy, Ste 330, Cypress, TX 77433",
        phone: "(713) 722-1200"
      }],
    bio_name: "About Dr. Rohan Kulangara",
    bio: `Dr. Kulangara is a native Houstonian. He started his medical education at UT Southwestern Medical Center in Dallas. He then went on to complete his surgical training at the University of Illinois at Chicago. During this time he recieved the Robert Gasior, MD Award for Clinical excellence and Humanitarianism.    After general surgery residency, Dr. Kulangara spent a year specializing in Minimially Invasive and Bariatric Surgery at the Jackson South Medical Center in Miami, FL. During fellowship training, he learned advanced techniques in robotic and laproscopic surgery for the management of weight loss, gastric reflux, and colon cancer.    Dr. Kulangara’s interest include minimally invasive and robotic general surgery, and is skilled in treating abdominal wall hernias, gallbladder disease, colon tumors, and gatric reflux. Dr. Kulangara is described by his colleagues as a dedicated and compassionate physician that treat everyone as if they were his own family.    He is excited to return to Houston to be with his loving family. Dr. Kulangara enjoys playing basketball, fishing, cooking and traveling.`,
    education: ["Medical Degree from University of Texas at Southwestern Medical Center", "BSc Degree (Biology) from University of Texas at Dallas", "Residency (General Surgery) at University of Illinois at Chicago", "Fellowship (Advanced GI/MIS) at University of Miami/Jackson South Hospital"],
    areasOfExpertise: `<ul>
<li>Colon Disease/Cancer</li>
<li>Diverticulitis</li>
<li>Gallbladder Disease</li>
<li>General Surgery</li>
<li>Hemorrhoids</li>
</ul>
<ul>
<li>Hernia Repair</li>
<li>Minimally Invasive and Robotic Surgery</li>
<li>Pleural Effusion</li>
<li>Reflux Surgery</li>
<li>Skin Lesions/Masses/Cysts</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/37187126_xl.jpg",
      title: "ROBOTIC SURGERY",
      contentTop: "Robotic surgery utilizes advanced robotic systems to perform minimally invasive procedures with enhanced precision, flexibility, and control. Surgeons control robotic arms from a console, allowing for smaller incisions, reduced pain, and faster recovery times.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Philip A. Matorin, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title: "ROBOTIC SURGERY",
      contentTop: "Robotic surgery utilizes advanced robotic systems to perform minimally invasive procedures with enhanced precision, flexibility, and control. Surgeons control robotic arms from a console, allowing for smaller incisions, reduced pain, and faster recovery times.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/R-Matorin.jpg",
      title: "OTOLARYNGOLOGIST",
      mdcontent: "Philip A. Matorin, MD, is a highly trained otolaryngology and ENT specialist providing the latest medical and surgical treatment options for disorders...",
      mdname: "PHILIP A. MATORIN, MD"
    },
    id: "philip-a-matorin-md",
    name: "Philip A. Matorin, MD",
    image: "/images/doctors/philip-a-matorin-md.jpg",
    phone: "281-920-5558",
    gender: "Male",
    language: "English",
    specialty: "Otolaryngology (ENT), Sleep Medicine",
    degrees: ["Doctor of Medicine"],
    clinics: [{
        name: "West Houston Office",
        address: "12121 Richmond Avenue, Suite #104, Houston, Texas 77082",
        phone: "(281) 920-5558"
      }, {
        name: "Bellaire Office",
        address: "6699 Chimney Rock Road, Suite #202, Houston, Texas 77081",
        phone: "(713) 665-8887"
      }],
    bio_name: "About Dr. Philip A. Matorin",
    bio: `Dr. Matorin is board certified in ear, nose, and throat, and head and neck surgery by the American Board of Otolaryngology. He is also one of the elite few surgeons in the country who is also board certified in sleep medicine.    On top of four years of medical school, he also completed six years of specialty training. He participates in the Maintenance of Certification program developed by the American Board of Medical Specialties, promoting lifelong learning and quality improvement.    Dr. Matorin attended Rice University for his undergraduate degree and completed medical school at UTMB, moving to Baylor College of Medicine for his residency. He trained in general surgery for two years, working in the operating room with Dr. DeBakey and spent the next 4 years training in otolaryngology under Dr. Bobby Alford. Dr. Matorin has served as Chief of Surgery at West Houston Medical Center and has been elected to multiple leadership positions at the Harris County Medical Society (the largest medical society in the country). He’s been listed in H Texas Magazine’s “Top Doctors” several times.    Dr. Matorin is on staff at several leading, convenient hospitals in the area that are equipped with the latest equipment and devices available for patient care.    He’s a strong advocate for patient education—founding his clinic around the idea of a holistic approach to medical care. He believes that patients should be highly involved in the decision-making process for their treatment. That’s why Dr. Matorin spends a great deal of time with patients to make sure they fully understand their options.`,
    education: ["Medical Degree from University of Texas Medical Branch School of Medicine", "Residency (Surgery) from Baylor College of Medicine", "Residency (Otolaryngology - Head and Neck Surgery) from Baylor College of Medicine"],
    areasOfExpertise: `<ul>
<li>Acute Sinusitis</li>
<li>Chronic Nose and Throat Inflammation</li>
<li>Chronic Sinusitis</li>
<li>Ear Conditions and Infections</li>
</ul>
<ul>
<li>Endoscopic Sinus Surgery</li>
<li>Hearing Loss and Impairment</li>
<li>Larynx and Vocal Cord Disease</li>
<li>Upper Respiratory Infection</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/37187126_xl.jpg",
      title: "ROBOTIC SURGERY",
      contentTop: "Robotic surgery utilizes advanced robotic systems to perform minimally invasive procedures with enhanced precision, flexibility, and control. Surgeons control robotic arms from a console, allowing for smaller incisions, reduced pain, and faster recovery times.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Limael E. Rodriguez, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title: "ROBOTIC SURGERY",
      contentTop: "Robotic surgery utilizes advanced robotic systems to perform minimally invasive procedures with enhanced precision, flexibility, and control. Surgeons control robotic arms from a console, allowing for smaller incisions, reduced pain, and faster recovery times.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/R-Rodriguez.jpg",
      title: "VASCULAR SURGEON",
      mdcontent: "Limael Rodriguez, MD, is a board-certified vascular surgeon based in Houston, TX, serving as the President and Vascular Surgeon at Texas Vascular and ...",
      mdname: "LIMAEL E. RODRIGUEZ, MD"
    },
    id: "limael-e-rodriguez-md",
    name: "Limael E. Rodriguez, MD",
    image: "/images/doctors/limael-e-rodriguez-md.jpg",
    phone: "713-781-5676",
    gender: "Male",
    language: "English, Spanish",
    specialty: "Vascular Surgery, General Surgery",
    degrees: ["Doctor of Medicine"],
    clinics: [{
        name: "Texas Vascular and Imaging",
        address: "2500 Fondren Rd #210, Houston, TX, 77063",
        phone: "(713) 781-5676"
      }],
    bio_name: "About Dr. Limael E. Rodriguez",
    bio: `Dr. Rodriguez was raised in Houston, Texas and comes from a family of physicians. He is a graduate of the University of Colorado School of Medicine, Robert B. Rutherford Vascular Surgery Fellowship program in Denver, Colorado. He completed his ACGME accredited 5-year general surgery training at Ponce Heath Sciences University in Ponce, Puerto Rico. He attained his MD from LCME accredited UCC-School of Medicine in Bayamon, Puerto Rico. He attained dual majors in Chemistry and Molecular Biology from Texas Lutheran University in Seguin, Texas. Dr. Rodriguez completed a postdoctoral research fellowship at the Houston Methodist DeBakey Heart & Vascular Center.    Dr. Limael E. Rodriguez is specialized in identifying and treating a wide scope of vascular and lymphatic pathologies. He is a Registered Physician in Vascular Interpretation (RPVI) which is the highest certification in vascular ultrasound interpretation.    He has numerous publications in Vascular, Cardiovascular, and General surgery. He is the recipient of the prestigious 2016 Servier Traveling Fellowship for the American Venous Forum.`,
    education: ["Medical Degree from Universidad Central del Caribe School of Medicine", "Residency (Surgery) at Hospital Episcopal San Lucas/Ponce School of Medicine", "Fellowship (Vascular Surgery) at University of Colorado School of Medicine", "Post Doctoral Fellowship (Thoracic Surgery) at Houston Methodist DeBakey Heart & Vascular Center"],
    areasOfExpertise: `<ul>
<li>Aneurysm Repair</li>
<li>Angioplasty</li>
<li>Carotid Endarterectomy</li>
<li>Deep Venous Lysis</li>
<li>Endovenous Ablation</li>
</ul>
<ul>
<li>Femoral Endarterectomy</li>
<li>Peripheral Arterial Bypass Graft</li>
<li>Thoracic Stenting</li>
<li>Thrombolysis</li>
<li>Varicose Veins</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/37187126_xl.jpg",
      title: "ROBOTIC SURGERY",
      contentTop: "Robotic surgery utilizes advanced robotic systems to perform minimally invasive procedures with enhanced precision, flexibility, and control. Surgeons control robotic arms from a console, allowing for smaller incisions, reduced pain, and faster recovery times.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Steven D. Maislos, MD",
      content: "Our Team Of Surgical Assistants Provide A Range Of Services, From Purely Intra-Operative Assisting To Complete Peri-Operative Support."
    },
    cardioThoracicDetailData: {
      title: "ROBOTIC SURGERY",
      contentTop: "Robotic surgery utilizes advanced robotic systems to perform minimally invasive procedures with enhanced precision, flexibility, and control. Surgeons control robotic arms from a console, allowing for smaller incisions, reduced pain, and faster recovery times.",
      slope: true,
      intoImgData: "/images/providers/37006109_cardio.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/R-Maislos.webp",
      title: "UROLOGIST",
      mdcontent: "Steven D. Maislos, MD is a urologist with 28 years of experience treating conditions affecting the urinary system and male reproductive health. He spe...",
      mdname: "STEVEN D. MAISLOS, MD"
    },
    id: "steven-d-maislos-md",
    name: "Steven D. Maislos, MD",
    image: "/images/doctors/steven-d-maislos-md.jpg",
    phone: "713-771-5300",
    gender: "Male",
    language: "English, French, Spanish",
    specialty: "Urology, Surgery",
    degrees: ["Doctor of Medicine"],
    clinics: [{
        name: "Urology Institute of West Houston",
        address: "5420 Dashwood Street, Ste 210, Houston, TX 77081",
        phone: "(713) 771-5300"
      }, {
        name: "Urology Institute Of West Houston-Sugar Land",
        address: "15200 Southwest Fwy Ste 385, Sugar Land, TX 77478",
        phone: "(713) 771-5300"
      }],
    bio_name: "About Dr. Steven D. Maislos",
    bio: `Dr. Maislos completed his undergraduate education at Yale University, medical training at the McGovern Medical School at the University of Texas Health Science Center at Houston, and his residency in urology at State University of New York at Downstate (affiliated with Memorial Sloan Kettering Cancer Center). He also completed a fellowship in robotic, laparoscopic, and minimally invasive urologic surgery at Urology San Antonio.    In his dedication to community outreach, Dr. Maislos provides free prostate cancer screenings and lectures at numerous organizational meetings to increase awareness about prostate cancer and the minimally invasive treatments available. He also serves as a member of the Houston Livestock Show and Rodeo Health Committee.    Dr. Maislos brings a unique perspective and set of skills to providing care for his patients.`,
    education: ["Medical Degree from McGovern Medical School At The Univ Of Texas Health Science Ctr At Houston", "Undergraduate Degree at Yale University", "Residency at University Hospital of Brooklyn-SUNY", "Fellowship (Minimally Invasive Urologic Surgery) at Urology San Antonio"],
    areasOfExpertise: `<ul>
<li>Bladder Cancer</li>
<li>Endoscopy</li>
<li>Enlarged Prostate</li>
<li>Erectile Dysfunction</li>
<li>Kidney Stone Disease</li>
</ul>
<ul>
<li>Prostate Inflammation</li>
<li>Sexually Transmitted Diseases (STDs)</li>
<li>Transurethral Surgery (TURP)</li>
<li>Urinary Endoscopy</li>
<li>Urinary Tract Infection (UTI)</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      introImg: "/images/MDDetails/37187126_xl.jpg",
      title: "ROBOTIC SURGERY",
      contentTop: "Robotic surgery utilizes advanced robotic systems to perform minimally invasive procedures with enhanced precision, flexibility, and control. Surgeons control robotic arms from a console, allowing for smaller incisions, reduced pain, and faster recovery times.",
      slope: true
    }
  },

  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Akashdeep Singh, DPM",
      content: "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },
    cardioThoracicDetailData: {
      title:"ROBOTIC SURGERY",
      contentTop:"Robotic surgery enhances surgical precision, flexibility, and control, enabling our team to perform complex procedures with greater accuracy. This advanced, minimally invasive technology allows for smaller incisions and improved patient outcomes compared to traditional techniques.",
      slope: true,
      intoImgData: "/images/providers/426157522_robo.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/R-Singh DPM.jpg",
      title: "ROBOTIC SURGERY",
      mdcontent: `Akashdeep Singh, MD is board certified in podiatry and has been in practice since 2017 to see patients of all ages. He performs all aspects of foot and ankle surgery, with a strong emphasis on prevention. He provides a wide range of podiatry services to patients in the southern Greater Houston area.`,
      mdname: "AKASHDEEP SINGH, DPM"
    },
    id: "akashdeep-singh-dpm",
    name: "Akashdeep Singh, DPM",
    image: "/images/physianDirectory/R-Singh DPM.jpg",
    phone: "281-724-8241",
    gender: "Male",
    language: "English",
    specialty: "Podiatry",
    degrees: ["Doctor of Medicine"],
    clinics: [
      {
            "name": "Anchor Bone & Joint- Pearland",
            "address": "11555 Magnolia Pkwy, Ste 140, Pearland, TX 77584",
            "phone": "(281) 724-8241"
      },
      {
            "name": "Anchor Bone & Joint- Pasadena",
            "address": "4427 Crenshaw Rd, Ste 120, Pasadena, TX 77504",
            "phone": "(281) 724-8241"
      }
],
    bio_name: "About Dr. Akashdeep Singh",
    bio: `Akashdeep Singh, DPM, is qualified by The American Board of Podiatric Medicine and works as a podiatrist performing all aspects of foot and ankle surgery with a strong emphasis on preventing limb loss and treatment of critical limb ischemia due to diabetes and peripheral vascular disease. Born in India and raised in California, Dr. Singh pursued Podiatry after his own sports related injuries. Dr. Singh attended the University of California-Davis and graduated with a bachelor's degree in physiology. He then earned his medical degree at Des Moines University in Iowa. Afterward, Dr. Singh completed his surgical training in Houston, Texas, encompassing trauma management, reconstructive surgery, sports medicine, and limb salvage. He is published in the areas of sports medicine and limb salvage. Throughout his training, Dr. Singh has participated in multiple international medical mission trips and continues to do so. He acknowledges the importance of early diagnosis and management of critical limb ischemia and performs limb salvage procedures to help patients heal wounds in the lower extremity preventing limb loss. A resident of Pearland, Dr. Singh enjoys running, baking and movies in his leisure time. He frequently volunteers to serve on international medical mission trips.`,
    education: [
      "Medical Degree from Des Moines University",
      "Bachelors Degree (Physiology) from University of California-Davis",
      "Residency at St. Joseph's Medical Center"
],
    areasOfExpertise: `<ul>
  <li>Ankle Trauma</li>
  <li>Charcot Reconstruction</li>
  <li>Critical Limb Ischemia</li>
  <li>Diabetic Foot Care</li>
  <li>Foot and Ankle Surgery</li>
  <li>Fracture Care</li>
  <li>Limb Salvage</li>
  <li>Plantar Fasciitis</li>
  <li>Sports Injuries</li>
  <li>Vascular Diseases</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      link: "",
      introImg: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      contentTop:"Robotic-assisted surgery is the latest development in minimally invasive surgery (MIS). Surgeons uses a robotic platform as a tool during the procedure. The surgical robot has interactive arms that serve as extensions of the surgeon's hands. These arms are equipped with surgical tools and cameras. They can suture, dissect, clamp and manipulate tissue. It provides surgeons the flexibility of traditional open surgery while operating through tiny incisions, which can lead to fewer complications during surgery and a shorter recovery period for patients.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Peter P. Hinh, MD",
      content: "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },
    cardioThoracicDetailData: {
      title:"ROBOTIC SURGERY",
      contentTop:"Robotic surgery enhances surgical precision, flexibility, and control, enabling our team to perform complex procedures with greater accuracy. This advanced, minimally invasive technology allows for smaller incisions and improved patient outcomes compared to traditional techniques.",
      slope: true,
      intoImgData: "/images/providers/426157522_robo.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/R-Hinh.webp",
      title: "ROBOTIC SURGERY",
      mdcontent: `Peter P. Hinh, MD is an urologist in Houston, Texas and has been in practice for more than 20 years. He is affiliated with multiple hospitals in the area. He has extensive experience in Male Reproductive Disorders & Procedures, Urinary Conditions, and Urinary Calculi & Removal.`,
      mdname: "PETER P. HINH, MD"
    },
    id: "peter-p-hinh-md",
    name: "Peter P. Hinh, MD",
    image: "/images/physianDirectory/R-Hinh.webp",
    phone: "713-366-7831",
    gender: "Male",
    language: "English, Vietnamese",
    specialty: "Urology",
    degrees: ["Doctor of Medicine"],
    clinics: [
      {
            "name": "Crescent Urology Institute",
            "address": "1200 Binz Street, Ste 690, Houston, TX 77004",
            "phone": "(713) 366-7831"
      },
      {
            "name": "Pearland Multispecialty Group",
            "address": "10970 Shadow Creek Parkway, Suite 100, Pearland, TX 77584",
            "phone": "(713) 885-9832"
      }
],
    bio_name: "About Dr. Peter P. Hinh",
    bio: `A native, life long Houstonian, he graduated from Clear Creek HS. Dr. Hinh went on to receive his undergraduate degree from the University of Texas at Austin with Honors. With an interest in clinical research, he then furthered his studies and obtained a Masters of Public Health from Tulane University in New Orleans. He graduated from Texas Tech School of Medicine with the distinction of being inducted into the national medical honor society, Alpha Omega Alpha. He performed his urology residency training at the University of Texas at Houston in the world renowned Texas Medical Center. Dr. Hinh believes in a patient centric approach, valuing empowerment of patient with knowledge of their condition and the therapeutic options. This collaborative method ensures patients are both invested and satisfied during their treatment. His practice encompasses all aspects of general urology, including endourology/stone therapy, male sexual dysfunction, urologic oncology, voiding dysfunction /incontinence, and aquablation therapy used to treat benign prostatic hyperplasia (BPH). He places special emphasis on minimally invasive approaches with the aim of incorporating the latest technological advances in managing urologic diseases.`,
    education: [
      "Medical Degree from Texas Tech University School of Medicine",
      "Undergraduate Degree from University of Texas- Austin",
      "Masters of Public Health from Tulane University",
      "Residency (Urology) at University of Texas Houston",
      "Fellowship (General Surgery) at University of Texas Houston"
],
    areasOfExpertise: `<ul>
  <li>Bladder Surgeries</li>
  <li>Chronic Kidney Disease</li>
  <li>Enlarged prostate</li>
  <li>Erectile Dysfunction</li>
  <li>Incontinence</li>
  <li>Kidney Stone Removal</li>
  <li>Penile Cancer</li>
  <li>Prostate Cancer</li>
  <li>Transurethral Resection Of The Prostate (Turp)</li>
  <li>Vasectomy</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      link: "",
      introImg: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      contentTop:"Robotic-assisted surgery is the latest development in minimally invasive surgery (MIS). Surgeons uses a robotic platform as a tool during the procedure. The surgical robot has interactive arms that serve as extensions of the surgeon's hands. These arms are equipped with surgical tools and cameras. They can suture, dissect, clamp and manipulate tissue. It provides surgeons the flexibility of traditional open surgery while operating through tiny incisions, which can lead to fewer complications during surgery and a shorter recovery period for patients.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Anthony N. Hoang, MD",
      content: "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },
    cardioThoracicDetailData: {
      title:"ROBOTIC SURGERY",
      contentTop:"Robotic surgery enhances surgical precision, flexibility, and control, enabling our team to perform complex procedures with greater accuracy. This advanced, minimally invasive technology allows for smaller incisions and improved patient outcomes compared to traditional techniques.",
      slope: true,
      intoImgData: "/images/providers/426157522_robo.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/R-Hoang.webp",
      title: "ROBOTIC SURGERY",
      mdcontent: `Anthony (An Ngoc) Hoang, MD is a board-certified urologist and urologic oncologist specializing in prostate cancer treatment. He brings two decades of experience to his specialized practice focused on men's and women's urinary health. Patients appreciate his patient-friendly explanations and customized approach to treatment.`,
      mdname: "ANTHONY N. HOANG, MD"
    },
    id: "anthony-n-hoang-md",
    name: "Anthony N. Hoang, MD",
    image: "/images/physianDirectory/R-Hoang.webp",
    phone: "281-325-1090",
    gender: "Male",
    language: "English, Vietnamese",
    specialty: "Urology, Surgical Oncology",
    degrees: ["Doctor of Medicine"],
    clinics: [
      {
            "name": "Houston Metro Urology",
            "address": "16605 Southwest Fwy Ste 250, Sugar Land, TX 77479",
            "phone": "(281) 325-1090"
      },
      {
            "name": "Houston Metro Urology",
            "address": "7777 Southwest Fwy Ste 1032, Houston, TX 77074",
            "phone": "(713) 771-9224"
      }
],
    bio_name: "About Dr. Anthony N. Hoang",
    bio: `Anthony Hoang MD is a respected urologist and urologic oncologist. At Baylor University, Dr. Hoang received his Bachelor of Science in biology. He attended the University of Texas Health Science Center in Houston for medical school. Houston was also the site of Dr. Hoang's internship and residency training. He completed his internship and residency in urological surgery at the University of Texas – Houston/MD Anderson Cancer Center. Anthony Hoang MD continued his education by completing fellowship training in urologic oncology at the National Cancer Institute, National Institutes of Health in Bethesda, Maryland. At the NIH, his research focused on the role of MRIs and focal therapy in the management of prostate cancer. Dr. Hoang has been published in various medical journals, authored several book chapters, presented at multiple regional and national meetings and received several awards for his works.`,
    education: [
      "Medical Degree from UT McGovern Medical School",
      "Bachelor of Science Degree (Biology) from Baylor University",
      "Residency (Urological Surgery) at UT MD Anderson Cancer Center",
      "Fellowship (Urologic Oncology) at National Cancer Institute, National Institutes of Health"
],
    areasOfExpertise: `<ul>
  <li>Kidney Stones</li>
  <li>Laparoscopic Cancer Surgery</li>
  <li>Lithotripsy ESWL</li>
  <li>Prostate Cancer</li>
  <li>Prostate Disease</li>
  <li>Robotic Surgery</li>
  <li>Sexual Dysfunction</li>
  <li>TURP Procedure</li>
  <li>Urinary Diversion</li>
  <li>Urology Oncology</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      link: "",
      introImg: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      contentTop:"Robotic-assisted surgery is the latest development in minimally invasive surgery (MIS). Surgeons uses a robotic platform as a tool during the procedure. The surgical robot has interactive arms that serve as extensions of the surgeon's hands. These arms are equipped with surgical tools and cameras. They can suture, dissect, clamp and manipulate tissue. It provides surgeons the flexibility of traditional open surgery while operating through tiny incisions, which can lead to fewer complications during surgery and a shorter recovery period for patients.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Richard D. Drake, MD",
      content: "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },
    cardioThoracicDetailData: {
      title:"ROBOTIC SURGERY",
      contentTop:"Robotic surgery enhances surgical precision, flexibility, and control, enabling our team to perform complex procedures with greater accuracy. This advanced, minimally invasive technology allows for smaller incisions and improved patient outcomes compared to traditional techniques.",
      slope: true,
      intoImgData: "/images/providers/426157522_robo.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/R-Drake.jpg",
      title: "ROBOTIC SURGERY",
      mdcontent: `Richard D. Drake, MD is a gynecology specialist in The Woodlands, Texas area. He has more experience with Gynecologic Oncology and Gynecologic Surgery than other specialists in his area. Dr. Drake talks with patients about a full range of effective, innovative treatment options. He's an expert in complex laparoscopic and robotic approaches, fertility-sparing surgery, and risk reduction procedures for inherited cancer syndromes.`,
      mdname: "RICHARD D. DRAKE, MD"
    },
    id: "richard-d-drake-md",
    name: "Richard D. Drake, MD",
    image: "/images/physianDirectory/R-Drake.jpg",
    phone: "281-203-5115",
    gender: "Male",
    language: "English",
    specialty: "Gynecologic Oncology",
    degrees: ["Doctor of Medicine"],
    clinics: [
      {
            "name": "Comprehensive Medical Specialists of Texas",
            "address": "8845 Six Pines Dr, Ste 100, Shenandoah, TX 77380",
            "phone": "(281) 203-5115"
      }
],
    bio_name: "About Dr. Richard D. Drake",
    bio: `Dr. Drake, MD is a gynecologist oncologist in Shenandoah, TX and has over 25 years of experience in the medical field. He graduated from Wayne State University School of Medicine in 1998. As a gynecologic oncologist, he practices medicine how he would like to be treated - with compassion, understanding, and comfort for getting through this difficult diagnosis. By using the latest advances in medicine (both surgically and with chemotherapy), he can help patients to combat their gynecological cancers aggressively to help them continue their lives. Dr. Drake and his wife, Natalie Drake, MD, a OBGYN, moved in 2007 to Cleveland, Ohio to begin positions on staff at the Cleveland Clinic. In 2013, Dr. Drake, his wife, and their two children moved to the warmth of Texas. Dr. Drake and his wife are active in the cancer community. Through Texas Oncology, he can offer clinical trials, minimally invasive surgery, and the latest therapies to help eradicate most gynecological malignancies.`,
    education: [
      "Medical Degree from Wayne State University School of Medicine",
      "Bachelor of Science (Biology) at University of Michigan, Ann Arbor",
      "Residency (Obstetrics and Gynecology) at Wayne State University School of Medicine/ Hutzel Hospital",
      "Fellowship (Gynecologic Oncology) at UT Southwestern Medical Center"
],
    areasOfExpertise: `<ul>
  <li>Cervical Cancer</li>
  <li>Endometrial Cancer</li>
  <li>Fibroids</li>
  <li>Gynecologic Oncology</li>
  <li>Hysterectomy</li>
  <li>Ovarian Cancer</li>
  <li>Pelvic Masses</li>
  <li>Salpingo Oopherectomy</li>
  <li>Uterine Cancer</li>
  <li>Vulvar Cancer</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      link: "",
      introImg: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      contentTop:"Robotic-assisted surgery is the latest development in minimally invasive surgery (MIS). Surgeons uses a robotic platform as a tool during the procedure. The surgical robot has interactive arms that serve as extensions of the surgeon's hands. These arms are equipped with surgical tools and cameras. They can suture, dissect, clamp and manipulate tissue. It provides surgeons the flexibility of traditional open surgery while operating through tiny incisions, which can lead to fewer complications during surgery and a shorter recovery period for patients.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Francisco J. Gelpi-Hammerschmidt, MD",
      content: "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },
    cardioThoracicDetailData: {
      title:"ROBOTIC SURGERY",
      contentTop:"Robotic surgery enhances surgical precision, flexibility, and control, enabling our team to perform complex procedures with greater accuracy. This advanced, minimally invasive technology allows for smaller incisions and improved patient outcomes compared to traditional techniques.",
      slope: true,
      intoImgData: "/images/providers/426157522_robo.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/R-Gelpi.webp",
      title: "ROBOTIC SURGERY",
      mdcontent: `Francisco J. Gelpi-Hammerschmidt, MD is an urologist in Houston, Texas and is affiliated with multiple hospitals in the area. He has over 15 years of experience in the medical field. Patients benefit from the training and care that Dr. Gelpi-Hammerschmidt provides. He treats a wide variety of men's and women's urologic issues. Dr. Gelpi specializes in robotic surgery and treating problems using minimally invasive procedures. He is skilled in helping patients with issues surrounding voiding dysfunction, benign prostatic hyperplasia or BPH, hormonal optimization and urologic cancer. His passion for medical advances is only surpassed by the well being and care for his patients.`,
      mdname: "FRANCISCO J. GELPI-HAMMERSCHMIDT, MD"
    },
    id: "francisco-j-gelpi-hammerschmidt-md",
    name: "Francisco J. Gelpi-Hammerschmidt, MD",
    image: "/images/physianDirectory/R-Gelpi.webp",
    phone: "713-634-4441",
    gender: "Male",
    language: "English, Spanish, Portuguese",
    specialty: "Urologic Oncology, Robotic Surgery",
    degrees: ["Doctor of Medicine"],
    clinics: [
      {
            "name": "Houston Metro Urology",
            "address": "9230 Katy Freeway, Suite 510, Houston, TX 77055",
            "phone": "(713) 634-4441"
      }
],
    bio_name: "About Dr. Francisco J. Gelpi-Hammerschmidt",
    bio: `Dr. Gelpi completed his undergraduate and medical school training at the University of Puerto Rico. After receiving his undergraduate degree in biology, he went on to the University of Puerto Rico School of Medicine. For his internship and residency, Francisco Gelpi MD went to Thomas Jefferson University Hospital in Philadelphia, Pennsylvania where he served as the chief urology resident. His fellowship training in urology took place at the esteemed Harvard University in Cambridge, Massachusetts. In addition to his medical training, Dr. Gelpi received a Master of Public Health from Harvard University School of Public Health. He has published in multiple peer-reviewed medical journals, presented at multiple regional/national meetings, and received many awards for his works. When he isn't caring for patients, Dr. Francisco Gelpi enjoys spending time with his wife and three children. He stays active by playing soccer, tennis and golf. He also enjoys traveling and playing the guitar.`,
    education: [
      "Medical School from University of Puerto Rico School of Medicine",
      "Undergraduate Degree from University of Puerto Rico",
      "Master's Degree from Harvard University School of Public Health",
      "Residency (Urology) at Thomas Jefferson University Hospital (Chief Urology Resident)",
      "Fellowship (Urologic Oncology) at Harvard University"
],
    areasOfExpertise: `<ul>
  <li>Bladder Cancer</li>
  <li>Circumcision</li>
  <li>Kidney Stones</li>
  <li>Laparoscopic Cancer Surgery</li>
  <li>Prostate Cancer</li>
  <li>Prostate Disease</li>
  <li>Robotic Surgery</li>
  <li>Ureteroscopy</li>
  <li>Urology Oncology</li>
  <li>Vasectomy</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=J8RImHtlV3M",
      introImg: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      contentTop:"Robotic-assisted surgery is the latest development in minimally invasive surgery (MIS). Surgeons uses a robotic platform as a tool during the procedure. The surgical robot has interactive arms that serve as extensions of the surgeon's hands. These arms are equipped with surgical tools and cameras. They can suture, dissect, clamp and manipulate tissue. It provides surgeons the flexibility of traditional open surgery while operating through tiny incisions, which can lead to fewer complications during surgery and a shorter recovery period for patients.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Christopher K. Livingston, MD",
      content: "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },
    cardioThoracicDetailData: {
      title:"ROBOTIC SURGERY",
      contentTop:"Robotic surgery enhances surgical precision, flexibility, and control, enabling our team to perform complex procedures with greater accuracy. This advanced, minimally invasive technology allows for smaller incisions and improved patient outcomes compared to traditional techniques.",
      slope: true,
      intoImgData: "/images/providers/426157522_robo.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/R-Livingston.jpg",
      title: "ROBOTIC SURGERY",
      mdcontent: `Christopher K. Livingston is a renowned plastic and reconstructive surgeon who has been helping patients achieve their plastic surgery goals since he opened his private practice located in Houston, TX, in 2003. His specialties include all areas of plastic surgery, reconstructive surgery, and hand surgery including breast augmentation, breast reduction, breast reconstruction, liposuction abdominoplasty, rhinoplasty, blepharoplasty, facelift, and hand surgery. Before, during, and after a plastic surgery procedure, Dr. Livingston and his staff will help patients feel comfortable, informed, safe, and prepared regarding their surgical procedure.`,
      mdname: "CHRISTOPHER K. LIVINGSTON, MD"
    },
    id: "christopher-k-livingston-md",
    name: "Christopher K. Livingston, MD",
    image: "/images/physianDirectory/R-Livingston.jpg",
    phone: "(281) 501-1812",
    gender: "Male",
    language: "English",
    specialty: "Plastic Surgery, Surgery of the Hand",
    degrees: ["Doctor of Medicine"],
    clinics: [
      {
            "name": "Livingston Plastic Surgery",
            "address": "12121 Richmond Ave, Suite 317, Houston, TX 77082",
            "phone": "(281) 501-1812"
      },
      {
            "name": "Livingston Plastic Surgery",
            "address": "6410 Fannin St Ste 927, Houston, TX 77030",
            "phone": "(281) 501-1812"
      }
],
    bio_name: "About Dr. Christopher K. Livingston",
    bio: `Double Board-Certified and re-certified plastic surgeon Christopher K. Livingston, MD FACS PA has proudly served as one of Houston's leading plastic and hand surgeons for almost two decades at Livingston Plastic Surgery. He graduated cum laude with a B.S. in Biology from Washington and Lee University before earning his M.D. from the University of Louisville School of Medicine. He completed a comprehensive surgical residency at the University of Texas Health Science Center, including specialized training in plastic and reconstructive surgery. Dr. Livingston further honed his expertise in hand and microsurgery through a prestigious fellowship at the Kleinert Institute for Hand and Microsurgery. He is a member of the American Society of Plastic Surgeons and the American College of Surgeons, committed to restoring form, function, and confidence through expert surgical care. Dr. Livingston serves as Assistant Clinical Professor in plastic surgery at the University of Texas School of Medicine and is the Chief of Surgery at HCA Houston West. Due to his surgical talent and unwavering dedication to his craft, Dr. Livingston has earned many awards, distinctions, and positions, along with numerous published articles. He is passionate about helping his patients achieve a youthful and refreshed look through evidence-based plastic surgery procedures designed specifically for each patient. By offering a comfortable, thoughtful, non-pressuring environment at Livingston Plastic Surgery, he helps patients feel relaxed and excited about their procedures while ensuring a rewarding experience.`,
    education: [
      "Doctorate of Medicine, University of Louisville School of Medicine",
      "Bachelor of Science (Biology, Cum Laude), Washington and Lee University",
      "Residency (General Surgery) at University of Texas-Houston",
      "Residency (Plastic/Reconstructive Surgery) at University of Texas Health Science Center",
      "Fellowship (Plastic Surgery) at Microsurgery Training Center, St. Joseph Hospital",
      "Fellowship (Hand and Microsurgery) at University of Louisville School of Medicine"
],
    areasOfExpertise: `<ul>
  <li>Abdominoplasty</li>
  <li>Blepharoplasty</li>
  <li>Breast Augmentation</li>
  <li>Breast Reduction</li>
  <li>Breast Reconstruction</li>
  <li>Facelift</li>
  <li>Hand Surgery</li>
  <li>Liposuction</li>
  <li>Rhinoplasty</li>
  <li>Thigh Lift</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      link: "https://www.youtube.com/watch?v=J4GLrqre3Qs",
      introImg: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      contentTop:"Robotic-assisted surgery is the latest development in minimally invasive surgery (MIS). Surgeons uses a robotic platform as a tool during the procedure. The surgical robot has interactive arms that serve as extensions of the surgeon's hands. These arms are equipped with surgical tools and cameras. They can suture, dissect, clamp and manipulate tissue. It provides surgeons the flexibility of traditional open surgery while operating through tiny incisions, which can lead to fewer complications during surgery and a shorter recovery period for patients.",
      slope: true
    }
  },
  {
    provider_General_surgery_detail: {
      image: "/images/providers/generalSurgeryBgdeatil.png",
      title1: "PHYSICIANS",
      title2: " DIRECTORY -",
      title3: "ROBOTIC SURGERY",
      mdName: "Thomas M. Loh, MD",
      content: "Our orthopedic surgeons provide advanced surgical and non-surgical treatment options to restore mobility, relieve pain, and improve quality of life."
    },
    cardioThoracicDetailData: {
      title:"ROBOTIC SURGERY",
      contentTop:"Robotic surgery enhances surgical precision, flexibility, and control, enabling our team to perform complex procedures with greater accuracy. This advanced, minimally invasive technology allows for smaller incisions and improved patient outcomes compared to traditional techniques.",
      slope: true,
      intoImgData: "/images/providers/426157522_robo.jpg"
    },
    cardioThoracicDetaillinkData2: {
      intoImgData: "/images/physianDirectory/R-Loh.jpg",
      title: "ROBOTIC SURGERY",
      mdcontent: `Thomas M. Loh, MD is a vascular surgeon with 18 years of experience providing comprehensive surgical care in Cypress, TX. Dr. Loh has extensive experience in Peripheral Vascular Procedures, Peripheral Vascular Disease, and Carotid Artery Disease or Carotid Endarterectomy. Patients consistently praise Dr. Loh for his exceptional bedside manner, thorough explanations, and attentiveness during consultations, appreciating his ability to communicate effectively and address all questions. Many report a positive experience with Dr. Loh and his staff, highlighting their professionalism, friendliness, and comprehensive care, leading to successful outcomes and a strong recommendation of his services.`,
      mdname: "THOMAS M. LOH, MD"
    },
    id: "thomas-m-loh-md",
    name: "Thomas M. Loh, MD",
    image: "/images/physianDirectory/R-Loh.jpg",
    phone: "(832) 533-3790",
    gender: "Male",
    language: "English",
    specialty: "Vascular Surgery",
    degrees: ["Doctor of Medicine"],
    clinics: [
      {
            "name": "Houston Methodist Cardiovascular Surgery Associates",
            "address": "24518 Northwest Freeway, Ste 525, Cypress, TX 77429",
            "phone": "(832) 533-3790"
      },
      {
            "name": "Methodist Cardiovascular Surgery Associates",
            "address": "17189 IH 45 South, Suite 475, The Woodlands, TX 77385",
            "phone": "(936) 270-3933"
      }
],
    bio_name: "About Dr. Thomas M. Loh",
    bio: `Dr. Loh, MD, is a vascular surgeon at Houston Methodist The Woodlands Hospital. He earned his medical degree from Saint Louis University School of Medicine in Saint Louis, Missouri, and completed his residency at Houston Methodist Hospital in Houston, Texas in 2019. Dr. Loh holds the distinction of being a Fellow of the American College of Surgeons (FACS), a certification that recognizes his advanced surgical training and commitment to high standards of patient care. Dr. Loh has undergone advanced training in vascular and endovascular surgery with clinical expertise in peripheral vascular disease, limb salvage, complex dialysis access, venous insufficiency, mesenteric disease and cerebrovascular disease. He has published multiple publications and presentations and serves on the executive subcommittee for Graduate Medical Education at Houston Methodist Hospital as well as the Editorial Board for the Methodist DeBakey Cardiovascular Journal. Dr. Loh seeks to provide comprehensive medical, surgical and endovascular care for patients with cardiovascular disease. He believes no two patient's vascular systems are the same and it is essential that he offers the gamut of treatment options to patients and the community.`,
    education: [
      "Medical Degree from Saint Louis University School of Medicine",
      "Undergraduate Degree (Physics) from Washington University, St. Louis",
      "Residency (Integrated Vascular Surgery) at Houston Methodist Hospital"
],
    areasOfExpertise: `<ul>
  <li>Aortic and Peripheral Aneurysms</li>
  <li>Aortic Dissection</li>
  <li>Carotid Artery Disease</li>
  <li>Cerebrovascular Disease</li>
  <li>Complex dialysis access</li>
  <li>Deep Vein Thrombosis</li>
  <li>Limb Salvage</li>
  <li>Mesenteric Disease</li>
  <li>Peripheral Vascular Disease</li>
  <li>Pulmonary Embolism</li>
  <li>Sclerotherapy</li>
  <li>Varicose Veins</li>
</ul>`,
    generalSurgeryDetaillinkData: {
      link: "https://youtu.be/Gl6CiAEwwB8?si=NEI1bKgSzxccqHp7",
      introImg: "/images/MDDetails/shutterstock_1730979037.jpg",
      title: "ROBOTIC SURGERY",
      contentTop:"Robotic-assisted surgery is the latest development in minimally invasive surgery (MIS). Surgeons uses a robotic platform as a tool during the procedure. The surgical robot has interactive arms that serve as extensions of the surgeon's hands. These arms are equipped with surgical tools and cameras. They can suture, dissect, clamp and manipulate tissue. It provides surgeons the flexibility of traditional open surgery while operating through tiny incisions, which can lead to fewer complications during surgery and a shorter recovery period for patients.",
      slope: true
    }
  }
];